//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { BaseClient } from "./BaseClient"; export class FileStream { static fromJS(data: any) { return new FileStream(); } }

export class AdminClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getSyncResults(): Promise<AmsSyncResultViewModel[]> {
        let url_ = this.baseUrl + "/api/Admin/getSyncResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSyncResults(_response);
        });
    }

    protected processGetSyncResults(response: Response): Promise<AmsSyncResultViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AmsSyncResultViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AmsSyncResultViewModel[]>(null as any);
    }

    getPrinters(): Promise<WarehousePrinterModel[]> {
        let url_ = this.baseUrl + "/api/Admin/getPrinters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrinters(_response);
        });
    }

    protected processGetPrinters(response: Response): Promise<WarehousePrinterModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehousePrinterModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehousePrinterModel[]>(null as any);
    }

    getPrinterClients(): Promise<WarehousePrinterClientModel[]> {
        let url_ = this.baseUrl + "/api/Admin/getPrinterClients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrinterClients(_response);
        });
    }

    protected processGetPrinterClients(response: Response): Promise<WarehousePrinterClientModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehousePrinterClientModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehousePrinterClientModel[]>(null as any);
    }

    getPrintJobLogs(pageSize: number | undefined, pageNumber: number | undefined, sortCriteria: string[] | null | undefined): Promise<PagedResultsOfWarehousePrintJobLogModel> {
        let url_ = this.baseUrl + "/api/Admin/getPrintJobLogs?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrintJobLogs(_response);
        });
    }

    protected processGetPrintJobLogs(response: Response): Promise<PagedResultsOfWarehousePrintJobLogModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultsOfWarehousePrintJobLogModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultsOfWarehousePrintJobLogModel>(null as any);
    }

    getUnownedWarehouseLocations(printerType: WarehousePrinterType | undefined): Promise<WarehouseLocationModel[]> {
        let url_ = this.baseUrl + "/api/Admin/getUnownedWarehouseLocations?";
        if (printerType === null)
            throw new Error("The parameter 'printerType' cannot be null.");
        else if (printerType !== undefined)
            url_ += "printerType=" + encodeURIComponent("" + printerType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnownedWarehouseLocations(_response);
        });
    }

    protected processGetUnownedWarehouseLocations(response: Response): Promise<WarehouseLocationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseLocationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseLocationModel[]>(null as any);
    }

    updateWarehousePrinter(warehousePrinter: WarehousePrinterModel): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Admin/updateWarehousePrinter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(warehousePrinter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWarehousePrinter(_response);
        });
    }

    protected processUpdateWarehousePrinter(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AmsOrderLineItemsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getOrderLineItem(id: number): Promise<OrderLineItemViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrderLineItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderLineItem(_response);
        });
    }

    protected processGetOrderLineItem(response: Response): Promise<OrderLineItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderLineItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderLineItemViewModel>(null as any);
    }

    getNextOrderLineItem(orderId: number | undefined, seq: number | undefined): Promise<OrderLineItemViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrderLineItems/nextOrderLineItem?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        if (seq === null)
            throw new Error("The parameter 'seq' cannot be null.");
        else if (seq !== undefined)
            url_ += "Seq=" + encodeURIComponent("" + seq) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNextOrderLineItem(_response);
        });
    }

    protected processGetNextOrderLineItem(response: Response): Promise<OrderLineItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderLineItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderLineItemViewModel>(null as any);
    }

    valid(id: number): Promise<OrderItemViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrderLineItems/{id}/valid";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValid(_response);
        });
    }

    protected processValid(response: Response): Promise<OrderItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderItemViewModel>(null as any);
    }

    inValid(id: number, data: OrderLineItemAndReasonInput[]): Promise<OrderItemViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrderLineItems/{id}/inValid";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInValid(_response);
        });
    }

    protected processInValid(response: Response): Promise<OrderItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderItemViewModel>(null as any);
    }

    pick(id: number): Promise<OrderItemViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrderLineItems/{id}/pick";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPick(_response);
        });
    }

    protected processPick(response: Response): Promise<OrderItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderItemViewModel>(null as any);
    }

    pickAndFinalizeOrder(id: number): Promise<OrderItemViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrderLineItems/{id}/pickAndFinalizeOrder";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPickAndFinalizeOrder(_response);
        });
    }

    protected processPickAndFinalizeOrder(response: Response): Promise<OrderItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderItemViewModel>(null as any);
    }

    editLineItemNote(id: number, input: OrderLineItemEditNoteInput): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AmsOrderLineItems/{id}/editLineItemNote";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditLineItemNote(_response);
        });
    }

    protected processEditLineItemNote(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    correctLane(id: number, correctedLane: string | undefined): Promise<IncorrectLaneReportModel> {
        let url_ = this.baseUrl + "/api/AmsOrderLineItems/{id}/correctLane?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (correctedLane === null)
            throw new Error("The parameter 'correctedLane' cannot be null.");
        else if (correctedLane !== undefined)
            url_ += "correctedLane=" + encodeURIComponent("" + correctedLane) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCorrectLane(_response);
        });
    }

    protected processCorrectLane(response: Response): Promise<IncorrectLaneReportModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncorrectLaneReportModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncorrectLaneReportModel>(null as any);
    }

    markLaneCorrected(incorrectLaneReportId: number, input: MarkLaneCorrectedInput): Promise<IncorrectLaneReportModel> {
        let url_ = this.baseUrl + "/api/AmsOrderLineItems/{incorrectLaneReportId}/markLaneCorrected";
        if (incorrectLaneReportId === undefined || incorrectLaneReportId === null)
            throw new Error("The parameter 'incorrectLaneReportId' must be defined.");
        url_ = url_.replace("{incorrectLaneReportId}", encodeURIComponent("" + incorrectLaneReportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkLaneCorrected(_response);
        });
    }

    protected processMarkLaneCorrected(response: Response): Promise<IncorrectLaneReportModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncorrectLaneReportModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncorrectLaneReportModel>(null as any);
    }

    getIncorrectLaneReports(hideCorrected: boolean | null | undefined, pageSize: number | undefined, pageNumber: number | undefined, sortCriteria: string[] | null | undefined): Promise<PagedResultsOfIncorrectLaneReportModel> {
        let url_ = this.baseUrl + "/api/AmsOrderLineItems/incorrectLaneReports?";
        if (hideCorrected !== undefined && hideCorrected !== null)
            url_ += "HideCorrected=" + encodeURIComponent("" + hideCorrected) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncorrectLaneReports(_response);
        });
    }

    protected processGetIncorrectLaneReports(response: Response): Promise<PagedResultsOfIncorrectLaneReportModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultsOfIncorrectLaneReportModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultsOfIncorrectLaneReportModel>(null as any);
    }

    getIncorrectLaneReportsCount(): Promise<number> {
        let url_ = this.baseUrl + "/api/AmsOrderLineItems/incorrectLaneReportsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncorrectLaneReportsCount(_response);
        });
    }

    protected processGetIncorrectLaneReportsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class AmsOrdersClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUnpickedOrders(): Promise<OrderViewModel[]> {
        let url_ = this.baseUrl + "/api/AmsOrders/GetUnpickedOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnpickedOrders(_response);
        });
    }

    protected processGetUnpickedOrders(response: Response): Promise<OrderViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderViewModel[]>(null as any);
    }

    getClerkOrders(pageSize: number | undefined, pageNumber: number | undefined, orderStatus: AmsOrderStatusEnum | null | undefined, orderAssignmentStatus: AmsOrderAssignmentStatus | null | undefined, locationCodes: string[] | null | undefined, returnReasons: string[] | null | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined): Promise<PagedResultsOfOrderListOutput> {
        let url_ = this.baseUrl + "/api/AmsOrders/clerk?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderStatus !== undefined && orderStatus !== null)
            url_ += "OrderStatus=" + encodeURIComponent("" + orderStatus) + "&";
        if (orderAssignmentStatus !== undefined && orderAssignmentStatus !== null)
            url_ += "OrderAssignmentStatus=" + encodeURIComponent("" + orderAssignmentStatus) + "&";
        if (locationCodes !== undefined && locationCodes !== null)
            locationCodes && locationCodes.forEach(item => { url_ += "LocationCodes=" + encodeURIComponent("" + item) + "&"; });
        if (returnReasons !== undefined && returnReasons !== null)
            returnReasons && returnReasons.forEach(item => { url_ += "ReturnReasons=" + encodeURIComponent("" + item) + "&"; });
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClerkOrders(_response);
        });
    }

    protected processGetClerkOrders(response: Response): Promise<PagedResultsOfOrderListOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultsOfOrderListOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultsOfOrderListOutput>(null as any);
    }

    getOrders(): Promise<OrderViewModel[]> {
        let url_ = this.baseUrl + "/api/AmsOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrders(_response);
        });
    }

    protected processGetOrders(response: Response): Promise<OrderViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderViewModel[]>(null as any);
    }

    getOrderById(id: number): Promise<OrderViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderById(_response);
        });
    }

    protected processGetOrderById(response: Response): Promise<OrderViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderViewModel>(null as any);
    }

    getOrderByIdAndUserId(id: number): Promise<OrderViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrders/picker/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderByIdAndUserId(_response);
        });
    }

    protected processGetOrderByIdAndUserId(response: Response): Promise<OrderViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderViewModel>(null as any);
    }

    assignPickerToOrder(request: UpdateOrderForPickerInput, id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/AmsOrders/{id}/assign/picker";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignPickerToOrder(_response);
        });
    }

    protected processAssignPickerToOrder(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    pauseOrder(request: PauseOrderInput, id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/AmsOrders/{id}/pause";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPauseOrder(_response);
        });
    }

    protected processPauseOrder(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    cancelOrder(input: CancelOrderInput, id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/AmsOrders/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelOrder(_response);
        });
    }

    protected processCancelOrder(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    returnOrder(request: ReturnOrderInput, id: number): Promise<OrderViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrders/{id}/return";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReturnOrder(_response);
        });
    }

    protected processReturnOrder(response: Response): Promise<OrderViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderViewModel>(null as any);
    }

    unpauseOrder(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/AmsOrders/{id}/unpause";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnpauseOrder(_response);
        });
    }

    protected processUnpauseOrder(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    priorityOrderUp(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/AmsOrders/{id}/priority/up";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPriorityOrderUp(_response);
        });
    }

    protected processPriorityOrderUp(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    priorityOrderDown(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/AmsOrders/{id}/priority/down";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPriorityOrderDown(_response);
        });
    }

    protected processPriorityOrderDown(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getOrdersQC(searchText: string | null | undefined, timeframe: Timeframe | undefined): Promise<OrderQCViewModel[]> {
        let url_ = this.baseUrl + "/api/AmsOrders/qc?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (timeframe === null)
            throw new Error("The parameter 'timeframe' cannot be null.");
        else if (timeframe !== undefined)
            url_ += "Timeframe=" + encodeURIComponent("" + timeframe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrdersQC(_response);
        });
    }

    protected processGetOrdersQC(response: Response): Promise<OrderQCViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderQCViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderQCViewModel[]>(null as any);
    }

    getOrderQc(id: number): Promise<OrderViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrders/qc/orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderQc(_response);
        });
    }

    protected processGetOrderQc(response: Response): Promise<OrderViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderViewModel>(null as any);
    }

    updateNumberOfPalletsOrder(orderId: number, input: UpdateNumberOfPalletsOrderInput): Promise<OrderViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrders/{orderId}/updateNumberOfPalletsOrder";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNumberOfPalletsOrder(_response);
        });
    }

    protected processUpdateNumberOfPalletsOrder(response: Response): Promise<OrderViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderViewModel>(null as any);
    }

    updateClerkNote(orderId: number, newNote: string): Promise<OrderViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrders/{orderId}/updateClerkNote";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateClerkNote(_response);
        });
    }

    protected processUpdateClerkNote(response: Response): Promise<OrderViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderViewModel>(null as any);
    }

    deleteClerkNote(orderId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/AmsOrders/{orderId}/deleteClerkNote";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteClerkNote(_response);
        });
    }

    protected processDeleteClerkNote(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    orderScanRequest(orderNo: string | null | undefined): Promise<OrderScanReportViewModel> {
        let url_ = this.baseUrl + "/api/AmsOrders/orderScanRequest?";
        if (orderNo !== undefined && orderNo !== null)
            url_ += "OrderNo=" + encodeURIComponent("" + orderNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOrderScanRequest(_response);
        });
    }

    protected processOrderScanRequest(response: Response): Promise<OrderScanReportViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderScanReportViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderScanReportViewModel>(null as any);
    }

    getWarehouseLocations(): Promise<WarehouseLocationModel[]> {
        let url_ = this.baseUrl + "/api/AmsOrders/warehouseLocations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWarehouseLocations(_response);
        });
    }

    protected processGetWarehouseLocations(response: Response): Promise<WarehouseLocationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseLocationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseLocationModel[]>(null as any);
    }
}

export class ClockedTimeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    startClock(): Promise<ClockedTimeModel> {
        let url_ = this.baseUrl + "/api/ClockedTime/start";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartClock(_response);
        });
    }

    protected processStartClock(response: Response): Promise<ClockedTimeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClockedTimeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClockedTimeModel>(null as any);
    }

    stopClock(): Promise<ClockedTimeModel> {
        let url_ = this.baseUrl + "/api/ClockedTime/stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStopClock(_response);
        });
    }

    protected processStopClock(response: Response): Promise<ClockedTimeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClockedTimeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClockedTimeModel>(null as any);
    }

    pauseClock(): Promise<ClockedTimeModel> {
        let url_ = this.baseUrl + "/api/ClockedTime/pause";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPauseClock(_response);
        });
    }

    protected processPauseClock(response: Response): Promise<ClockedTimeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClockedTimeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClockedTimeModel>(null as any);
    }

    getStatus(): Promise<ClockedTimeModel> {
        let url_ = this.baseUrl + "/api/ClockedTime/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: Response): Promise<ClockedTimeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClockedTimeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClockedTimeModel>(null as any);
    }

    getLastClockedTime(): Promise<ClockedTimeModel> {
        let url_ = this.baseUrl + "/api/ClockedTime/lastClockedTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLastClockedTime(_response);
        });
    }

    protected processGetLastClockedTime(response: Response): Promise<ClockedTimeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClockedTimeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClockedTimeModel>(null as any);
    }
}

export class ConfigurationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getConfigurations(): Promise<ConfigurationViewModel> {
        let url_ = this.baseUrl + "/api/Configurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurations(_response);
        });
    }

    protected processGetConfigurations(response: Response): Promise<ConfigurationViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigurationViewModel>(null as any);
    }
}

export class PickersClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getClerkPickers(pageSize: number | undefined, pageNumber: number | undefined, pickerStatus: ScanToPickUserStatusEnum | null | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined): Promise<PagedResultsOfPickerListOutput> {
        let url_ = this.baseUrl + "/api/Pickers?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pickerStatus !== undefined && pickerStatus !== null)
            url_ += "PickerStatus=" + encodeURIComponent("" + pickerStatus) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClerkPickers(_response);
        });
    }

    protected processGetClerkPickers(response: Response): Promise<PagedResultsOfPickerListOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultsOfPickerListOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultsOfPickerListOutput>(null as any);
    }

    getPickerOrders(pickerId: number, pageSize: number | undefined, pageNumber: number | undefined, hideCompletedBeforeDate: Date | null | undefined, orderStatus: AmsOrderStatusEnum[] | null | undefined, sortCriteria: string[] | null | undefined): Promise<PagedResultsOfOrderListOutput> {
        let url_ = this.baseUrl + "/api/Pickers/{pickerId}/orders?";
        if (pickerId === undefined || pickerId === null)
            throw new Error("The parameter 'pickerId' must be defined.");
        url_ = url_.replace("{pickerId}", encodeURIComponent("" + pickerId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (hideCompletedBeforeDate !== undefined && hideCompletedBeforeDate !== null)
            url_ += "HideCompletedBeforeDate=" + encodeURIComponent(hideCompletedBeforeDate ? "" + hideCompletedBeforeDate.toISOString() : "") + "&";
        if (orderStatus !== undefined && orderStatus !== null)
            orderStatus && orderStatus.forEach(item => { url_ += "OrderStatus=" + encodeURIComponent("" + item) + "&"; });
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPickerOrders(_response);
        });
    }

    protected processGetPickerOrders(response: Response): Promise<PagedResultsOfOrderListOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultsOfOrderListOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultsOfOrderListOutput>(null as any);
    }

    getNextOrderOfPicker(id: number, orderId: number | undefined, take: number | undefined): Promise<PickerOrderViewModel[]> {
        let url_ = this.baseUrl + "/api/Pickers/{id}/orders/next?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNextOrderOfPicker(_response);
        });
    }

    protected processGetNextOrderOfPicker(response: Response): Promise<PickerOrderViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PickerOrderViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PickerOrderViewModel[]>(null as any);
    }

    getNextOrderLineItemsOfPicker(take: number | undefined): Promise<AmsOrderLineItemModel[]> {
        let url_ = this.baseUrl + "/api/Pickers/orders/lineItems/next?";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNextOrderLineItemsOfPicker(_response);
        });
    }

    protected processGetNextOrderLineItemsOfPicker(response: Response): Promise<AmsOrderLineItemModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AmsOrderLineItemModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AmsOrderLineItemModel[]>(null as any);
    }

    skuScanRequest(partNo: string | undefined): Promise<SkuScanReportViewModel> {
        let url_ = this.baseUrl + "/api/Pickers/skuScanRequest?";
        if (partNo === null)
            throw new Error("The parameter 'partNo' cannot be null.");
        else if (partNo !== undefined)
            url_ += "partNo=" + encodeURIComponent("" + partNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSkuScanRequest(_response);
        });
    }

    protected processSkuScanRequest(response: Response): Promise<SkuScanReportViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkuScanReportViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SkuScanReportViewModel>(null as any);
    }

    getInventoryOfLineItem(partNo: string, loc: string | null | undefined): Promise<AmsLaneOnHandViewModel[]> {
        let url_ = this.baseUrl + "/api/Pickers/inventory/{partNo}?";
        if (partNo === undefined || partNo === null)
            throw new Error("The parameter 'partNo' must be defined.");
        url_ = url_.replace("{partNo}", encodeURIComponent("" + partNo));
        if (loc !== undefined && loc !== null)
            url_ += "loc=" + encodeURIComponent("" + loc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventoryOfLineItem(_response);
        });
    }

    protected processGetInventoryOfLineItem(response: Response): Promise<AmsLaneOnHandViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AmsLaneOnHandViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AmsLaneOnHandViewModel[]>(null as any);
    }

    getPrintLocations(orderId: number | undefined, printerType: WarehousePrinterType | undefined): Promise<PrinterLocationDTO[]> {
        let url_ = this.baseUrl + "/api/Pickers/getPrintLocations?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (printerType === null)
            throw new Error("The parameter 'printerType' cannot be null.");
        else if (printerType !== undefined)
            url_ += "printerType=" + encodeURIComponent("" + printerType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrintLocations(_response);
        });
    }

    protected processGetPrintLocations(response: Response): Promise<PrinterLocationDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrinterLocationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrinterLocationDTO[]>(null as any);
    }

    queuePalletTagPrintJob(orderId: number | undefined, locationCode: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Pickers/queuePalletTagPrintJob?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (locationCode === null)
            throw new Error("The parameter 'locationCode' cannot be null.");
        else if (locationCode !== undefined)
            url_ += "locationCode=" + encodeURIComponent("" + locationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueuePalletTagPrintJob(_response);
        });
    }

    protected processQueuePalletTagPrintJob(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    queuePickTicketPrintJob(orderId: number | undefined, locationCode: string | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Pickers/queuePickTicketPrintJob?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (locationCode === null)
            throw new Error("The parameter 'locationCode' cannot be null.");
        else if (locationCode !== undefined)
            url_ += "locationCode=" + encodeURIComponent("" + locationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueuePickTicketPrintJob(_response);
        });
    }

    protected processQueuePickTicketPrintJob(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PrinterClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getPalletTagReportPdf(orderId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Printer/PalletTagReport/pdf?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPalletTagReportPdf(_response);
        });
    }

    protected processGetPalletTagReportPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPalletTagReportXps(orderId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Printer/PalletTagReport/xps?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPalletTagReportXps(_response);
        });
    }

    protected processGetPalletTagReportXps(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPickTicketReportPdf(orderId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Printer/PickTicketReport/pdf?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPickTicketReportPdf(_response);
        });
    }

    protected processGetPickTicketReportPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPickTicketReportXps(orderId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Printer/PickTicketReport/xps?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPickTicketReportXps(_response);
        });
    }

    protected processGetPickTicketReportXps(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ReportsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getPalletTagReportPdf(orderId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/PalletTagReport/pdf?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPalletTagReportPdf(_response);
        });
    }

    protected processGetPalletTagReportPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPalletTagReportXps(orderId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/PalletTagReport/xps?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPalletTagReportXps(_response);
        });
    }

    protected processGetPalletTagReportXps(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPickTicketReportPdf(orderId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/PickTicketReport/pdf?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPickTicketReportPdf(_response);
        });
    }

    protected processGetPickTicketReportPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPickTicketReportXps(orderId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/PickTicketReport/xps?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPickTicketReportXps(_response);
        });
    }

    protected processGetPickTicketReportXps(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    sendFile(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/SendFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendFile(_response);
        });
    }

    protected processSendFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    downloadFile(fileName: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/DownloadFile/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadFile(_response);
        });
    }

    protected processDownloadFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getCustomerContactsReport(): Promise<FileStream> {
        let url_ = this.baseUrl + "/api/Reports/GetCustomerContactsReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerContactsReport(_response);
        });
    }

    protected processGetCustomerContactsReport(response: Response): Promise<FileStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStream.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStream>(null as any);
    }

    getDeliveriesByDestinationReport(i_oSearchOptions: SearchOptions): Promise<FileStream> {
        let url_ = this.baseUrl + "/api/Reports/GetDeliveriesByDestinationReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeliveriesByDestinationReport(_response);
        });
    }

    protected processGetDeliveriesByDestinationReport(response: Response): Promise<FileStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStream.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStream>(null as any);
    }

    getDeliveriesByDestinationSummaryReport(i_oSearchOptions: SearchOptions): Promise<FileStream> {
        let url_ = this.baseUrl + "/api/Reports/GetDeliveriesByDestinationSummaryReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeliveriesByDestinationSummaryReport(_response);
        });
    }

    protected processGetDeliveriesByDestinationSummaryReport(response: Response): Promise<FileStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStream.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStream>(null as any);
    }

    getOrderPickedDatesReport(searchOptions: SearchOptions): Promise<FileStream> {
        let url_ = this.baseUrl + "/api/Reports/GetOrderPickedDatesReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderPickedDatesReport(_response);
        });
    }

    protected processGetOrderPickedDatesReport(response: Response): Promise<FileStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStream.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStream>(null as any);
    }

    getLoadReport(searchOptions: SearchOptions): Promise<FileStream> {
        let url_ = this.baseUrl + "/api/Reports/GetLoadReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoadReport(_response);
        });
    }

    protected processGetLoadReport(response: Response): Promise<FileStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStream.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStream>(null as any);
    }

    getPickupsByWarehouseReport(searchOptions: SearchOptions): Promise<FileStream> {
        let url_ = this.baseUrl + "/api/Reports/GetPickupsByWarehouseReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPickupsByWarehouseReport(_response);
        });
    }

    protected processGetPickupsByWarehouseReport(response: Response): Promise<FileStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStream.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStream>(null as any);
    }

    getOrderAvailabilityReport(reportInputDTO: OrderAvailabilityReportInputDTO): Promise<FileStream> {
        let url_ = this.baseUrl + "/api/Reports/GetOrderAvailabilityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportInputDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderAvailabilityReport(_response);
        });
    }

    protected processGetOrderAvailabilityReport(response: Response): Promise<FileStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStream.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStream>(null as any);
    }

    getOrderStatusXlsxReport(reportInputDTO: OrderStatusReportInputDTO): Promise<FileStream> {
        let url_ = this.baseUrl + "/api/Reports/GetOrderStatusXlsxReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportInputDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderStatusXlsxReport(_response);
        });
    }

    protected processGetOrderStatusXlsxReport(response: Response): Promise<FileStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStream.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStream>(null as any);
    }

    getCdtfaXlsxReport(reportInputDTO: CdtfaReportInputDTO): Promise<FileStream> {
        let url_ = this.baseUrl + "/api/Reports/GetCdtfaXlsxReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportInputDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCdtfaXlsxReport(_response);
        });
    }

    protected processGetCdtfaXlsxReport(response: Response): Promise<FileStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStream.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStream>(null as any);
    }

    getCustomerSubscriptions(orderCustomerId: number): Promise<ReportSubscriptionModel[]> {
        let url_ = this.baseUrl + "/api/Reports/GetCustomerSubscriptions/{orderCustomerId}";
        if (orderCustomerId === undefined || orderCustomerId === null)
            throw new Error("The parameter 'orderCustomerId' must be defined.");
        url_ = url_.replace("{orderCustomerId}", encodeURIComponent("" + orderCustomerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerSubscriptions(_response);
        });
    }

    protected processGetCustomerSubscriptions(response: Response): Promise<ReportSubscriptionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportSubscriptionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportSubscriptionModel[]>(null as any);
    }

    putCustomerSubscriptions(orderCustomerId: number, subscriptions: ReportSubscriptionModel[]): Promise<ReportSubscriptionModel[]> {
        let url_ = this.baseUrl + "/api/Reports/PutCustomerSubscriptions/{orderCustomerId}";
        if (orderCustomerId === undefined || orderCustomerId === null)
            throw new Error("The parameter 'orderCustomerId' must be defined.");
        url_ = url_.replace("{orderCustomerId}", encodeURIComponent("" + orderCustomerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptions);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutCustomerSubscriptions(_response);
        });
    }

    protected processPutCustomerSubscriptions(response: Response): Promise<ReportSubscriptionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportSubscriptionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportSubscriptionModel[]>(null as any);
    }

    sendReport(reportSubscriptionId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Reports/SendReport/{reportSubscriptionId}";
        if (reportSubscriptionId === undefined || reportSubscriptionId === null)
            throw new Error("The parameter 'reportSubscriptionId' must be defined.");
        url_ = url_.replace("{reportSubscriptionId}", encodeURIComponent("" + reportSubscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendReport(_response);
        });
    }

    protected processSendReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLoadSummaryReport(i_oSearchOptions: SearchOptions): Promise<FileStream> {
        let url_ = this.baseUrl + "/api/Reports/GetLoadSummaryReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoadSummaryReport(_response);
        });
    }

    protected processGetLoadSummaryReport(response: Response): Promise<FileStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStream.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStream>(null as any);
    }

    getReceivingSummaryReport(i_oSearchOptions: SearchOptions): Promise<FileStream> {
        let url_ = this.baseUrl + "/api/Reports/GetReceivingSummaryReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReceivingSummaryReport(_response);
        });
    }

    protected processGetReceivingSummaryReport(response: Response): Promise<FileStream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStream.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStream>(null as any);
    }
}

export class UsersClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    login(request: UserLoginInput): Promise<AuthResultViewModel> {
        let url_ = this.baseUrl + "/api/Users/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<AuthResultViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResultViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResultViewModel>(null as any);
    }

    logout(): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCurrentInternalUser(): Promise<ApplicationUserViewModel> {
        let url_ = this.baseUrl + "/api/Users/Internal/Users/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentInternalUser(_response);
        });
    }

    protected processGetCurrentInternalUser(response: Response): Promise<ApplicationUserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUserViewModel>(null as any);
    }
}

export class AuditEventsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<AuditEventModel[]> {
        let url_ = this.baseUrl + "/api/AuditEvents/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<AuditEventModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditEventModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditEventModel[]>(null as any);
    }

    getItemById(id: number): Promise<AuditEventModel> {
        let url_ = this.baseUrl + "/api/AuditEvents/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<AuditEventModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditEventModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditEventModel>(null as any);
    }
}

export class CacheClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getEnums(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Session/GetEnums";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEnums(_response);
        });
    }

    protected processGetEnums(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getEnumsAdmin(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Session/GetEnumsAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEnumsAdmin(_response);
        });
    }

    protected processGetEnumsAdmin(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class CarriersClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getResultItems(i_oSearchOptions: SearchOptions): Promise<ListResultItem[]> {
        let url_ = this.baseUrl + "/api/Carriers/GetResultItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResultItems(_response);
        });
    }

    protected processGetResultItems(response: Response): Promise<ListResultItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListResultItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResultItem[]>(null as any);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<CarrierModel[]> {
        let url_ = this.baseUrl + "/api/Carriers/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<CarrierModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarrierModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarrierModel[]>(null as any);
    }

    getItemById(id: number): Promise<CarrierModel> {
        let url_ = this.baseUrl + "/api/Carriers/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<CarrierModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarrierModel>(null as any);
    }

    getItemNew(): Promise<CarrierModel> {
        let url_ = this.baseUrl + "/api/Carriers/GetItemNew";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemNew(_response);
        });
    }

    protected processGetItemNew(response: Response): Promise<CarrierModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarrierModel>(null as any);
    }

    post(i_oValue: CarrierModel): Promise<CarrierModel> {
        let url_ = this.baseUrl + "/api/Carriers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<CarrierModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarrierModel>(null as any);
    }

    put(id: number, i_oValue: CarrierModel): Promise<CarrierModel> {
        let url_ = this.baseUrl + "/api/Carriers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<CarrierModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarrierModel>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Carriers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteBulk(i_iIdArray: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Carriers/DeleteBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_iIdArray);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBulk(_response);
        });
    }

    protected processDeleteBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setCarrierEnabled(id: number, isEnabled: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Carriers/SetCarrierEnabled/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isEnabled === null)
            throw new Error("The parameter 'isEnabled' cannot be null.");
        else if (isEnabled !== undefined)
            url_ += "isEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCarrierEnabled(_response);
        });
    }

    protected processSetCarrierEnabled(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContactsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getCarrierContacts(carrierId: number, shouldSortAscending: boolean | null | undefined): Promise<ContactModel[]> {
        let url_ = this.baseUrl + "/api/Contacts/CarrierContacts/{carrierId}?";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined.");
        url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
        if (shouldSortAscending !== undefined && shouldSortAscending !== null)
            url_ += "shouldSortAscending=" + encodeURIComponent("" + shouldSortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCarrierContacts(_response);
        });
    }

    protected processGetCarrierContacts(response: Response): Promise<ContactModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactModel[]>(null as any);
    }

    postCarrierContacts(carrierId: number, newContacts: ContactModel[]): Promise<ContactModel[]> {
        let url_ = this.baseUrl + "/api/Contacts/CarrierContacts/{carrierId}";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined.");
        url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newContacts);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostCarrierContacts(_response);
        });
    }

    protected processPostCarrierContacts(response: Response): Promise<ContactModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactModel[]>(null as any);
    }

    getLocationContacts(locationId: number, shouldSortAscending: boolean | null | undefined): Promise<ContactModel[]> {
        let url_ = this.baseUrl + "/api/Contacts/LocationContacts/{locationId}?";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        if (shouldSortAscending !== undefined && shouldSortAscending !== null)
            url_ += "shouldSortAscending=" + encodeURIComponent("" + shouldSortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocationContacts(_response);
        });
    }

    protected processGetLocationContacts(response: Response): Promise<ContactModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactModel[]>(null as any);
    }

    postLocationContacts(locationId: number, newContacts: ContactModel[]): Promise<ContactModel[]> {
        let url_ = this.baseUrl + "/api/Contacts/LocationContacts/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newContacts);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostLocationContacts(_response);
        });
    }

    protected processPostLocationContacts(response: Response): Promise<ContactModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactModel[]>(null as any);
    }

    getCustomerContacts(customerId: number, shouldSortAscending: boolean | null | undefined): Promise<ContactModel[]> {
        let url_ = this.baseUrl + "/api/Contacts/CustomerContacts/{customerId}?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (shouldSortAscending !== undefined && shouldSortAscending !== null)
            url_ += "shouldSortAscending=" + encodeURIComponent("" + shouldSortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerContacts(_response);
        });
    }

    protected processGetCustomerContacts(response: Response): Promise<ContactModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactModel[]>(null as any);
    }

    postCustomerContacts(customerId: number, newContacts: ContactModel[]): Promise<ContactModel[]> {
        let url_ = this.baseUrl + "/api/Contacts/CustomerContacts/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newContacts);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostCustomerContacts(_response);
        });
    }

    protected processPostCustomerContacts(response: Response): Promise<ContactModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactModel[]>(null as any);
    }
}

export class ExternalSyncClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getSyncIssuesBadge(): Promise<ExternalSyncBadgeDTO> {
        let url_ = this.baseUrl + "/api/ExternalSync/GetSyncIssuesBadge";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSyncIssuesBadge(_response);
        });
    }

    protected processGetSyncIssuesBadge(response: Response): Promise<ExternalSyncBadgeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSyncBadgeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalSyncBadgeDTO>(null as any);
    }

    getUnreviewedCustomers(i_oSearchOptions: SearchOptions): Promise<OrderCustomerModel[]> {
        let url_ = this.baseUrl + "/api/ExternalSync/GetUnreviewedCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnreviewedCustomers(_response);
        });
    }

    protected processGetUnreviewedCustomers(response: Response): Promise<OrderCustomerModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderCustomerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderCustomerModel[]>(null as any);
    }

    getUnreviewedLocations(i_oSearchOptions: SearchOptions): Promise<LocationModel[]> {
        let url_ = this.baseUrl + "/api/ExternalSync/GetUnreviewedLocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnreviewedLocations(_response);
        });
    }

    protected processGetUnreviewedLocations(response: Response): Promise<LocationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationModel[]>(null as any);
    }

    markCustomerReviewed(orderCustomerId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/ExternalSync/MarkCustomerReviewed/{orderCustomerId}";
        if (orderCustomerId === undefined || orderCustomerId === null)
            throw new Error("The parameter 'orderCustomerId' must be defined.");
        url_ = url_.replace("{orderCustomerId}", encodeURIComponent("" + orderCustomerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkCustomerReviewed(_response);
        });
    }

    protected processMarkCustomerReviewed(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    markLocationReviewed(locationId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/ExternalSync/MarkLocationReviewed/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkLocationReviewed(_response);
        });
    }

    protected processMarkLocationReviewed(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSyncEvents(i_oSearchOptions: SearchOptions): Promise<SyncEventModel[]> {
        let url_ = this.baseUrl + "/api/ExternalSync/GetSyncEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSyncEvents(_response);
        });
    }

    protected processGetSyncEvents(response: Response): Promise<SyncEventModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SyncEventModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncEventModel[]>(null as any);
    }
}

export class FilesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getOrderFiles(orderId: number, shouldSortAscending: boolean | null | undefined): Promise<FileModel[]> {
        let url_ = this.baseUrl + "/api/Files/OrderFiles/{orderId}?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (shouldSortAscending !== undefined && shouldSortAscending !== null)
            url_ += "shouldSortAscending=" + encodeURIComponent("" + shouldSortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderFiles(_response);
        });
    }

    protected processGetOrderFiles(response: Response): Promise<FileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel[]>(null as any);
    }

    postOrderFile(orderId: number, contentType: string | undefined, contentDisposition: string | undefined, headers: Headers[] | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined, nameOfFile: string | null | undefined, description: string | undefined): Promise<FileModel> {
        let url_ = this.baseUrl + "/api/Files/OrderFiles/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());
        if (nameOfFile !== null && nameOfFile !== undefined)
            content_.append("nameOfFile", nameOfFile.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostOrderFile(_response);
        });
    }

    protected processPostOrderFile(response: Response): Promise<FileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel>(null as any);
    }

    getOrderFileCount(orderId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Files/OrderFiles/{orderId}/GetOrderFileCount";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderFileCount(_response);
        });
    }

    protected processGetOrderFileCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    downloadOrderFile(orderId: number, fileId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Files/OrderFiles/{orderId}/{fileId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadOrderFile(_response);
        });
    }

    protected processDownloadOrderFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    putOrderFile(orderId: number, fileId: number, newFile: FileModel): Promise<FileModel> {
        let url_ = this.baseUrl + "/api/Files/OrderFiles/{orderId}/{fileId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newFile);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutOrderFile(_response);
        });
    }

    protected processPutOrderFile(response: Response): Promise<FileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel>(null as any);
    }

    deleteOrderFile(orderId: number, fileId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Files/OrderFiles/{orderId}/{fileId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteOrderFile(_response);
        });
    }

    protected processDeleteOrderFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLoadFiles(loadId: number, shouldSortAscending: boolean | null | undefined): Promise<FileModel[]> {
        let url_ = this.baseUrl + "/api/Files/LoadFiles/{loadId}?";
        if (loadId === undefined || loadId === null)
            throw new Error("The parameter 'loadId' must be defined.");
        url_ = url_.replace("{loadId}", encodeURIComponent("" + loadId));
        if (shouldSortAscending !== undefined && shouldSortAscending !== null)
            url_ += "shouldSortAscending=" + encodeURIComponent("" + shouldSortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoadFiles(_response);
        });
    }

    protected processGetLoadFiles(response: Response): Promise<FileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel[]>(null as any);
    }

    postLoadFile(loadId: number, contentType: string | undefined, contentDisposition: string | undefined, headers: Headers2[] | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined, nameOfFile: string | null | undefined, description: string | undefined): Promise<FileModel> {
        let url_ = this.baseUrl + "/api/Files/LoadFiles/{loadId}";
        if (loadId === undefined || loadId === null)
            throw new Error("The parameter 'loadId' must be defined.");
        url_ = url_.replace("{loadId}", encodeURIComponent("" + loadId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());
        if (nameOfFile !== null && nameOfFile !== undefined)
            content_.append("nameOfFile", nameOfFile.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostLoadFile(_response);
        });
    }

    protected processPostLoadFile(response: Response): Promise<FileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel>(null as any);
    }

    getLoadFileCount(loadId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Files/LoadFiles/{loadId}/GetLoadFileCount";
        if (loadId === undefined || loadId === null)
            throw new Error("The parameter 'loadId' must be defined.");
        url_ = url_.replace("{loadId}", encodeURIComponent("" + loadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoadFileCount(_response);
        });
    }

    protected processGetLoadFileCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    downloadLoadFile(loadId: number, fileId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Files/LoadFiles/{loadId}/{fileId}";
        if (loadId === undefined || loadId === null)
            throw new Error("The parameter 'loadId' must be defined.");
        url_ = url_.replace("{loadId}", encodeURIComponent("" + loadId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadLoadFile(_response);
        });
    }

    protected processDownloadLoadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    putLoadFile(loadId: number, fileId: number, newFile: FileModel): Promise<FileModel> {
        let url_ = this.baseUrl + "/api/Files/LoadFiles/{loadId}/{fileId}";
        if (loadId === undefined || loadId === null)
            throw new Error("The parameter 'loadId' must be defined.");
        url_ = url_.replace("{loadId}", encodeURIComponent("" + loadId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newFile);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutLoadFile(_response);
        });
    }

    protected processPutLoadFile(response: Response): Promise<FileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel>(null as any);
    }

    deleteLoadFile(loadId: number, fileId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Files/LoadFiles/{loadId}/{fileId}";
        if (loadId === undefined || loadId === null)
            throw new Error("The parameter 'loadId' must be defined.");
        url_ = url_.replace("{loadId}", encodeURIComponent("" + loadId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLoadFile(_response);
        });
    }

    protected processDeleteLoadFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCarrierFiles(carrierId: number, shouldSortAscending: boolean | null | undefined): Promise<FileModel[]> {
        let url_ = this.baseUrl + "/api/Files/CarrierFiles/{carrierId}?";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined.");
        url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
        if (shouldSortAscending !== undefined && shouldSortAscending !== null)
            url_ += "shouldSortAscending=" + encodeURIComponent("" + shouldSortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCarrierFiles(_response);
        });
    }

    protected processGetCarrierFiles(response: Response): Promise<FileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel[]>(null as any);
    }

    postCarrierFile(carrierId: number, contentType: string | undefined, contentDisposition: string | undefined, headers: Headers3[] | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined, nameOfFile: string | null | undefined, description: string | undefined, documentType: string | null | undefined): Promise<FileModel> {
        let url_ = this.baseUrl + "/api/Files/CarrierFiles/{carrierId}";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined.");
        url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());
        if (nameOfFile !== null && nameOfFile !== undefined)
            content_.append("nameOfFile", nameOfFile.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());
        if (documentType !== null && documentType !== undefined)
            content_.append("documentType", documentType.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostCarrierFile(_response);
        });
    }

    protected processPostCarrierFile(response: Response): Promise<FileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel>(null as any);
    }

    getCarrierFileCount(carrierId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Files/CarrierFiles/{carrierId}/GetCarrierFileCount";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined.");
        url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCarrierFileCount(_response);
        });
    }

    protected processGetCarrierFileCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    downloadCarrierFile(carrierId: number, fileId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Files/CarrierFiles/{carrierId}/{fileId}";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined.");
        url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCarrierFile(_response);
        });
    }

    protected processDownloadCarrierFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    putCarrierFile(carrierId: number, fileId: number, newFile: FileModel): Promise<FileModel> {
        let url_ = this.baseUrl + "/api/Files/CarrierFiles/{carrierId}/{fileId}";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined.");
        url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newFile);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutCarrierFile(_response);
        });
    }

    protected processPutCarrierFile(response: Response): Promise<FileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel>(null as any);
    }

    deleteCarrierFile(carrierId: number, fileId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Files/CarrierFiles/{carrierId}/{fileId}";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined.");
        url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCarrierFile(_response);
        });
    }

    protected processDeleteCarrierFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCustomerFiles(customerId: number, shouldSortAscending: boolean | null | undefined): Promise<FileModel[]> {
        let url_ = this.baseUrl + "/api/Files/CustomerFiles/{customerId}?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (shouldSortAscending !== undefined && shouldSortAscending !== null)
            url_ += "shouldSortAscending=" + encodeURIComponent("" + shouldSortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerFiles(_response);
        });
    }

    protected processGetCustomerFiles(response: Response): Promise<FileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel[]>(null as any);
    }

    postCustomerFile(customerId: number, contentType: string | undefined, contentDisposition: string | undefined, headers: Headers4[] | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined, nameOfFile: string | null | undefined, description: string | undefined): Promise<FileModel> {
        let url_ = this.baseUrl + "/api/Files/CustomerFiles/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());
        if (nameOfFile !== null && nameOfFile !== undefined)
            content_.append("nameOfFile", nameOfFile.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostCustomerFile(_response);
        });
    }

    protected processPostCustomerFile(response: Response): Promise<FileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel>(null as any);
    }

    getCustomerFileCount(customerId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Files/CustomerFiles/{customerId}/GetCustomerFileCount";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerFileCount(_response);
        });
    }

    protected processGetCustomerFileCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    downloadCustomerFile(customerId: number, fileId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Files/CustomerFiles/{customerId}/{fileId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCustomerFile(_response);
        });
    }

    protected processDownloadCustomerFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    putCustomerFile(customerId: number, fileId: number, newFile: FileModel): Promise<FileModel> {
        let url_ = this.baseUrl + "/api/Files/CustomerFiles/{customerId}/{fileId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newFile);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutCustomerFile(_response);
        });
    }

    protected processPutCustomerFile(response: Response): Promise<FileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel>(null as any);
    }

    deleteCustomerFile(customerId: number, fileId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Files/CustomerFiles/{customerId}/{fileId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCustomerFile(_response);
        });
    }

    protected processDeleteCustomerFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class IntegrationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    rndcTransportOrderSync(i_oMessage: TransportationOrder): Promise<void> {
        let url_ = this.baseUrl + "/api/Integrations/RndcTransportOrderSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oMessage);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRndcTransportOrderSync(_response);
        });
    }

    protected processRndcTransportOrderSync(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LoadsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<LoadModel[]> {
        let url_ = this.baseUrl + "/api/Loads/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<LoadModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LoadModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoadModel[]>(null as any);
    }

    getItemById(id: number): Promise<LoadModel> {
        let url_ = this.baseUrl + "/api/Loads/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<LoadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoadModel>(null as any);
    }

    getItemNew(): Promise<LoadModel> {
        let url_ = this.baseUrl + "/api/Loads/GetItemNew";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemNew(_response);
        });
    }

    protected processGetItemNew(response: Response): Promise<LoadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoadModel>(null as any);
    }

    post(i_oValue: LoadModel): Promise<LoadModel> {
        let url_ = this.baseUrl + "/api/Loads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<LoadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoadModel>(null as any);
    }

    put(id: number, i_oValue: LoadModel): Promise<LoadModel> {
        let url_ = this.baseUrl + "/api/Loads/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<LoadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoadModel>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Loads/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    putCarrierStopNotes(i_oValue: LoadCarrierNoteUpdates): Promise<LoadCarrierNoteUpdates> {
        let url_ = this.baseUrl + "/api/Loads/PutCarrierStopNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutCarrierStopNotes(_response);
        });
    }

    protected processPutCarrierStopNotes(response: Response): Promise<LoadCarrierNoteUpdates> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadCarrierNoteUpdates.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoadCarrierNoteUpdates>(null as any);
    }

    putCarrierLoadNote(i_oValue: LoadCarrierNoteUpdate): Promise<LoadCarrierNoteUpdate> {
        let url_ = this.baseUrl + "/api/Loads/PutCarrierLoadNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutCarrierLoadNote(_response);
        });
    }

    protected processPutCarrierLoadNote(response: Response): Promise<LoadCarrierNoteUpdate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadCarrierNoteUpdate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoadCarrierNoteUpdate>(null as any);
    }

    setOrderingOfLoadStops(i_oValue: LoadModel): Promise<LoadModel> {
        let url_ = this.baseUrl + "/api/Loads/SetOrderingOfLoadStops";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetOrderingOfLoadStops(_response);
        });
    }

    protected processSetOrderingOfLoadStops(response: Response): Promise<LoadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoadModel>(null as any);
    }

    addOrderToLoad(loadId: number | undefined, orderId: number | undefined, locationId: number | undefined, shouldAddGroup: boolean | undefined, deliveryIsConsolidation: boolean | undefined): Promise<LoadModel> {
        let url_ = this.baseUrl + "/api/Loads/AddOrderToLoad?";
        if (loadId === null)
            throw new Error("The parameter 'loadId' cannot be null.");
        else if (loadId !== undefined)
            url_ += "loadId=" + encodeURIComponent("" + loadId) + "&";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (shouldAddGroup === null)
            throw new Error("The parameter 'shouldAddGroup' cannot be null.");
        else if (shouldAddGroup !== undefined)
            url_ += "shouldAddGroup=" + encodeURIComponent("" + shouldAddGroup) + "&";
        if (deliveryIsConsolidation === null)
            throw new Error("The parameter 'deliveryIsConsolidation' cannot be null.");
        else if (deliveryIsConsolidation !== undefined)
            url_ += "deliveryIsConsolidation=" + encodeURIComponent("" + deliveryIsConsolidation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddOrderToLoad(_response);
        });
    }

    protected processAddOrderToLoad(response: Response): Promise<LoadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoadModel>(null as any);
    }

    bulkRemoveOrdersFromLoad(i_oRemoveUpdate: LoadRemoveOrdersUpdate): Promise<LoadModel> {
        let url_ = this.baseUrl + "/api/Loads/BulkRemoveOrdersFromLoad";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oRemoveUpdate);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemoveOrdersFromLoad(_response);
        });
    }

    protected processBulkRemoveOrdersFromLoad(response: Response): Promise<LoadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoadModel>(null as any);
    }

    deleteBulk(i_iIdArray: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Loads/DeleteBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_iIdArray);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBulk(_response);
        });
    }

    protected processDeleteBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLoadChangeLogs(id: number, i_oSearchOptions: SearchOptions): Promise<LoadChangelogModel[]> {
        let url_ = this.baseUrl + "/api/Loads/GetLoadChangeLogs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoadChangeLogs(_response);
        });
    }

    protected processGetLoadChangeLogs(response: Response): Promise<LoadChangelogModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LoadChangelogModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoadChangelogModel[]>(null as any);
    }

    cancelLoads(i_iIdArray: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Loads/CancelLoads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_iIdArray);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelLoads(_response);
        });
    }

    protected processCancelLoads(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addOrderToLoadPreflight(request: AddOrderToLoadPreflightRequest): Promise<AddOrderToLoadPreflightResponse> {
        let url_ = this.baseUrl + "/api/Loads/AddOrderToLoadPreflight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddOrderToLoadPreflight(_response);
        });
    }

    protected processAddOrderToLoadPreflight(response: Response): Promise<AddOrderToLoadPreflightResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddOrderToLoadPreflightResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddOrderToLoadPreflightResponse>(null as any);
    }

    addOrderToLoadConfirm(request: AddOrderToLoadConfirmRequest): Promise<AddOrderToLoadConfirmResponse> {
        let url_ = this.baseUrl + "/api/Loads/AddOrderToLoadConfirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddOrderToLoadConfirm(_response);
        });
    }

    protected processAddOrderToLoadConfirm(response: Response): Promise<AddOrderToLoadConfirmResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddOrderToLoadConfirmResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddOrderToLoadConfirmResponse>(null as any);
    }
}

export class LocationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<LocationModel[]> {
        let url_ = this.baseUrl + "/api/Locations/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<LocationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationModel[]>(null as any);
    }

    getItemById(id: number): Promise<LocationModel> {
        let url_ = this.baseUrl + "/api/Locations/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<LocationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationModel>(null as any);
    }

    getItemNew(): Promise<LocationModel> {
        let url_ = this.baseUrl + "/api/Locations/GetItemNew";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemNew(_response);
        });
    }

    protected processGetItemNew(response: Response): Promise<LocationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationModel>(null as any);
    }

    post(i_oValue: LocationModel): Promise<LocationModel> {
        let url_ = this.baseUrl + "/api/Locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<LocationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationModel>(null as any);
    }

    put(id: number, i_oValue: LocationModel): Promise<LocationModel> {
        let url_ = this.baseUrl + "/api/Locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<LocationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationModel>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteBulk(ids: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Locations/DeleteBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBulk(_response);
        });
    }

    protected processDeleteBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRecentlyUsedLocationsByCustomerId(customerId: number, count: number | null | undefined): Promise<LocationModel[]> {
        let url_ = this.baseUrl + "/api/Locations/GetRecentlyUsedLocationsByCustomerId/{customerId}?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecentlyUsedLocationsByCustomerId(_response);
        });
    }

    protected processGetRecentlyUsedLocationsByCustomerId(response: Response): Promise<LocationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationModel[]>(null as any);
    }

    getLocationMergeInfo(locationIds: number[]): Promise<LocationMergeInfoDTO> {
        let url_ = this.baseUrl + "/api/Locations/GetLocationMergeInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocationMergeInfo(_response);
        });
    }

    protected processGetLocationMergeInfo(response: Response): Promise<LocationMergeInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationMergeInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationMergeInfoDTO>(null as any);
    }

    mergeLocations(primaryLocationId: number | undefined, locationIdsToMerge: number[]): Promise<LocationModel> {
        let url_ = this.baseUrl + "/api/Locations/MergeLocations?";
        if (primaryLocationId === null)
            throw new Error("The parameter 'primaryLocationId' cannot be null.");
        else if (primaryLocationId !== undefined)
            url_ += "primaryLocationId=" + encodeURIComponent("" + primaryLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationIdsToMerge);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeLocations(_response);
        });
    }

    protected processMergeLocations(response: Response): Promise<LocationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationModel>(null as any);
    }
}

export class NotesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getOrderNotes(orderId: number, shouldSortAscending: boolean | null | undefined): Promise<NoteModel[]> {
        let url_ = this.baseUrl + "/api/Notes/OrderNotes/{orderId}?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (shouldSortAscending !== undefined && shouldSortAscending !== null)
            url_ += "shouldSortAscending=" + encodeURIComponent("" + shouldSortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderNotes(_response);
        });
    }

    protected processGetOrderNotes(response: Response): Promise<NoteModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NoteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel[]>(null as any);
    }

    postOrderNote(orderId: number, newNote: NoteModel): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/Notes/OrderNotes/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostOrderNote(_response);
        });
    }

    protected processPostOrderNote(response: Response): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel>(null as any);
    }

    getOrderNoteCount(orderId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Notes/OrderNotes/{orderId}/GetOrderNoteCount";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderNoteCount(_response);
        });
    }

    protected processGetOrderNoteCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    putOrderNote(orderId: number, noteId: number, newNote: NoteModel): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/Notes/OrderNotes/{orderId}/{noteId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutOrderNote(_response);
        });
    }

    protected processPutOrderNote(response: Response): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel>(null as any);
    }

    deleteOrderNote(orderId: number, noteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Notes/OrderNotes/{orderId}/{noteId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteOrderNote(_response);
        });
    }

    protected processDeleteOrderNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCustomerNotes(customerId: number, shouldSortAscending: boolean | null | undefined): Promise<NoteModel[]> {
        let url_ = this.baseUrl + "/api/Notes/Customer/{customerId}?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (shouldSortAscending !== undefined && shouldSortAscending !== null)
            url_ += "shouldSortAscending=" + encodeURIComponent("" + shouldSortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerNotes(_response);
        });
    }

    protected processGetCustomerNotes(response: Response): Promise<NoteModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NoteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel[]>(null as any);
    }

    getCustomerNoteCount(customerId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Notes/CustomerNotes/{customerId}/GetCustomerNoteCount";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerNoteCount(_response);
        });
    }

    protected processGetCustomerNoteCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    postCustomerNote(customerId: number, newNote: NoteModel): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/Notes/CustomerNotes/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostCustomerNote(_response);
        });
    }

    protected processPostCustomerNote(response: Response): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel>(null as any);
    }

    putCustomerNote(customerId: number, noteId: number, newNote: NoteModel): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/Notes/CustomerNotes/{customerId}/{noteId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutCustomerNote(_response);
        });
    }

    protected processPutCustomerNote(response: Response): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel>(null as any);
    }

    deleteCustomerNote(customerId: number, noteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Notes/CustomerNotes/{customerId}/{noteId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCustomerNote(_response);
        });
    }

    protected processDeleteCustomerNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLocationNotes(locationId: number, shouldSortAscending: boolean | null | undefined): Promise<NoteModel[]> {
        let url_ = this.baseUrl + "/api/Notes/LocationNotes/{locationId}?";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        if (shouldSortAscending !== undefined && shouldSortAscending !== null)
            url_ += "shouldSortAscending=" + encodeURIComponent("" + shouldSortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocationNotes(_response);
        });
    }

    protected processGetLocationNotes(response: Response): Promise<NoteModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NoteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel[]>(null as any);
    }

    getLocationNoteCount(locationId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Notes/LocationNotes/{locationId}/GetLocationNoteCount";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocationNoteCount(_response);
        });
    }

    protected processGetLocationNoteCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    postLocationNote(locationId: number, newNote: NoteModel): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/Notes/LocatinNotes/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostLocationNote(_response);
        });
    }

    protected processPostLocationNote(response: Response): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel>(null as any);
    }

    putLocationNote(locationId: number, noteId: number, newNote: NoteModel): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/Notes/LocationNotes/{locationId}/{noteId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutLocationNote(_response);
        });
    }

    protected processPutLocationNote(response: Response): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel>(null as any);
    }

    deleteLocationNote(locationId: number, noteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Notes/LocationNotes/{locationId}/{noteId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLocationNote(_response);
        });
    }

    protected processDeleteLocationNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLoadNotes(loadId: number, shouldSortAscending: boolean | null | undefined): Promise<NoteModel[]> {
        let url_ = this.baseUrl + "/api/Notes/LoadNotes/{loadId}?";
        if (loadId === undefined || loadId === null)
            throw new Error("The parameter 'loadId' must be defined.");
        url_ = url_.replace("{loadId}", encodeURIComponent("" + loadId));
        if (shouldSortAscending !== undefined && shouldSortAscending !== null)
            url_ += "shouldSortAscending=" + encodeURIComponent("" + shouldSortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoadNotes(_response);
        });
    }

    protected processGetLoadNotes(response: Response): Promise<NoteModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NoteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel[]>(null as any);
    }

    postLoadNote(loadId: number, newNote: NoteModel): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/Notes/LoadNotes/{loadId}";
        if (loadId === undefined || loadId === null)
            throw new Error("The parameter 'loadId' must be defined.");
        url_ = url_.replace("{loadId}", encodeURIComponent("" + loadId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostLoadNote(_response);
        });
    }

    protected processPostLoadNote(response: Response): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel>(null as any);
    }

    getLoadNoteCount(loadId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Notes/LoadNotes/{loadId}/GetLoadNoteCount";
        if (loadId === undefined || loadId === null)
            throw new Error("The parameter 'loadId' must be defined.");
        url_ = url_.replace("{loadId}", encodeURIComponent("" + loadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoadNoteCount(_response);
        });
    }

    protected processGetLoadNoteCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    putLoadNote(loadId: number, noteId: number, newNote: NoteModel): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/Notes/LoadNotes/{loadId}/{noteId}";
        if (loadId === undefined || loadId === null)
            throw new Error("The parameter 'loadId' must be defined.");
        url_ = url_.replace("{loadId}", encodeURIComponent("" + loadId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newNote);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutLoadNote(_response);
        });
    }

    protected processPutLoadNote(response: Response): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteModel>(null as any);
    }

    deleteLoadNote(loadId: number, noteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Notes/LoadNotes/{loadId}/{noteId}";
        if (loadId === undefined || loadId === null)
            throw new Error("The parameter 'loadId' must be defined.");
        url_ = url_.replace("{loadId}", encodeURIComponent("" + loadId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLoadNote(_response);
        });
    }

    protected processDeleteLoadNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrderCustomersClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<OrderCustomerModel[]> {
        let url_ = this.baseUrl + "/api/OrderCustomers/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<OrderCustomerModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderCustomerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderCustomerModel[]>(null as any);
    }

    getItemById(id: number): Promise<OrderCustomerModel> {
        let url_ = this.baseUrl + "/api/OrderCustomers/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<OrderCustomerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCustomerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderCustomerModel>(null as any);
    }

    getItemNew(): Promise<OrderCustomerModel> {
        let url_ = this.baseUrl + "/api/OrderCustomers/GetItemNew";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemNew(_response);
        });
    }

    protected processGetItemNew(response: Response): Promise<OrderCustomerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCustomerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderCustomerModel>(null as any);
    }

    post(i_oValue: OrderCustomerModel): Promise<OrderCustomerModel> {
        let url_ = this.baseUrl + "/api/OrderCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<OrderCustomerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCustomerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderCustomerModel>(null as any);
    }

    put(id: number, i_oValue: OrderCustomerModel): Promise<OrderCustomerModel> {
        let url_ = this.baseUrl + "/api/OrderCustomers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<OrderCustomerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCustomerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderCustomerModel>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderCustomers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteBulk(i_iIdArray: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderCustomers/DeleteBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_iIdArray);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBulk(_response);
        });
    }

    protected processDeleteBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getOrderCustomerMergeInfo(orderCustomerIds: number[]): Promise<OrderCustomerMergeInfoDTO> {
        let url_ = this.baseUrl + "/api/OrderCustomers/GetOrderCustomerMergeInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderCustomerIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderCustomerMergeInfo(_response);
        });
    }

    protected processGetOrderCustomerMergeInfo(response: Response): Promise<OrderCustomerMergeInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCustomerMergeInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderCustomerMergeInfoDTO>(null as any);
    }

    mergeOrderCustomers(primaryOrderCustomerId: number | undefined, orderCustomerIdsToMerge: number[]): Promise<OrderCustomerModel> {
        let url_ = this.baseUrl + "/api/OrderCustomers/MergeOrderCustomers?";
        if (primaryOrderCustomerId === null)
            throw new Error("The parameter 'primaryOrderCustomerId' cannot be null.");
        else if (primaryOrderCustomerId !== undefined)
            url_ += "primaryOrderCustomerId=" + encodeURIComponent("" + primaryOrderCustomerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderCustomerIdsToMerge);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeOrderCustomers(_response);
        });
    }

    protected processMergeOrderCustomers(response: Response): Promise<OrderCustomerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCustomerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderCustomerModel>(null as any);
    }
}

export class OrdersClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Orders/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<OrderModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderModel[]>(null as any);
    }

    getItemById(id: number): Promise<OrderModel> {
        let url_ = this.baseUrl + "/api/Orders/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<OrderModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderModel>(null as any);
    }

    getItemNew(): Promise<OrderModel> {
        let url_ = this.baseUrl + "/api/Orders/GetItemNew";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemNew(_response);
        });
    }

    protected processGetItemNew(response: Response): Promise<OrderModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderModel>(null as any);
    }

    post(i_oValue: OrderModel): Promise<OrderModel> {
        let url_ = this.baseUrl + "/api/Orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<OrderModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderModel>(null as any);
    }

    put(id: number, i_oValue: OrderModel): Promise<OrderModel> {
        let url_ = this.baseUrl + "/api/Orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<OrderModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderModel>(null as any);
    }

    getChangeLogs(id: number, i_oSearchOptions: SearchOptions): Promise<OrderChangelogModel[]> {
        let url_ = this.baseUrl + "/api/Orders/GetChangeLogs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetChangeLogs(_response);
        });
    }

    protected processGetChangeLogs(response: Response): Promise<OrderChangelogModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderChangelogModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderChangelogModel[]>(null as any);
    }

    groupOrders(orderIds: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Orders/GroupOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGroupOrders(_response);
        });
    }

    protected processGroupOrders(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    ungroupOrders(orderIds: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Orders/UngroupOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUngroupOrders(_response);
        });
    }

    protected processUngroupOrders(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getOrderItinerary(id: number): Promise<OrderModel> {
        let url_ = this.baseUrl + "/api/Orders/GetOrderItinerary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderItinerary(_response);
        });
    }

    protected processGetOrderItinerary(response: Response): Promise<OrderModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderModel>(null as any);
    }

    groupOrdersPreflight(request: OrderGroupingPreflightRequest): Promise<OrderGroupingPreflightResponse> {
        let url_ = this.baseUrl + "/api/Orders/GroupOrdersPreflight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGroupOrdersPreflight(_response);
        });
    }

    protected processGroupOrdersPreflight(response: Response): Promise<OrderGroupingPreflightResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderGroupingPreflightResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderGroupingPreflightResponse>(null as any);
    }

    groupOrdersConfirm(request: OrderGroupingConfirmRequest): Promise<OrderGroupingConfirmResponse> {
        let url_ = this.baseUrl + "/api/Orders/GroupOrdersConfirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGroupOrdersConfirm(_response);
        });
    }

    protected processGroupOrdersConfirm(response: Response): Promise<OrderGroupingConfirmResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderGroupingConfirmResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderGroupingConfirmResponse>(null as any);
    }
}

export class UserNotificationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<UserNotificationModel[]> {
        let url_ = this.baseUrl + "/api/UserNotifications/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<UserNotificationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserNotificationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserNotificationModel[]>(null as any);
    }

    getItemById(id: number): Promise<UserNotificationModel> {
        let url_ = this.baseUrl + "/api/UserNotifications/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<UserNotificationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserNotificationModel>(null as any);
    }

    getActiveForCurrentUser(): Promise<UserNotificationViewDTO[]> {
        let url_ = this.baseUrl + "/api/UserNotifications/GetActiveForCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveForCurrentUser(_response);
        });
    }

    protected processGetActiveForCurrentUser(response: Response): Promise<UserNotificationViewDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserNotificationViewDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserNotificationViewDTO[]>(null as any);
    }

    acknowledge(userNotificationRecipientId: number): Promise<UserNotificationViewDTO> {
        let url_ = this.baseUrl + "/api/UserNotifications/Acknowledge/{userNotificationRecipientId}";
        if (userNotificationRecipientId === undefined || userNotificationRecipientId === null)
            throw new Error("The parameter 'userNotificationRecipientId' must be defined.");
        url_ = url_.replace("{userNotificationRecipientId}", encodeURIComponent("" + userNotificationRecipientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcknowledge(_response);
        });
    }

    protected processAcknowledge(response: Response): Promise<UserNotificationViewDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationViewDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserNotificationViewDTO>(null as any);
    }
}

export class SystemUsersClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getMe(): Promise<SystemUserModel> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/GetMe";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMe(_response);
        });
    }

    protected processGetMe(response: Response): Promise<SystemUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserModel>(null as any);
    }

    putMe(i_oValue: SystemUserModel): Promise<SystemUserModel> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/PutMe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutMe(_response);
        });
    }

    protected processPutMe(response: Response): Promise<SystemUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserModel>(null as any);
    }

    getPickerUsers(i_oSearchOptions: SearchOptions): Promise<SystemUserModel[]> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/GetPickerUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPickerUsers(_response);
        });
    }

    protected processGetPickerUsers(response: Response): Promise<SystemUserModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserModel[]>(null as any);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<SystemUserModel[]> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<SystemUserModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserModel[]>(null as any);
    }

    getItemById(id: number): Promise<SystemUserModel> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<SystemUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserModel>(null as any);
    }

    getLoginsByUserId(id: number): Promise<LoginDTO> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/GetLoginsByUserId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoginsByUserId(_response);
        });
    }

    protected processGetLoginsByUserId(response: Response): Promise<LoginDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginDTO>(null as any);
    }

    saveNewLogin(login: LoginDTO): Promise<LoginDTO> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/SaveNewLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveNewLogin(_response);
        });
    }

    protected processSaveNewLogin(response: Response): Promise<LoginDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginDTO>(null as any);
    }

    deleteLogin(login: LoginDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/DeleteLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLogin(_response);
        });
    }

    protected processDeleteLogin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateLogin(login: LoginDTO): Promise<LoginDTO> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/UpdateLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLogin(_response);
        });
    }

    protected processUpdateLogin(response: Response): Promise<LoginDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginDTO>(null as any);
    }

    changePassword(id: number, i_oValue: SystemUserModel): Promise<SystemUserModel> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/ChangePassword/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<SystemUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserModel>(null as any);
    }

    put(id: number, i_oValue: SystemUserModel): Promise<SystemUserModel> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<SystemUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserModel>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    post(i_oValue: SystemUserModel): Promise<SystemUserModel> {
        let url_ = this.baseUrl + "/api/System/SystemUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<SystemUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserModel>(null as any);
    }

    deleteBulk(i_iIdArray: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/System/SystemUsers/DeleteBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_iIdArray);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBulk(_response);
        });
    }

    protected processDeleteBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SystemAdminsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<SystemAdminModel[]> {
        let url_ = this.baseUrl + "/api/System/SystemAdmins/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<SystemAdminModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemAdminModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemAdminModel[]>(null as any);
    }

    getItemById(id: number): Promise<SystemAdminModel> {
        let url_ = this.baseUrl + "/api/System/SystemAdmins/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<SystemAdminModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemAdminModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemAdminModel>(null as any);
    }

    post(i_oValue: SystemAdminModel): Promise<SystemAdminModel> {
        let url_ = this.baseUrl + "/api/System/SystemAdmins";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<SystemAdminModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemAdminModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemAdminModel>(null as any);
    }

    put(id: number, i_oValue: SystemAdminModel): Promise<SystemAdminModel> {
        let url_ = this.baseUrl + "/api/System/SystemAdmins/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<SystemAdminModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemAdminModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemAdminModel>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/System/SystemAdmins/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteBulk(i_iIdArray: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/System/SystemAdmins/DeleteBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_iIdArray);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBulk(_response);
        });
    }

    protected processDeleteBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SystemCustomersClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<SystemCustomerModel[]> {
        let url_ = this.baseUrl + "/api/SystemCustomers/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<SystemCustomerModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemCustomerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemCustomerModel[]>(null as any);
    }

    getItemById(id: number): Promise<SystemCustomerModel> {
        let url_ = this.baseUrl + "/api/SystemCustomers/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<SystemCustomerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemCustomerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemCustomerModel>(null as any);
    }

    post(i_oValue: SystemCustomerModel): Promise<SystemCustomerModel> {
        let url_ = this.baseUrl + "/api/SystemCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<SystemCustomerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemCustomerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemCustomerModel>(null as any);
    }

    fromUserRequest(requestId: number, i_oValue: SystemCustomerModel): Promise<SystemCustomerModel> {
        let url_ = this.baseUrl + "/api/SystemCustomers/FromUserRequest/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFromUserRequest(_response);
        });
    }

    protected processFromUserRequest(response: Response): Promise<SystemCustomerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemCustomerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemCustomerModel>(null as any);
    }

    put(id: number, i_oValue: SystemCustomerModel): Promise<SystemCustomerModel> {
        let url_ = this.baseUrl + "/api/SystemCustomers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<SystemCustomerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemCustomerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemCustomerModel>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/SystemCustomers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteBulk(i_iIdArray: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/SystemCustomers/DeleteBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_iIdArray);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBulk(_response);
        });
    }

    protected processDeleteBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SystemDocumentsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    downloadResource(i_sFileName: string): Promise<void> {
        let url_ = this.baseUrl + "/api/documents/resources/{i_sFileName}";
        if (i_sFileName === undefined || i_sFileName === null)
            throw new Error("The parameter 'i_sFileName' must be defined.");
        url_ = url_.replace("{i_sFileName}", encodeURIComponent("" + i_sFileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadResource(_response);
        });
    }

    protected processDownloadResource(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SystemEmployeesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<SystemEmployeeModel[]> {
        let url_ = this.baseUrl + "/api/SystemEmployees/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<SystemEmployeeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemEmployeeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemEmployeeModel[]>(null as any);
    }

    getItemById(id: number): Promise<SystemEmployeeModel> {
        let url_ = this.baseUrl + "/api/SystemEmployees/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<SystemEmployeeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemEmployeeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemEmployeeModel>(null as any);
    }

    post(i_oValue: SystemEmployeeModel): Promise<SystemEmployeeModel> {
        let url_ = this.baseUrl + "/api/SystemEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<SystemEmployeeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemEmployeeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemEmployeeModel>(null as any);
    }

    put(id: number, i_oValue: SystemEmployeeModel): Promise<SystemEmployeeModel> {
        let url_ = this.baseUrl + "/api/SystemEmployees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<SystemEmployeeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemEmployeeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemEmployeeModel>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/SystemEmployees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteBulk(i_iIdArray: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/SystemEmployees/DeleteBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_iIdArray);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBulk(_response);
        });
    }

    protected processDeleteBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SystemRolesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<SystemRoleModel[]> {
        let url_ = this.baseUrl + "/api/System/SystemRoles/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<SystemRoleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemRoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemRoleModel[]>(null as any);
    }

    getItemById(id: number): Promise<SystemRoleModel> {
        let url_ = this.baseUrl + "/api/System/SystemRoles/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<SystemRoleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemRoleModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemRoleModel>(null as any);
    }

    put(id: number, i_oValue: SystemRoleModel): Promise<SystemRoleModel> {
        let url_ = this.baseUrl + "/api/System/SystemRoles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<SystemRoleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemRoleModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemRoleModel>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/System/SystemRoles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    post(i_oValue: SystemRoleModel): Promise<SystemRoleModel> {
        let url_ = this.baseUrl + "/api/System/SystemRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<SystemRoleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemRoleModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemRoleModel>(null as any);
    }

    deleteBulk(i_iIdArray: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/System/SystemRoles/DeleteBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_iIdArray);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBulk(_response);
        });
    }

    protected processDeleteBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllActiveRolesWithPermissions(): Promise<SystemRoleModel[]> {
        let url_ = this.baseUrl + "/api/System/SystemRoles/GetAllActiveRolesWithPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllActiveRolesWithPermissions(_response);
        });
    }

    protected processGetAllActiveRolesWithPermissions(response: Response): Promise<SystemRoleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemRoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemRoleModel[]>(null as any);
    }
}

export class SystemScanToPicksClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<SystemScanToPickModel[]> {
        let url_ = this.baseUrl + "/api/SystemScanToPicks/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<SystemScanToPickModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemScanToPickModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemScanToPickModel[]>(null as any);
    }

    getItemById(id: number): Promise<SystemScanToPickModel> {
        let url_ = this.baseUrl + "/api/SystemScanToPicks/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<SystemScanToPickModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemScanToPickModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemScanToPickModel>(null as any);
    }

    post(i_oValue: SystemScanToPickModel): Promise<SystemScanToPickModel> {
        let url_ = this.baseUrl + "/api/SystemScanToPicks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<SystemScanToPickModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemScanToPickModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemScanToPickModel>(null as any);
    }

    fromUserRequest(requestId: number, i_oValue: SystemScanToPickModel): Promise<SystemScanToPickModel> {
        let url_ = this.baseUrl + "/api/SystemScanToPicks/FromUserRequest/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFromUserRequest(_response);
        });
    }

    protected processFromUserRequest(response: Response): Promise<SystemScanToPickModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemScanToPickModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemScanToPickModel>(null as any);
    }

    put(id: number, i_oValue: SystemScanToPickModel): Promise<SystemScanToPickModel> {
        let url_ = this.baseUrl + "/api/SystemScanToPicks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<SystemScanToPickModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemScanToPickModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemScanToPickModel>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/SystemScanToPicks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteBulk(i_iIdArray: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/SystemScanToPicks/DeleteBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_iIdArray);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBulk(_response);
        });
    }

    protected processDeleteBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SystemUserRequestsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getItems(i_oSearchOptions: SearchOptions): Promise<SystemUserRequestModel[]> {
        let url_ = this.baseUrl + "/api/System/SystemUserRequests/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oSearchOptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<SystemUserRequestModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemUserRequestModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserRequestModel[]>(null as any);
    }

    getItemById(id: number): Promise<SystemUserRequestModel> {
        let url_ = this.baseUrl + "/api/System/SystemUserRequests/GetItemById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemById(_response);
        });
    }

    protected processGetItemById(response: Response): Promise<SystemUserRequestModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserRequestModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserRequestModel>(null as any);
    }

    getItemNew(): Promise<SystemUserRequestModel> {
        let url_ = this.baseUrl + "/api/System/SystemUserRequests/GetItemNew";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemNew(_response);
        });
    }

    protected processGetItemNew(response: Response): Promise<SystemUserRequestModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserRequestModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserRequestModel>(null as any);
    }

    post(i_oValue: SystemUserRequestModel): Promise<SystemUserRequestModel> {
        let url_ = this.baseUrl + "/api/System/SystemUserRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<SystemUserRequestModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserRequestModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserRequestModel>(null as any);
    }

    put(id: number, i_oValue: SystemUserRequestModel): Promise<SystemUserRequestModel> {
        let url_ = this.baseUrl + "/api/System/SystemUserRequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<SystemUserRequestModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserRequestModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserRequestModel>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/System/SystemUserRequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteBulk(i_iIdArray: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/System/SystemUserRequests/DeleteBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_iIdArray);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBulk(_response);
        });
    }

    protected processDeleteBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCount(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/System/SystemUserRequests/GetCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCount(_response);
        });
    }

    protected processGetCount(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AuthClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    logout(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Auth/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    isValidPasswordResetHash(i_oUser: AuthUser): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/Auth/IsValidPasswordResetHash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oUser);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsValidPasswordResetHash(_response);
        });
    }

    protected processIsValidPasswordResetHash(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(null as any);
    }

    updatePassword(i_oUser: AuthUser): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/UpdatePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oUser);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendPasswordResetLinkByEmail(email: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/SendPasswordResetLinkByEmail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendPasswordResetLinkByEmail(_response);
        });
    }

    protected processSendPasswordResetLinkByEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getPasswordResetLinkByUserId(systemUserId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/GetPasswordResetLinkByUserId?";
        if (systemUserId === null)
            throw new Error("The parameter 'systemUserId' cannot be null.");
        else if (systemUserId !== undefined)
            url_ += "systemUserId=" + encodeURIComponent("" + systemUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPasswordResetLinkByUserId(_response);
        });
    }

    protected processGetPasswordResetLinkByUserId(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    changePassword(i_oUser: AuthUser): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oUser);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    register(i_oUser: AuthUser): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oUser);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    completeRegistration(i_oUser: AuthUser): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Auth/CompleteRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oUser);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteRegistration(_response);
        });
    }

    protected processCompleteRegistration(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    claims(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Auth/Claims";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClaims(_response);
        });
    }

    protected processClaims(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    login(i_oUser: AuthUser): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/Auth/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oUser);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(null as any);
    }

    loginToAccount(i_oIdentity: AuthUserIdentity): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/Auth/LoginToAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i_oIdentity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoginToAccount(_response);
        });
    }

    protected processLoginToAccount(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(null as any);
    }
}

export class AmsSyncResultViewModel implements IAmsSyncResultViewModel {
    amsSyncResultId!: number;
    syncSource!: AmsSyncResultSource;
    passed!: boolean;
    resultMessage?: string | undefined;
    dateCreated!: Date;
    dateModified!: Date;

    constructor(data?: IAmsSyncResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amsSyncResultId = _data["amsSyncResultId"];
            this.syncSource = _data["syncSource"];
            this.passed = _data["passed"];
            this.resultMessage = _data["resultMessage"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AmsSyncResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmsSyncResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amsSyncResultId"] = this.amsSyncResultId;
        data["syncSource"] = this.syncSource;
        data["passed"] = this.passed;
        data["resultMessage"] = this.resultMessage;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAmsSyncResultViewModel {
    amsSyncResultId: number;
    syncSource: AmsSyncResultSource;
    passed: boolean;
    resultMessage?: string | undefined;
    dateCreated: Date;
    dateModified: Date;
}

export enum AmsSyncResultSource {
    StorageCustomerSync = 0,
    ProductsSync = 1,
    AmsApiSync = 2,
}

export class WarehousePrinterModel implements IWarehousePrinterModel {
    warehousePrinterClient!: WarehousePrinterClientModel;
    warehouseLocations!: WarehouseLocationModel[];
    warehousePrintJobLogs!: WarehousePrintJobLogModel[];
    warehousePrinterId!: number;
    portName!: string;
    name!: string;
    driverName!: string;
    printerType!: WarehousePrinterType;
    status!: string;
    isOnline!: boolean;
    clientId!: string;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IWarehousePrinterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehousePrinterClient = new WarehousePrinterClientModel();
            this.warehouseLocations = [];
            this.warehousePrintJobLogs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehousePrinterClient = _data["warehousePrinterClient"] ? WarehousePrinterClientModel.fromJS(_data["warehousePrinterClient"]) : new WarehousePrinterClientModel();
            if (Array.isArray(_data["warehouseLocations"])) {
                this.warehouseLocations = [] as any;
                for (let item of _data["warehouseLocations"])
                    this.warehouseLocations!.push(WarehouseLocationModel.fromJS(item));
            }
            if (Array.isArray(_data["warehousePrintJobLogs"])) {
                this.warehousePrintJobLogs = [] as any;
                for (let item of _data["warehousePrintJobLogs"])
                    this.warehousePrintJobLogs!.push(WarehousePrintJobLogModel.fromJS(item));
            }
            this.warehousePrinterId = _data["warehousePrinterId"];
            this.portName = _data["portName"];
            this.name = _data["name"];
            this.driverName = _data["driverName"];
            this.printerType = _data["printerType"];
            this.status = _data["status"];
            this.isOnline = _data["isOnline"];
            this.clientId = _data["clientId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WarehousePrinterModel {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousePrinterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehousePrinterClient"] = this.warehousePrinterClient ? this.warehousePrinterClient.toJSON() : <any>undefined;
        if (Array.isArray(this.warehouseLocations)) {
            data["warehouseLocations"] = [];
            for (let item of this.warehouseLocations)
                data["warehouseLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.warehousePrintJobLogs)) {
            data["warehousePrintJobLogs"] = [];
            for (let item of this.warehousePrintJobLogs)
                data["warehousePrintJobLogs"].push(item.toJSON());
        }
        data["warehousePrinterId"] = this.warehousePrinterId;
        data["portName"] = this.portName;
        data["name"] = this.name;
        data["driverName"] = this.driverName;
        data["printerType"] = this.printerType;
        data["status"] = this.status;
        data["isOnline"] = this.isOnline;
        data["clientId"] = this.clientId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWarehousePrinterModel {
    warehousePrinterClient: WarehousePrinterClientModel;
    warehouseLocations: WarehouseLocationModel[];
    warehousePrintJobLogs: WarehousePrintJobLogModel[];
    warehousePrinterId: number;
    portName: string;
    name: string;
    driverName: string;
    printerType: WarehousePrinterType;
    status: string;
    isOnline: boolean;
    clientId: string;
    dateAdded: Date;
    dateModified: Date;
}

export class WarehousePrinterClientModel implements IWarehousePrinterClientModel {
    warehousePrinters!: WarehousePrinterModel[];
    clientId!: string;
    machineName!: string;
    isOnline!: boolean;
    lastSeen!: Date;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IWarehousePrinterClientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehousePrinters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehousePrinters"])) {
                this.warehousePrinters = [] as any;
                for (let item of _data["warehousePrinters"])
                    this.warehousePrinters!.push(WarehousePrinterModel.fromJS(item));
            }
            this.clientId = _data["clientId"];
            this.machineName = _data["machineName"];
            this.isOnline = _data["isOnline"];
            this.lastSeen = _data["lastSeen"] ? new Date(_data["lastSeen"].toString()) : <any>undefined;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WarehousePrinterClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousePrinterClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehousePrinters)) {
            data["warehousePrinters"] = [];
            for (let item of this.warehousePrinters)
                data["warehousePrinters"].push(item.toJSON());
        }
        data["clientId"] = this.clientId;
        data["machineName"] = this.machineName;
        data["isOnline"] = this.isOnline;
        data["lastSeen"] = this.lastSeen ? this.lastSeen.toISOString() : <any>undefined;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWarehousePrinterClientModel {
    warehousePrinters: WarehousePrinterModel[];
    clientId: string;
    machineName: string;
    isOnline: boolean;
    lastSeen: Date;
    dateAdded: Date;
    dateModified: Date;
}

export class WarehouseLocationModel implements IWarehouseLocationModel {
    warehousePrinters!: WarehousePrinterModel[];
    warehouseLocationId!: number;
    warehouseId!: number;
    location!: string;
    address!: string;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IWarehouseLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehousePrinters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehousePrinters"])) {
                this.warehousePrinters = [] as any;
                for (let item of _data["warehousePrinters"])
                    this.warehousePrinters!.push(WarehousePrinterModel.fromJS(item));
            }
            this.warehouseLocationId = _data["warehouseLocationId"];
            this.warehouseId = _data["warehouseId"];
            this.location = _data["location"];
            this.address = _data["address"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WarehouseLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseLocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehousePrinters)) {
            data["warehousePrinters"] = [];
            for (let item of this.warehousePrinters)
                data["warehousePrinters"].push(item.toJSON());
        }
        data["warehouseLocationId"] = this.warehouseLocationId;
        data["warehouseId"] = this.warehouseId;
        data["location"] = this.location;
        data["address"] = this.address;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWarehouseLocationModel {
    warehousePrinters: WarehousePrinterModel[];
    warehouseLocationId: number;
    warehouseId: number;
    location: string;
    address: string;
    dateAdded: Date;
    dateModified: Date;
}

export class WarehousePrintJobLogModel implements IWarehousePrintJobLogModel {
    warehousePrinter?: WarehousePrinterModel | undefined;
    warehousePrintJobLogId!: number;
    warehousePrinterId?: number | undefined;
    documentName!: string;
    reportType!: ScanToPickReportTypeEnum;
    pageCount!: number;
    status!: PrintJobStatus;
    errorMessage!: string;
    startTime!: Date;
    endTime?: Date | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    printerPortName!: string;
    printerFriendlyName!: string;

    constructor(data?: IWarehousePrintJobLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehousePrinter = _data["warehousePrinter"] ? WarehousePrinterModel.fromJS(_data["warehousePrinter"]) : <any>undefined;
            this.warehousePrintJobLogId = _data["warehousePrintJobLogId"];
            this.warehousePrinterId = _data["warehousePrinterId"];
            this.documentName = _data["documentName"];
            this.reportType = _data["reportType"];
            this.pageCount = _data["pageCount"];
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.printerPortName = _data["printerPortName"];
            this.printerFriendlyName = _data["printerFriendlyName"];
        }
    }

    static fromJS(data: any): WarehousePrintJobLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousePrintJobLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehousePrinter"] = this.warehousePrinter ? this.warehousePrinter.toJSON() : <any>undefined;
        data["warehousePrintJobLogId"] = this.warehousePrintJobLogId;
        data["warehousePrinterId"] = this.warehousePrinterId;
        data["documentName"] = this.documentName;
        data["reportType"] = this.reportType;
        data["pageCount"] = this.pageCount;
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["printerPortName"] = this.printerPortName;
        data["printerFriendlyName"] = this.printerFriendlyName;
        return data;
    }
}

export interface IWarehousePrintJobLogModel {
    warehousePrinter?: WarehousePrinterModel | undefined;
    warehousePrintJobLogId: number;
    warehousePrinterId?: number | undefined;
    documentName: string;
    reportType: ScanToPickReportTypeEnum;
    pageCount: number;
    status: PrintJobStatus;
    errorMessage: string;
    startTime: Date;
    endTime?: Date | undefined;
    dateAdded: Date;
    dateModified: Date;
    printerPortName: string;
    printerFriendlyName: string;
}

export enum ScanToPickReportTypeEnum {
    PalletTag = 0,
    PickTicket = 1,
}

export enum PrintJobStatus {
    Success = 0,
    Failed = 1,
}

export enum WarehousePrinterType {
    None = 0,
    Standard = 1,
    Label = 2,
}

export class PagedResultsOfWarehousePrintJobLogModel implements IPagedResultsOfWarehousePrintJobLogModel {
    resultCount!: number;
    results?: WarehousePrintJobLogModel[] | undefined;

    constructor(data?: IPagedResultsOfWarehousePrintJobLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(WarehousePrintJobLogModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfWarehousePrintJobLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfWarehousePrintJobLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultsOfWarehousePrintJobLogModel {
    resultCount: number;
    results?: WarehousePrintJobLogModel[] | undefined;
}

export class OrderLineItemViewModel implements IOrderLineItemViewModel {
    id!: number;
    itemNo!: number;
    name?: string | undefined;
    upcCode?: string | undefined;
    yearCode?: string | undefined;
    quantity!: number;
    statusCode!: AmsOrderLineStatusEnum;
    description?: string | undefined;
    specialInstructions?: string | undefined;
    sizeDescription?: string | undefined;
    gallon?: number | undefined;
    liter?: number | undefined;
    laneReservations?: AmsLaneReservation[] | undefined;
    isValid?: boolean | undefined;
    orderId!: number;
    customer?: string | undefined;
    note?: string | undefined;
    wineryCode?: string | undefined;
    wineryName?: string | undefined;
    partNo?: string | undefined;
    unitsPerCase!: number;
    shippingLocCode?: string | undefined;
    orderLineItemAndReasons?: OrderLineItemAndReasonViewModel[] | undefined;

    constructor(data?: IOrderLineItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemNo = _data["itemNo"];
            this.name = _data["name"];
            this.upcCode = _data["upcCode"];
            this.yearCode = _data["yearCode"];
            this.quantity = _data["quantity"];
            this.statusCode = _data["statusCode"];
            this.description = _data["description"];
            this.specialInstructions = _data["specialInstructions"];
            this.sizeDescription = _data["sizeDescription"];
            this.gallon = _data["gallon"];
            this.liter = _data["liter"];
            if (Array.isArray(_data["laneReservations"])) {
                this.laneReservations = [] as any;
                for (let item of _data["laneReservations"])
                    this.laneReservations!.push(AmsLaneReservation.fromJS(item));
            }
            this.isValid = _data["isValid"];
            this.orderId = _data["orderId"];
            this.customer = _data["customer"];
            this.note = _data["note"];
            this.wineryCode = _data["wineryCode"];
            this.wineryName = _data["wineryName"];
            this.partNo = _data["partNo"];
            this.unitsPerCase = _data["unitsPerCase"];
            this.shippingLocCode = _data["shippingLocCode"];
            if (Array.isArray(_data["orderLineItemAndReasons"])) {
                this.orderLineItemAndReasons = [] as any;
                for (let item of _data["orderLineItemAndReasons"])
                    this.orderLineItemAndReasons!.push(OrderLineItemAndReasonViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderLineItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemNo"] = this.itemNo;
        data["name"] = this.name;
        data["upcCode"] = this.upcCode;
        data["yearCode"] = this.yearCode;
        data["quantity"] = this.quantity;
        data["statusCode"] = this.statusCode;
        data["description"] = this.description;
        data["specialInstructions"] = this.specialInstructions;
        data["sizeDescription"] = this.sizeDescription;
        data["gallon"] = this.gallon;
        data["liter"] = this.liter;
        if (Array.isArray(this.laneReservations)) {
            data["laneReservations"] = [];
            for (let item of this.laneReservations)
                data["laneReservations"].push(item.toJSON());
        }
        data["isValid"] = this.isValid;
        data["orderId"] = this.orderId;
        data["customer"] = this.customer;
        data["note"] = this.note;
        data["wineryCode"] = this.wineryCode;
        data["wineryName"] = this.wineryName;
        data["partNo"] = this.partNo;
        data["unitsPerCase"] = this.unitsPerCase;
        data["shippingLocCode"] = this.shippingLocCode;
        if (Array.isArray(this.orderLineItemAndReasons)) {
            data["orderLineItemAndReasons"] = [];
            for (let item of this.orderLineItemAndReasons)
                data["orderLineItemAndReasons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderLineItemViewModel {
    id: number;
    itemNo: number;
    name?: string | undefined;
    upcCode?: string | undefined;
    yearCode?: string | undefined;
    quantity: number;
    statusCode: AmsOrderLineStatusEnum;
    description?: string | undefined;
    specialInstructions?: string | undefined;
    sizeDescription?: string | undefined;
    gallon?: number | undefined;
    liter?: number | undefined;
    laneReservations?: AmsLaneReservation[] | undefined;
    isValid?: boolean | undefined;
    orderId: number;
    customer?: string | undefined;
    note?: string | undefined;
    wineryCode?: string | undefined;
    wineryName?: string | undefined;
    partNo?: string | undefined;
    unitsPerCase: number;
    shippingLocCode?: string | undefined;
    orderLineItemAndReasons?: OrderLineItemAndReasonViewModel[] | undefined;
}

export enum AmsOrderLineStatusEnum {
    Unpicked = 0,
    Picked = 1,
}

export class AmsLaneReservation implements IAmsLaneReservation {
    lane!: string;
    reservationQuantity!: number;
    productionDate?: Date | undefined;

    constructor(data?: IAmsLaneReservation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lane = _data["lane"];
            this.reservationQuantity = _data["reservationQuantity"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AmsLaneReservation {
        data = typeof data === 'object' ? data : {};
        let result = new AmsLaneReservation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lane"] = this.lane;
        data["reservationQuantity"] = this.reservationQuantity;
        data["productionDate"] = this.productionDate ? formatDate(this.productionDate) : <any>undefined;
        return data;
    }
}

export interface IAmsLaneReservation {
    lane: string;
    reservationQuantity: number;
    productionDate?: Date | undefined;
}

export class OrderLineItemAndReasonViewModel implements IOrderLineItemAndReasonViewModel {
    id!: number;
    orderLineItemId!: number;
    reasonCode?: string | undefined;
    reasonNote?: string | undefined;
    pickerId?: number | undefined;

    constructor(data?: IOrderLineItemAndReasonViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderLineItemId = _data["orderLineItemId"];
            this.reasonCode = _data["reasonCode"];
            this.reasonNote = _data["reasonNote"];
            this.pickerId = _data["pickerId"];
        }
    }

    static fromJS(data: any): OrderLineItemAndReasonViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineItemAndReasonViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderLineItemId"] = this.orderLineItemId;
        data["reasonCode"] = this.reasonCode;
        data["reasonNote"] = this.reasonNote;
        data["pickerId"] = this.pickerId;
        return data;
    }
}

export interface IOrderLineItemAndReasonViewModel {
    id: number;
    orderLineItemId: number;
    reasonCode?: string | undefined;
    reasonNote?: string | undefined;
    pickerId?: number | undefined;
}

export class OrderItemViewModel implements IOrderItemViewModel {
    id!: number;
    orderId!: number;
    varietal?: string | undefined;
    status?: string | undefined;
    vintage?: string | undefined;
    upc?: string | undefined;
    size?: string | undefined;
    totalCases!: number;
    remainingBottles!: number;
    totalBottles!: number;
    unitsPercase!: number;
    statusCode!: AmsOrderLineStatusEnum;
    laneReservations?: AmsLaneReservation[] | undefined;
    isValid?: boolean | undefined;
    note?: string | undefined;
    itemNo!: number;
    partNo?: string | undefined;
    returnReason?: string | undefined;
    shippingLocCode?: string | undefined;
    pickDate?: Date | undefined;

    constructor(data?: IOrderItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.varietal = _data["varietal"];
            this.status = _data["status"];
            this.vintage = _data["vintage"];
            this.upc = _data["upc"];
            this.size = _data["size"];
            this.totalCases = _data["totalCases"];
            this.remainingBottles = _data["remainingBottles"];
            this.totalBottles = _data["totalBottles"];
            this.unitsPercase = _data["unitsPercase"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["laneReservations"])) {
                this.laneReservations = [] as any;
                for (let item of _data["laneReservations"])
                    this.laneReservations!.push(AmsLaneReservation.fromJS(item));
            }
            this.isValid = _data["isValid"];
            this.note = _data["note"];
            this.itemNo = _data["itemNo"];
            this.partNo = _data["partNo"];
            this.returnReason = _data["returnReason"];
            this.shippingLocCode = _data["shippingLocCode"];
            this.pickDate = _data["pickDate"] ? new Date(_data["pickDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["varietal"] = this.varietal;
        data["status"] = this.status;
        data["vintage"] = this.vintage;
        data["upc"] = this.upc;
        data["size"] = this.size;
        data["totalCases"] = this.totalCases;
        data["remainingBottles"] = this.remainingBottles;
        data["totalBottles"] = this.totalBottles;
        data["unitsPercase"] = this.unitsPercase;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.laneReservations)) {
            data["laneReservations"] = [];
            for (let item of this.laneReservations)
                data["laneReservations"].push(item.toJSON());
        }
        data["isValid"] = this.isValid;
        data["note"] = this.note;
        data["itemNo"] = this.itemNo;
        data["partNo"] = this.partNo;
        data["returnReason"] = this.returnReason;
        data["shippingLocCode"] = this.shippingLocCode;
        data["pickDate"] = this.pickDate ? this.pickDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrderItemViewModel {
    id: number;
    orderId: number;
    varietal?: string | undefined;
    status?: string | undefined;
    vintage?: string | undefined;
    upc?: string | undefined;
    size?: string | undefined;
    totalCases: number;
    remainingBottles: number;
    totalBottles: number;
    unitsPercase: number;
    statusCode: AmsOrderLineStatusEnum;
    laneReservations?: AmsLaneReservation[] | undefined;
    isValid?: boolean | undefined;
    note?: string | undefined;
    itemNo: number;
    partNo?: string | undefined;
    returnReason?: string | undefined;
    shippingLocCode?: string | undefined;
    pickDate?: Date | undefined;
}

export class OrderLineItemAndReasonInput implements IOrderLineItemAndReasonInput {
    orderLineItemId!: number;
    reasonCode?: string | undefined;
    reasonNote?: string | undefined;

    constructor(data?: IOrderLineItemAndReasonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLineItemId = _data["orderLineItemId"];
            this.reasonCode = _data["reasonCode"];
            this.reasonNote = _data["reasonNote"];
        }
    }

    static fromJS(data: any): OrderLineItemAndReasonInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineItemAndReasonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderLineItemId"] = this.orderLineItemId;
        data["reasonCode"] = this.reasonCode;
        data["reasonNote"] = this.reasonNote;
        return data;
    }
}

export interface IOrderLineItemAndReasonInput {
    orderLineItemId: number;
    reasonCode?: string | undefined;
    reasonNote?: string | undefined;
}

export class OrderLineItemEditNoteInput implements IOrderLineItemEditNoteInput {
    note?: string | undefined;

    constructor(data?: IOrderLineItemEditNoteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): OrderLineItemEditNoteInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineItemEditNoteInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        return data;
    }
}

export interface IOrderLineItemEditNoteInput {
    note?: string | undefined;
}

export abstract class BaseModel implements IBaseModel {

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseModel {
}

export abstract class BasePagedModel extends BaseModel implements IBasePagedModel {
    selected!: boolean;
    editing!: boolean;
    pager?: Pager | undefined;

    constructor(data?: IBasePagedModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.selected = _data["selected"];
            this.editing = _data["editing"];
            this.pager = _data["pager"] ? Pager.fromJS(_data["pager"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BasePagedModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BasePagedModel' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected"] = this.selected;
        data["editing"] = this.editing;
        data["pager"] = this.pager ? this.pager.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBasePagedModel extends IBaseModel {
    selected: boolean;
    editing: boolean;
    pager?: Pager | undefined;
}

export class IncorrectLaneReportModel extends BasePagedModel implements IIncorrectLaneReportModel {
    orderLineItem!: AmsOrderLineItemModel;
    systemUser?: SystemUserModel | undefined;
    correctedByUser?: SystemUserModel | undefined;
    incorrectLaneReportId!: number;
    originalLane!: string;
    correctedLane!: string;
    wasCorrected!: boolean;
    dateCorrected?: Date | undefined;
    correctedByUserId?: number | undefined;
    correctionType?: ScanToPickLaneCorrectionTypeEnum | undefined;
    orderLineItemId!: number;
    systemUserId!: number;
    dateAdded!: Date;
    dateModified!: Date;
    sourceAmsOrderId?: string | undefined;

    constructor(data?: IIncorrectLaneReportModel) {
        super(data);
        if (!data) {
            this.orderLineItem = new AmsOrderLineItemModel();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderLineItem = _data["orderLineItem"] ? AmsOrderLineItemModel.fromJS(_data["orderLineItem"]) : new AmsOrderLineItemModel();
            this.systemUser = _data["systemUser"] ? SystemUserModel.fromJS(_data["systemUser"]) : <any>undefined;
            this.correctedByUser = _data["correctedByUser"] ? SystemUserModel.fromJS(_data["correctedByUser"]) : <any>undefined;
            this.incorrectLaneReportId = _data["incorrectLaneReportId"];
            this.originalLane = _data["originalLane"];
            this.correctedLane = _data["correctedLane"];
            this.wasCorrected = _data["wasCorrected"];
            this.dateCorrected = _data["dateCorrected"] ? new Date(_data["dateCorrected"].toString()) : <any>undefined;
            this.correctedByUserId = _data["correctedByUserId"];
            this.correctionType = _data["correctionType"];
            this.orderLineItemId = _data["orderLineItemId"];
            this.systemUserId = _data["systemUserId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.sourceAmsOrderId = _data["sourceAmsOrderId"];
        }
    }

    static override fromJS(data: any): IncorrectLaneReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new IncorrectLaneReportModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderLineItem"] = this.orderLineItem ? this.orderLineItem.toJSON() : <any>undefined;
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        data["correctedByUser"] = this.correctedByUser ? this.correctedByUser.toJSON() : <any>undefined;
        data["incorrectLaneReportId"] = this.incorrectLaneReportId;
        data["originalLane"] = this.originalLane;
        data["correctedLane"] = this.correctedLane;
        data["wasCorrected"] = this.wasCorrected;
        data["dateCorrected"] = this.dateCorrected ? this.dateCorrected.toISOString() : <any>undefined;
        data["correctedByUserId"] = this.correctedByUserId;
        data["correctionType"] = this.correctionType;
        data["orderLineItemId"] = this.orderLineItemId;
        data["systemUserId"] = this.systemUserId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["sourceAmsOrderId"] = this.sourceAmsOrderId;
        super.toJSON(data);
        return data;
    }
}

export interface IIncorrectLaneReportModel extends IBasePagedModel {
    orderLineItem: AmsOrderLineItemModel;
    systemUser?: SystemUserModel | undefined;
    correctedByUser?: SystemUserModel | undefined;
    incorrectLaneReportId: number;
    originalLane: string;
    correctedLane: string;
    wasCorrected: boolean;
    dateCorrected?: Date | undefined;
    correctedByUserId?: number | undefined;
    correctionType?: ScanToPickLaneCorrectionTypeEnum | undefined;
    orderLineItemId: number;
    systemUserId: number;
    dateAdded: Date;
    dateModified: Date;
    sourceAmsOrderId?: string | undefined;
}

export class AmsOrderLineItemModel extends BasePagedModel implements IAmsOrderLineItemModel {
    order!: AmsOrderModel;
    id!: number;
    amsItemNumber!: number;
    itemNo!: number;
    name!: string;
    upcCode!: string;
    yearCode!: string;
    quantity!: number;
    statusCode!: AmsOrderLineStatusEnum;
    description!: string;
    specialInstructions!: string;
    sizeDescription!: string;
    poundsPerCase?: number | undefined;
    gallon?: number | undefined;
    liter?: number | undefined;
    location!: string;
    isValid?: boolean | undefined;
    partNo!: string;
    unitsPercase?: number | undefined;
    revisionDate?: Date | undefined;
    casesPerPallet?: number | undefined;
    shippingLocCode!: string;
    note!: string;
    pickDate?: Date | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    orderId!: number;
    laneOnHands!: AmsLaneOnHandModel[];
    orderLineItemAndReasons!: OrderLineItemAndReasonModel[];
    laneReservationsJson!: string;
    laneReservations!: AmsLaneReservation[];

    constructor(data?: IAmsOrderLineItemModel) {
        super(data);
        if (!data) {
            this.order = new AmsOrderModel();
            this.laneOnHands = [];
            this.orderLineItemAndReasons = [];
            this.laneReservations = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["order"] ? AmsOrderModel.fromJS(_data["order"]) : new AmsOrderModel();
            this.id = _data["id"];
            this.amsItemNumber = _data["amsItemNumber"];
            this.itemNo = _data["itemNo"];
            this.name = _data["name"];
            this.upcCode = _data["upcCode"];
            this.yearCode = _data["yearCode"];
            this.quantity = _data["quantity"];
            this.statusCode = _data["statusCode"];
            this.description = _data["description"];
            this.specialInstructions = _data["specialInstructions"];
            this.sizeDescription = _data["sizeDescription"];
            this.poundsPerCase = _data["poundsPerCase"];
            this.gallon = _data["gallon"];
            this.liter = _data["liter"];
            this.location = _data["location"];
            this.isValid = _data["isValid"];
            this.partNo = _data["partNo"];
            this.unitsPercase = _data["unitsPercase"];
            this.revisionDate = _data["revisionDate"] ? new Date(_data["revisionDate"].toString()) : <any>undefined;
            this.casesPerPallet = _data["casesPerPallet"];
            this.shippingLocCode = _data["shippingLocCode"];
            this.note = _data["note"];
            this.pickDate = _data["pickDate"] ? new Date(_data["pickDate"].toString()) : <any>undefined;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["laneOnHands"])) {
                this.laneOnHands = [] as any;
                for (let item of _data["laneOnHands"])
                    this.laneOnHands!.push(AmsLaneOnHandModel.fromJS(item));
            }
            if (Array.isArray(_data["orderLineItemAndReasons"])) {
                this.orderLineItemAndReasons = [] as any;
                for (let item of _data["orderLineItemAndReasons"])
                    this.orderLineItemAndReasons!.push(OrderLineItemAndReasonModel.fromJS(item));
            }
            this.laneReservationsJson = _data["laneReservationsJson"];
            if (Array.isArray(_data["laneReservations"])) {
                this.laneReservations = [] as any;
                for (let item of _data["laneReservations"])
                    this.laneReservations!.push(AmsLaneReservation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AmsOrderLineItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmsOrderLineItemModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["amsItemNumber"] = this.amsItemNumber;
        data["itemNo"] = this.itemNo;
        data["name"] = this.name;
        data["upcCode"] = this.upcCode;
        data["yearCode"] = this.yearCode;
        data["quantity"] = this.quantity;
        data["statusCode"] = this.statusCode;
        data["description"] = this.description;
        data["specialInstructions"] = this.specialInstructions;
        data["sizeDescription"] = this.sizeDescription;
        data["poundsPerCase"] = this.poundsPerCase;
        data["gallon"] = this.gallon;
        data["liter"] = this.liter;
        data["location"] = this.location;
        data["isValid"] = this.isValid;
        data["partNo"] = this.partNo;
        data["unitsPercase"] = this.unitsPercase;
        data["revisionDate"] = this.revisionDate ? this.revisionDate.toISOString() : <any>undefined;
        data["casesPerPallet"] = this.casesPerPallet;
        data["shippingLocCode"] = this.shippingLocCode;
        data["note"] = this.note;
        data["pickDate"] = this.pickDate ? this.pickDate.toISOString() : <any>undefined;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.laneOnHands)) {
            data["laneOnHands"] = [];
            for (let item of this.laneOnHands)
                data["laneOnHands"].push(item.toJSON());
        }
        if (Array.isArray(this.orderLineItemAndReasons)) {
            data["orderLineItemAndReasons"] = [];
            for (let item of this.orderLineItemAndReasons)
                data["orderLineItemAndReasons"].push(item.toJSON());
        }
        data["laneReservationsJson"] = this.laneReservationsJson;
        if (Array.isArray(this.laneReservations)) {
            data["laneReservations"] = [];
            for (let item of this.laneReservations)
                data["laneReservations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAmsOrderLineItemModel extends IBasePagedModel {
    order: AmsOrderModel;
    id: number;
    amsItemNumber: number;
    itemNo: number;
    name: string;
    upcCode: string;
    yearCode: string;
    quantity: number;
    statusCode: AmsOrderLineStatusEnum;
    description: string;
    specialInstructions: string;
    sizeDescription: string;
    poundsPerCase?: number | undefined;
    gallon?: number | undefined;
    liter?: number | undefined;
    location: string;
    isValid?: boolean | undefined;
    partNo: string;
    unitsPercase?: number | undefined;
    revisionDate?: Date | undefined;
    casesPerPallet?: number | undefined;
    shippingLocCode: string;
    note: string;
    pickDate?: Date | undefined;
    dateAdded: Date;
    dateModified: Date;
    orderId: number;
    laneOnHands: AmsLaneOnHandModel[];
    orderLineItemAndReasons: OrderLineItemAndReasonModel[];
    laneReservationsJson: string;
    laneReservations: AmsLaneReservation[];
}

export class AmsOrderModel extends BasePagedModel implements IAmsOrderModel {
    orderId!: number;
    amsOrderId!: number;
    orderStatusCode!: AmsOrderStatusEnum;
    priority!: number;
    customer!: string;
    wineryRefNo!: string;
    wineryCode!: string;
    amsStorageCustomer?: AmsStorageCustomerModel | undefined;
    wineryName!: string;
    deliveryInst1!: string;
    deliveryInst2!: string;
    deliveryInst3!: string;
    deliveryZoneCode!: string;
    shipToName!: string;
    shipToAddr1!: string;
    shipToAddr2!: string;
    shipToCity!: string;
    shipToState!: string;
    shipToZipCode!: string;
    poNumber!: string;
    custNo?: number | undefined;
    billToCustNo?: number | undefined;
    shipVia!: string;
    orderDate?: Date | undefined;
    assignmentDate?: Date | undefined;
    progressDate?: Date | undefined;
    orderCompleteDate?: Date | undefined;
    expectedShipDate?: Date | undefined;
    shipDate?: Date | undefined;
    pickedDate?: Date | undefined;
    qcQueueDate?: Date | undefined;
    qcModifiedOn?: Date | undefined;
    loadedDate?: Date | undefined;
    pickslipDateAndTime?: Date | undefined;
    schedDateAndTime?: Date | undefined;
    frghtDesc!: string;
    carrierCode!: string;
    numberOfPallets!: number;
    numberOfCases!: number;
    numberOfBottles!: number;
    locationCode!: string;
    locationDestinationCode!: string;
    clerkNote!: string;
    taxExemptCode!: AmsOrderTaxExemptCodeEnum;
    pickedBy?: number | undefined;
    pickerUser?: SystemUserModel | undefined;
    qcdBy?: number | undefined;
    qcUser?: SystemUserModel | undefined;
    loadedBy?: number | undefined;
    loaderUser?: SystemUserModel | undefined;
    orderLineItems!: AmsOrderLineItemModel[];
    orderInterruptions!: OrderInterruptionModel[];
    billToCustId?: number | undefined;
    amsCustomer?: AmsCustomerModel | undefined;
    custId?: number | undefined;
    amsBillToCustomer?: AmsCustomerModel | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IAmsOrderModel) {
        super(data);
        if (!data) {
            this.orderLineItems = [];
            this.orderInterruptions = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderId = _data["orderId"];
            this.amsOrderId = _data["amsOrderId"];
            this.orderStatusCode = _data["orderStatusCode"];
            this.priority = _data["priority"];
            this.customer = _data["customer"];
            this.wineryRefNo = _data["wineryRefNo"];
            this.wineryCode = _data["wineryCode"];
            this.amsStorageCustomer = _data["amsStorageCustomer"] ? AmsStorageCustomerModel.fromJS(_data["amsStorageCustomer"]) : <any>undefined;
            this.wineryName = _data["wineryName"];
            this.deliveryInst1 = _data["deliveryInst1"];
            this.deliveryInst2 = _data["deliveryInst2"];
            this.deliveryInst3 = _data["deliveryInst3"];
            this.deliveryZoneCode = _data["deliveryZoneCode"];
            this.shipToName = _data["shipToName"];
            this.shipToAddr1 = _data["shipToAddr1"];
            this.shipToAddr2 = _data["shipToAddr2"];
            this.shipToCity = _data["shipToCity"];
            this.shipToState = _data["shipToState"];
            this.shipToZipCode = _data["shipToZipCode"];
            this.poNumber = _data["poNumber"];
            this.custNo = _data["custNo"];
            this.billToCustNo = _data["billToCustNo"];
            this.shipVia = _data["shipVia"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.assignmentDate = _data["assignmentDate"] ? new Date(_data["assignmentDate"].toString()) : <any>undefined;
            this.progressDate = _data["progressDate"] ? new Date(_data["progressDate"].toString()) : <any>undefined;
            this.orderCompleteDate = _data["orderCompleteDate"] ? new Date(_data["orderCompleteDate"].toString()) : <any>undefined;
            this.expectedShipDate = _data["expectedShipDate"] ? new Date(_data["expectedShipDate"].toString()) : <any>undefined;
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
            this.pickedDate = _data["pickedDate"] ? new Date(_data["pickedDate"].toString()) : <any>undefined;
            this.qcQueueDate = _data["qcQueueDate"] ? new Date(_data["qcQueueDate"].toString()) : <any>undefined;
            this.qcModifiedOn = _data["qcModifiedOn"] ? new Date(_data["qcModifiedOn"].toString()) : <any>undefined;
            this.loadedDate = _data["loadedDate"] ? new Date(_data["loadedDate"].toString()) : <any>undefined;
            this.pickslipDateAndTime = _data["pickslipDateAndTime"] ? new Date(_data["pickslipDateAndTime"].toString()) : <any>undefined;
            this.schedDateAndTime = _data["schedDateAndTime"] ? new Date(_data["schedDateAndTime"].toString()) : <any>undefined;
            this.frghtDesc = _data["frghtDesc"];
            this.carrierCode = _data["carrierCode"];
            this.numberOfPallets = _data["numberOfPallets"];
            this.numberOfCases = _data["numberOfCases"];
            this.numberOfBottles = _data["numberOfBottles"];
            this.locationCode = _data["locationCode"];
            this.locationDestinationCode = _data["locationDestinationCode"];
            this.clerkNote = _data["clerkNote"];
            this.taxExemptCode = _data["taxExemptCode"];
            this.pickedBy = _data["pickedBy"];
            this.pickerUser = _data["pickerUser"] ? SystemUserModel.fromJS(_data["pickerUser"]) : <any>undefined;
            this.qcdBy = _data["qcdBy"];
            this.qcUser = _data["qcUser"] ? SystemUserModel.fromJS(_data["qcUser"]) : <any>undefined;
            this.loadedBy = _data["loadedBy"];
            this.loaderUser = _data["loaderUser"] ? SystemUserModel.fromJS(_data["loaderUser"]) : <any>undefined;
            if (Array.isArray(_data["orderLineItems"])) {
                this.orderLineItems = [] as any;
                for (let item of _data["orderLineItems"])
                    this.orderLineItems!.push(AmsOrderLineItemModel.fromJS(item));
            }
            if (Array.isArray(_data["orderInterruptions"])) {
                this.orderInterruptions = [] as any;
                for (let item of _data["orderInterruptions"])
                    this.orderInterruptions!.push(OrderInterruptionModel.fromJS(item));
            }
            this.billToCustId = _data["billToCustId"];
            this.amsCustomer = _data["amsCustomer"] ? AmsCustomerModel.fromJS(_data["amsCustomer"]) : <any>undefined;
            this.custId = _data["custId"];
            this.amsBillToCustomer = _data["amsBillToCustomer"] ? AmsCustomerModel.fromJS(_data["amsBillToCustomer"]) : <any>undefined;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): AmsOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmsOrderModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["amsOrderId"] = this.amsOrderId;
        data["orderStatusCode"] = this.orderStatusCode;
        data["priority"] = this.priority;
        data["customer"] = this.customer;
        data["wineryRefNo"] = this.wineryRefNo;
        data["wineryCode"] = this.wineryCode;
        data["amsStorageCustomer"] = this.amsStorageCustomer ? this.amsStorageCustomer.toJSON() : <any>undefined;
        data["wineryName"] = this.wineryName;
        data["deliveryInst1"] = this.deliveryInst1;
        data["deliveryInst2"] = this.deliveryInst2;
        data["deliveryInst3"] = this.deliveryInst3;
        data["deliveryZoneCode"] = this.deliveryZoneCode;
        data["shipToName"] = this.shipToName;
        data["shipToAddr1"] = this.shipToAddr1;
        data["shipToAddr2"] = this.shipToAddr2;
        data["shipToCity"] = this.shipToCity;
        data["shipToState"] = this.shipToState;
        data["shipToZipCode"] = this.shipToZipCode;
        data["poNumber"] = this.poNumber;
        data["custNo"] = this.custNo;
        data["billToCustNo"] = this.billToCustNo;
        data["shipVia"] = this.shipVia;
        data["orderDate"] = this.orderDate ? formatDate(this.orderDate) : <any>undefined;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : <any>undefined;
        data["progressDate"] = this.progressDate ? this.progressDate.toISOString() : <any>undefined;
        data["orderCompleteDate"] = this.orderCompleteDate ? this.orderCompleteDate.toISOString() : <any>undefined;
        data["expectedShipDate"] = this.expectedShipDate ? this.expectedShipDate.toISOString() : <any>undefined;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        data["pickedDate"] = this.pickedDate ? this.pickedDate.toISOString() : <any>undefined;
        data["qcQueueDate"] = this.qcQueueDate ? this.qcQueueDate.toISOString() : <any>undefined;
        data["qcModifiedOn"] = this.qcModifiedOn ? this.qcModifiedOn.toISOString() : <any>undefined;
        data["loadedDate"] = this.loadedDate ? this.loadedDate.toISOString() : <any>undefined;
        data["pickslipDateAndTime"] = this.pickslipDateAndTime ? this.pickslipDateAndTime.toISOString() : <any>undefined;
        data["schedDateAndTime"] = this.schedDateAndTime ? this.schedDateAndTime.toISOString() : <any>undefined;
        data["frghtDesc"] = this.frghtDesc;
        data["carrierCode"] = this.carrierCode;
        data["numberOfPallets"] = this.numberOfPallets;
        data["numberOfCases"] = this.numberOfCases;
        data["numberOfBottles"] = this.numberOfBottles;
        data["locationCode"] = this.locationCode;
        data["locationDestinationCode"] = this.locationDestinationCode;
        data["clerkNote"] = this.clerkNote;
        data["taxExemptCode"] = this.taxExemptCode;
        data["pickedBy"] = this.pickedBy;
        data["pickerUser"] = this.pickerUser ? this.pickerUser.toJSON() : <any>undefined;
        data["qcdBy"] = this.qcdBy;
        data["qcUser"] = this.qcUser ? this.qcUser.toJSON() : <any>undefined;
        data["loadedBy"] = this.loadedBy;
        data["loaderUser"] = this.loaderUser ? this.loaderUser.toJSON() : <any>undefined;
        if (Array.isArray(this.orderLineItems)) {
            data["orderLineItems"] = [];
            for (let item of this.orderLineItems)
                data["orderLineItems"].push(item.toJSON());
        }
        if (Array.isArray(this.orderInterruptions)) {
            data["orderInterruptions"] = [];
            for (let item of this.orderInterruptions)
                data["orderInterruptions"].push(item.toJSON());
        }
        data["billToCustId"] = this.billToCustId;
        data["amsCustomer"] = this.amsCustomer ? this.amsCustomer.toJSON() : <any>undefined;
        data["custId"] = this.custId;
        data["amsBillToCustomer"] = this.amsBillToCustomer ? this.amsBillToCustomer.toJSON() : <any>undefined;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAmsOrderModel extends IBasePagedModel {
    orderId: number;
    amsOrderId: number;
    orderStatusCode: AmsOrderStatusEnum;
    priority: number;
    customer: string;
    wineryRefNo: string;
    wineryCode: string;
    amsStorageCustomer?: AmsStorageCustomerModel | undefined;
    wineryName: string;
    deliveryInst1: string;
    deliveryInst2: string;
    deliveryInst3: string;
    deliveryZoneCode: string;
    shipToName: string;
    shipToAddr1: string;
    shipToAddr2: string;
    shipToCity: string;
    shipToState: string;
    shipToZipCode: string;
    poNumber: string;
    custNo?: number | undefined;
    billToCustNo?: number | undefined;
    shipVia: string;
    orderDate?: Date | undefined;
    assignmentDate?: Date | undefined;
    progressDate?: Date | undefined;
    orderCompleteDate?: Date | undefined;
    expectedShipDate?: Date | undefined;
    shipDate?: Date | undefined;
    pickedDate?: Date | undefined;
    qcQueueDate?: Date | undefined;
    qcModifiedOn?: Date | undefined;
    loadedDate?: Date | undefined;
    pickslipDateAndTime?: Date | undefined;
    schedDateAndTime?: Date | undefined;
    frghtDesc: string;
    carrierCode: string;
    numberOfPallets: number;
    numberOfCases: number;
    numberOfBottles: number;
    locationCode: string;
    locationDestinationCode: string;
    clerkNote: string;
    taxExemptCode: AmsOrderTaxExemptCodeEnum;
    pickedBy?: number | undefined;
    pickerUser?: SystemUserModel | undefined;
    qcdBy?: number | undefined;
    qcUser?: SystemUserModel | undefined;
    loadedBy?: number | undefined;
    loaderUser?: SystemUserModel | undefined;
    orderLineItems: AmsOrderLineItemModel[];
    orderInterruptions: OrderInterruptionModel[];
    billToCustId?: number | undefined;
    amsCustomer?: AmsCustomerModel | undefined;
    custId?: number | undefined;
    amsBillToCustomer?: AmsCustomerModel | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export enum AmsOrderStatusEnum {
    All = 0,
    NotStarted = 1,
    InProgress = 2,
    Paused = 3,
    Returned = 4,
    AwaitingQc = 5,
    QcInProgress = 6,
    Completed = 7,
    Cancelled = 8,
}

export class AmsStorageCustomerModel extends BasePagedModel implements IAmsStorageCustomerModel {
    id!: number;
    wineryCode!: string;
    nextCusNo?: number | undefined;
    pwPriceClass?: string | undefined;
    pwSortCode?: string | undefined;
    pwShortDesc?: string | undefined;
    pwDefaultShipLoc?: string | undefined;
    pwSalesTypeCode?: string | undefined;
    datesArea?: string | undefined;
    compName!: string;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city!: string;
    stateCode!: string;
    zipCode?: string | undefined;
    phoneNumber?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IAmsStorageCustomerModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.wineryCode = _data["wineryCode"];
            this.nextCusNo = _data["nextCusNo"];
            this.pwPriceClass = _data["pwPriceClass"];
            this.pwSortCode = _data["pwSortCode"];
            this.pwShortDesc = _data["pwShortDesc"];
            this.pwDefaultShipLoc = _data["pwDefaultShipLoc"];
            this.pwSalesTypeCode = _data["pwSalesTypeCode"];
            this.datesArea = _data["datesArea"];
            this.compName = _data["compName"];
            this.addr1 = _data["addr1"];
            this.addr2 = _data["addr2"];
            this.city = _data["city"];
            this.stateCode = _data["stateCode"];
            this.zipCode = _data["zipCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): AmsStorageCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmsStorageCustomerModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wineryCode"] = this.wineryCode;
        data["nextCusNo"] = this.nextCusNo;
        data["pwPriceClass"] = this.pwPriceClass;
        data["pwSortCode"] = this.pwSortCode;
        data["pwShortDesc"] = this.pwShortDesc;
        data["pwDefaultShipLoc"] = this.pwDefaultShipLoc;
        data["pwSalesTypeCode"] = this.pwSalesTypeCode;
        data["datesArea"] = this.datesArea;
        data["compName"] = this.compName;
        data["addr1"] = this.addr1;
        data["addr2"] = this.addr2;
        data["city"] = this.city;
        data["stateCode"] = this.stateCode;
        data["zipCode"] = this.zipCode;
        data["phoneNumber"] = this.phoneNumber;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAmsStorageCustomerModel extends IBasePagedModel {
    id: number;
    wineryCode: string;
    nextCusNo?: number | undefined;
    pwPriceClass?: string | undefined;
    pwSortCode?: string | undefined;
    pwShortDesc?: string | undefined;
    pwDefaultShipLoc?: string | undefined;
    pwSalesTypeCode?: string | undefined;
    datesArea?: string | undefined;
    compName: string;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city: string;
    stateCode: string;
    zipCode?: string | undefined;
    phoneNumber?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export class Pager implements IPager {
    totalItems!: number;
    itemStart!: number;
    pageSize!: number;
    pageNumber!: number;
    pagerLetter?: string | undefined;
    queryLetters?: string[] | undefined;

    constructor(data?: IPager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalItems = _data["totalItems"];
            this.itemStart = _data["itemStart"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.pagerLetter = _data["pagerLetter"];
            if (Array.isArray(_data["queryLetters"])) {
                this.queryLetters = [] as any;
                for (let item of _data["queryLetters"])
                    this.queryLetters!.push(item);
            }
        }
    }

    static fromJS(data: any): Pager {
        data = typeof data === 'object' ? data : {};
        let result = new Pager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalItems"] = this.totalItems;
        data["itemStart"] = this.itemStart;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["pagerLetter"] = this.pagerLetter;
        if (Array.isArray(this.queryLetters)) {
            data["queryLetters"] = [];
            for (let item of this.queryLetters)
                data["queryLetters"].push(item);
        }
        return data;
    }
}

export interface IPager {
    totalItems: number;
    itemStart: number;
    pageSize: number;
    pageNumber: number;
    pagerLetter?: string | undefined;
    queryLetters?: string[] | undefined;
}

export enum AmsOrderTaxExemptCodeEnum {
    NotSync = 0,
    TB = 1,
    EX = 2,
    NO = 3,
    ET = 4,
    UN = 5,
}

export class SystemUserModel extends BasePagedModel implements ISystemUserModel {
    systemAdmins?: SystemAdminModel[] | undefined;
    systemCustomers?: SystemCustomerModel[] | undefined;
    systemEmployees?: SystemEmployeeModel[] | undefined;
    systemScanToPicks?: SystemScanToPickModel[] | undefined;
    systemUserRoleAssignments!: SystemUserRoleAssignmentModel[];
    systemRoles!: SystemRoleModel[];
    clockedTimes!: ClockedTimeModel[];
    pickerAmsOrders!: AmsOrderModel[];
    qcAmsOrders!: AmsOrderModel[];
    loaderAmsOrders!: AmsOrderModel[];
    tableName!: string;
    systemUserId!: number;
    isActive!: boolean;
    isInvisible!: boolean;
    isDeleted?: boolean | undefined;
    emailAddress?: string | undefined;
    username?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    timeZoneOffsetMinutes?: number | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    datePasswordResetHashExpire?: Date | undefined;
    dateLastLogin?: Date | undefined;
    datePasswordReminded?: Date | undefined;
    password!: string;
    name?: string | undefined;

    constructor(data?: ISystemUserModel) {
        super(data);
        if (!data) {
            this.systemUserRoleAssignments = [];
            this.systemRoles = [];
            this.clockedTimes = [];
            this.pickerAmsOrders = [];
            this.qcAmsOrders = [];
            this.loaderAmsOrders = [];
            this.isActive = false;
            this.isInvisible = false;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["systemAdmins"])) {
                this.systemAdmins = [] as any;
                for (let item of _data["systemAdmins"])
                    this.systemAdmins!.push(SystemAdminModel.fromJS(item));
            }
            if (Array.isArray(_data["systemCustomers"])) {
                this.systemCustomers = [] as any;
                for (let item of _data["systemCustomers"])
                    this.systemCustomers!.push(SystemCustomerModel.fromJS(item));
            }
            if (Array.isArray(_data["systemEmployees"])) {
                this.systemEmployees = [] as any;
                for (let item of _data["systemEmployees"])
                    this.systemEmployees!.push(SystemEmployeeModel.fromJS(item));
            }
            if (Array.isArray(_data["systemScanToPicks"])) {
                this.systemScanToPicks = [] as any;
                for (let item of _data["systemScanToPicks"])
                    this.systemScanToPicks!.push(SystemScanToPickModel.fromJS(item));
            }
            if (Array.isArray(_data["systemUserRoleAssignments"])) {
                this.systemUserRoleAssignments = [] as any;
                for (let item of _data["systemUserRoleAssignments"])
                    this.systemUserRoleAssignments!.push(SystemUserRoleAssignmentModel.fromJS(item));
            }
            if (Array.isArray(_data["systemRoles"])) {
                this.systemRoles = [] as any;
                for (let item of _data["systemRoles"])
                    this.systemRoles!.push(SystemRoleModel.fromJS(item));
            }
            if (Array.isArray(_data["clockedTimes"])) {
                this.clockedTimes = [] as any;
                for (let item of _data["clockedTimes"])
                    this.clockedTimes!.push(ClockedTimeModel.fromJS(item));
            }
            if (Array.isArray(_data["pickerAmsOrders"])) {
                this.pickerAmsOrders = [] as any;
                for (let item of _data["pickerAmsOrders"])
                    this.pickerAmsOrders!.push(AmsOrderModel.fromJS(item));
            }
            if (Array.isArray(_data["qcAmsOrders"])) {
                this.qcAmsOrders = [] as any;
                for (let item of _data["qcAmsOrders"])
                    this.qcAmsOrders!.push(AmsOrderModel.fromJS(item));
            }
            if (Array.isArray(_data["loaderAmsOrders"])) {
                this.loaderAmsOrders = [] as any;
                for (let item of _data["loaderAmsOrders"])
                    this.loaderAmsOrders!.push(AmsOrderModel.fromJS(item));
            }
            this.tableName = _data["tableName"];
            this.systemUserId = _data["systemUserId"];
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : false;
            this.isInvisible = _data["isInvisible"] !== undefined ? _data["isInvisible"] : false;
            this.isDeleted = _data["isDeleted"];
            this.emailAddress = _data["emailAddress"];
            this.username = _data["username"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.timeZoneOffsetMinutes = _data["timeZoneOffsetMinutes"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.datePasswordResetHashExpire = _data["datePasswordResetHashExpire"] ? new Date(_data["datePasswordResetHashExpire"].toString()) : <any>undefined;
            this.dateLastLogin = _data["dateLastLogin"] ? new Date(_data["dateLastLogin"].toString()) : <any>undefined;
            this.datePasswordReminded = _data["datePasswordReminded"] ? new Date(_data["datePasswordReminded"].toString()) : <any>undefined;
            this.password = _data["password"];
            this.name = _data["name"];
        }
    }

    static override fromJS(data: any): SystemUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemAdmins)) {
            data["systemAdmins"] = [];
            for (let item of this.systemAdmins)
                data["systemAdmins"].push(item.toJSON());
        }
        if (Array.isArray(this.systemCustomers)) {
            data["systemCustomers"] = [];
            for (let item of this.systemCustomers)
                data["systemCustomers"].push(item.toJSON());
        }
        if (Array.isArray(this.systemEmployees)) {
            data["systemEmployees"] = [];
            for (let item of this.systemEmployees)
                data["systemEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.systemScanToPicks)) {
            data["systemScanToPicks"] = [];
            for (let item of this.systemScanToPicks)
                data["systemScanToPicks"].push(item.toJSON());
        }
        if (Array.isArray(this.systemUserRoleAssignments)) {
            data["systemUserRoleAssignments"] = [];
            for (let item of this.systemUserRoleAssignments)
                data["systemUserRoleAssignments"].push(item.toJSON());
        }
        if (Array.isArray(this.systemRoles)) {
            data["systemRoles"] = [];
            for (let item of this.systemRoles)
                data["systemRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.clockedTimes)) {
            data["clockedTimes"] = [];
            for (let item of this.clockedTimes)
                data["clockedTimes"].push(item.toJSON());
        }
        if (Array.isArray(this.pickerAmsOrders)) {
            data["pickerAmsOrders"] = [];
            for (let item of this.pickerAmsOrders)
                data["pickerAmsOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.qcAmsOrders)) {
            data["qcAmsOrders"] = [];
            for (let item of this.qcAmsOrders)
                data["qcAmsOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.loaderAmsOrders)) {
            data["loaderAmsOrders"] = [];
            for (let item of this.loaderAmsOrders)
                data["loaderAmsOrders"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["systemUserId"] = this.systemUserId;
        data["isActive"] = this.isActive;
        data["isInvisible"] = this.isInvisible;
        data["isDeleted"] = this.isDeleted;
        data["emailAddress"] = this.emailAddress;
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["timeZoneOffsetMinutes"] = this.timeZoneOffsetMinutes;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["datePasswordResetHashExpire"] = this.datePasswordResetHashExpire ? this.datePasswordResetHashExpire.toISOString() : <any>undefined;
        data["dateLastLogin"] = this.dateLastLogin ? this.dateLastLogin.toISOString() : <any>undefined;
        data["datePasswordReminded"] = this.datePasswordReminded ? this.datePasswordReminded.toISOString() : <any>undefined;
        data["password"] = this.password;
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemUserModel extends IBasePagedModel {
    systemAdmins?: SystemAdminModel[] | undefined;
    systemCustomers?: SystemCustomerModel[] | undefined;
    systemEmployees?: SystemEmployeeModel[] | undefined;
    systemScanToPicks?: SystemScanToPickModel[] | undefined;
    systemUserRoleAssignments: SystemUserRoleAssignmentModel[];
    systemRoles: SystemRoleModel[];
    clockedTimes: ClockedTimeModel[];
    pickerAmsOrders: AmsOrderModel[];
    qcAmsOrders: AmsOrderModel[];
    loaderAmsOrders: AmsOrderModel[];
    tableName: string;
    systemUserId: number;
    isActive: boolean;
    isInvisible: boolean;
    isDeleted?: boolean | undefined;
    emailAddress?: string | undefined;
    username?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    timeZoneOffsetMinutes?: number | undefined;
    dateAdded: Date;
    dateModified: Date;
    datePasswordResetHashExpire?: Date | undefined;
    dateLastLogin?: Date | undefined;
    datePasswordReminded?: Date | undefined;
    password: string;
    name?: string | undefined;
}

export class SystemAdminModel extends BasePagedModel implements ISystemAdminModel {
    systemAdminRoleAssignments!: SystemAdminRoleAssignmentModel[];
    systemUser?: SystemUserModel | undefined;
    overrides?: SystemIdentityPermissionOverrideModel[] | undefined;
    tableName!: string;
    systemAdminId!: number;
    systemUserId?: number | undefined;
    isActive?: boolean | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    systemUserEmailAddress?: string | undefined;
    systemUserUsername?: string | undefined;
    systemUserPhoneNumber?: string | undefined;
    systemUserFirstName?: string | undefined;
    systemUserLastName?: string | undefined;
    systemRoleIds?: number[] | undefined;
    systemRoleNames?: string | undefined;
    loginSubTitle?: string | undefined;
    systemUserIsActive?: boolean | undefined;
    shouldDisplayAsActive?: boolean | undefined;

    constructor(data?: ISystemAdminModel) {
        super(data);
        if (!data) {
            this.systemAdminRoleAssignments = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["systemAdminRoleAssignments"])) {
                this.systemAdminRoleAssignments = [] as any;
                for (let item of _data["systemAdminRoleAssignments"])
                    this.systemAdminRoleAssignments!.push(SystemAdminRoleAssignmentModel.fromJS(item));
            }
            this.systemUser = _data["systemUser"] ? SystemUserModel.fromJS(_data["systemUser"]) : <any>undefined;
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(SystemIdentityPermissionOverrideModel.fromJS(item));
            }
            this.tableName = _data["tableName"];
            this.systemAdminId = _data["systemAdminId"];
            this.systemUserId = _data["systemUserId"];
            this.isActive = _data["isActive"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.systemUserEmailAddress = _data["systemUserEmailAddress"];
            this.systemUserUsername = _data["systemUserUsername"];
            this.systemUserPhoneNumber = _data["systemUserPhoneNumber"];
            this.systemUserFirstName = _data["systemUserFirstName"];
            this.systemUserLastName = _data["systemUserLastName"];
            if (Array.isArray(_data["systemRoleIds"])) {
                this.systemRoleIds = [] as any;
                for (let item of _data["systemRoleIds"])
                    this.systemRoleIds!.push(item);
            }
            this.systemRoleNames = _data["systemRoleNames"];
            this.loginSubTitle = _data["loginSubTitle"];
            this.systemUserIsActive = _data["systemUserIsActive"];
            this.shouldDisplayAsActive = _data["shouldDisplayAsActive"];
        }
    }

    static override fromJS(data: any): SystemAdminModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemAdminModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemAdminRoleAssignments)) {
            data["systemAdminRoleAssignments"] = [];
            for (let item of this.systemAdminRoleAssignments)
                data["systemAdminRoleAssignments"].push(item.toJSON());
        }
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["systemAdminId"] = this.systemAdminId;
        data["systemUserId"] = this.systemUserId;
        data["isActive"] = this.isActive;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["systemUserEmailAddress"] = this.systemUserEmailAddress;
        data["systemUserUsername"] = this.systemUserUsername;
        data["systemUserPhoneNumber"] = this.systemUserPhoneNumber;
        data["systemUserFirstName"] = this.systemUserFirstName;
        data["systemUserLastName"] = this.systemUserLastName;
        if (Array.isArray(this.systemRoleIds)) {
            data["systemRoleIds"] = [];
            for (let item of this.systemRoleIds)
                data["systemRoleIds"].push(item);
        }
        data["systemRoleNames"] = this.systemRoleNames;
        data["loginSubTitle"] = this.loginSubTitle;
        data["systemUserIsActive"] = this.systemUserIsActive;
        data["shouldDisplayAsActive"] = this.shouldDisplayAsActive;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemAdminModel extends IBasePagedModel {
    systemAdminRoleAssignments: SystemAdminRoleAssignmentModel[];
    systemUser?: SystemUserModel | undefined;
    overrides?: SystemIdentityPermissionOverrideModel[] | undefined;
    tableName: string;
    systemAdminId: number;
    systemUserId?: number | undefined;
    isActive?: boolean | undefined;
    dateAdded: Date;
    dateModified: Date;
    systemUserEmailAddress?: string | undefined;
    systemUserUsername?: string | undefined;
    systemUserPhoneNumber?: string | undefined;
    systemUserFirstName?: string | undefined;
    systemUserLastName?: string | undefined;
    systemRoleIds?: number[] | undefined;
    systemRoleNames?: string | undefined;
    loginSubTitle?: string | undefined;
    systemUserIsActive?: boolean | undefined;
    shouldDisplayAsActive?: boolean | undefined;
}

export class SystemAdminRoleAssignmentModel extends BasePagedModel implements ISystemAdminRoleAssignmentModel {
    systemAdmin?: SystemAdminModel | undefined;
    systemRole?: SystemRoleModel | undefined;
    tableName!: string;
    systemAdminId!: number;
    systemRoleId!: number;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: ISystemAdminRoleAssignmentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systemAdmin = _data["systemAdmin"] ? SystemAdminModel.fromJS(_data["systemAdmin"]) : <any>undefined;
            this.systemRole = _data["systemRole"] ? SystemRoleModel.fromJS(_data["systemRole"]) : <any>undefined;
            this.tableName = _data["tableName"];
            this.systemAdminId = _data["systemAdminId"];
            this.systemRoleId = _data["systemRoleId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SystemAdminRoleAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemAdminRoleAssignmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemAdmin"] = this.systemAdmin ? this.systemAdmin.toJSON() : <any>undefined;
        data["systemRole"] = this.systemRole ? this.systemRole.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["systemAdminId"] = this.systemAdminId;
        data["systemRoleId"] = this.systemRoleId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemAdminRoleAssignmentModel extends IBasePagedModel {
    systemAdmin?: SystemAdminModel | undefined;
    systemRole?: SystemRoleModel | undefined;
    tableName: string;
    systemAdminId: number;
    systemRoleId: number;
    dateAdded: Date;
    dateModified: Date;
}

export class SystemRoleModel extends BasePagedModel implements ISystemRoleModel {
    systemRolePermissionAssignments!: SystemRolePermissionAssignmentModel[];
    systemUserRoleAssignments!: SystemUserRoleAssignmentModel[];
    systemUsers!: SystemUserModel[];
    tableName!: string;
    systemRoleId!: number;
    systemRoleGroup!: SystemRoleGroups;
    name!: string;
    description?: string | undefined;
    isActive?: boolean | undefined;
    isDefaultForGroup?: boolean | undefined;
    isAdminDefaultForGroup?: boolean | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    systemPermissions?: SystemPermission[] | undefined;
    systemRoleGroupName?: string | undefined;

    constructor(data?: ISystemRoleModel) {
        super(data);
        if (!data) {
            this.systemRolePermissionAssignments = [];
            this.systemUserRoleAssignments = [];
            this.systemUsers = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["systemRolePermissionAssignments"])) {
                this.systemRolePermissionAssignments = [] as any;
                for (let item of _data["systemRolePermissionAssignments"])
                    this.systemRolePermissionAssignments!.push(SystemRolePermissionAssignmentModel.fromJS(item));
            }
            if (Array.isArray(_data["systemUserRoleAssignments"])) {
                this.systemUserRoleAssignments = [] as any;
                for (let item of _data["systemUserRoleAssignments"])
                    this.systemUserRoleAssignments!.push(SystemUserRoleAssignmentModel.fromJS(item));
            }
            if (Array.isArray(_data["systemUsers"])) {
                this.systemUsers = [] as any;
                for (let item of _data["systemUsers"])
                    this.systemUsers!.push(SystemUserModel.fromJS(item));
            }
            this.tableName = _data["tableName"];
            this.systemRoleId = _data["systemRoleId"];
            this.systemRoleGroup = _data["systemRoleGroup"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isDefaultForGroup = _data["isDefaultForGroup"];
            this.isAdminDefaultForGroup = _data["isAdminDefaultForGroup"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            if (Array.isArray(_data["systemPermissions"])) {
                this.systemPermissions = [] as any;
                for (let item of _data["systemPermissions"])
                    this.systemPermissions!.push(item);
            }
            this.systemRoleGroupName = _data["systemRoleGroupName"];
        }
    }

    static override fromJS(data: any): SystemRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemRoleModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemRolePermissionAssignments)) {
            data["systemRolePermissionAssignments"] = [];
            for (let item of this.systemRolePermissionAssignments)
                data["systemRolePermissionAssignments"].push(item.toJSON());
        }
        if (Array.isArray(this.systemUserRoleAssignments)) {
            data["systemUserRoleAssignments"] = [];
            for (let item of this.systemUserRoleAssignments)
                data["systemUserRoleAssignments"].push(item.toJSON());
        }
        if (Array.isArray(this.systemUsers)) {
            data["systemUsers"] = [];
            for (let item of this.systemUsers)
                data["systemUsers"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["systemRoleId"] = this.systemRoleId;
        data["systemRoleGroup"] = this.systemRoleGroup;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isDefaultForGroup"] = this.isDefaultForGroup;
        data["isAdminDefaultForGroup"] = this.isAdminDefaultForGroup;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        if (Array.isArray(this.systemPermissions)) {
            data["systemPermissions"] = [];
            for (let item of this.systemPermissions)
                data["systemPermissions"].push(item);
        }
        data["systemRoleGroupName"] = this.systemRoleGroupName;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemRoleModel extends IBasePagedModel {
    systemRolePermissionAssignments: SystemRolePermissionAssignmentModel[];
    systemUserRoleAssignments: SystemUserRoleAssignmentModel[];
    systemUsers: SystemUserModel[];
    tableName: string;
    systemRoleId: number;
    systemRoleGroup: SystemRoleGroups;
    name: string;
    description?: string | undefined;
    isActive?: boolean | undefined;
    isDefaultForGroup?: boolean | undefined;
    isAdminDefaultForGroup?: boolean | undefined;
    dateAdded: Date;
    dateModified: Date;
    systemPermissions?: SystemPermission[] | undefined;
    systemRoleGroupName?: string | undefined;
}

export class SystemRolePermissionAssignmentModel extends BasePagedModel implements ISystemRolePermissionAssignmentModel {
    systemRole?: SystemRoleModel | undefined;
    systemPermission?: SystemPermissionModel | undefined;
    tableName!: string;
    systemRoleId!: number;
    systemPermissionId!: SystemPermission;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: ISystemRolePermissionAssignmentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systemRole = _data["systemRole"] ? SystemRoleModel.fromJS(_data["systemRole"]) : <any>undefined;
            this.systemPermission = _data["systemPermission"] ? SystemPermissionModel.fromJS(_data["systemPermission"]) : <any>undefined;
            this.tableName = _data["tableName"];
            this.systemRoleId = _data["systemRoleId"];
            this.systemPermissionId = _data["systemPermissionId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SystemRolePermissionAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemRolePermissionAssignmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemRole"] = this.systemRole ? this.systemRole.toJSON() : <any>undefined;
        data["systemPermission"] = this.systemPermission ? this.systemPermission.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["systemRoleId"] = this.systemRoleId;
        data["systemPermissionId"] = this.systemPermissionId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemRolePermissionAssignmentModel extends IBasePagedModel {
    systemRole?: SystemRoleModel | undefined;
    systemPermission?: SystemPermissionModel | undefined;
    tableName: string;
    systemRoleId: number;
    systemPermissionId: SystemPermission;
    dateAdded: Date;
    dateModified: Date;
}

export class SystemPermissionModel extends BasePagedModel implements ISystemPermissionModel {
    tableName!: string;
    systemPermissionId!: SystemPermission;
    name!: SystemPermission;
    groupName!: SystemPermissionGroupType;
    shortName!: SystemPermissionAccessType;
    description?: string | undefined;
    sortNo?: number | undefined;
    visible?: boolean | undefined;

    constructor(data?: ISystemPermissionModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.systemPermissionId = _data["systemPermissionId"];
            this.name = _data["name"];
            this.groupName = _data["groupName"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.sortNo = _data["sortNo"];
            this.visible = _data["visible"];
        }
    }

    static override fromJS(data: any): SystemPermissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemPermissionModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["systemPermissionId"] = this.systemPermissionId;
        data["name"] = this.name;
        data["groupName"] = this.groupName;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["sortNo"] = this.sortNo;
        data["visible"] = this.visible;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemPermissionModel extends IBasePagedModel {
    tableName: string;
    systemPermissionId: SystemPermission;
    name: SystemPermission;
    groupName: SystemPermissionGroupType;
    shortName: SystemPermissionAccessType;
    description?: string | undefined;
    sortNo?: number | undefined;
    visible?: boolean | undefined;
}

export enum SystemPermission {
    PortalAccess = 1,
    AdminPortalAccess = 2,
    UserAdd = 11,
    UserView = 12,
    UserUpdate = 13,
    UserDelete = 14,
    CustomerAdd = 15,
    CustomerView = 16,
    CustomerUpdate = 17,
    CustomerDelete = 18,
    CarrierAdd = 23,
    CarrierView = 24,
    CarrierUpdate = 25,
    CarrierDelete = 26,
    ScanToPickAdmin = 27,
    ScanToPickClerk = 28,
    ScanToPickPicker = 29,
    ScanToPickQC = 30,
    OrderAdd = 31,
    OrderView = 32,
    OrderUpdate = 33,
    OrderDelete = 34,
    LoadAdd = 35,
    LoadView = 36,
    LoadUpdate = 37,
    LoadDelete = 38,
    LocationAdd = 39,
    LocationView = 40,
    LocationUpdate = 41,
    LocationDelete = 42,
    ReportView = 43,
    OrderNoteAdd = 44,
    OrderNoteView = 45,
    OrderNoteUpdate = 46,
    OrderNoteDelete = 47,
    CustomerNoteAdd = 48,
    CustomerNoteView = 49,
    CustomerNoteUpdate = 50,
    CustomerNoteDelete = 51,
    OrderFileAdd = 52,
    OrderFileView = 53,
    OrderFileUpdate = 54,
    OrderFileDelete = 55,
    CustomerFileAdd = 56,
    CustomerFileView = 57,
    CustomerFileUpdate = 58,
    CustomerFileDelete = 59,
    LoadFileAdd = 62,
    LoadFileView = 63,
    LoadFileUpdate = 64,
    LoadFileDelete = 65,
    CarrierFileAdd = 66,
    CarrierFileView = 67,
    CarrierFileUpdate = 68,
    CarrierFileDelete = 69,
    LoadNoteAdd = 70,
    LoadNoteView = 71,
    LoadNoteUpdate = 72,
    LoadNoteDelete = 73,
    CustomerContactAdd = 74,
    CustomerContactView = 75,
    CustomerContactUpdate = 76,
    CustomerContactDelete = 77,
    LocationContactAdd = 78,
    LocationContactView = 79,
    LocationContactUpdate = 80,
    LocationContactDelete = 81,
    CarrierContactAdd = 82,
    CarrierContactView = 83,
    CarrierContactUpdate = 84,
    CarrierContactDelete = 85,
    LocationNoteView = 86,
    LocationNoteAdd = 87,
    LocationNoteUpdate = 88,
    LocationNoteDelete = 89,
    LocationMerge = 430,
    SyncIssuesView = 431,
    CustomerMerge = 432,
}

export enum SystemPermissionGroupType {
    User = 0,
    Admin = 1,
    AdminUser = 2,
    ScanToPick = 3,
}

export enum SystemPermissionAccessType {
    View = 0,
    Add = 1,
    Update = 2,
    Delete = 3,
    Portal = 4,
}

export class SystemUserRoleAssignmentModel extends BasePagedModel implements ISystemUserRoleAssignmentModel {
    systemRole!: SystemRoleModel;
    systemUser!: SystemUserModel;
    tableName!: string;
    systemRoleId!: number;
    systemUserId!: number;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: ISystemUserRoleAssignmentModel) {
        super(data);
        if (!data) {
            this.systemRole = new SystemRoleModel();
            this.systemUser = new SystemUserModel();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systemRole = _data["systemRole"] ? SystemRoleModel.fromJS(_data["systemRole"]) : new SystemRoleModel();
            this.systemUser = _data["systemUser"] ? SystemUserModel.fromJS(_data["systemUser"]) : new SystemUserModel();
            this.tableName = _data["tableName"];
            this.systemRoleId = _data["systemRoleId"];
            this.systemUserId = _data["systemUserId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SystemUserRoleAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserRoleAssignmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemRole"] = this.systemRole ? this.systemRole.toJSON() : <any>undefined;
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["systemRoleId"] = this.systemRoleId;
        data["systemUserId"] = this.systemUserId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemUserRoleAssignmentModel extends IBasePagedModel {
    systemRole: SystemRoleModel;
    systemUser: SystemUserModel;
    tableName: string;
    systemRoleId: number;
    systemUserId: number;
    dateAdded: Date;
    dateModified: Date;
}

export enum SystemRoleGroups {
    Admin = 0,
    Customers = 1,
    Employee = 2,
    Carrier = 3,
    ScanToPick = 4,
    None = -1,
}

export class SystemIdentityPermissionOverrideModel extends BasePagedModel implements ISystemIdentityPermissionOverrideModel {
    systemUser?: SystemUserModel | undefined;
    systemAdmin?: SystemAdminModel | undefined;
    systemCustomer?: SystemCustomerModel | undefined;
    systemScanToPick?: SystemScanToPickModel | undefined;
    systemEmployee?: SystemEmployeeModel | undefined;
    systemPermission?: SystemPermissionModel | undefined;
    tableName!: string;
    systemIdentityPermissionOverrideId!: number;
    systemUserId!: number;
    systemAdminId?: number | undefined;
    systemCustomerId?: number | undefined;
    systemScanToPickId?: number | undefined;
    systemEmployeeId?: number | undefined;
    systemPermissionId!: SystemPermission;
    enabled!: boolean;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: ISystemIdentityPermissionOverrideModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systemUser = _data["systemUser"] ? SystemUserModel.fromJS(_data["systemUser"]) : <any>undefined;
            this.systemAdmin = _data["systemAdmin"] ? SystemAdminModel.fromJS(_data["systemAdmin"]) : <any>undefined;
            this.systemCustomer = _data["systemCustomer"] ? SystemCustomerModel.fromJS(_data["systemCustomer"]) : <any>undefined;
            this.systemScanToPick = _data["systemScanToPick"] ? SystemScanToPickModel.fromJS(_data["systemScanToPick"]) : <any>undefined;
            this.systemEmployee = _data["systemEmployee"] ? SystemEmployeeModel.fromJS(_data["systemEmployee"]) : <any>undefined;
            this.systemPermission = _data["systemPermission"] ? SystemPermissionModel.fromJS(_data["systemPermission"]) : <any>undefined;
            this.tableName = _data["tableName"];
            this.systemIdentityPermissionOverrideId = _data["systemIdentityPermissionOverrideId"];
            this.systemUserId = _data["systemUserId"];
            this.systemAdminId = _data["systemAdminId"];
            this.systemCustomerId = _data["systemCustomerId"];
            this.systemScanToPickId = _data["systemScanToPickId"];
            this.systemEmployeeId = _data["systemEmployeeId"];
            this.systemPermissionId = _data["systemPermissionId"];
            this.enabled = _data["enabled"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SystemIdentityPermissionOverrideModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemIdentityPermissionOverrideModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        data["systemAdmin"] = this.systemAdmin ? this.systemAdmin.toJSON() : <any>undefined;
        data["systemCustomer"] = this.systemCustomer ? this.systemCustomer.toJSON() : <any>undefined;
        data["systemScanToPick"] = this.systemScanToPick ? this.systemScanToPick.toJSON() : <any>undefined;
        data["systemEmployee"] = this.systemEmployee ? this.systemEmployee.toJSON() : <any>undefined;
        data["systemPermission"] = this.systemPermission ? this.systemPermission.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["systemIdentityPermissionOverrideId"] = this.systemIdentityPermissionOverrideId;
        data["systemUserId"] = this.systemUserId;
        data["systemAdminId"] = this.systemAdminId;
        data["systemCustomerId"] = this.systemCustomerId;
        data["systemScanToPickId"] = this.systemScanToPickId;
        data["systemEmployeeId"] = this.systemEmployeeId;
        data["systemPermissionId"] = this.systemPermissionId;
        data["enabled"] = this.enabled;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemIdentityPermissionOverrideModel extends IBasePagedModel {
    systemUser?: SystemUserModel | undefined;
    systemAdmin?: SystemAdminModel | undefined;
    systemCustomer?: SystemCustomerModel | undefined;
    systemScanToPick?: SystemScanToPickModel | undefined;
    systemEmployee?: SystemEmployeeModel | undefined;
    systemPermission?: SystemPermissionModel | undefined;
    tableName: string;
    systemIdentityPermissionOverrideId: number;
    systemUserId: number;
    systemAdminId?: number | undefined;
    systemCustomerId?: number | undefined;
    systemScanToPickId?: number | undefined;
    systemEmployeeId?: number | undefined;
    systemPermissionId: SystemPermission;
    enabled: boolean;
    dateAdded: Date;
    dateModified: Date;
}

export class SystemCustomerModel extends BasePagedModel implements ISystemCustomerModel {
    systemCustomerRoleAssignments!: SystemCustomerRoleAssignmentModel[];
    systemUser?: SystemUserModel | undefined;
    orderCustomer?: OrderCustomerModel | undefined;
    overrides?: SystemIdentityPermissionOverrideModel[] | undefined;
    tableName!: string;
    systemCustomerId!: number;
    systemUserId?: number | undefined;
    orderCustomerId!: number;
    isActive?: boolean | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    systemUserEmailAddress?: string | undefined;
    systemUserUsername?: string | undefined;
    systemUserPhoneNumber?: string | undefined;
    systemUserFirstName?: string | undefined;
    systemUserLastName?: string | undefined;
    orderCustomerName?: string | undefined;
    systemRoleIds?: number[] | undefined;
    systemRoleNames?: string | undefined;
    name?: string | undefined;
    loginSubTitle?: string | undefined;
    systemUserIsActive?: boolean | undefined;
    shouldDisplayAsActive?: boolean | undefined;

    constructor(data?: ISystemCustomerModel) {
        super(data);
        if (!data) {
            this.systemCustomerRoleAssignments = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["systemCustomerRoleAssignments"])) {
                this.systemCustomerRoleAssignments = [] as any;
                for (let item of _data["systemCustomerRoleAssignments"])
                    this.systemCustomerRoleAssignments!.push(SystemCustomerRoleAssignmentModel.fromJS(item));
            }
            this.systemUser = _data["systemUser"] ? SystemUserModel.fromJS(_data["systemUser"]) : <any>undefined;
            this.orderCustomer = _data["orderCustomer"] ? OrderCustomerModel.fromJS(_data["orderCustomer"]) : <any>undefined;
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(SystemIdentityPermissionOverrideModel.fromJS(item));
            }
            this.tableName = _data["tableName"];
            this.systemCustomerId = _data["systemCustomerId"];
            this.systemUserId = _data["systemUserId"];
            this.orderCustomerId = _data["orderCustomerId"];
            this.isActive = _data["isActive"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.systemUserEmailAddress = _data["systemUserEmailAddress"];
            this.systemUserUsername = _data["systemUserUsername"];
            this.systemUserPhoneNumber = _data["systemUserPhoneNumber"];
            this.systemUserFirstName = _data["systemUserFirstName"];
            this.systemUserLastName = _data["systemUserLastName"];
            this.orderCustomerName = _data["orderCustomerName"];
            if (Array.isArray(_data["systemRoleIds"])) {
                this.systemRoleIds = [] as any;
                for (let item of _data["systemRoleIds"])
                    this.systemRoleIds!.push(item);
            }
            this.systemRoleNames = _data["systemRoleNames"];
            this.name = _data["name"];
            this.loginSubTitle = _data["loginSubTitle"];
            this.systemUserIsActive = _data["systemUserIsActive"];
            this.shouldDisplayAsActive = _data["shouldDisplayAsActive"];
        }
    }

    static override fromJS(data: any): SystemCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCustomerModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemCustomerRoleAssignments)) {
            data["systemCustomerRoleAssignments"] = [];
            for (let item of this.systemCustomerRoleAssignments)
                data["systemCustomerRoleAssignments"].push(item.toJSON());
        }
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        data["orderCustomer"] = this.orderCustomer ? this.orderCustomer.toJSON() : <any>undefined;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["systemCustomerId"] = this.systemCustomerId;
        data["systemUserId"] = this.systemUserId;
        data["orderCustomerId"] = this.orderCustomerId;
        data["isActive"] = this.isActive;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["systemUserEmailAddress"] = this.systemUserEmailAddress;
        data["systemUserUsername"] = this.systemUserUsername;
        data["systemUserPhoneNumber"] = this.systemUserPhoneNumber;
        data["systemUserFirstName"] = this.systemUserFirstName;
        data["systemUserLastName"] = this.systemUserLastName;
        data["orderCustomerName"] = this.orderCustomerName;
        if (Array.isArray(this.systemRoleIds)) {
            data["systemRoleIds"] = [];
            for (let item of this.systemRoleIds)
                data["systemRoleIds"].push(item);
        }
        data["systemRoleNames"] = this.systemRoleNames;
        data["name"] = this.name;
        data["loginSubTitle"] = this.loginSubTitle;
        data["systemUserIsActive"] = this.systemUserIsActive;
        data["shouldDisplayAsActive"] = this.shouldDisplayAsActive;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemCustomerModel extends IBasePagedModel {
    systemCustomerRoleAssignments: SystemCustomerRoleAssignmentModel[];
    systemUser?: SystemUserModel | undefined;
    orderCustomer?: OrderCustomerModel | undefined;
    overrides?: SystemIdentityPermissionOverrideModel[] | undefined;
    tableName: string;
    systemCustomerId: number;
    systemUserId?: number | undefined;
    orderCustomerId: number;
    isActive?: boolean | undefined;
    dateAdded: Date;
    dateModified: Date;
    systemUserEmailAddress?: string | undefined;
    systemUserUsername?: string | undefined;
    systemUserPhoneNumber?: string | undefined;
    systemUserFirstName?: string | undefined;
    systemUserLastName?: string | undefined;
    orderCustomerName?: string | undefined;
    systemRoleIds?: number[] | undefined;
    systemRoleNames?: string | undefined;
    name?: string | undefined;
    loginSubTitle?: string | undefined;
    systemUserIsActive?: boolean | undefined;
    shouldDisplayAsActive?: boolean | undefined;
}

export class SystemCustomerRoleAssignmentModel extends BasePagedModel implements ISystemCustomerRoleAssignmentModel {
    systemCustomer?: SystemCustomerModel | undefined;
    systemRole?: SystemRoleModel | undefined;
    tableName!: string;
    systemCustomerId!: number;
    systemRoleId!: number;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: ISystemCustomerRoleAssignmentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systemCustomer = _data["systemCustomer"] ? SystemCustomerModel.fromJS(_data["systemCustomer"]) : <any>undefined;
            this.systemRole = _data["systemRole"] ? SystemRoleModel.fromJS(_data["systemRole"]) : <any>undefined;
            this.tableName = _data["tableName"];
            this.systemCustomerId = _data["systemCustomerId"];
            this.systemRoleId = _data["systemRoleId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SystemCustomerRoleAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCustomerRoleAssignmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemCustomer"] = this.systemCustomer ? this.systemCustomer.toJSON() : <any>undefined;
        data["systemRole"] = this.systemRole ? this.systemRole.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["systemCustomerId"] = this.systemCustomerId;
        data["systemRoleId"] = this.systemRoleId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemCustomerRoleAssignmentModel extends IBasePagedModel {
    systemCustomer?: SystemCustomerModel | undefined;
    systemRole?: SystemRoleModel | undefined;
    tableName: string;
    systemCustomerId: number;
    systemRoleId: number;
    dateAdded: Date;
    dateModified: Date;
}

export class OrderCustomerModel extends BasePagedModel implements IOrderCustomerModel {
    orderCustomerHasNotes!: OrderCustomerHasNotesModel[];
    orderCustomerHasContacts!: OrderCustomerHasContactsModel[];
    orderCustomerHasLocations!: OrderCustomerHasLocationsModel[];
    locations?: LocationModel[] | undefined;
    orders!: OrderModel[];
    addedByUser?: SystemUserModel | undefined;
    modifiedByUser?: SystemUserModel | undefined;
    tableName!: string;
    orderCustomerId!: number;
    refCountryStateId?: CountryStates | undefined;
    refCountryState?: RefCountryStateModel | undefined;
    refCountryId?: Countries | undefined;
    refCountry?: RefCountryModel | undefined;
    orderCustomerName!: string;
    status!: CustomerStatus;
    address1!: string;
    address2?: string | undefined;
    city!: string;
    zipCode!: string;
    dateAdded!: Date;
    dateModified!: Date;
    dateLastAssigned?: Date | undefined;
    addedByUserId?: number | undefined;
    modifiedByUserId?: number | undefined;
    syncSource?: SyncSourceEnum | undefined;
    externalSyncReviewed!: boolean;
    isActive!: boolean;
    note?: string | undefined;
    stateName?: string | undefined;
    notes?: string | undefined;
    primaryContactName?: string | undefined;
    primaryContactPhone?: string | undefined;
    contactsCount?: number | undefined;
    locationsCount?: number | undefined;
    notesCount?: number | undefined;
    overview?: OverviewDTO | undefined;

    constructor(data?: IOrderCustomerModel) {
        super(data);
        if (!data) {
            this.orderCustomerHasNotes = [];
            this.orderCustomerHasContacts = [];
            this.orderCustomerHasLocations = [];
            this.orders = [];
            this.externalSyncReviewed = false;
            this.isActive = true;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["orderCustomerHasNotes"])) {
                this.orderCustomerHasNotes = [] as any;
                for (let item of _data["orderCustomerHasNotes"])
                    this.orderCustomerHasNotes!.push(OrderCustomerHasNotesModel.fromJS(item));
            }
            if (Array.isArray(_data["orderCustomerHasContacts"])) {
                this.orderCustomerHasContacts = [] as any;
                for (let item of _data["orderCustomerHasContacts"])
                    this.orderCustomerHasContacts!.push(OrderCustomerHasContactsModel.fromJS(item));
            }
            if (Array.isArray(_data["orderCustomerHasLocations"])) {
                this.orderCustomerHasLocations = [] as any;
                for (let item of _data["orderCustomerHasLocations"])
                    this.orderCustomerHasLocations!.push(OrderCustomerHasLocationsModel.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationModel.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderModel.fromJS(item));
            }
            this.addedByUser = _data["addedByUser"] ? SystemUserModel.fromJS(_data["addedByUser"]) : <any>undefined;
            this.modifiedByUser = _data["modifiedByUser"] ? SystemUserModel.fromJS(_data["modifiedByUser"]) : <any>undefined;
            this.tableName = _data["tableName"];
            this.orderCustomerId = _data["orderCustomerId"];
            this.refCountryStateId = _data["refCountryStateId"];
            this.refCountryState = _data["refCountryState"] ? RefCountryStateModel.fromJS(_data["refCountryState"]) : <any>undefined;
            this.refCountryId = _data["refCountryId"];
            this.refCountry = _data["refCountry"] ? RefCountryModel.fromJS(_data["refCountry"]) : <any>undefined;
            this.orderCustomerName = _data["orderCustomerName"];
            this.status = _data["status"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.dateLastAssigned = _data["dateLastAssigned"] ? new Date(_data["dateLastAssigned"].toString()) : <any>undefined;
            this.addedByUserId = _data["addedByUserId"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.syncSource = _data["syncSource"];
            this.externalSyncReviewed = _data["externalSyncReviewed"] !== undefined ? _data["externalSyncReviewed"] : false;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : true;
            this.note = _data["note"];
            this.stateName = _data["stateName"];
            this.notes = _data["notes"];
            this.primaryContactName = _data["primaryContactName"];
            this.primaryContactPhone = _data["primaryContactPhone"];
            this.contactsCount = _data["contactsCount"];
            this.locationsCount = _data["locationsCount"];
            this.notesCount = _data["notesCount"];
            this.overview = _data["overview"] ? OverviewDTO.fromJS(_data["overview"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): OrderCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomerModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderCustomerHasNotes)) {
            data["orderCustomerHasNotes"] = [];
            for (let item of this.orderCustomerHasNotes)
                data["orderCustomerHasNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.orderCustomerHasContacts)) {
            data["orderCustomerHasContacts"] = [];
            for (let item of this.orderCustomerHasContacts)
                data["orderCustomerHasContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.orderCustomerHasLocations)) {
            data["orderCustomerHasLocations"] = [];
            for (let item of this.orderCustomerHasLocations)
                data["orderCustomerHasLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["addedByUser"] = this.addedByUser ? this.addedByUser.toJSON() : <any>undefined;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["orderCustomerId"] = this.orderCustomerId;
        data["refCountryStateId"] = this.refCountryStateId;
        data["refCountryState"] = this.refCountryState ? this.refCountryState.toJSON() : <any>undefined;
        data["refCountryId"] = this.refCountryId;
        data["refCountry"] = this.refCountry ? this.refCountry.toJSON() : <any>undefined;
        data["orderCustomerName"] = this.orderCustomerName;
        data["status"] = this.status;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["dateLastAssigned"] = this.dateLastAssigned ? this.dateLastAssigned.toISOString() : <any>undefined;
        data["addedByUserId"] = this.addedByUserId;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["syncSource"] = this.syncSource;
        data["externalSyncReviewed"] = this.externalSyncReviewed;
        data["isActive"] = this.isActive;
        data["note"] = this.note;
        data["stateName"] = this.stateName;
        data["notes"] = this.notes;
        data["primaryContactName"] = this.primaryContactName;
        data["primaryContactPhone"] = this.primaryContactPhone;
        data["contactsCount"] = this.contactsCount;
        data["locationsCount"] = this.locationsCount;
        data["notesCount"] = this.notesCount;
        data["overview"] = this.overview ? this.overview.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderCustomerModel extends IBasePagedModel {
    orderCustomerHasNotes: OrderCustomerHasNotesModel[];
    orderCustomerHasContacts: OrderCustomerHasContactsModel[];
    orderCustomerHasLocations: OrderCustomerHasLocationsModel[];
    locations?: LocationModel[] | undefined;
    orders: OrderModel[];
    addedByUser?: SystemUserModel | undefined;
    modifiedByUser?: SystemUserModel | undefined;
    tableName: string;
    orderCustomerId: number;
    refCountryStateId?: CountryStates | undefined;
    refCountryState?: RefCountryStateModel | undefined;
    refCountryId?: Countries | undefined;
    refCountry?: RefCountryModel | undefined;
    orderCustomerName: string;
    status: CustomerStatus;
    address1: string;
    address2?: string | undefined;
    city: string;
    zipCode: string;
    dateAdded: Date;
    dateModified: Date;
    dateLastAssigned?: Date | undefined;
    addedByUserId?: number | undefined;
    modifiedByUserId?: number | undefined;
    syncSource?: SyncSourceEnum | undefined;
    externalSyncReviewed: boolean;
    isActive: boolean;
    note?: string | undefined;
    stateName?: string | undefined;
    notes?: string | undefined;
    primaryContactName?: string | undefined;
    primaryContactPhone?: string | undefined;
    contactsCount?: number | undefined;
    locationsCount?: number | undefined;
    notesCount?: number | undefined;
    overview?: OverviewDTO | undefined;
}

export class OrderCustomerHasNotesModel implements IOrderCustomerHasNotesModel {
    orderCustomerId!: number;
    orderCustomer!: OrderCustomerModel;
    noteId!: number;
    note!: NoteModel;

    constructor(data?: IOrderCustomerHasNotesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderCustomer = new OrderCustomerModel();
            this.note = new NoteModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCustomerId = _data["orderCustomerId"];
            this.orderCustomer = _data["orderCustomer"] ? OrderCustomerModel.fromJS(_data["orderCustomer"]) : new OrderCustomerModel();
            this.noteId = _data["noteId"];
            this.note = _data["note"] ? NoteModel.fromJS(_data["note"]) : new NoteModel();
        }
    }

    static fromJS(data: any): OrderCustomerHasNotesModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomerHasNotesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCustomerId"] = this.orderCustomerId;
        data["orderCustomer"] = this.orderCustomer ? this.orderCustomer.toJSON() : <any>undefined;
        data["noteId"] = this.noteId;
        data["note"] = this.note ? this.note.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderCustomerHasNotesModel {
    orderCustomerId: number;
    orderCustomer: OrderCustomerModel;
    noteId: number;
    note: NoteModel;
}

export class NoteModel extends BasePagedModel implements INoteModel {
    tableName!: string;
    modifiedByUser?: SystemUserModel | undefined;
    createdByUser?: SystemUserModel | undefined;
    noteId!: number;
    noteContent!: string;
    dateAdded!: Date;
    dateModified!: Date;
    modifiedByUserId?: number | undefined;
    createdByUserId?: number | undefined;
    deprecateD_CreatorName?: string | undefined;
    createdByUserName?: string | undefined;
    modifiedByUserName?: string | undefined;

    constructor(data?: INoteModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.modifiedByUser = _data["modifiedByUser"] ? SystemUserModel.fromJS(_data["modifiedByUser"]) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? SystemUserModel.fromJS(_data["createdByUser"]) : <any>undefined;
            this.noteId = _data["noteId"];
            this.noteContent = _data["noteContent"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.createdByUserId = _data["createdByUserId"];
            this.deprecateD_CreatorName = _data["deprecateD_CreatorName"];
            this.createdByUserName = _data["createdByUserName"];
            this.modifiedByUserName = _data["modifiedByUserName"];
        }
    }

    static override fromJS(data: any): NoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new NoteModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["noteId"] = this.noteId;
        data["noteContent"] = this.noteContent;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["createdByUserId"] = this.createdByUserId;
        data["deprecateD_CreatorName"] = this.deprecateD_CreatorName;
        data["createdByUserName"] = this.createdByUserName;
        data["modifiedByUserName"] = this.modifiedByUserName;
        super.toJSON(data);
        return data;
    }
}

export interface INoteModel extends IBasePagedModel {
    tableName: string;
    modifiedByUser?: SystemUserModel | undefined;
    createdByUser?: SystemUserModel | undefined;
    noteId: number;
    noteContent: string;
    dateAdded: Date;
    dateModified: Date;
    modifiedByUserId?: number | undefined;
    createdByUserId?: number | undefined;
    deprecateD_CreatorName?: string | undefined;
    createdByUserName?: string | undefined;
    modifiedByUserName?: string | undefined;
}

export class OrderCustomerHasContactsModel implements IOrderCustomerHasContactsModel {
    orderCustomerId!: number;
    orderCustomer!: OrderCustomerModel;
    contactId!: number;
    contact!: ContactModel;

    constructor(data?: IOrderCustomerHasContactsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderCustomer = new OrderCustomerModel();
            this.contact = new ContactModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCustomerId = _data["orderCustomerId"];
            this.orderCustomer = _data["orderCustomer"] ? OrderCustomerModel.fromJS(_data["orderCustomer"]) : new OrderCustomerModel();
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? ContactModel.fromJS(_data["contact"]) : new ContactModel();
        }
    }

    static fromJS(data: any): OrderCustomerHasContactsModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomerHasContactsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCustomerId"] = this.orderCustomerId;
        data["orderCustomer"] = this.orderCustomer ? this.orderCustomer.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderCustomerHasContactsModel {
    orderCustomerId: number;
    orderCustomer: OrderCustomerModel;
    contactId: number;
    contact: ContactModel;
}

export class ContactModel extends BasePagedModel implements IContactModel {
    tableName!: string;
    modifiedByUser?: SystemUserModel | undefined;
    location?: LocationHasContactsModel | undefined;
    carrier?: CarrierHasContactsModel | undefined;
    contactId!: number;
    contactType!: ContactType;
    description!: string;
    name!: string;
    email?: string | undefined;
    phone?: string | undefined;
    notes?: string | undefined;
    isPrimaryContact?: boolean | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    modifiedByUserId?: number | undefined;

    constructor(data?: IContactModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.modifiedByUser = _data["modifiedByUser"] ? SystemUserModel.fromJS(_data["modifiedByUser"]) : <any>undefined;
            this.location = _data["location"] ? LocationHasContactsModel.fromJS(_data["location"]) : <any>undefined;
            this.carrier = _data["carrier"] ? CarrierHasContactsModel.fromJS(_data["carrier"]) : <any>undefined;
            this.contactId = _data["contactId"];
            this.contactType = _data["contactType"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.notes = _data["notes"];
            this.isPrimaryContact = _data["isPrimaryContact"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.modifiedByUserId = _data["modifiedByUserId"];
        }
    }

    static override fromJS(data: any): ContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        data["contactType"] = this.contactType;
        data["description"] = this.description;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["notes"] = this.notes;
        data["isPrimaryContact"] = this.isPrimaryContact;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["modifiedByUserId"] = this.modifiedByUserId;
        super.toJSON(data);
        return data;
    }
}

export interface IContactModel extends IBasePagedModel {
    tableName: string;
    modifiedByUser?: SystemUserModel | undefined;
    location?: LocationHasContactsModel | undefined;
    carrier?: CarrierHasContactsModel | undefined;
    contactId: number;
    contactType: ContactType;
    description: string;
    name: string;
    email?: string | undefined;
    phone?: string | undefined;
    notes?: string | undefined;
    isPrimaryContact?: boolean | undefined;
    dateAdded: Date;
    dateModified: Date;
    modifiedByUserId?: number | undefined;
}

export class LocationHasContactsModel implements ILocationHasContactsModel {
    locationId!: number;
    location?: LocationModel | undefined;
    contactId!: number;
    contact?: ContactModel | undefined;

    constructor(data?: ILocationHasContactsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? ContactModel.fromJS(_data["contact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationHasContactsModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationHasContactsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILocationHasContactsModel {
    locationId: number;
    location?: LocationModel | undefined;
    contactId: number;
    contact?: ContactModel | undefined;
}

export class LocationModel extends BasePagedModel implements ILocationModel {
    tableName!: string;
    sourceOrders!: OrderModel[];
    destinationOrders!: OrderModel[];
    currentStopOrders!: OrderModel[];
    nextStopOrders!: OrderModel[];
    country?: RefCountryModel | undefined;
    state?: RefCountryStateModel | undefined;
    relatedOrderCustomer?: OrderCustomerModel | undefined;
    modifiedByUser?: SystemUserModel | undefined;
    addedByUser?: SystemUserModel | undefined;
    locationHasNotes!: LocationHasNotesModel[];
    locationHasContacts!: LocationHasContactsModel[];
    orderCustomerHasLocations!: OrderCustomerHasLocationsModel[];
    locationId!: number;
    relatedOrderCustomerId?: number | undefined;
    refCountryId?: Countries | undefined;
    refStateId?: CountryStates | undefined;
    modifiedByUserId?: number | undefined;
    addedByUserId?: number | undefined;
    name!: string;
    address!: string;
    address2?: string | undefined;
    city!: string;
    zipCode?: string | undefined;
    locationDirections?: string | undefined;
    isNWDWarehouse?: boolean | undefined;
    ignoredByWarehousePickupsReport?: boolean | undefined;
    externalId?: string | undefined;
    syncSource?: SyncSourceEnum | undefined;
    externalSyncReviewed!: boolean;
    dateAdded!: Date;
    dateModified!: Date;
    dateLastAssigned?: Date | undefined;
    isActive!: boolean;
    countryName?: string | undefined;
    stateName?: string | undefined;
    contactsCount?: number | undefined;
    primaryContactName?: string | undefined;
    primaryContactPhone?: string | undefined;

    constructor(data?: ILocationModel) {
        super(data);
        if (!data) {
            this.sourceOrders = [];
            this.destinationOrders = [];
            this.currentStopOrders = [];
            this.nextStopOrders = [];
            this.locationHasNotes = [];
            this.locationHasContacts = [];
            this.orderCustomerHasLocations = [];
            this.externalSyncReviewed = false;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            if (Array.isArray(_data["sourceOrders"])) {
                this.sourceOrders = [] as any;
                for (let item of _data["sourceOrders"])
                    this.sourceOrders!.push(OrderModel.fromJS(item));
            }
            if (Array.isArray(_data["destinationOrders"])) {
                this.destinationOrders = [] as any;
                for (let item of _data["destinationOrders"])
                    this.destinationOrders!.push(OrderModel.fromJS(item));
            }
            if (Array.isArray(_data["currentStopOrders"])) {
                this.currentStopOrders = [] as any;
                for (let item of _data["currentStopOrders"])
                    this.currentStopOrders!.push(OrderModel.fromJS(item));
            }
            if (Array.isArray(_data["nextStopOrders"])) {
                this.nextStopOrders = [] as any;
                for (let item of _data["nextStopOrders"])
                    this.nextStopOrders!.push(OrderModel.fromJS(item));
            }
            this.country = _data["country"] ? RefCountryModel.fromJS(_data["country"]) : <any>undefined;
            this.state = _data["state"] ? RefCountryStateModel.fromJS(_data["state"]) : <any>undefined;
            this.relatedOrderCustomer = _data["relatedOrderCustomer"] ? OrderCustomerModel.fromJS(_data["relatedOrderCustomer"]) : <any>undefined;
            this.modifiedByUser = _data["modifiedByUser"] ? SystemUserModel.fromJS(_data["modifiedByUser"]) : <any>undefined;
            this.addedByUser = _data["addedByUser"] ? SystemUserModel.fromJS(_data["addedByUser"]) : <any>undefined;
            if (Array.isArray(_data["locationHasNotes"])) {
                this.locationHasNotes = [] as any;
                for (let item of _data["locationHasNotes"])
                    this.locationHasNotes!.push(LocationHasNotesModel.fromJS(item));
            }
            if (Array.isArray(_data["locationHasContacts"])) {
                this.locationHasContacts = [] as any;
                for (let item of _data["locationHasContacts"])
                    this.locationHasContacts!.push(LocationHasContactsModel.fromJS(item));
            }
            if (Array.isArray(_data["orderCustomerHasLocations"])) {
                this.orderCustomerHasLocations = [] as any;
                for (let item of _data["orderCustomerHasLocations"])
                    this.orderCustomerHasLocations!.push(OrderCustomerHasLocationsModel.fromJS(item));
            }
            this.locationId = _data["locationId"];
            this.relatedOrderCustomerId = _data["relatedOrderCustomerId"];
            this.refCountryId = _data["refCountryId"];
            this.refStateId = _data["refStateId"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.addedByUserId = _data["addedByUserId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.locationDirections = _data["locationDirections"];
            this.isNWDWarehouse = _data["isNWDWarehouse"];
            this.ignoredByWarehousePickupsReport = _data["ignoredByWarehousePickupsReport"];
            this.externalId = _data["externalId"];
            this.syncSource = _data["syncSource"];
            this.externalSyncReviewed = _data["externalSyncReviewed"] !== undefined ? _data["externalSyncReviewed"] : false;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.dateLastAssigned = _data["dateLastAssigned"] ? new Date(_data["dateLastAssigned"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.countryName = _data["countryName"];
            this.stateName = _data["stateName"];
            this.contactsCount = _data["contactsCount"];
            this.primaryContactName = _data["primaryContactName"];
            this.primaryContactPhone = _data["primaryContactPhone"];
        }
    }

    static override fromJS(data: any): LocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        if (Array.isArray(this.sourceOrders)) {
            data["sourceOrders"] = [];
            for (let item of this.sourceOrders)
                data["sourceOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.destinationOrders)) {
            data["destinationOrders"] = [];
            for (let item of this.destinationOrders)
                data["destinationOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.currentStopOrders)) {
            data["currentStopOrders"] = [];
            for (let item of this.currentStopOrders)
                data["currentStopOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.nextStopOrders)) {
            data["nextStopOrders"] = [];
            for (let item of this.nextStopOrders)
                data["nextStopOrders"].push(item.toJSON());
        }
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        data["relatedOrderCustomer"] = this.relatedOrderCustomer ? this.relatedOrderCustomer.toJSON() : <any>undefined;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : <any>undefined;
        data["addedByUser"] = this.addedByUser ? this.addedByUser.toJSON() : <any>undefined;
        if (Array.isArray(this.locationHasNotes)) {
            data["locationHasNotes"] = [];
            for (let item of this.locationHasNotes)
                data["locationHasNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.locationHasContacts)) {
            data["locationHasContacts"] = [];
            for (let item of this.locationHasContacts)
                data["locationHasContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.orderCustomerHasLocations)) {
            data["orderCustomerHasLocations"] = [];
            for (let item of this.orderCustomerHasLocations)
                data["orderCustomerHasLocations"].push(item.toJSON());
        }
        data["locationId"] = this.locationId;
        data["relatedOrderCustomerId"] = this.relatedOrderCustomerId;
        data["refCountryId"] = this.refCountryId;
        data["refStateId"] = this.refStateId;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["addedByUserId"] = this.addedByUserId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["locationDirections"] = this.locationDirections;
        data["isNWDWarehouse"] = this.isNWDWarehouse;
        data["ignoredByWarehousePickupsReport"] = this.ignoredByWarehousePickupsReport;
        data["externalId"] = this.externalId;
        data["syncSource"] = this.syncSource;
        data["externalSyncReviewed"] = this.externalSyncReviewed;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["dateLastAssigned"] = this.dateLastAssigned ? this.dateLastAssigned.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["countryName"] = this.countryName;
        data["stateName"] = this.stateName;
        data["contactsCount"] = this.contactsCount;
        data["primaryContactName"] = this.primaryContactName;
        data["primaryContactPhone"] = this.primaryContactPhone;
        super.toJSON(data);
        return data;
    }
}

export interface ILocationModel extends IBasePagedModel {
    tableName: string;
    sourceOrders: OrderModel[];
    destinationOrders: OrderModel[];
    currentStopOrders: OrderModel[];
    nextStopOrders: OrderModel[];
    country?: RefCountryModel | undefined;
    state?: RefCountryStateModel | undefined;
    relatedOrderCustomer?: OrderCustomerModel | undefined;
    modifiedByUser?: SystemUserModel | undefined;
    addedByUser?: SystemUserModel | undefined;
    locationHasNotes: LocationHasNotesModel[];
    locationHasContacts: LocationHasContactsModel[];
    orderCustomerHasLocations: OrderCustomerHasLocationsModel[];
    locationId: number;
    relatedOrderCustomerId?: number | undefined;
    refCountryId?: Countries | undefined;
    refStateId?: CountryStates | undefined;
    modifiedByUserId?: number | undefined;
    addedByUserId?: number | undefined;
    name: string;
    address: string;
    address2?: string | undefined;
    city: string;
    zipCode?: string | undefined;
    locationDirections?: string | undefined;
    isNWDWarehouse?: boolean | undefined;
    ignoredByWarehousePickupsReport?: boolean | undefined;
    externalId?: string | undefined;
    syncSource?: SyncSourceEnum | undefined;
    externalSyncReviewed: boolean;
    dateAdded: Date;
    dateModified: Date;
    dateLastAssigned?: Date | undefined;
    isActive: boolean;
    countryName?: string | undefined;
    stateName?: string | undefined;
    contactsCount?: number | undefined;
    primaryContactName?: string | undefined;
    primaryContactPhone?: string | undefined;
}

export abstract class ChangelogTrackedBasePagedModel extends BasePagedModel implements IChangelogTrackedBasePagedModel {

    constructor(data?: IChangelogTrackedBasePagedModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChangelogTrackedBasePagedModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ChangelogTrackedBasePagedModel' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IChangelogTrackedBasePagedModel extends IBasePagedModel {
}

export class OrderModel extends ChangelogTrackedBasePagedModel implements IOrderModel {
    tableName!: string;
    changelogs!: OrderChangelogModel[];
    deliveringCarrier?: CarrierModel | undefined;
    orderCustomer?: OrderCustomerModel | undefined;
    refOrderStatus?: RefOrderStatusModel | undefined;
    refOrderStep?: RefOrderTypeModel | undefined;
    pickedByUser?: SystemUserModel | undefined;
    addedByUser?: SystemUserModel | undefined;
    modifiedByUser?: SystemUserModel | undefined;
    placedByCustomerUser?: SystemUserModel | undefined;
    loadStopOrders!: LoadStopOrderModel[];
    orderGroup?: OrderGroupModel | undefined;
    sourceLocation?: LocationModel | undefined;
    destinationLocation?: LocationModel | undefined;
    currentLocation?: LocationModel | undefined;
    nextLocation?: LocationModel | undefined;
    pickLocation?: LocationModel | undefined;
    orderHasNotes!: OrderHasNotesModel[];
    orderHasFiles!: OrderHasFilesModel[];
    orderId!: number;
    orderGroupId?: number | undefined;
    orderCustomerId!: number;
    refOrderStatusId!: OrderStatus;
    refOrderTypeId?: OrderType | undefined;
    warehouseId!: number;
    sourceLocationId?: number | undefined;
    destinationLocationId?: number | undefined;
    currentLocationId?: number | undefined;
    nextLocationId?: number | undefined;
    pickLocationId?: number | undefined;
    addedByUserId?: number | undefined;
    modifiedByUserId?: number | undefined;
    pickedByUserId?: number | undefined;
    placedByCustomerUserId?: number | undefined;
    deliveringCarrierId?: number | undefined;
    externalId?: string | undefined;
    syncSource?: SyncSourceEnum | undefined;
    poNumber?: string | undefined;
    producerName?: string | undefined;
    bol?: string | undefined;
    special?: string | undefined;
    quantity?: number | undefined;
    caseEquivalent?: number | undefined;
    numberOfBottles?: number | undefined;
    unitType?: OrderUnitType | undefined;
    isPicked!: boolean;
    revenue?: number | undefined;
    cons?: string | undefined;
    ignoreStatusUpdates!: boolean;
    migrationError?: string | undefined;
    datePicked?: Date | undefined;
    datePickBy?: Date | undefined;
    datePlaced?: Date | undefined;
    dateReadyBy?: Date | undefined;
    dateNeededBy?: Date | undefined;
    dateShipBy?: Date | undefined;
    dateEstimatedShipBy?: Date | undefined;
    dateShipped?: Date | undefined;
    dateDelivered?: Date | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    statusName?: string | undefined;
    latestNote?: NoteModel | undefined;
    orderCustomerName?: string | undefined;
    numberOfLoads?: number | undefined;
    numberOfNotes?: number | undefined;
    isConsolidation!: boolean;
    consolidationLocationId!: number;
    orderIsOnLoad!: boolean;
    stepName?: string | undefined;
    sourceLocationName?: string | undefined;
    sourceCityName?: string | undefined;
    sourceStateAbbrv?: string | undefined;
    sourceLocationText?: string | undefined;
    destinationLocationName?: string | undefined;
    destinationCityName?: string | undefined;
    destinationStateAbbrv?: string | undefined;
    destinationLocationText?: string | undefined;
    currentLocationName?: string | undefined;
    currentLocationText?: string | undefined;
    nextLocationName?: string | undefined;
    nextLocationText?: string | undefined;
    loadIdsForThisOrder?: number[] | undefined;
    placedByCustomerUserName?: string | undefined;
    initialCustomerNoteOnAddingOrder?: string | undefined;
    pickedByUserFullName?: string | undefined;
    deliveringCarrierName?: string | undefined;

    constructor(data?: IOrderModel) {
        super(data);
        if (!data) {
            this.changelogs = [];
            this.loadStopOrders = [];
            this.orderHasNotes = [];
            this.orderHasFiles = [];
            this.ignoreStatusUpdates = false;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            if (Array.isArray(_data["changelogs"])) {
                this.changelogs = [] as any;
                for (let item of _data["changelogs"])
                    this.changelogs!.push(OrderChangelogModel.fromJS(item));
            }
            this.deliveringCarrier = _data["deliveringCarrier"] ? CarrierModel.fromJS(_data["deliveringCarrier"]) : <any>undefined;
            this.orderCustomer = _data["orderCustomer"] ? OrderCustomerModel.fromJS(_data["orderCustomer"]) : <any>undefined;
            this.refOrderStatus = _data["refOrderStatus"] ? RefOrderStatusModel.fromJS(_data["refOrderStatus"]) : <any>undefined;
            this.refOrderStep = _data["refOrderStep"] ? RefOrderTypeModel.fromJS(_data["refOrderStep"]) : <any>undefined;
            this.pickedByUser = _data["pickedByUser"] ? SystemUserModel.fromJS(_data["pickedByUser"]) : <any>undefined;
            this.addedByUser = _data["addedByUser"] ? SystemUserModel.fromJS(_data["addedByUser"]) : <any>undefined;
            this.modifiedByUser = _data["modifiedByUser"] ? SystemUserModel.fromJS(_data["modifiedByUser"]) : <any>undefined;
            this.placedByCustomerUser = _data["placedByCustomerUser"] ? SystemUserModel.fromJS(_data["placedByCustomerUser"]) : <any>undefined;
            if (Array.isArray(_data["loadStopOrders"])) {
                this.loadStopOrders = [] as any;
                for (let item of _data["loadStopOrders"])
                    this.loadStopOrders!.push(LoadStopOrderModel.fromJS(item));
            }
            this.orderGroup = _data["orderGroup"] ? OrderGroupModel.fromJS(_data["orderGroup"]) : <any>undefined;
            this.sourceLocation = _data["sourceLocation"] ? LocationModel.fromJS(_data["sourceLocation"]) : <any>undefined;
            this.destinationLocation = _data["destinationLocation"] ? LocationModel.fromJS(_data["destinationLocation"]) : <any>undefined;
            this.currentLocation = _data["currentLocation"] ? LocationModel.fromJS(_data["currentLocation"]) : <any>undefined;
            this.nextLocation = _data["nextLocation"] ? LocationModel.fromJS(_data["nextLocation"]) : <any>undefined;
            this.pickLocation = _data["pickLocation"] ? LocationModel.fromJS(_data["pickLocation"]) : <any>undefined;
            if (Array.isArray(_data["orderHasNotes"])) {
                this.orderHasNotes = [] as any;
                for (let item of _data["orderHasNotes"])
                    this.orderHasNotes!.push(OrderHasNotesModel.fromJS(item));
            }
            if (Array.isArray(_data["orderHasFiles"])) {
                this.orderHasFiles = [] as any;
                for (let item of _data["orderHasFiles"])
                    this.orderHasFiles!.push(OrderHasFilesModel.fromJS(item));
            }
            this.orderId = _data["orderId"];
            this.orderGroupId = _data["orderGroupId"];
            this.orderCustomerId = _data["orderCustomerId"];
            this.refOrderStatusId = _data["refOrderStatusId"];
            this.refOrderTypeId = _data["refOrderTypeId"];
            this.warehouseId = _data["warehouseId"];
            this.sourceLocationId = _data["sourceLocationId"];
            this.destinationLocationId = _data["destinationLocationId"];
            this.currentLocationId = _data["currentLocationId"];
            this.nextLocationId = _data["nextLocationId"];
            this.pickLocationId = _data["pickLocationId"];
            this.addedByUserId = _data["addedByUserId"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.pickedByUserId = _data["pickedByUserId"];
            this.placedByCustomerUserId = _data["placedByCustomerUserId"];
            this.deliveringCarrierId = _data["deliveringCarrierId"];
            this.externalId = _data["externalId"];
            this.syncSource = _data["syncSource"];
            this.poNumber = _data["poNumber"];
            this.producerName = _data["producerName"];
            this.bol = _data["bol"];
            this.special = _data["special"];
            this.quantity = _data["quantity"];
            this.caseEquivalent = _data["caseEquivalent"];
            this.numberOfBottles = _data["numberOfBottles"];
            this.unitType = _data["unitType"];
            this.isPicked = _data["isPicked"];
            this.revenue = _data["revenue"];
            this.cons = _data["cons"];
            this.ignoreStatusUpdates = _data["ignoreStatusUpdates"] !== undefined ? _data["ignoreStatusUpdates"] : false;
            this.migrationError = _data["migrationError"];
            this.datePicked = _data["datePicked"] ? new Date(_data["datePicked"].toString()) : <any>undefined;
            this.datePickBy = _data["datePickBy"] ? new Date(_data["datePickBy"].toString()) : <any>undefined;
            this.datePlaced = _data["datePlaced"] ? new Date(_data["datePlaced"].toString()) : <any>undefined;
            this.dateReadyBy = _data["dateReadyBy"] ? new Date(_data["dateReadyBy"].toString()) : <any>undefined;
            this.dateNeededBy = _data["dateNeededBy"] ? new Date(_data["dateNeededBy"].toString()) : <any>undefined;
            this.dateShipBy = _data["dateShipBy"] ? new Date(_data["dateShipBy"].toString()) : <any>undefined;
            this.dateEstimatedShipBy = _data["dateEstimatedShipBy"] ? new Date(_data["dateEstimatedShipBy"].toString()) : <any>undefined;
            this.dateShipped = _data["dateShipped"] ? new Date(_data["dateShipped"].toString()) : <any>undefined;
            this.dateDelivered = _data["dateDelivered"] ? new Date(_data["dateDelivered"].toString()) : <any>undefined;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.statusName = _data["statusName"];
            this.latestNote = _data["latestNote"] ? NoteModel.fromJS(_data["latestNote"]) : <any>undefined;
            this.orderCustomerName = _data["orderCustomerName"];
            this.numberOfLoads = _data["numberOfLoads"];
            this.numberOfNotes = _data["numberOfNotes"];
            this.isConsolidation = _data["isConsolidation"];
            this.consolidationLocationId = _data["consolidationLocationId"];
            this.orderIsOnLoad = _data["orderIsOnLoad"];
            this.stepName = _data["stepName"];
            this.sourceLocationName = _data["sourceLocationName"];
            this.sourceCityName = _data["sourceCityName"];
            this.sourceStateAbbrv = _data["sourceStateAbbrv"];
            this.sourceLocationText = _data["sourceLocationText"];
            this.destinationLocationName = _data["destinationLocationName"];
            this.destinationCityName = _data["destinationCityName"];
            this.destinationStateAbbrv = _data["destinationStateAbbrv"];
            this.destinationLocationText = _data["destinationLocationText"];
            this.currentLocationName = _data["currentLocationName"];
            this.currentLocationText = _data["currentLocationText"];
            this.nextLocationName = _data["nextLocationName"];
            this.nextLocationText = _data["nextLocationText"];
            if (Array.isArray(_data["loadIdsForThisOrder"])) {
                this.loadIdsForThisOrder = [] as any;
                for (let item of _data["loadIdsForThisOrder"])
                    this.loadIdsForThisOrder!.push(item);
            }
            this.placedByCustomerUserName = _data["placedByCustomerUserName"];
            this.initialCustomerNoteOnAddingOrder = _data["initialCustomerNoteOnAddingOrder"];
            this.pickedByUserFullName = _data["pickedByUserFullName"];
            this.deliveringCarrierName = _data["deliveringCarrierName"];
        }
    }

    static override fromJS(data: any): OrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        if (Array.isArray(this.changelogs)) {
            data["changelogs"] = [];
            for (let item of this.changelogs)
                data["changelogs"].push(item.toJSON());
        }
        data["deliveringCarrier"] = this.deliveringCarrier ? this.deliveringCarrier.toJSON() : <any>undefined;
        data["orderCustomer"] = this.orderCustomer ? this.orderCustomer.toJSON() : <any>undefined;
        data["refOrderStatus"] = this.refOrderStatus ? this.refOrderStatus.toJSON() : <any>undefined;
        data["refOrderStep"] = this.refOrderStep ? this.refOrderStep.toJSON() : <any>undefined;
        data["pickedByUser"] = this.pickedByUser ? this.pickedByUser.toJSON() : <any>undefined;
        data["addedByUser"] = this.addedByUser ? this.addedByUser.toJSON() : <any>undefined;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : <any>undefined;
        data["placedByCustomerUser"] = this.placedByCustomerUser ? this.placedByCustomerUser.toJSON() : <any>undefined;
        if (Array.isArray(this.loadStopOrders)) {
            data["loadStopOrders"] = [];
            for (let item of this.loadStopOrders)
                data["loadStopOrders"].push(item.toJSON());
        }
        data["orderGroup"] = this.orderGroup ? this.orderGroup.toJSON() : <any>undefined;
        data["sourceLocation"] = this.sourceLocation ? this.sourceLocation.toJSON() : <any>undefined;
        data["destinationLocation"] = this.destinationLocation ? this.destinationLocation.toJSON() : <any>undefined;
        data["currentLocation"] = this.currentLocation ? this.currentLocation.toJSON() : <any>undefined;
        data["nextLocation"] = this.nextLocation ? this.nextLocation.toJSON() : <any>undefined;
        data["pickLocation"] = this.pickLocation ? this.pickLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.orderHasNotes)) {
            data["orderHasNotes"] = [];
            for (let item of this.orderHasNotes)
                data["orderHasNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.orderHasFiles)) {
            data["orderHasFiles"] = [];
            for (let item of this.orderHasFiles)
                data["orderHasFiles"].push(item.toJSON());
        }
        data["orderId"] = this.orderId;
        data["orderGroupId"] = this.orderGroupId;
        data["orderCustomerId"] = this.orderCustomerId;
        data["refOrderStatusId"] = this.refOrderStatusId;
        data["refOrderTypeId"] = this.refOrderTypeId;
        data["warehouseId"] = this.warehouseId;
        data["sourceLocationId"] = this.sourceLocationId;
        data["destinationLocationId"] = this.destinationLocationId;
        data["currentLocationId"] = this.currentLocationId;
        data["nextLocationId"] = this.nextLocationId;
        data["pickLocationId"] = this.pickLocationId;
        data["addedByUserId"] = this.addedByUserId;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["pickedByUserId"] = this.pickedByUserId;
        data["placedByCustomerUserId"] = this.placedByCustomerUserId;
        data["deliveringCarrierId"] = this.deliveringCarrierId;
        data["externalId"] = this.externalId;
        data["syncSource"] = this.syncSource;
        data["poNumber"] = this.poNumber;
        data["producerName"] = this.producerName;
        data["bol"] = this.bol;
        data["special"] = this.special;
        data["quantity"] = this.quantity;
        data["caseEquivalent"] = this.caseEquivalent;
        data["numberOfBottles"] = this.numberOfBottles;
        data["unitType"] = this.unitType;
        data["isPicked"] = this.isPicked;
        data["revenue"] = this.revenue;
        data["cons"] = this.cons;
        data["ignoreStatusUpdates"] = this.ignoreStatusUpdates;
        data["migrationError"] = this.migrationError;
        data["datePicked"] = this.datePicked ? this.datePicked.toISOString() : <any>undefined;
        data["datePickBy"] = this.datePickBy ? formatDate(this.datePickBy) : <any>undefined;
        data["datePlaced"] = this.datePlaced ? formatDate(this.datePlaced) : <any>undefined;
        data["dateReadyBy"] = this.dateReadyBy ? formatDate(this.dateReadyBy) : <any>undefined;
        data["dateNeededBy"] = this.dateNeededBy ? formatDate(this.dateNeededBy) : <any>undefined;
        data["dateShipBy"] = this.dateShipBy ? formatDate(this.dateShipBy) : <any>undefined;
        data["dateEstimatedShipBy"] = this.dateEstimatedShipBy ? this.dateEstimatedShipBy.toISOString() : <any>undefined;
        data["dateShipped"] = this.dateShipped ? this.dateShipped.toISOString() : <any>undefined;
        data["dateDelivered"] = this.dateDelivered ? this.dateDelivered.toISOString() : <any>undefined;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["statusName"] = this.statusName;
        data["latestNote"] = this.latestNote ? this.latestNote.toJSON() : <any>undefined;
        data["orderCustomerName"] = this.orderCustomerName;
        data["numberOfLoads"] = this.numberOfLoads;
        data["numberOfNotes"] = this.numberOfNotes;
        data["isConsolidation"] = this.isConsolidation;
        data["consolidationLocationId"] = this.consolidationLocationId;
        data["orderIsOnLoad"] = this.orderIsOnLoad;
        data["stepName"] = this.stepName;
        data["sourceLocationName"] = this.sourceLocationName;
        data["sourceCityName"] = this.sourceCityName;
        data["sourceStateAbbrv"] = this.sourceStateAbbrv;
        data["sourceLocationText"] = this.sourceLocationText;
        data["destinationLocationName"] = this.destinationLocationName;
        data["destinationCityName"] = this.destinationCityName;
        data["destinationStateAbbrv"] = this.destinationStateAbbrv;
        data["destinationLocationText"] = this.destinationLocationText;
        data["currentLocationName"] = this.currentLocationName;
        data["currentLocationText"] = this.currentLocationText;
        data["nextLocationName"] = this.nextLocationName;
        data["nextLocationText"] = this.nextLocationText;
        if (Array.isArray(this.loadIdsForThisOrder)) {
            data["loadIdsForThisOrder"] = [];
            for (let item of this.loadIdsForThisOrder)
                data["loadIdsForThisOrder"].push(item);
        }
        data["placedByCustomerUserName"] = this.placedByCustomerUserName;
        data["initialCustomerNoteOnAddingOrder"] = this.initialCustomerNoteOnAddingOrder;
        data["pickedByUserFullName"] = this.pickedByUserFullName;
        data["deliveringCarrierName"] = this.deliveringCarrierName;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderModel extends IChangelogTrackedBasePagedModel {
    tableName: string;
    changelogs: OrderChangelogModel[];
    deliveringCarrier?: CarrierModel | undefined;
    orderCustomer?: OrderCustomerModel | undefined;
    refOrderStatus?: RefOrderStatusModel | undefined;
    refOrderStep?: RefOrderTypeModel | undefined;
    pickedByUser?: SystemUserModel | undefined;
    addedByUser?: SystemUserModel | undefined;
    modifiedByUser?: SystemUserModel | undefined;
    placedByCustomerUser?: SystemUserModel | undefined;
    loadStopOrders: LoadStopOrderModel[];
    orderGroup?: OrderGroupModel | undefined;
    sourceLocation?: LocationModel | undefined;
    destinationLocation?: LocationModel | undefined;
    currentLocation?: LocationModel | undefined;
    nextLocation?: LocationModel | undefined;
    pickLocation?: LocationModel | undefined;
    orderHasNotes: OrderHasNotesModel[];
    orderHasFiles: OrderHasFilesModel[];
    orderId: number;
    orderGroupId?: number | undefined;
    orderCustomerId: number;
    refOrderStatusId: OrderStatus;
    refOrderTypeId?: OrderType | undefined;
    warehouseId: number;
    sourceLocationId?: number | undefined;
    destinationLocationId?: number | undefined;
    currentLocationId?: number | undefined;
    nextLocationId?: number | undefined;
    pickLocationId?: number | undefined;
    addedByUserId?: number | undefined;
    modifiedByUserId?: number | undefined;
    pickedByUserId?: number | undefined;
    placedByCustomerUserId?: number | undefined;
    deliveringCarrierId?: number | undefined;
    externalId?: string | undefined;
    syncSource?: SyncSourceEnum | undefined;
    poNumber?: string | undefined;
    producerName?: string | undefined;
    bol?: string | undefined;
    special?: string | undefined;
    quantity?: number | undefined;
    caseEquivalent?: number | undefined;
    numberOfBottles?: number | undefined;
    unitType?: OrderUnitType | undefined;
    isPicked: boolean;
    revenue?: number | undefined;
    cons?: string | undefined;
    ignoreStatusUpdates: boolean;
    migrationError?: string | undefined;
    datePicked?: Date | undefined;
    datePickBy?: Date | undefined;
    datePlaced?: Date | undefined;
    dateReadyBy?: Date | undefined;
    dateNeededBy?: Date | undefined;
    dateShipBy?: Date | undefined;
    dateEstimatedShipBy?: Date | undefined;
    dateShipped?: Date | undefined;
    dateDelivered?: Date | undefined;
    dateAdded: Date;
    dateModified: Date;
    statusName?: string | undefined;
    latestNote?: NoteModel | undefined;
    orderCustomerName?: string | undefined;
    numberOfLoads?: number | undefined;
    numberOfNotes?: number | undefined;
    isConsolidation: boolean;
    consolidationLocationId: number;
    orderIsOnLoad: boolean;
    stepName?: string | undefined;
    sourceLocationName?: string | undefined;
    sourceCityName?: string | undefined;
    sourceStateAbbrv?: string | undefined;
    sourceLocationText?: string | undefined;
    destinationLocationName?: string | undefined;
    destinationCityName?: string | undefined;
    destinationStateAbbrv?: string | undefined;
    destinationLocationText?: string | undefined;
    currentLocationName?: string | undefined;
    currentLocationText?: string | undefined;
    nextLocationName?: string | undefined;
    nextLocationText?: string | undefined;
    loadIdsForThisOrder?: number[] | undefined;
    placedByCustomerUserName?: string | undefined;
    initialCustomerNoteOnAddingOrder?: string | undefined;
    pickedByUserFullName?: string | undefined;
    deliveringCarrierName?: string | undefined;
}

export class OrderChangelogModel extends BasePagedModel implements IOrderChangelogModel {
    order?: OrderModel | undefined;
    systemUser?: SystemUserModel | undefined;
    tableName!: string;
    orderChangelogId!: number;
    orderId!: number;
    systemUserId?: number | undefined;
    actionType?: ChangelogAction | undefined;
    bulletedChanges?: BulletedList | undefined;
    dateAdded?: Date | undefined;
    createdBy?: string | undefined;

    constructor(data?: IOrderChangelogModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : <any>undefined;
            this.systemUser = _data["systemUser"] ? SystemUserModel.fromJS(_data["systemUser"]) : <any>undefined;
            this.tableName = _data["tableName"];
            this.orderChangelogId = _data["orderChangelogId"];
            this.orderId = _data["orderId"];
            this.systemUserId = _data["systemUserId"];
            this.actionType = _data["actionType"];
            this.bulletedChanges = _data["bulletedChanges"] ? BulletedList.fromJS(_data["bulletedChanges"]) : <any>undefined;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static override fromJS(data: any): OrderChangelogModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderChangelogModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["orderChangelogId"] = this.orderChangelogId;
        data["orderId"] = this.orderId;
        data["systemUserId"] = this.systemUserId;
        data["actionType"] = this.actionType;
        data["bulletedChanges"] = this.bulletedChanges ? this.bulletedChanges.toJSON() : <any>undefined;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderChangelogModel extends IBasePagedModel {
    order?: OrderModel | undefined;
    systemUser?: SystemUserModel | undefined;
    tableName: string;
    orderChangelogId: number;
    orderId: number;
    systemUserId?: number | undefined;
    actionType?: ChangelogAction | undefined;
    bulletedChanges?: BulletedList | undefined;
    dateAdded?: Date | undefined;
    createdBy?: string | undefined;
}

export enum ChangelogAction {
    Updated = 0,
    Created = 1,
}

export class BulletedList implements IBulletedList {
    bullets!: string[];

    constructor(data?: IBulletedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.bullets = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bullets"])) {
                this.bullets = [] as any;
                for (let item of _data["bullets"])
                    this.bullets!.push(item);
            }
        }
    }

    static fromJS(data: any): BulletedList {
        data = typeof data === 'object' ? data : {};
        let result = new BulletedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bullets)) {
            data["bullets"] = [];
            for (let item of this.bullets)
                data["bullets"].push(item);
        }
        return data;
    }
}

export interface IBulletedList {
    bullets: string[];
}

export class CarrierModel extends BasePagedModel implements ICarrierModel {
    carrierHasOperatingZones!: CarrierHasOperatingZoneModel[];
    modifiedByUser?: SystemUserModel | undefined;
    addedByUser?: SystemUserModel | undefined;
    tableName!: string;
    carrierId!: number;
    name!: string;
    status!: CarrierStatusEnum;
    insuranceExempt!: boolean;
    insuranceProvider?: string | undefined;
    insuranceProviderContact?: string | undefined;
    insuranceCargoCoverage!: number;
    insuranceExpirationDate?: Date | undefined;
    address!: string;
    address2?: string | undefined;
    city!: string;
    refCountryStateId?: CountryStates | undefined;
    refCountryId?: Countries | undefined;
    zipCode!: string;
    note?: string | undefined;
    usDotNumber?: string | undefined;
    mcNumber?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    isActive!: boolean;
    modifiedByUserId?: number | undefined;
    addedByUserId?: number | undefined;
    stateName?: string | undefined;
    contactsCount?: number | undefined;
    primaryContactName?: string | undefined;
    primaryContactPhone?: string | undefined;
    operatingZonesIds?: number[] | undefined;
    overview?: OverviewDTO | undefined;

    constructor(data?: ICarrierModel) {
        super(data);
        if (!data) {
            this.carrierHasOperatingZones = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["carrierHasOperatingZones"])) {
                this.carrierHasOperatingZones = [] as any;
                for (let item of _data["carrierHasOperatingZones"])
                    this.carrierHasOperatingZones!.push(CarrierHasOperatingZoneModel.fromJS(item));
            }
            this.modifiedByUser = _data["modifiedByUser"] ? SystemUserModel.fromJS(_data["modifiedByUser"]) : <any>undefined;
            this.addedByUser = _data["addedByUser"] ? SystemUserModel.fromJS(_data["addedByUser"]) : <any>undefined;
            this.tableName = _data["tableName"];
            this.carrierId = _data["carrierId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.insuranceExempt = _data["insuranceExempt"];
            this.insuranceProvider = _data["insuranceProvider"];
            this.insuranceProviderContact = _data["insuranceProviderContact"];
            this.insuranceCargoCoverage = _data["insuranceCargoCoverage"];
            this.insuranceExpirationDate = _data["insuranceExpirationDate"] ? new Date(_data["insuranceExpirationDate"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.refCountryStateId = _data["refCountryStateId"];
            this.refCountryId = _data["refCountryId"];
            this.zipCode = _data["zipCode"];
            this.note = _data["note"];
            this.usDotNumber = _data["usDotNumber"];
            this.mcNumber = _data["mcNumber"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.addedByUserId = _data["addedByUserId"];
            this.stateName = _data["stateName"];
            this.contactsCount = _data["contactsCount"];
            this.primaryContactName = _data["primaryContactName"];
            this.primaryContactPhone = _data["primaryContactPhone"];
            if (Array.isArray(_data["operatingZonesIds"])) {
                this.operatingZonesIds = [] as any;
                for (let item of _data["operatingZonesIds"])
                    this.operatingZonesIds!.push(item);
            }
            this.overview = _data["overview"] ? OverviewDTO.fromJS(_data["overview"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CarrierModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.carrierHasOperatingZones)) {
            data["carrierHasOperatingZones"] = [];
            for (let item of this.carrierHasOperatingZones)
                data["carrierHasOperatingZones"].push(item.toJSON());
        }
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : <any>undefined;
        data["addedByUser"] = this.addedByUser ? this.addedByUser.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["carrierId"] = this.carrierId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["insuranceExempt"] = this.insuranceExempt;
        data["insuranceProvider"] = this.insuranceProvider;
        data["insuranceProviderContact"] = this.insuranceProviderContact;
        data["insuranceCargoCoverage"] = this.insuranceCargoCoverage;
        data["insuranceExpirationDate"] = this.insuranceExpirationDate ? formatDate(this.insuranceExpirationDate) : <any>undefined;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["refCountryStateId"] = this.refCountryStateId;
        data["refCountryId"] = this.refCountryId;
        data["zipCode"] = this.zipCode;
        data["note"] = this.note;
        data["usDotNumber"] = this.usDotNumber;
        data["mcNumber"] = this.mcNumber;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["addedByUserId"] = this.addedByUserId;
        data["stateName"] = this.stateName;
        data["contactsCount"] = this.contactsCount;
        data["primaryContactName"] = this.primaryContactName;
        data["primaryContactPhone"] = this.primaryContactPhone;
        if (Array.isArray(this.operatingZonesIds)) {
            data["operatingZonesIds"] = [];
            for (let item of this.operatingZonesIds)
                data["operatingZonesIds"].push(item);
        }
        data["overview"] = this.overview ? this.overview.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICarrierModel extends IBasePagedModel {
    carrierHasOperatingZones: CarrierHasOperatingZoneModel[];
    modifiedByUser?: SystemUserModel | undefined;
    addedByUser?: SystemUserModel | undefined;
    tableName: string;
    carrierId: number;
    name: string;
    status: CarrierStatusEnum;
    insuranceExempt: boolean;
    insuranceProvider?: string | undefined;
    insuranceProviderContact?: string | undefined;
    insuranceCargoCoverage: number;
    insuranceExpirationDate?: Date | undefined;
    address: string;
    address2?: string | undefined;
    city: string;
    refCountryStateId?: CountryStates | undefined;
    refCountryId?: Countries | undefined;
    zipCode: string;
    note?: string | undefined;
    usDotNumber?: string | undefined;
    mcNumber?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
    isActive: boolean;
    modifiedByUserId?: number | undefined;
    addedByUserId?: number | undefined;
    stateName?: string | undefined;
    contactsCount?: number | undefined;
    primaryContactName?: string | undefined;
    primaryContactPhone?: string | undefined;
    operatingZonesIds?: number[] | undefined;
    overview?: OverviewDTO | undefined;
}

export class CarrierHasOperatingZoneModel implements ICarrierHasOperatingZoneModel {
    carrierId!: number;
    carrier?: CarrierModel | undefined;
    refOperatingZoneId!: number;
    operatingZoneEnum?: RefOperatingZoneModel | undefined;

    constructor(data?: ICarrierHasOperatingZoneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierModel.fromJS(_data["carrier"]) : <any>undefined;
            this.refOperatingZoneId = _data["refOperatingZoneId"];
            this.operatingZoneEnum = _data["operatingZoneEnum"] ? RefOperatingZoneModel.fromJS(_data["operatingZoneEnum"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CarrierHasOperatingZoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierHasOperatingZoneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["refOperatingZoneId"] = this.refOperatingZoneId;
        data["operatingZoneEnum"] = this.operatingZoneEnum ? this.operatingZoneEnum.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICarrierHasOperatingZoneModel {
    carrierId: number;
    carrier?: CarrierModel | undefined;
    refOperatingZoneId: number;
    operatingZoneEnum?: RefOperatingZoneModel | undefined;
}

export class RefOperatingZoneModel extends BasePagedModel implements IRefOperatingZoneModel {
    tableName!: string;
    refOperatingZoneId!: OperatingZoneEnum;
    name!: string;
    description?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IRefOperatingZoneModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.refOperatingZoneId = _data["refOperatingZoneId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): RefOperatingZoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefOperatingZoneModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["refOperatingZoneId"] = this.refOperatingZoneId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRefOperatingZoneModel extends IBasePagedModel {
    tableName: string;
    refOperatingZoneId: OperatingZoneEnum;
    name: string;
    description?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export enum OperatingZoneEnum {
    Zone0 = 0,
    Zone1 = 1,
    Zone2 = 2,
    Zone3 = 3,
    Zone4 = 4,
    Zone5 = 5,
    Zone6 = 6,
    Zone7 = 7,
    Zone8 = 8,
    Zone9 = 9,
}

export enum CarrierStatusEnum {
    Active = 0,
    Expiring = 1,
    Expired = 2,
    Inactive = 3,
    DoNotUse = 4,
}

export enum CountryStates {
    AL = 0,
    AK = 1,
    AZ = 2,
    AR = 3,
    CA = 4,
    CO = 5,
    CT = 6,
    DE = 7,
    DC = 8,
    FL = 9,
    GA = 10,
    HI = 11,
    ID = 12,
    IL = 13,
    IN = 14,
    IA = 15,
    KS = 16,
    KY = 17,
    LA = 18,
    ME = 19,
    MT = 20,
    NE = 21,
    NV = 22,
    NH = 23,
    NJ = 24,
    NM = 25,
    NY = 26,
    NC = 27,
    ND = 28,
    OH = 29,
    OK = 30,
    OR = 31,
    MD = 32,
    MA = 33,
    MI = 34,
    MN = 35,
    MS = 36,
    MO = 37,
    PA = 38,
    RI = 39,
    SC = 40,
    SD = 41,
    TN = 42,
    TX = 43,
    UT = 44,
    VT = 45,
    VA = 46,
    WA = 47,
    WV = 48,
    WI = 49,
    WY = 50,
    PR = 51,
    VI = 52,
    AS = 53,
    GU = 54,
    MP = 55,
}

export enum Countries {
    UnitedStates = 1,
    Canada = 2,
    Mexico = 3,
    Afghanistan = 4,
    Albania = 5,
    Algeria = 6,
    Andorra = 7,
    Angola = 8,
    AntiguaAndBarbuda = 9,
    Argentina = 10,
    Armenia = 11,
    Australia = 12,
    Austria = 13,
    Azerbaijan = 14,
    Bahamas = 15,
    Bahrain = 16,
    Bangladesh = 17,
    Barbados = 18,
    Belarus = 19,
    Belgium = 20,
    Belize = 21,
    Benin = 22,
    Bhutan = 23,
    Bolivia = 24,
    BosniaAndHerzegovina = 25,
    Botswana = 26,
    Brazil = 27,
    BruneiDarussalam = 28,
    Bulgaria = 29,
    BurkinaFaso = 30,
    Burundi = 31,
    CaboVerde = 32,
    Cambodia = 33,
    Cameroon = 34,
    CentralAfricanRepublic = 35,
    Chad = 36,
    Chile = 37,
    China = 38,
    Colombia = 39,
    Comoros = 40,
    Congo = 41,
    CongoDemocraticRepublic = 42,
    CostaRica = 43,
    Croatia = 44,
    Cuba = 45,
    Cyprus = 46,
    Czechia = 47,
    Denmark = 48,
    Djibouti = 49,
    Dominica = 50,
    DominicanRepublic = 51,
    Ecuador = 52,
    Egypt = 53,
    ElSalvador = 54,
    EquatorialGuinea = 55,
    Eritrea = 56,
    Estonia = 57,
    Eswatini = 58,
    Ethiopia = 59,
    Fiji = 60,
    Finland = 61,
    France = 62,
    Gabon = 63,
    Gambia = 64,
    Georgia = 65,
    Germany = 66,
    Ghana = 67,
    Greece = 68,
    Grenada = 69,
    Guatemala = 70,
    Guinea = 71,
    GuineaBissau = 72,
    Guyana = 73,
    Haiti = 74,
    Honduras = 75,
    Hungary = 76,
    Iceland = 77,
    India = 78,
    Indonesia = 79,
    Iran = 80,
    Iraq = 81,
    Ireland = 82,
    Israel = 83,
    Italy = 84,
    Jamaica = 85,
    Japan = 86,
    Jordan = 87,
    Kazakhstan = 88,
    Kenya = 89,
    Kiribati = 90,
    Korea = 91,
    Kuwait = 92,
    Kyrgyzstan = 93,
    Laos = 94,
    Latvia = 95,
    Lebanon = 96,
    Lesotho = 97,
    Liberia = 98,
    Libya = 99,
    Liechtenstein = 100,
    Lithuania = 101,
    Luxembourg = 102,
    Madagascar = 103,
    Malawi = 104,
    Malaysia = 105,
    Maldives = 106,
    Mali = 107,
    Malta = 108,
    MarshallIslands = 109,
    Mauritania = 110,
    Mauritius = 111,
    Micronesia = 112,
    Moldova = 113,
    Monaco = 114,
    Mongolia = 115,
    Montenegro = 116,
    Morocco = 117,
    Mozambique = 118,
    Myanmar = 119,
    Namibia = 120,
    Nauru = 121,
    Nepal = 122,
    Netherlands = 123,
    NewZealand = 124,
    Nicaragua = 125,
    Niger = 126,
    Nigeria = 127,
    NorthMacedonia = 128,
    Norway = 129,
    Oman = 130,
    Pakistan = 131,
    Palau = 132,
    Panama = 133,
    PapuaNewGuinea = 134,
    Paraguay = 135,
    Peru = 136,
    Philippines = 137,
    Poland = 138,
    Portugal = 139,
    Qatar = 140,
    Romania = 141,
    Russia = 142,
    Rwanda = 143,
    SaintKittsAndNevis = 144,
    SaintLucia = 145,
    SaintVincentAndTheGrenadines = 146,
    Samoa = 147,
    SanMarino = 148,
    SaoTomeAndPrincipe = 149,
    SaudiArabia = 150,
    Senegal = 151,
    Serbia = 152,
    Seychelles = 153,
    SierraLeone = 154,
    Singapore = 155,
    Slovakia = 156,
    Slovenia = 157,
    SolomonIslands = 158,
    Somalia = 159,
    SouthAfrica = 160,
    SouthSudan = 161,
    Spain = 162,
    SriLanka = 163,
    Sudan = 164,
    Suriname = 165,
    Sweden = 166,
    Switzerland = 167,
    SyrianArabRepublic = 168,
    Taiwan = 169,
    Tajikistan = 170,
    Tanzania = 171,
    Thailand = 172,
    TimorLeste = 173,
    Togo = 174,
    Tonga = 175,
    TrinidadAndTobago = 176,
    Tunisia = 177,
    Turkey = 178,
    Turkmenistan = 179,
    Tuvalu = 180,
    Uganda = 181,
    Ukraine = 182,
    UnitedArabEmirates = 183,
    UnitedKingdom = 184,
    Uruguay = 185,
    Uzbekistan = 186,
    Vanuatu = 187,
    Venezuela = 188,
    Vietnam = 189,
    Yemen = 190,
    Zambia = 191,
    Zimbabwe = 192,
}

export class OverviewDTO implements IOverviewDTO {
    active!: number;
    lastMonth!: number;
    lastYear!: number;
    total!: number;

    constructor(data?: IOverviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.lastMonth = _data["lastMonth"];
            this.lastYear = _data["lastYear"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): OverviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OverviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["lastMonth"] = this.lastMonth;
        data["lastYear"] = this.lastYear;
        data["total"] = this.total;
        return data;
    }
}

export interface IOverviewDTO {
    active: number;
    lastMonth: number;
    lastYear: number;
    total: number;
}

export class RefOrderStatusModel extends BasePagedModel implements IRefOrderStatusModel {
    tableName!: string;
    refOrderStatusId!: OrderStatus;
    name!: string;
    description?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IRefOrderStatusModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.refOrderStatusId = _data["refOrderStatusId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): RefOrderStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefOrderStatusModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["refOrderStatusId"] = this.refOrderStatusId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRefOrderStatusModel extends IBasePagedModel {
    tableName: string;
    refOrderStatusId: OrderStatus;
    name: string;
    description?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export enum OrderStatus {
    OnHold = 100,
    Issue = 150,
    Intake = 200,
    Open = 250,
    Planned = 300,
    Booked = 350,
    Consolidating = 400,
    Consolidated = 450,
    InTransit = 500,
    Staged = 550,
    Delivered = 600,
    Cancelled = 650,
}

export class RefOrderTypeModel extends BasePagedModel implements IRefOrderTypeModel {
    tableName!: string;
    refOrderTypeId!: OrderType;
    name!: string;
    description?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IRefOrderTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.refOrderTypeId = _data["refOrderTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): RefOrderTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefOrderTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["refOrderTypeId"] = this.refOrderTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRefOrderTypeModel extends IBasePagedModel {
    tableName: string;
    refOrderTypeId: OrderType;
    name: string;
    description?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export enum OrderType {
    CaConsol = 1,
    EastConsol = 2,
    OrConsol = 3,
    OwbConsol = 4,
    WaConsol = 5,
    WyConsol = 6,
    ToCaFtl = 7,
    FromCaFtl = 8,
    LocalFtl = 9,
    InboundForCrossDock = 10,
    InboundStorage = 11,
    InboundForWineco = 12,
    Flatbed = 13,
    Pickup = 14,
    RTV = 15,
    Tanker = 16,
    Barrels = 17,
    Glass = 18,
    Broker = 19,
    Project = 20,
    WvwaAuction = 21,
    Special = 22,
    DirectToTrade = 23,
}

export class LoadStopOrderModel implements ILoadStopOrderModel {
    tableName!: string;
    order?: OrderModel | undefined;
    loadStop?: LoadStopModel | undefined;
    loadStopOrderId!: number;
    orderId!: number;
    loadStopId!: number;
    stopOrderSequence!: number;
    dateAdded!: Date;
    dateModified!: Date;
    isConsolidation!: boolean;
    fromConsolidation!: boolean;
    toConsolidation!: boolean;

    constructor(data?: ILoadStopOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableName = _data["tableName"];
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : <any>undefined;
            this.loadStop = _data["loadStop"] ? LoadStopModel.fromJS(_data["loadStop"]) : <any>undefined;
            this.loadStopOrderId = _data["loadStopOrderId"];
            this.orderId = _data["orderId"];
            this.loadStopId = _data["loadStopId"];
            this.stopOrderSequence = _data["stopOrderSequence"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.isConsolidation = _data["isConsolidation"];
            this.fromConsolidation = _data["fromConsolidation"];
            this.toConsolidation = _data["toConsolidation"];
        }
    }

    static fromJS(data: any): LoadStopOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoadStopOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["loadStop"] = this.loadStop ? this.loadStop.toJSON() : <any>undefined;
        data["loadStopOrderId"] = this.loadStopOrderId;
        data["orderId"] = this.orderId;
        data["loadStopId"] = this.loadStopId;
        data["stopOrderSequence"] = this.stopOrderSequence;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["isConsolidation"] = this.isConsolidation;
        data["fromConsolidation"] = this.fromConsolidation;
        data["toConsolidation"] = this.toConsolidation;
        return data;
    }
}

export interface ILoadStopOrderModel {
    tableName: string;
    order?: OrderModel | undefined;
    loadStop?: LoadStopModel | undefined;
    loadStopOrderId: number;
    orderId: number;
    loadStopId: number;
    stopOrderSequence: number;
    dateAdded: Date;
    dateModified: Date;
    isConsolidation: boolean;
    fromConsolidation: boolean;
    toConsolidation: boolean;
}

export class LoadStopModel extends BasePagedModel implements ILoadStopModel {
    loadStopOrders!: LoadStopOrderModel[];
    tableName!: string;
    loadStopId!: number;
    locationId!: number;
    location?: LocationModel | undefined;
    loadId!: number;
    load?: LoadModel | undefined;
    refLoadStopTypeId!: LoadStopType;
    refLoadStopType?: RefLoadStopTypeModel | undefined;
    stopSequence!: number;
    revenue?: number | undefined;
    stopHasIssue!: boolean;
    pickedUpOrDelivered!: boolean;
    hasAppointment!: boolean;
    carrierMakesAppointment!: boolean;
    pickedUpDeliveryDate?: Date | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    scheduledWithDescription?: string | undefined;
    issueDescription?: string | undefined;
    stopDirections?: string | undefined;
    locationName!: string;
    locationText!: string;
    dateAdded!: Date;
    dateModified!: Date;
    requireDeliveryWindow!: boolean;
    totalQuantity!: number;
    totalCaseEquivalent!: number;
    totalItems!: number;
    totalCaseString!: string;
    caseTotalAfterLocation!: number;
    caseTotalAfterLocationString!: string;

    constructor(data?: ILoadStopModel) {
        super(data);
        if (!data) {
            this.loadStopOrders = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["loadStopOrders"])) {
                this.loadStopOrders = [] as any;
                for (let item of _data["loadStopOrders"])
                    this.loadStopOrders!.push(LoadStopOrderModel.fromJS(item));
            }
            this.tableName = _data["tableName"];
            this.loadStopId = _data["loadStopId"];
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
            this.loadId = _data["loadId"];
            this.load = _data["load"] ? LoadModel.fromJS(_data["load"]) : <any>undefined;
            this.refLoadStopTypeId = _data["refLoadStopTypeId"];
            this.refLoadStopType = _data["refLoadStopType"] ? RefLoadStopTypeModel.fromJS(_data["refLoadStopType"]) : <any>undefined;
            this.stopSequence = _data["stopSequence"];
            this.revenue = _data["revenue"];
            this.stopHasIssue = _data["stopHasIssue"];
            this.pickedUpOrDelivered = _data["pickedUpOrDelivered"];
            this.hasAppointment = _data["hasAppointment"];
            this.carrierMakesAppointment = _data["carrierMakesAppointment"];
            this.pickedUpDeliveryDate = _data["pickedUpDeliveryDate"] ? new Date(_data["pickedUpDeliveryDate"].toString()) : <any>undefined;
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.scheduledWithDescription = _data["scheduledWithDescription"];
            this.issueDescription = _data["issueDescription"];
            this.stopDirections = _data["stopDirections"];
            this.locationName = _data["locationName"];
            this.locationText = _data["locationText"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.requireDeliveryWindow = _data["requireDeliveryWindow"];
            this.totalQuantity = _data["totalQuantity"];
            this.totalCaseEquivalent = _data["totalCaseEquivalent"];
            this.totalItems = _data["totalItems"];
            this.totalCaseString = _data["totalCaseString"];
            this.caseTotalAfterLocation = _data["caseTotalAfterLocation"];
            this.caseTotalAfterLocationString = _data["caseTotalAfterLocationString"];
        }
    }

    static override fromJS(data: any): LoadStopModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoadStopModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.loadStopOrders)) {
            data["loadStopOrders"] = [];
            for (let item of this.loadStopOrders)
                data["loadStopOrders"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["loadStopId"] = this.loadStopId;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["loadId"] = this.loadId;
        data["load"] = this.load ? this.load.toJSON() : <any>undefined;
        data["refLoadStopTypeId"] = this.refLoadStopTypeId;
        data["refLoadStopType"] = this.refLoadStopType ? this.refLoadStopType.toJSON() : <any>undefined;
        data["stopSequence"] = this.stopSequence;
        data["revenue"] = this.revenue;
        data["stopHasIssue"] = this.stopHasIssue;
        data["pickedUpOrDelivered"] = this.pickedUpOrDelivered;
        data["hasAppointment"] = this.hasAppointment;
        data["carrierMakesAppointment"] = this.carrierMakesAppointment;
        data["pickedUpDeliveryDate"] = this.pickedUpDeliveryDate ? this.pickedUpDeliveryDate.toISOString() : <any>undefined;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["scheduledWithDescription"] = this.scheduledWithDescription;
        data["issueDescription"] = this.issueDescription;
        data["stopDirections"] = this.stopDirections;
        data["locationName"] = this.locationName;
        data["locationText"] = this.locationText;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["requireDeliveryWindow"] = this.requireDeliveryWindow;
        data["totalQuantity"] = this.totalQuantity;
        data["totalCaseEquivalent"] = this.totalCaseEquivalent;
        data["totalItems"] = this.totalItems;
        data["totalCaseString"] = this.totalCaseString;
        data["caseTotalAfterLocation"] = this.caseTotalAfterLocation;
        data["caseTotalAfterLocationString"] = this.caseTotalAfterLocationString;
        super.toJSON(data);
        return data;
    }
}

export interface ILoadStopModel extends IBasePagedModel {
    loadStopOrders: LoadStopOrderModel[];
    tableName: string;
    loadStopId: number;
    locationId: number;
    location?: LocationModel | undefined;
    loadId: number;
    load?: LoadModel | undefined;
    refLoadStopTypeId: LoadStopType;
    refLoadStopType?: RefLoadStopTypeModel | undefined;
    stopSequence: number;
    revenue?: number | undefined;
    stopHasIssue: boolean;
    pickedUpOrDelivered: boolean;
    hasAppointment: boolean;
    carrierMakesAppointment: boolean;
    pickedUpDeliveryDate?: Date | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    scheduledWithDescription?: string | undefined;
    issueDescription?: string | undefined;
    stopDirections?: string | undefined;
    locationName: string;
    locationText: string;
    dateAdded: Date;
    dateModified: Date;
    requireDeliveryWindow: boolean;
    totalQuantity: number;
    totalCaseEquivalent: number;
    totalItems: number;
    totalCaseString: string;
    caseTotalAfterLocation: number;
    caseTotalAfterLocationString: string;
}

export class LoadModel extends ChangelogTrackedBasePagedModel implements ILoadModel {
    loadStops!: LoadStopModel[];
    tableName!: string;
    modifiedByUser?: SystemUserModel | undefined;
    createdByUser?: SystemUserModel | undefined;
    carrierPaidByUser?: SystemUserModel | undefined;
    carrier?: CarrierModel | undefined;
    destinationLocation?: LocationModel | undefined;
    currentLocation?: LocationModel | undefined;
    originLocation?: LocationModel | undefined;
    changelogs!: LoadChangelogModel[];
    loadHasNotes!: LoadHasNotesModel[];
    loadId!: number;
    refLoadTypeId?: LoadType | undefined;
    refLoadStatusId!: LoadStatus;
    refLoadDesignationId?: LoadDesignation | undefined;
    refLoadTrailerTypeId?: LoadTrailerType | undefined;
    carrierId?: number | undefined;
    modifiedByUserId?: number | undefined;
    createdByUserId?: number | undefined;
    currentLocationId?: number | undefined;
    originLocationId?: number | undefined;
    destinationLocationId?: number | undefined;
    carrierPaidByUserId?: number | undefined;
    trailerNumber?: string | undefined;
    carrierNote?: string | undefined;
    miles!: number;
    pickups!: number;
    deliveries!: number;
    isAllDay?: boolean | undefined;
    revenue!: number;
    showRevenueOnLoadSummary!: boolean;
    carrierPaid!: boolean;
    carrierRate!: number;
    carrierAccessoryCharge!: number;
    carrierAccessoryChargeDescription?: string | undefined;
    carrierPaidCheckNumber?: string | undefined;
    carrierPaidInvoiceNumber?: string | undefined;
    carrierPaidAmount!: number;
    carrierPaidNote?: string | undefined;
    ignoreStatusUpdates!: boolean;
    isExternallySynced!: boolean;
    carrierPaidDate?: Date | undefined;
    estimatedShippingDate?: Date | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    fullModifiedByName?: string | undefined;
    fullCreatedByName?: string | undefined;
    fullCarrierPaidByName?: string | undefined;
    cases!: number;
    destinationLocationName?: string | undefined;
    currentLocationName?: string | undefined;
    originLocationName?: string | undefined;
    noteCount!: number;
    carrierName?: string | undefined;
    carrierDirection?: string | undefined;
    orderIdsOnLoad?: number[] | undefined;
    netRevenue?: number | undefined;

    constructor(data?: ILoadModel) {
        super(data);
        if (!data) {
            this.loadStops = [];
            this.changelogs = [];
            this.loadHasNotes = [];
            this.refLoadStatusId = LoadStatus.Open;
            this.ignoreStatusUpdates = false;
            this.isExternallySynced = false;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["loadStops"])) {
                this.loadStops = [] as any;
                for (let item of _data["loadStops"])
                    this.loadStops!.push(LoadStopModel.fromJS(item));
            }
            this.tableName = _data["tableName"];
            this.modifiedByUser = _data["modifiedByUser"] ? SystemUserModel.fromJS(_data["modifiedByUser"]) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? SystemUserModel.fromJS(_data["createdByUser"]) : <any>undefined;
            this.carrierPaidByUser = _data["carrierPaidByUser"] ? SystemUserModel.fromJS(_data["carrierPaidByUser"]) : <any>undefined;
            this.carrier = _data["carrier"] ? CarrierModel.fromJS(_data["carrier"]) : <any>undefined;
            this.destinationLocation = _data["destinationLocation"] ? LocationModel.fromJS(_data["destinationLocation"]) : <any>undefined;
            this.currentLocation = _data["currentLocation"] ? LocationModel.fromJS(_data["currentLocation"]) : <any>undefined;
            this.originLocation = _data["originLocation"] ? LocationModel.fromJS(_data["originLocation"]) : <any>undefined;
            if (Array.isArray(_data["changelogs"])) {
                this.changelogs = [] as any;
                for (let item of _data["changelogs"])
                    this.changelogs!.push(LoadChangelogModel.fromJS(item));
            }
            if (Array.isArray(_data["loadHasNotes"])) {
                this.loadHasNotes = [] as any;
                for (let item of _data["loadHasNotes"])
                    this.loadHasNotes!.push(LoadHasNotesModel.fromJS(item));
            }
            this.loadId = _data["loadId"];
            this.refLoadTypeId = _data["refLoadTypeId"];
            this.refLoadStatusId = _data["refLoadStatusId"] !== undefined ? _data["refLoadStatusId"] : LoadStatus.Open;
            this.refLoadDesignationId = _data["refLoadDesignationId"];
            this.refLoadTrailerTypeId = _data["refLoadTrailerTypeId"];
            this.carrierId = _data["carrierId"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.createdByUserId = _data["createdByUserId"];
            this.currentLocationId = _data["currentLocationId"];
            this.originLocationId = _data["originLocationId"];
            this.destinationLocationId = _data["destinationLocationId"];
            this.carrierPaidByUserId = _data["carrierPaidByUserId"];
            this.trailerNumber = _data["trailerNumber"];
            this.carrierNote = _data["carrierNote"];
            this.miles = _data["miles"];
            this.pickups = _data["pickups"];
            this.deliveries = _data["deliveries"];
            this.isAllDay = _data["isAllDay"];
            this.revenue = _data["revenue"];
            this.showRevenueOnLoadSummary = _data["showRevenueOnLoadSummary"];
            this.carrierPaid = _data["carrierPaid"];
            this.carrierRate = _data["carrierRate"];
            this.carrierAccessoryCharge = _data["carrierAccessoryCharge"];
            this.carrierAccessoryChargeDescription = _data["carrierAccessoryChargeDescription"];
            this.carrierPaidCheckNumber = _data["carrierPaidCheckNumber"];
            this.carrierPaidInvoiceNumber = _data["carrierPaidInvoiceNumber"];
            this.carrierPaidAmount = _data["carrierPaidAmount"];
            this.carrierPaidNote = _data["carrierPaidNote"];
            this.ignoreStatusUpdates = _data["ignoreStatusUpdates"] !== undefined ? _data["ignoreStatusUpdates"] : false;
            this.isExternallySynced = _data["isExternallySynced"] !== undefined ? _data["isExternallySynced"] : false;
            this.carrierPaidDate = _data["carrierPaidDate"] ? new Date(_data["carrierPaidDate"].toString()) : <any>undefined;
            this.estimatedShippingDate = _data["estimatedShippingDate"] ? new Date(_data["estimatedShippingDate"].toString()) : <any>undefined;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.fullModifiedByName = _data["fullModifiedByName"];
            this.fullCreatedByName = _data["fullCreatedByName"];
            this.fullCarrierPaidByName = _data["fullCarrierPaidByName"];
            this.cases = _data["cases"];
            this.destinationLocationName = _data["destinationLocationName"];
            this.currentLocationName = _data["currentLocationName"];
            this.originLocationName = _data["originLocationName"];
            this.noteCount = _data["noteCount"];
            this.carrierName = _data["carrierName"];
            this.carrierDirection = _data["carrierDirection"];
            if (Array.isArray(_data["orderIdsOnLoad"])) {
                this.orderIdsOnLoad = [] as any;
                for (let item of _data["orderIdsOnLoad"])
                    this.orderIdsOnLoad!.push(item);
            }
            this.netRevenue = _data["netRevenue"];
        }
    }

    static override fromJS(data: any): LoadModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoadModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.loadStops)) {
            data["loadStops"] = [];
            for (let item of this.loadStops)
                data["loadStops"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["carrierPaidByUser"] = this.carrierPaidByUser ? this.carrierPaidByUser.toJSON() : <any>undefined;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["destinationLocation"] = this.destinationLocation ? this.destinationLocation.toJSON() : <any>undefined;
        data["currentLocation"] = this.currentLocation ? this.currentLocation.toJSON() : <any>undefined;
        data["originLocation"] = this.originLocation ? this.originLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.changelogs)) {
            data["changelogs"] = [];
            for (let item of this.changelogs)
                data["changelogs"].push(item.toJSON());
        }
        if (Array.isArray(this.loadHasNotes)) {
            data["loadHasNotes"] = [];
            for (let item of this.loadHasNotes)
                data["loadHasNotes"].push(item.toJSON());
        }
        data["loadId"] = this.loadId;
        data["refLoadTypeId"] = this.refLoadTypeId;
        data["refLoadStatusId"] = this.refLoadStatusId;
        data["refLoadDesignationId"] = this.refLoadDesignationId;
        data["refLoadTrailerTypeId"] = this.refLoadTrailerTypeId;
        data["carrierId"] = this.carrierId;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["createdByUserId"] = this.createdByUserId;
        data["currentLocationId"] = this.currentLocationId;
        data["originLocationId"] = this.originLocationId;
        data["destinationLocationId"] = this.destinationLocationId;
        data["carrierPaidByUserId"] = this.carrierPaidByUserId;
        data["trailerNumber"] = this.trailerNumber;
        data["carrierNote"] = this.carrierNote;
        data["miles"] = this.miles;
        data["pickups"] = this.pickups;
        data["deliveries"] = this.deliveries;
        data["isAllDay"] = this.isAllDay;
        data["revenue"] = this.revenue;
        data["showRevenueOnLoadSummary"] = this.showRevenueOnLoadSummary;
        data["carrierPaid"] = this.carrierPaid;
        data["carrierRate"] = this.carrierRate;
        data["carrierAccessoryCharge"] = this.carrierAccessoryCharge;
        data["carrierAccessoryChargeDescription"] = this.carrierAccessoryChargeDescription;
        data["carrierPaidCheckNumber"] = this.carrierPaidCheckNumber;
        data["carrierPaidInvoiceNumber"] = this.carrierPaidInvoiceNumber;
        data["carrierPaidAmount"] = this.carrierPaidAmount;
        data["carrierPaidNote"] = this.carrierPaidNote;
        data["ignoreStatusUpdates"] = this.ignoreStatusUpdates;
        data["isExternallySynced"] = this.isExternallySynced;
        data["carrierPaidDate"] = this.carrierPaidDate ? this.carrierPaidDate.toISOString() : <any>undefined;
        data["estimatedShippingDate"] = this.estimatedShippingDate ? this.estimatedShippingDate.toISOString() : <any>undefined;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["fullModifiedByName"] = this.fullModifiedByName;
        data["fullCreatedByName"] = this.fullCreatedByName;
        data["fullCarrierPaidByName"] = this.fullCarrierPaidByName;
        data["cases"] = this.cases;
        data["destinationLocationName"] = this.destinationLocationName;
        data["currentLocationName"] = this.currentLocationName;
        data["originLocationName"] = this.originLocationName;
        data["noteCount"] = this.noteCount;
        data["carrierName"] = this.carrierName;
        data["carrierDirection"] = this.carrierDirection;
        if (Array.isArray(this.orderIdsOnLoad)) {
            data["orderIdsOnLoad"] = [];
            for (let item of this.orderIdsOnLoad)
                data["orderIdsOnLoad"].push(item);
        }
        data["netRevenue"] = this.netRevenue;
        super.toJSON(data);
        return data;
    }
}

export interface ILoadModel extends IChangelogTrackedBasePagedModel {
    loadStops: LoadStopModel[];
    tableName: string;
    modifiedByUser?: SystemUserModel | undefined;
    createdByUser?: SystemUserModel | undefined;
    carrierPaidByUser?: SystemUserModel | undefined;
    carrier?: CarrierModel | undefined;
    destinationLocation?: LocationModel | undefined;
    currentLocation?: LocationModel | undefined;
    originLocation?: LocationModel | undefined;
    changelogs: LoadChangelogModel[];
    loadHasNotes: LoadHasNotesModel[];
    loadId: number;
    refLoadTypeId?: LoadType | undefined;
    refLoadStatusId: LoadStatus;
    refLoadDesignationId?: LoadDesignation | undefined;
    refLoadTrailerTypeId?: LoadTrailerType | undefined;
    carrierId?: number | undefined;
    modifiedByUserId?: number | undefined;
    createdByUserId?: number | undefined;
    currentLocationId?: number | undefined;
    originLocationId?: number | undefined;
    destinationLocationId?: number | undefined;
    carrierPaidByUserId?: number | undefined;
    trailerNumber?: string | undefined;
    carrierNote?: string | undefined;
    miles: number;
    pickups: number;
    deliveries: number;
    isAllDay?: boolean | undefined;
    revenue: number;
    showRevenueOnLoadSummary: boolean;
    carrierPaid: boolean;
    carrierRate: number;
    carrierAccessoryCharge: number;
    carrierAccessoryChargeDescription?: string | undefined;
    carrierPaidCheckNumber?: string | undefined;
    carrierPaidInvoiceNumber?: string | undefined;
    carrierPaidAmount: number;
    carrierPaidNote?: string | undefined;
    ignoreStatusUpdates: boolean;
    isExternallySynced: boolean;
    carrierPaidDate?: Date | undefined;
    estimatedShippingDate?: Date | undefined;
    dateAdded: Date;
    dateModified: Date;
    fullModifiedByName?: string | undefined;
    fullCreatedByName?: string | undefined;
    fullCarrierPaidByName?: string | undefined;
    cases: number;
    destinationLocationName?: string | undefined;
    currentLocationName?: string | undefined;
    originLocationName?: string | undefined;
    noteCount: number;
    carrierName?: string | undefined;
    carrierDirection?: string | undefined;
    orderIdsOnLoad?: number[] | undefined;
    netRevenue?: number | undefined;
}

export class LoadChangelogModel extends BasePagedModel implements ILoadChangelogModel {
    load?: LoadModel | undefined;
    systemUser?: SystemUserModel | undefined;
    tableName!: string;
    loadChangelogId!: number;
    loadId!: number;
    systemUserId?: number | undefined;
    actionType?: ChangelogAction | undefined;
    bulletedChanges?: BulletedList | undefined;
    dateAdded?: Date | undefined;
    createdBy?: string | undefined;

    constructor(data?: ILoadChangelogModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.load = _data["load"] ? LoadModel.fromJS(_data["load"]) : <any>undefined;
            this.systemUser = _data["systemUser"] ? SystemUserModel.fromJS(_data["systemUser"]) : <any>undefined;
            this.tableName = _data["tableName"];
            this.loadChangelogId = _data["loadChangelogId"];
            this.loadId = _data["loadId"];
            this.systemUserId = _data["systemUserId"];
            this.actionType = _data["actionType"];
            this.bulletedChanges = _data["bulletedChanges"] ? BulletedList.fromJS(_data["bulletedChanges"]) : <any>undefined;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static override fromJS(data: any): LoadChangelogModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoadChangelogModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["load"] = this.load ? this.load.toJSON() : <any>undefined;
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["loadChangelogId"] = this.loadChangelogId;
        data["loadId"] = this.loadId;
        data["systemUserId"] = this.systemUserId;
        data["actionType"] = this.actionType;
        data["bulletedChanges"] = this.bulletedChanges ? this.bulletedChanges.toJSON() : <any>undefined;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        super.toJSON(data);
        return data;
    }
}

export interface ILoadChangelogModel extends IBasePagedModel {
    load?: LoadModel | undefined;
    systemUser?: SystemUserModel | undefined;
    tableName: string;
    loadChangelogId: number;
    loadId: number;
    systemUserId?: number | undefined;
    actionType?: ChangelogAction | undefined;
    bulletedChanges?: BulletedList | undefined;
    dateAdded?: Date | undefined;
    createdBy?: string | undefined;
}

export class LoadHasNotesModel implements ILoadHasNotesModel {
    loadId!: number;
    load!: LoadModel;
    noteId!: number;
    note!: NoteModel;

    constructor(data?: ILoadHasNotesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.load = new LoadModel();
            this.note = new NoteModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loadId = _data["loadId"];
            this.load = _data["load"] ? LoadModel.fromJS(_data["load"]) : new LoadModel();
            this.noteId = _data["noteId"];
            this.note = _data["note"] ? NoteModel.fromJS(_data["note"]) : new NoteModel();
        }
    }

    static fromJS(data: any): LoadHasNotesModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoadHasNotesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loadId"] = this.loadId;
        data["load"] = this.load ? this.load.toJSON() : <any>undefined;
        data["noteId"] = this.noteId;
        data["note"] = this.note ? this.note.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoadHasNotesModel {
    loadId: number;
    load: LoadModel;
    noteId: number;
    note: NoteModel;
}

export enum LoadType {
    TL = 0,
    LTL = 1,
}

export enum LoadStatus {
    Open = 1,
    Hold = 2,
    Booked = 3,
    InTransit = 4,
    Delivered = 5,
    Planned = 6,
    Cancelled = 70,
}

export enum LoadDesignation {
    BrokerGeneral = 1,
    California = 2,
    BrokerEast = 3,
    OregonOrWashingtion = 4,
    Pickup = 5,
    Inbound = 6,
    Project = 7,
    BrokerRailWine = 8,
    BrokerRailGeneral = 9,
    StorageTrailer = 10,
    TankerFlatbed = 11,
    Transfer = 12,
    BrokerWestCoast = 13,
    OutsideCarrierInbound = 14,
    BrokerInbound = 15,
    DirectToTrade = 16,
}

export enum LoadTrailerType {
    Dry = 1,
    Reefer = 2,
}

export enum LoadStopType {
    Pickup = 1,
    Delivery = 2,
}

export class RefLoadStopTypeModel extends BasePagedModel implements IRefLoadStopTypeModel {
    tableName!: string;
    refLoadStopTypeId!: LoadStopType;
    name!: string;
    description?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IRefLoadStopTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.refLoadStopTypeId = _data["refLoadStopTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): RefLoadStopTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefLoadStopTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["refLoadStopTypeId"] = this.refLoadStopTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRefLoadStopTypeModel extends IBasePagedModel {
    tableName: string;
    refLoadStopTypeId: LoadStopType;
    name: string;
    description?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export class OrderGroupModel extends BasePagedModel implements IOrderGroupModel {
    tableName!: string;
    orders?: OrderModel[] | undefined;
    orderGroupId!: number;
    dateAdded?: Date | undefined;
    dateModified?: Date | undefined;

    constructor(data?: IOrderGroupModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderModel.fromJS(item));
            }
            this.orderGroupId = _data["orderGroupId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): OrderGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGroupModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["orderGroupId"] = this.orderGroupId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderGroupModel extends IBasePagedModel {
    tableName: string;
    orders?: OrderModel[] | undefined;
    orderGroupId: number;
    dateAdded?: Date | undefined;
    dateModified?: Date | undefined;
}

export class OrderHasNotesModel implements IOrderHasNotesModel {
    orderId!: number;
    order!: OrderModel;
    noteId!: number;
    note!: NoteModel;

    constructor(data?: IOrderHasNotesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.order = new OrderModel();
            this.note = new NoteModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : new OrderModel();
            this.noteId = _data["noteId"];
            this.note = _data["note"] ? NoteModel.fromJS(_data["note"]) : new NoteModel();
        }
    }

    static fromJS(data: any): OrderHasNotesModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHasNotesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["noteId"] = this.noteId;
        data["note"] = this.note ? this.note.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderHasNotesModel {
    orderId: number;
    order: OrderModel;
    noteId: number;
    note: NoteModel;
}

export class OrderHasFilesModel implements IOrderHasFilesModel {
    orderId!: number;
    order!: OrderModel;
    fileId!: number;
    file!: FileModel;

    constructor(data?: IOrderHasFilesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.order = new OrderModel();
            this.file = new FileModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : new OrderModel();
            this.fileId = _data["fileId"];
            this.file = _data["file"] ? FileModel.fromJS(_data["file"]) : new FileModel();
        }
    }

    static fromJS(data: any): OrderHasFilesModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHasFilesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["fileId"] = this.fileId;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderHasFilesModel {
    orderId: number;
    order: OrderModel;
    fileId: number;
    file: FileModel;
}

export class FileModel extends BasePagedModel implements IFileModel {
    tableName!: string;
    fileId!: number;
    name!: string;
    type!: string;
    path!: string;
    size!: number;
    description!: string;
    dateAdded!: Date;
    dateModified!: Date;
    documentType?: string | undefined;

    constructor(data?: IFileModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.path = _data["path"];
            this.size = _data["size"];
            this.description = _data["description"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.documentType = _data["documentType"];
        }
    }

    static override fromJS(data: any): FileModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["path"] = this.path;
        data["size"] = this.size;
        data["description"] = this.description;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        super.toJSON(data);
        return data;
    }
}

export interface IFileModel extends IBasePagedModel {
    tableName: string;
    fileId: number;
    name: string;
    type: string;
    path: string;
    size: number;
    description: string;
    dateAdded: Date;
    dateModified: Date;
    documentType?: string | undefined;
}

export enum SyncSourceEnum {
    RNDC = 1,
}

export enum OrderUnitType {
    Case = 1,
    Case3Pk = 2,
    Case6Pk = 3,
    CaseOther = 4,
    Can12Pk = 5,
    Can24Pk = 6,
    CanOther = 7,
    BarrelFullOnRack = 8,
    BarrelEmptyOnRack = 9,
    BarrelFullOnPallet = 10,
    BarrelEmptyOnPallet = 11,
    BinCaseFull = 12,
    BinEmpty = 13,
    Feet = 14,
    GlassPalletBulk = 15,
    GlassPalletCarton = 16,
    IbcToteFull = 17,
    IbcToteEmpty = 18,
    KegHalfBbl = 19,
    KegQuarterBbl = 20,
    KegSixthBbl = 21,
    Keg20L = 22,
    Lbs = 23,
    PalletWine = 24,
    PalletDryGoods = 25,
    PalletEmpty = 26,
    PalletOther = 27,
    Tanker = 28,
    Other = 29,
}

export class RefCountryModel extends BasePagedModel implements IRefCountryModel {
    tableName!: string;
    refCountryId!: Countries;
    name!: string;
    alpha2Code?: string | undefined;
    alpha3Code?: string | undefined;
    numericCode?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IRefCountryModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.refCountryId = _data["refCountryId"];
            this.name = _data["name"];
            this.alpha2Code = _data["alpha2Code"];
            this.alpha3Code = _data["alpha3Code"];
            this.numericCode = _data["numericCode"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): RefCountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefCountryModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["refCountryId"] = this.refCountryId;
        data["name"] = this.name;
        data["alpha2Code"] = this.alpha2Code;
        data["alpha3Code"] = this.alpha3Code;
        data["numericCode"] = this.numericCode;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRefCountryModel extends IBasePagedModel {
    tableName: string;
    refCountryId: Countries;
    name: string;
    alpha2Code?: string | undefined;
    alpha3Code?: string | undefined;
    numericCode?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export class RefCountryStateModel extends BasePagedModel implements IRefCountryStateModel {
    tableName!: string;
    country?: RefCountryModel | undefined;
    refCountryStateId!: CountryStates;
    refCountryId!: Countries;
    name!: string;
    longName!: string;
    isTerritory?: boolean | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IRefCountryStateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.country = _data["country"] ? RefCountryModel.fromJS(_data["country"]) : <any>undefined;
            this.refCountryStateId = _data["refCountryStateId"];
            this.refCountryId = _data["refCountryId"];
            this.name = _data["name"];
            this.longName = _data["longName"];
            this.isTerritory = _data["isTerritory"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): RefCountryStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefCountryStateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["refCountryStateId"] = this.refCountryStateId;
        data["refCountryId"] = this.refCountryId;
        data["name"] = this.name;
        data["longName"] = this.longName;
        data["isTerritory"] = this.isTerritory;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRefCountryStateModel extends IBasePagedModel {
    tableName: string;
    country?: RefCountryModel | undefined;
    refCountryStateId: CountryStates;
    refCountryId: Countries;
    name: string;
    longName: string;
    isTerritory?: boolean | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export class LocationHasNotesModel implements ILocationHasNotesModel {
    locationId!: number;
    location!: LocationModel;
    noteId!: number;
    note!: NoteModel;

    constructor(data?: ILocationHasNotesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.location = new LocationModel();
            this.note = new NoteModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : new LocationModel();
            this.noteId = _data["noteId"];
            this.note = _data["note"] ? NoteModel.fromJS(_data["note"]) : new NoteModel();
        }
    }

    static fromJS(data: any): LocationHasNotesModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationHasNotesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["noteId"] = this.noteId;
        data["note"] = this.note ? this.note.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILocationHasNotesModel {
    locationId: number;
    location: LocationModel;
    noteId: number;
    note: NoteModel;
}

export class OrderCustomerHasLocationsModel implements IOrderCustomerHasLocationsModel {
    customName?: string | undefined;
    orderCustomerId!: number;
    orderCustomer!: OrderCustomerModel;
    locationId!: number;
    location!: LocationModel;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IOrderCustomerHasLocationsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderCustomer = new OrderCustomerModel();
            this.location = new LocationModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customName = _data["customName"];
            this.orderCustomerId = _data["orderCustomerId"];
            this.orderCustomer = _data["orderCustomer"] ? OrderCustomerModel.fromJS(_data["orderCustomer"]) : new OrderCustomerModel();
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : new LocationModel();
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderCustomerHasLocationsModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomerHasLocationsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customName"] = this.customName;
        data["orderCustomerId"] = this.orderCustomerId;
        data["orderCustomer"] = this.orderCustomer ? this.orderCustomer.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrderCustomerHasLocationsModel {
    customName?: string | undefined;
    orderCustomerId: number;
    orderCustomer: OrderCustomerModel;
    locationId: number;
    location: LocationModel;
    dateAdded: Date;
    dateModified: Date;
}

export class CarrierHasContactsModel implements ICarrierHasContactsModel {
    carrierId!: number;
    carrier!: CarrierModel;
    contactId!: number;
    contact!: ContactModel;

    constructor(data?: ICarrierHasContactsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.carrier = new CarrierModel();
            this.contact = new ContactModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierModel.fromJS(_data["carrier"]) : new CarrierModel();
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? ContactModel.fromJS(_data["contact"]) : new ContactModel();
        }
    }

    static fromJS(data: any): CarrierHasContactsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierHasContactsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICarrierHasContactsModel {
    carrierId: number;
    carrier: CarrierModel;
    contactId: number;
    contact: ContactModel;
}

export enum ContactType {
    Location = 1,
    OrderCustomer = 2,
    Carrier = 3,
}

export enum CustomerStatus {
    GoodStanding = 0,
    PendingApproval = 1,
    ConsolidationOnly = 2,
    Suspended = 3,
}

export class SystemScanToPickModel extends BasePagedModel implements ISystemScanToPickModel {
    systemScanToPickRoleAssignments!: SystemScanToPickRoleAssignmentModel[];
    systemUser?: SystemUserModel | undefined;
    overrides?: SystemIdentityPermissionOverrideModel[] | undefined;
    tableName!: string;
    systemScanToPickId!: number;
    systemUserId?: number | undefined;
    isActive?: boolean | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    systemUserEmailAddress?: string | undefined;
    systemUserUsername?: string | undefined;
    systemUserPhoneNumber?: string | undefined;
    systemUserFirstName?: string | undefined;
    systemUserLastName?: string | undefined;
    systemRoleIds?: number[] | undefined;
    systemRoleNames?: string | undefined;
    loginSubTitle?: string | undefined;
    systemUserIsActive?: boolean | undefined;
    shouldDisplayAsActive?: boolean | undefined;

    constructor(data?: ISystemScanToPickModel) {
        super(data);
        if (!data) {
            this.systemScanToPickRoleAssignments = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["systemScanToPickRoleAssignments"])) {
                this.systemScanToPickRoleAssignments = [] as any;
                for (let item of _data["systemScanToPickRoleAssignments"])
                    this.systemScanToPickRoleAssignments!.push(SystemScanToPickRoleAssignmentModel.fromJS(item));
            }
            this.systemUser = _data["systemUser"] ? SystemUserModel.fromJS(_data["systemUser"]) : <any>undefined;
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(SystemIdentityPermissionOverrideModel.fromJS(item));
            }
            this.tableName = _data["tableName"];
            this.systemScanToPickId = _data["systemScanToPickId"];
            this.systemUserId = _data["systemUserId"];
            this.isActive = _data["isActive"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.systemUserEmailAddress = _data["systemUserEmailAddress"];
            this.systemUserUsername = _data["systemUserUsername"];
            this.systemUserPhoneNumber = _data["systemUserPhoneNumber"];
            this.systemUserFirstName = _data["systemUserFirstName"];
            this.systemUserLastName = _data["systemUserLastName"];
            if (Array.isArray(_data["systemRoleIds"])) {
                this.systemRoleIds = [] as any;
                for (let item of _data["systemRoleIds"])
                    this.systemRoleIds!.push(item);
            }
            this.systemRoleNames = _data["systemRoleNames"];
            this.loginSubTitle = _data["loginSubTitle"];
            this.systemUserIsActive = _data["systemUserIsActive"];
            this.shouldDisplayAsActive = _data["shouldDisplayAsActive"];
        }
    }

    static override fromJS(data: any): SystemScanToPickModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemScanToPickModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemScanToPickRoleAssignments)) {
            data["systemScanToPickRoleAssignments"] = [];
            for (let item of this.systemScanToPickRoleAssignments)
                data["systemScanToPickRoleAssignments"].push(item.toJSON());
        }
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["systemScanToPickId"] = this.systemScanToPickId;
        data["systemUserId"] = this.systemUserId;
        data["isActive"] = this.isActive;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["systemUserEmailAddress"] = this.systemUserEmailAddress;
        data["systemUserUsername"] = this.systemUserUsername;
        data["systemUserPhoneNumber"] = this.systemUserPhoneNumber;
        data["systemUserFirstName"] = this.systemUserFirstName;
        data["systemUserLastName"] = this.systemUserLastName;
        if (Array.isArray(this.systemRoleIds)) {
            data["systemRoleIds"] = [];
            for (let item of this.systemRoleIds)
                data["systemRoleIds"].push(item);
        }
        data["systemRoleNames"] = this.systemRoleNames;
        data["loginSubTitle"] = this.loginSubTitle;
        data["systemUserIsActive"] = this.systemUserIsActive;
        data["shouldDisplayAsActive"] = this.shouldDisplayAsActive;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemScanToPickModel extends IBasePagedModel {
    systemScanToPickRoleAssignments: SystemScanToPickRoleAssignmentModel[];
    systemUser?: SystemUserModel | undefined;
    overrides?: SystemIdentityPermissionOverrideModel[] | undefined;
    tableName: string;
    systemScanToPickId: number;
    systemUserId?: number | undefined;
    isActive?: boolean | undefined;
    dateAdded: Date;
    dateModified: Date;
    systemUserEmailAddress?: string | undefined;
    systemUserUsername?: string | undefined;
    systemUserPhoneNumber?: string | undefined;
    systemUserFirstName?: string | undefined;
    systemUserLastName?: string | undefined;
    systemRoleIds?: number[] | undefined;
    systemRoleNames?: string | undefined;
    loginSubTitle?: string | undefined;
    systemUserIsActive?: boolean | undefined;
    shouldDisplayAsActive?: boolean | undefined;
}

export class SystemScanToPickRoleAssignmentModel extends BasePagedModel implements ISystemScanToPickRoleAssignmentModel {
    systemScanToPick?: SystemScanToPickModel | undefined;
    systemRole?: SystemRoleModel | undefined;
    tableName!: string;
    systemScanToPickId!: number;
    systemRoleId!: number;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: ISystemScanToPickRoleAssignmentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systemScanToPick = _data["systemScanToPick"] ? SystemScanToPickModel.fromJS(_data["systemScanToPick"]) : <any>undefined;
            this.systemRole = _data["systemRole"] ? SystemRoleModel.fromJS(_data["systemRole"]) : <any>undefined;
            this.tableName = _data["tableName"];
            this.systemScanToPickId = _data["systemScanToPickId"];
            this.systemRoleId = _data["systemRoleId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SystemScanToPickRoleAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemScanToPickRoleAssignmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemScanToPick"] = this.systemScanToPick ? this.systemScanToPick.toJSON() : <any>undefined;
        data["systemRole"] = this.systemRole ? this.systemRole.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["systemScanToPickId"] = this.systemScanToPickId;
        data["systemRoleId"] = this.systemRoleId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemScanToPickRoleAssignmentModel extends IBasePagedModel {
    systemScanToPick?: SystemScanToPickModel | undefined;
    systemRole?: SystemRoleModel | undefined;
    tableName: string;
    systemScanToPickId: number;
    systemRoleId: number;
    dateAdded: Date;
    dateModified: Date;
}

export class SystemEmployeeModel extends BasePagedModel implements ISystemEmployeeModel {
    systemEmployeeRoleAssignments!: SystemEmployeeRoleAssignmentModel[];
    systemUser?: SystemUserModel | undefined;
    overrides?: SystemIdentityPermissionOverrideModel[] | undefined;
    tableName!: string;
    systemEmployeeId!: number;
    systemUserId?: number | undefined;
    isActive?: boolean | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    systemUserEmailAddress?: string | undefined;
    systemUserUsername?: string | undefined;
    systemUserPhoneNumber?: string | undefined;
    systemUserFirstName?: string | undefined;
    systemUserLastName?: string | undefined;
    systemRoleIds?: number[] | undefined;
    systemRoleNames?: string | undefined;
    loginSubTitle?: string | undefined;
    systemUserIsActive?: boolean | undefined;
    shouldDisplayAsActive?: boolean | undefined;

    constructor(data?: ISystemEmployeeModel) {
        super(data);
        if (!data) {
            this.systemEmployeeRoleAssignments = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["systemEmployeeRoleAssignments"])) {
                this.systemEmployeeRoleAssignments = [] as any;
                for (let item of _data["systemEmployeeRoleAssignments"])
                    this.systemEmployeeRoleAssignments!.push(SystemEmployeeRoleAssignmentModel.fromJS(item));
            }
            this.systemUser = _data["systemUser"] ? SystemUserModel.fromJS(_data["systemUser"]) : <any>undefined;
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(SystemIdentityPermissionOverrideModel.fromJS(item));
            }
            this.tableName = _data["tableName"];
            this.systemEmployeeId = _data["systemEmployeeId"];
            this.systemUserId = _data["systemUserId"];
            this.isActive = _data["isActive"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.systemUserEmailAddress = _data["systemUserEmailAddress"];
            this.systemUserUsername = _data["systemUserUsername"];
            this.systemUserPhoneNumber = _data["systemUserPhoneNumber"];
            this.systemUserFirstName = _data["systemUserFirstName"];
            this.systemUserLastName = _data["systemUserLastName"];
            if (Array.isArray(_data["systemRoleIds"])) {
                this.systemRoleIds = [] as any;
                for (let item of _data["systemRoleIds"])
                    this.systemRoleIds!.push(item);
            }
            this.systemRoleNames = _data["systemRoleNames"];
            this.loginSubTitle = _data["loginSubTitle"];
            this.systemUserIsActive = _data["systemUserIsActive"];
            this.shouldDisplayAsActive = _data["shouldDisplayAsActive"];
        }
    }

    static override fromJS(data: any): SystemEmployeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmployeeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemEmployeeRoleAssignments)) {
            data["systemEmployeeRoleAssignments"] = [];
            for (let item of this.systemEmployeeRoleAssignments)
                data["systemEmployeeRoleAssignments"].push(item.toJSON());
        }
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["systemEmployeeId"] = this.systemEmployeeId;
        data["systemUserId"] = this.systemUserId;
        data["isActive"] = this.isActive;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["systemUserEmailAddress"] = this.systemUserEmailAddress;
        data["systemUserUsername"] = this.systemUserUsername;
        data["systemUserPhoneNumber"] = this.systemUserPhoneNumber;
        data["systemUserFirstName"] = this.systemUserFirstName;
        data["systemUserLastName"] = this.systemUserLastName;
        if (Array.isArray(this.systemRoleIds)) {
            data["systemRoleIds"] = [];
            for (let item of this.systemRoleIds)
                data["systemRoleIds"].push(item);
        }
        data["systemRoleNames"] = this.systemRoleNames;
        data["loginSubTitle"] = this.loginSubTitle;
        data["systemUserIsActive"] = this.systemUserIsActive;
        data["shouldDisplayAsActive"] = this.shouldDisplayAsActive;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmployeeModel extends IBasePagedModel {
    systemEmployeeRoleAssignments: SystemEmployeeRoleAssignmentModel[];
    systemUser?: SystemUserModel | undefined;
    overrides?: SystemIdentityPermissionOverrideModel[] | undefined;
    tableName: string;
    systemEmployeeId: number;
    systemUserId?: number | undefined;
    isActive?: boolean | undefined;
    dateAdded: Date;
    dateModified: Date;
    systemUserEmailAddress?: string | undefined;
    systemUserUsername?: string | undefined;
    systemUserPhoneNumber?: string | undefined;
    systemUserFirstName?: string | undefined;
    systemUserLastName?: string | undefined;
    systemRoleIds?: number[] | undefined;
    systemRoleNames?: string | undefined;
    loginSubTitle?: string | undefined;
    systemUserIsActive?: boolean | undefined;
    shouldDisplayAsActive?: boolean | undefined;
}

export class SystemEmployeeRoleAssignmentModel extends BasePagedModel implements ISystemEmployeeRoleAssignmentModel {
    systemEmployee?: SystemEmployeeModel | undefined;
    systemRole?: SystemRoleModel | undefined;
    tableName!: string;
    systemEmployeeId!: number;
    systemRoleId!: number;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: ISystemEmployeeRoleAssignmentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systemEmployee = _data["systemEmployee"] ? SystemEmployeeModel.fromJS(_data["systemEmployee"]) : <any>undefined;
            this.systemRole = _data["systemRole"] ? SystemRoleModel.fromJS(_data["systemRole"]) : <any>undefined;
            this.tableName = _data["tableName"];
            this.systemEmployeeId = _data["systemEmployeeId"];
            this.systemRoleId = _data["systemRoleId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SystemEmployeeRoleAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmployeeRoleAssignmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemEmployee"] = this.systemEmployee ? this.systemEmployee.toJSON() : <any>undefined;
        data["systemRole"] = this.systemRole ? this.systemRole.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["systemEmployeeId"] = this.systemEmployeeId;
        data["systemRoleId"] = this.systemRoleId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmployeeRoleAssignmentModel extends IBasePagedModel {
    systemEmployee?: SystemEmployeeModel | undefined;
    systemRole?: SystemRoleModel | undefined;
    tableName: string;
    systemEmployeeId: number;
    systemRoleId: number;
    dateAdded: Date;
    dateModified: Date;
}

export class ClockedTimeModel extends BasePagedModel implements IClockedTimeModel {
    pauseIntervals!: TimePauseIntervalModel[];
    systemUser?: SystemUserModel | undefined;
    clockedTimeId!: number;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    totalHours!: number;
    systemUserId!: number;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IClockedTimeModel) {
        super(data);
        if (!data) {
            this.pauseIntervals = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pauseIntervals"])) {
                this.pauseIntervals = [] as any;
                for (let item of _data["pauseIntervals"])
                    this.pauseIntervals!.push(TimePauseIntervalModel.fromJS(item));
            }
            this.systemUser = _data["systemUser"] ? SystemUserModel.fromJS(_data["systemUser"]) : <any>undefined;
            this.clockedTimeId = _data["clockedTimeId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.totalHours = _data["totalHours"];
            this.systemUserId = _data["systemUserId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ClockedTimeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClockedTimeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pauseIntervals)) {
            data["pauseIntervals"] = [];
            for (let item of this.pauseIntervals)
                data["pauseIntervals"].push(item.toJSON());
        }
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        data["clockedTimeId"] = this.clockedTimeId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["totalHours"] = this.totalHours;
        data["systemUserId"] = this.systemUserId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IClockedTimeModel extends IBasePagedModel {
    pauseIntervals: TimePauseIntervalModel[];
    systemUser?: SystemUserModel | undefined;
    clockedTimeId: number;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    totalHours: number;
    systemUserId: number;
    dateAdded: Date;
    dateModified: Date;
}

export class TimePauseIntervalModel extends BasePagedModel implements ITimePauseIntervalModel {
    clockedTime!: ClockedTimeModel;
    timePauseIntervalId!: number;
    startTime!: Date;
    endTime?: Date | undefined;
    totalHours?: number | undefined;
    clockedTimeId!: number;

    constructor(data?: ITimePauseIntervalModel) {
        super(data);
        if (!data) {
            this.clockedTime = new ClockedTimeModel();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clockedTime = _data["clockedTime"] ? ClockedTimeModel.fromJS(_data["clockedTime"]) : new ClockedTimeModel();
            this.timePauseIntervalId = _data["timePauseIntervalId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.totalHours = _data["totalHours"];
            this.clockedTimeId = _data["clockedTimeId"];
        }
    }

    static override fromJS(data: any): TimePauseIntervalModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimePauseIntervalModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clockedTime"] = this.clockedTime ? this.clockedTime.toJSON() : <any>undefined;
        data["timePauseIntervalId"] = this.timePauseIntervalId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["totalHours"] = this.totalHours;
        data["clockedTimeId"] = this.clockedTimeId;
        super.toJSON(data);
        return data;
    }
}

export interface ITimePauseIntervalModel extends IBasePagedModel {
    clockedTime: ClockedTimeModel;
    timePauseIntervalId: number;
    startTime: Date;
    endTime?: Date | undefined;
    totalHours?: number | undefined;
    clockedTimeId: number;
}

export class OrderInterruptionModel extends BasePagedModel implements IOrderInterruptionModel {
    interrupter!: SystemUserModel;
    order!: AmsOrderModel;
    lookupAndReasonType!: LookupAndReasonTypeModel;
    id!: number;
    orderId!: number;
    reasonCode!: string;
    reasonNote!: string;
    type!: number;
    dateAdded!: Date;
    dateModified!: Date;
    createdByUserId!: string;
    modifiedByUserId!: string;
    interrupterId!: number;

    constructor(data?: IOrderInterruptionModel) {
        super(data);
        if (!data) {
            this.interrupter = new SystemUserModel();
            this.order = new AmsOrderModel();
            this.lookupAndReasonType = new LookupAndReasonTypeModel();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.interrupter = _data["interrupter"] ? SystemUserModel.fromJS(_data["interrupter"]) : new SystemUserModel();
            this.order = _data["order"] ? AmsOrderModel.fromJS(_data["order"]) : new AmsOrderModel();
            this.lookupAndReasonType = _data["lookupAndReasonType"] ? LookupAndReasonTypeModel.fromJS(_data["lookupAndReasonType"]) : new LookupAndReasonTypeModel();
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.reasonCode = _data["reasonCode"];
            this.reasonNote = _data["reasonNote"];
            this.type = _data["type"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.createdByUserId = _data["createdByUserId"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.interrupterId = _data["interrupterId"];
        }
    }

    static override fromJS(data: any): OrderInterruptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInterruptionModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interrupter"] = this.interrupter ? this.interrupter.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["lookupAndReasonType"] = this.lookupAndReasonType ? this.lookupAndReasonType.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["reasonCode"] = this.reasonCode;
        data["reasonNote"] = this.reasonNote;
        data["type"] = this.type;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["createdByUserId"] = this.createdByUserId;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["interrupterId"] = this.interrupterId;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderInterruptionModel extends IBasePagedModel {
    interrupter: SystemUserModel;
    order: AmsOrderModel;
    lookupAndReasonType: LookupAndReasonTypeModel;
    id: number;
    orderId: number;
    reasonCode: string;
    reasonNote: string;
    type: number;
    dateAdded: Date;
    dateModified: Date;
    createdByUserId: string;
    modifiedByUserId: string;
    interrupterId: number;
}

export class LookupAndReasonTypeModel extends BasePagedModel implements ILookupAndReasonTypeModel {
    code!: string;
    description!: string;

    constructor(data?: ILookupAndReasonTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static override fromJS(data: any): LookupAndReasonTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new LookupAndReasonTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface ILookupAndReasonTypeModel extends IBasePagedModel {
    code: string;
    description: string;
}

export class AmsCustomerModel extends BasePagedModel implements IAmsCustomerModel {
    id!: number;
    cusNo?: number | undefined;
    name!: string;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city!: string;
    stateCode!: string;
    zipCode?: string | undefined;
    phoneNumber?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IAmsCustomerModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.cusNo = _data["cusNo"];
            this.name = _data["name"];
            this.addr1 = _data["addr1"];
            this.addr2 = _data["addr2"];
            this.city = _data["city"];
            this.stateCode = _data["stateCode"];
            this.zipCode = _data["zipCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): AmsCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmsCustomerModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cusNo"] = this.cusNo;
        data["name"] = this.name;
        data["addr1"] = this.addr1;
        data["addr2"] = this.addr2;
        data["city"] = this.city;
        data["stateCode"] = this.stateCode;
        data["zipCode"] = this.zipCode;
        data["phoneNumber"] = this.phoneNumber;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAmsCustomerModel extends IBasePagedModel {
    id: number;
    cusNo?: number | undefined;
    name: string;
    addr1?: string | undefined;
    addr2?: string | undefined;
    city: string;
    stateCode: string;
    zipCode?: string | undefined;
    phoneNumber?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export class AmsLaneOnHandModel extends BasePagedModel implements IAmsLaneOnHandModel {
    warehouse!: string;
    lane!: string;
    partNo!: string;
    loc!: string;
    qtyOnHand!: number;
    qtyOnHandP1!: number;
    qtyOnHandP2!: number;
    qtyReservedIn?: number | undefined;
    qtyReservedOut?: number | undefined;
    fifoString!: string;

    constructor(data?: IAmsLaneOnHandModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.warehouse = _data["warehouse"];
            this.lane = _data["lane"];
            this.partNo = _data["partNo"];
            this.loc = _data["loc"];
            this.qtyOnHand = _data["qtyOnHand"];
            this.qtyOnHandP1 = _data["qtyOnHandP1"];
            this.qtyOnHandP2 = _data["qtyOnHandP2"];
            this.qtyReservedIn = _data["qtyReservedIn"];
            this.qtyReservedOut = _data["qtyReservedOut"];
            this.fifoString = _data["fifoString"];
        }
    }

    static override fromJS(data: any): AmsLaneOnHandModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmsLaneOnHandModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse;
        data["lane"] = this.lane;
        data["partNo"] = this.partNo;
        data["loc"] = this.loc;
        data["qtyOnHand"] = this.qtyOnHand;
        data["qtyOnHandP1"] = this.qtyOnHandP1;
        data["qtyOnHandP2"] = this.qtyOnHandP2;
        data["qtyReservedIn"] = this.qtyReservedIn;
        data["qtyReservedOut"] = this.qtyReservedOut;
        data["fifoString"] = this.fifoString;
        super.toJSON(data);
        return data;
    }
}

export interface IAmsLaneOnHandModel extends IBasePagedModel {
    warehouse: string;
    lane: string;
    partNo: string;
    loc: string;
    qtyOnHand: number;
    qtyOnHandP1: number;
    qtyOnHandP2: number;
    qtyReservedIn?: number | undefined;
    qtyReservedOut?: number | undefined;
    fifoString: string;
}

export class OrderLineItemAndReasonModel extends BasePagedModel implements IOrderLineItemAndReasonModel {
    id!: number;
    orderLineItemId!: number;
    reasonCode!: string;
    reasonNote!: string;
    pickerId?: number | undefined;
    reviewerId?: number | undefined;
    orderLineItem!: AmsOrderLineItemModel;
    lookupAndReasonType!: LookupAndReasonTypeModel;

    constructor(data?: IOrderLineItemAndReasonModel) {
        super(data);
        if (!data) {
            this.orderLineItem = new AmsOrderLineItemModel();
            this.lookupAndReasonType = new LookupAndReasonTypeModel();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.orderLineItemId = _data["orderLineItemId"];
            this.reasonCode = _data["reasonCode"];
            this.reasonNote = _data["reasonNote"];
            this.pickerId = _data["pickerId"];
            this.reviewerId = _data["reviewerId"];
            this.orderLineItem = _data["orderLineItem"] ? AmsOrderLineItemModel.fromJS(_data["orderLineItem"]) : new AmsOrderLineItemModel();
            this.lookupAndReasonType = _data["lookupAndReasonType"] ? LookupAndReasonTypeModel.fromJS(_data["lookupAndReasonType"]) : new LookupAndReasonTypeModel();
        }
    }

    static override fromJS(data: any): OrderLineItemAndReasonModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineItemAndReasonModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderLineItemId"] = this.orderLineItemId;
        data["reasonCode"] = this.reasonCode;
        data["reasonNote"] = this.reasonNote;
        data["pickerId"] = this.pickerId;
        data["reviewerId"] = this.reviewerId;
        data["orderLineItem"] = this.orderLineItem ? this.orderLineItem.toJSON() : <any>undefined;
        data["lookupAndReasonType"] = this.lookupAndReasonType ? this.lookupAndReasonType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderLineItemAndReasonModel extends IBasePagedModel {
    id: number;
    orderLineItemId: number;
    reasonCode: string;
    reasonNote: string;
    pickerId?: number | undefined;
    reviewerId?: number | undefined;
    orderLineItem: AmsOrderLineItemModel;
    lookupAndReasonType: LookupAndReasonTypeModel;
}

export enum ScanToPickLaneCorrectionTypeEnum {
    Physical = 0,
    Ams = 1,
}

export class MarkLaneCorrectedInput implements IMarkLaneCorrectedInput {
    laneCorrectionType!: ScanToPickLaneCorrectionTypeEnum;

    constructor(data?: IMarkLaneCorrectedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.laneCorrectionType = _data["laneCorrectionType"];
        }
    }

    static fromJS(data: any): MarkLaneCorrectedInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkLaneCorrectedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["laneCorrectionType"] = this.laneCorrectionType;
        return data;
    }
}

export interface IMarkLaneCorrectedInput {
    laneCorrectionType: ScanToPickLaneCorrectionTypeEnum;
}

export class PagedResultsOfIncorrectLaneReportModel implements IPagedResultsOfIncorrectLaneReportModel {
    resultCount!: number;
    results?: IncorrectLaneReportModel[] | undefined;

    constructor(data?: IPagedResultsOfIncorrectLaneReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(IncorrectLaneReportModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfIncorrectLaneReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfIncorrectLaneReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultsOfIncorrectLaneReportModel {
    resultCount: number;
    results?: IncorrectLaneReportModel[] | undefined;
}

export class OrderViewModel implements IOrderViewModel {
    id!: number;
    amsOrderId!: number;
    status?: string | undefined;
    orderStatusCode!: AmsOrderStatusEnum;
    casesPicked!: number;
    numberOfCases!: number;
    numberOfBottles!: number;
    totalLineItemBottles!: number;
    locationCode?: string | undefined;
    priority!: number;
    lineItemCount!: number;
    customer?: string | undefined;
    returnNote?: string | undefined;
    returnReason?: string | undefined;
    wineryCode?: string | undefined;
    wineryName?: string | undefined;
    poNumber?: string | undefined;
    clerkNote?: string | undefined;
    deliveryInstructions?: string | undefined;
    expectedShipDate?: Date | undefined;
    shipDate?: Date | undefined;
    assignmentDate?: Date | undefined;
    progressDate?: Date | undefined;
    orderCompleteDate?: Date | undefined;
    pickedDate?: Date | undefined;
    picker?: PickerViewModel | undefined;
    qCedByUser?: ApplicationUserViewModel | undefined;
    interrupter?: UserViewModel | undefined;
    orderItems?: OrderItemViewModel[] | undefined;
    orderInterruptionsPaused?: OrderInterruptionViewModel[] | undefined;
    orderInterruptionsReturned?: OrderInterruptionViewModel[] | undefined;
    orderInterruptionsCancelled?: OrderInterruptionViewModel[] | undefined;
    shipToCity?: string | undefined;
    shipToState?: string | undefined;

    constructor(data?: IOrderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amsOrderId = _data["amsOrderId"];
            this.status = _data["status"];
            this.orderStatusCode = _data["orderStatusCode"];
            this.casesPicked = _data["casesPicked"];
            this.numberOfCases = _data["numberOfCases"];
            this.numberOfBottles = _data["numberOfBottles"];
            this.totalLineItemBottles = _data["totalLineItemBottles"];
            this.locationCode = _data["locationCode"];
            this.priority = _data["priority"];
            this.lineItemCount = _data["lineItemCount"];
            this.customer = _data["customer"];
            this.returnNote = _data["returnNote"];
            this.returnReason = _data["returnReason"];
            this.wineryCode = _data["wineryCode"];
            this.wineryName = _data["wineryName"];
            this.poNumber = _data["poNumber"];
            this.clerkNote = _data["clerkNote"];
            this.deliveryInstructions = _data["deliveryInstructions"];
            this.expectedShipDate = _data["expectedShipDate"] ? new Date(_data["expectedShipDate"].toString()) : <any>undefined;
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
            this.assignmentDate = _data["assignmentDate"] ? new Date(_data["assignmentDate"].toString()) : <any>undefined;
            this.progressDate = _data["progressDate"] ? new Date(_data["progressDate"].toString()) : <any>undefined;
            this.orderCompleteDate = _data["orderCompleteDate"] ? new Date(_data["orderCompleteDate"].toString()) : <any>undefined;
            this.pickedDate = _data["pickedDate"] ? new Date(_data["pickedDate"].toString()) : <any>undefined;
            this.picker = _data["picker"] ? PickerViewModel.fromJS(_data["picker"]) : <any>undefined;
            this.qCedByUser = _data["qCedByUser"] ? ApplicationUserViewModel.fromJS(_data["qCedByUser"]) : <any>undefined;
            this.interrupter = _data["interrupter"] ? UserViewModel.fromJS(_data["interrupter"]) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItemViewModel.fromJS(item));
            }
            if (Array.isArray(_data["orderInterruptionsPaused"])) {
                this.orderInterruptionsPaused = [] as any;
                for (let item of _data["orderInterruptionsPaused"])
                    this.orderInterruptionsPaused!.push(OrderInterruptionViewModel.fromJS(item));
            }
            if (Array.isArray(_data["orderInterruptionsReturned"])) {
                this.orderInterruptionsReturned = [] as any;
                for (let item of _data["orderInterruptionsReturned"])
                    this.orderInterruptionsReturned!.push(OrderInterruptionViewModel.fromJS(item));
            }
            if (Array.isArray(_data["orderInterruptionsCancelled"])) {
                this.orderInterruptionsCancelled = [] as any;
                for (let item of _data["orderInterruptionsCancelled"])
                    this.orderInterruptionsCancelled!.push(OrderInterruptionViewModel.fromJS(item));
            }
            this.shipToCity = _data["shipToCity"];
            this.shipToState = _data["shipToState"];
        }
    }

    static fromJS(data: any): OrderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amsOrderId"] = this.amsOrderId;
        data["status"] = this.status;
        data["orderStatusCode"] = this.orderStatusCode;
        data["casesPicked"] = this.casesPicked;
        data["numberOfCases"] = this.numberOfCases;
        data["numberOfBottles"] = this.numberOfBottles;
        data["totalLineItemBottles"] = this.totalLineItemBottles;
        data["locationCode"] = this.locationCode;
        data["priority"] = this.priority;
        data["lineItemCount"] = this.lineItemCount;
        data["customer"] = this.customer;
        data["returnNote"] = this.returnNote;
        data["returnReason"] = this.returnReason;
        data["wineryCode"] = this.wineryCode;
        data["wineryName"] = this.wineryName;
        data["poNumber"] = this.poNumber;
        data["clerkNote"] = this.clerkNote;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["expectedShipDate"] = this.expectedShipDate ? this.expectedShipDate.toISOString() : <any>undefined;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : <any>undefined;
        data["progressDate"] = this.progressDate ? this.progressDate.toISOString() : <any>undefined;
        data["orderCompleteDate"] = this.orderCompleteDate ? this.orderCompleteDate.toISOString() : <any>undefined;
        data["pickedDate"] = this.pickedDate ? this.pickedDate.toISOString() : <any>undefined;
        data["picker"] = this.picker ? this.picker.toJSON() : <any>undefined;
        data["qCedByUser"] = this.qCedByUser ? this.qCedByUser.toJSON() : <any>undefined;
        data["interrupter"] = this.interrupter ? this.interrupter.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.orderInterruptionsPaused)) {
            data["orderInterruptionsPaused"] = [];
            for (let item of this.orderInterruptionsPaused)
                data["orderInterruptionsPaused"].push(item.toJSON());
        }
        if (Array.isArray(this.orderInterruptionsReturned)) {
            data["orderInterruptionsReturned"] = [];
            for (let item of this.orderInterruptionsReturned)
                data["orderInterruptionsReturned"].push(item.toJSON());
        }
        if (Array.isArray(this.orderInterruptionsCancelled)) {
            data["orderInterruptionsCancelled"] = [];
            for (let item of this.orderInterruptionsCancelled)
                data["orderInterruptionsCancelled"].push(item.toJSON());
        }
        data["shipToCity"] = this.shipToCity;
        data["shipToState"] = this.shipToState;
        return data;
    }
}

export interface IOrderViewModel {
    id: number;
    amsOrderId: number;
    status?: string | undefined;
    orderStatusCode: AmsOrderStatusEnum;
    casesPicked: number;
    numberOfCases: number;
    numberOfBottles: number;
    totalLineItemBottles: number;
    locationCode?: string | undefined;
    priority: number;
    lineItemCount: number;
    customer?: string | undefined;
    returnNote?: string | undefined;
    returnReason?: string | undefined;
    wineryCode?: string | undefined;
    wineryName?: string | undefined;
    poNumber?: string | undefined;
    clerkNote?: string | undefined;
    deliveryInstructions?: string | undefined;
    expectedShipDate?: Date | undefined;
    shipDate?: Date | undefined;
    assignmentDate?: Date | undefined;
    progressDate?: Date | undefined;
    orderCompleteDate?: Date | undefined;
    pickedDate?: Date | undefined;
    picker?: PickerViewModel | undefined;
    qCedByUser?: ApplicationUserViewModel | undefined;
    interrupter?: UserViewModel | undefined;
    orderItems?: OrderItemViewModel[] | undefined;
    orderInterruptionsPaused?: OrderInterruptionViewModel[] | undefined;
    orderInterruptionsReturned?: OrderInterruptionViewModel[] | undefined;
    orderInterruptionsCancelled?: OrderInterruptionViewModel[] | undefined;
    shipToCity?: string | undefined;
    shipToState?: string | undefined;
}

export class PickerViewModel implements IPickerViewModel {
    pickerId!: number;
    name?: string | undefined;
    status?: string | undefined;
    statusCode!: ScanToPickUserStatusEnum;
    inqueue!: number;
    casePicked!: number;
    totalCase!: number;
    time?: Date | undefined;
    orders?: OrderViewModel[] | undefined;

    constructor(data?: IPickerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickerId = _data["pickerId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.inqueue = _data["inqueue"];
            this.casePicked = _data["casePicked"];
            this.totalCase = _data["totalCase"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PickerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PickerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickerId"] = this.pickerId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["inqueue"] = this.inqueue;
        data["casePicked"] = this.casePicked;
        data["totalCase"] = this.totalCase;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPickerViewModel {
    pickerId: number;
    name?: string | undefined;
    status?: string | undefined;
    statusCode: ScanToPickUserStatusEnum;
    inqueue: number;
    casePicked: number;
    totalCase: number;
    time?: Date | undefined;
    orders?: OrderViewModel[] | undefined;
}

export enum ScanToPickUserStatusEnum {
    All = 0,
    Online = 1,
    Paused = 2,
    Offline = 3,
}

export class ApplicationUserViewModel implements IApplicationUserViewModel {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    permissions?: SystemPermission[] | undefined;

    constructor(data?: IApplicationUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IApplicationUserViewModel {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    permissions?: SystemPermission[] | undefined;
}

export class UserViewModel implements IUserViewModel {
    userId!: number;
    name?: string | undefined;

    constructor(data?: IUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserViewModel {
    userId: number;
    name?: string | undefined;
}

export class OrderInterruptionViewModel implements IOrderInterruptionViewModel {
    id!: number;
    interrupterId?: number | undefined;
    returnNote?: string | undefined;
    returnCode?: string | undefined;
    interrupter?: UserViewModel | undefined;
    dateCreated!: Date;
    interrupterUser?: ApplicationUserViewModel | undefined;

    constructor(data?: IOrderInterruptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interrupterId = _data["interrupterId"];
            this.returnNote = _data["returnNote"];
            this.returnCode = _data["returnCode"];
            this.interrupter = _data["interrupter"] ? UserViewModel.fromJS(_data["interrupter"]) : <any>undefined;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.interrupterUser = _data["interrupterUser"] ? ApplicationUserViewModel.fromJS(_data["interrupterUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderInterruptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInterruptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interrupterId"] = this.interrupterId;
        data["returnNote"] = this.returnNote;
        data["returnCode"] = this.returnCode;
        data["interrupter"] = this.interrupter ? this.interrupter.toJSON() : <any>undefined;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["interrupterUser"] = this.interrupterUser ? this.interrupterUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderInterruptionViewModel {
    id: number;
    interrupterId?: number | undefined;
    returnNote?: string | undefined;
    returnCode?: string | undefined;
    interrupter?: UserViewModel | undefined;
    dateCreated: Date;
    interrupterUser?: ApplicationUserViewModel | undefined;
}

export class PagedResultsOfOrderListOutput implements IPagedResultsOfOrderListOutput {
    resultCount!: number;
    results?: OrderListOutput[] | undefined;

    constructor(data?: IPagedResultsOfOrderListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(OrderListOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfOrderListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfOrderListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultsOfOrderListOutput {
    resultCount: number;
    results?: OrderListOutput[] | undefined;
}

export class OrderListOutput implements IOrderListOutput {
    orderId!: number;
    amsOrderId!: number;
    orderStatusCode!: AmsOrderStatusEnum;
    numberOfCases!: number;
    numberOfBottles!: number;
    totalLineItemBottles!: number;
    casesPicked!: number;
    priority!: number;
    lineItemCount!: number;
    customer?: string | undefined;
    wineryName?: string | undefined;
    locationCode?: string | undefined;
    expectedShipDate?: Date | undefined;
    shipDate?: Date | undefined;
    assignmentDate?: Date | undefined;
    progressDate?: Date | undefined;
    qCedDate?: Date | undefined;
    pickedDate?: Date | undefined;
    interrupter?: string | undefined;
    pickerId?: number | undefined;
    pickerName?: string | undefined;
    canMoveUp!: boolean;
    canMoveDown!: boolean;
    deliveryInstructions?: string | undefined;
    clerkNote?: string | undefined;
    lineItemNotes?: string | undefined;

    constructor(data?: IOrderListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.amsOrderId = _data["amsOrderId"];
            this.orderStatusCode = _data["orderStatusCode"];
            this.numberOfCases = _data["numberOfCases"];
            this.numberOfBottles = _data["numberOfBottles"];
            this.totalLineItemBottles = _data["totalLineItemBottles"];
            this.casesPicked = _data["casesPicked"];
            this.priority = _data["priority"];
            this.lineItemCount = _data["lineItemCount"];
            this.customer = _data["customer"];
            this.wineryName = _data["wineryName"];
            this.locationCode = _data["locationCode"];
            this.expectedShipDate = _data["expectedShipDate"] ? new Date(_data["expectedShipDate"].toString()) : <any>undefined;
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
            this.assignmentDate = _data["assignmentDate"] ? new Date(_data["assignmentDate"].toString()) : <any>undefined;
            this.progressDate = _data["progressDate"] ? new Date(_data["progressDate"].toString()) : <any>undefined;
            this.qCedDate = _data["qCedDate"] ? new Date(_data["qCedDate"].toString()) : <any>undefined;
            this.pickedDate = _data["pickedDate"] ? new Date(_data["pickedDate"].toString()) : <any>undefined;
            this.interrupter = _data["interrupter"];
            this.pickerId = _data["pickerId"];
            this.pickerName = _data["pickerName"];
            this.canMoveUp = _data["canMoveUp"];
            this.canMoveDown = _data["canMoveDown"];
            this.deliveryInstructions = _data["deliveryInstructions"];
            this.clerkNote = _data["clerkNote"];
            this.lineItemNotes = _data["lineItemNotes"];
        }
    }

    static fromJS(data: any): OrderListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["amsOrderId"] = this.amsOrderId;
        data["orderStatusCode"] = this.orderStatusCode;
        data["numberOfCases"] = this.numberOfCases;
        data["numberOfBottles"] = this.numberOfBottles;
        data["totalLineItemBottles"] = this.totalLineItemBottles;
        data["casesPicked"] = this.casesPicked;
        data["priority"] = this.priority;
        data["lineItemCount"] = this.lineItemCount;
        data["customer"] = this.customer;
        data["wineryName"] = this.wineryName;
        data["locationCode"] = this.locationCode;
        data["expectedShipDate"] = this.expectedShipDate ? this.expectedShipDate.toISOString() : <any>undefined;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : <any>undefined;
        data["progressDate"] = this.progressDate ? this.progressDate.toISOString() : <any>undefined;
        data["qCedDate"] = this.qCedDate ? this.qCedDate.toISOString() : <any>undefined;
        data["pickedDate"] = this.pickedDate ? this.pickedDate.toISOString() : <any>undefined;
        data["interrupter"] = this.interrupter;
        data["pickerId"] = this.pickerId;
        data["pickerName"] = this.pickerName;
        data["canMoveUp"] = this.canMoveUp;
        data["canMoveDown"] = this.canMoveDown;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["clerkNote"] = this.clerkNote;
        data["lineItemNotes"] = this.lineItemNotes;
        return data;
    }
}

export interface IOrderListOutput {
    orderId: number;
    amsOrderId: number;
    orderStatusCode: AmsOrderStatusEnum;
    numberOfCases: number;
    numberOfBottles: number;
    totalLineItemBottles: number;
    casesPicked: number;
    priority: number;
    lineItemCount: number;
    customer?: string | undefined;
    wineryName?: string | undefined;
    locationCode?: string | undefined;
    expectedShipDate?: Date | undefined;
    shipDate?: Date | undefined;
    assignmentDate?: Date | undefined;
    progressDate?: Date | undefined;
    qCedDate?: Date | undefined;
    pickedDate?: Date | undefined;
    interrupter?: string | undefined;
    pickerId?: number | undefined;
    pickerName?: string | undefined;
    canMoveUp: boolean;
    canMoveDown: boolean;
    deliveryInstructions?: string | undefined;
    clerkNote?: string | undefined;
    lineItemNotes?: string | undefined;
}

export enum AmsOrderAssignmentStatus {
    Unassigned = 1,
    Assigned = 2,
}

export class UpdateOrderForPickerInput implements IUpdateOrderForPickerInput {
    orderId!: number;
    pickerId?: number | undefined;
    orderStatusCode!: AmsOrderStatusEnum;

    constructor(data?: IUpdateOrderForPickerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.pickerId = _data["pickerId"];
            this.orderStatusCode = _data["orderStatusCode"];
        }
    }

    static fromJS(data: any): UpdateOrderForPickerInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderForPickerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["pickerId"] = this.pickerId;
        data["orderStatusCode"] = this.orderStatusCode;
        return data;
    }
}

export interface IUpdateOrderForPickerInput {
    orderId: number;
    pickerId?: number | undefined;
    orderStatusCode: AmsOrderStatusEnum;
}

export class PauseOrderInput implements IPauseOrderInput {
    orderId!: number;
    pauseNote?: string | undefined;

    constructor(data?: IPauseOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.pauseNote = _data["pauseNote"];
        }
    }

    static fromJS(data: any): PauseOrderInput {
        data = typeof data === 'object' ? data : {};
        let result = new PauseOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["pauseNote"] = this.pauseNote;
        return data;
    }
}

export interface IPauseOrderInput {
    orderId: number;
    pauseNote?: string | undefined;
}

export class CancelOrderInput implements ICancelOrderInput {
    orderId!: number;
    reason?: string | undefined;

    constructor(data?: ICancelOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CancelOrderInput {
        data = typeof data === 'object' ? data : {};
        let result = new CancelOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICancelOrderInput {
    orderId: number;
    reason?: string | undefined;
}

export class ReturnOrderInput implements IReturnOrderInput {
    reasonCode?: string | undefined;
    reasonNote?: string | undefined;

    constructor(data?: IReturnOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonCode = _data["reasonCode"];
            this.reasonNote = _data["reasonNote"];
        }
    }

    static fromJS(data: any): ReturnOrderInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonCode"] = this.reasonCode;
        data["reasonNote"] = this.reasonNote;
        return data;
    }
}

export interface IReturnOrderInput {
    reasonCode?: string | undefined;
    reasonNote?: string | undefined;
}

export class OrderQCViewModel implements IOrderQCViewModel {
    id!: number;
    amsOrderId!: number;
    orderStatusCode!: AmsOrderStatusEnum;
    numberOfCases!: number;
    numberOfBottles!: number;
    lineItemCount!: number;
    locationCode!: string;
    qCedByUserName!: string;
    orderCompleteDate?: Date | undefined;
    deliveryZone!: string;
    addedToQueue?: Date | undefined;
    lastModified?: Date | undefined;
    wineryName!: string;
    pickedByUserId?: number | undefined;

    constructor(data?: IOrderQCViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amsOrderId = _data["amsOrderId"];
            this.orderStatusCode = _data["orderStatusCode"];
            this.numberOfCases = _data["numberOfCases"];
            this.numberOfBottles = _data["numberOfBottles"];
            this.lineItemCount = _data["lineItemCount"];
            this.locationCode = _data["locationCode"];
            this.qCedByUserName = _data["qCedByUserName"];
            this.orderCompleteDate = _data["orderCompleteDate"] ? new Date(_data["orderCompleteDate"].toString()) : <any>undefined;
            this.deliveryZone = _data["deliveryZone"];
            this.addedToQueue = _data["addedToQueue"] ? new Date(_data["addedToQueue"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.wineryName = _data["wineryName"];
            this.pickedByUserId = _data["pickedByUserId"];
        }
    }

    static fromJS(data: any): OrderQCViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderQCViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amsOrderId"] = this.amsOrderId;
        data["orderStatusCode"] = this.orderStatusCode;
        data["numberOfCases"] = this.numberOfCases;
        data["numberOfBottles"] = this.numberOfBottles;
        data["lineItemCount"] = this.lineItemCount;
        data["locationCode"] = this.locationCode;
        data["qCedByUserName"] = this.qCedByUserName;
        data["orderCompleteDate"] = this.orderCompleteDate ? this.orderCompleteDate.toISOString() : <any>undefined;
        data["deliveryZone"] = this.deliveryZone;
        data["addedToQueue"] = this.addedToQueue ? this.addedToQueue.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["wineryName"] = this.wineryName;
        data["pickedByUserId"] = this.pickedByUserId;
        return data;
    }
}

export interface IOrderQCViewModel {
    id: number;
    amsOrderId: number;
    orderStatusCode: AmsOrderStatusEnum;
    numberOfCases: number;
    numberOfBottles: number;
    lineItemCount: number;
    locationCode: string;
    qCedByUserName: string;
    orderCompleteDate?: Date | undefined;
    deliveryZone: string;
    addedToQueue?: Date | undefined;
    lastModified?: Date | undefined;
    wineryName: string;
    pickedByUserId?: number | undefined;
}

export enum Timeframe {
    None = 0,
    Today = 1,
    PastWeek = 2,
    Past30Days = 3,
    Past60Days = 4,
    Past90Days = 5,
    Past6Months = 6,
    PastYear = 7,
}

export class UpdateNumberOfPalletsOrderInput implements IUpdateNumberOfPalletsOrderInput {
    numberOfPallets!: number;

    constructor(data?: IUpdateNumberOfPalletsOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfPallets = _data["numberOfPallets"];
        }
    }

    static fromJS(data: any): UpdateNumberOfPalletsOrderInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNumberOfPalletsOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfPallets"] = this.numberOfPallets;
        return data;
    }
}

export interface IUpdateNumberOfPalletsOrderInput {
    numberOfPallets: number;
}

export class OrderScanReportViewModel implements IOrderScanReportViewModel {
    orderScanReportId!: number;
    scanStatus!: OrderScanStatusEnum;
    orderNo?: string | undefined;
    orderId?: number | undefined;
    order?: AmsOrderModel | undefined;
    userId!: number;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;

    constructor(data?: IOrderScanReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderScanReportId = _data["orderScanReportId"];
            this.scanStatus = _data["scanStatus"];
            this.orderNo = _data["orderNo"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? AmsOrderModel.fromJS(_data["order"]) : <any>undefined;
            this.userId = _data["userId"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderScanReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderScanReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderScanReportId"] = this.orderScanReportId;
        data["scanStatus"] = this.scanStatus;
        data["orderNo"] = this.orderNo;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrderScanReportViewModel {
    orderScanReportId: number;
    scanStatus: OrderScanStatusEnum;
    orderNo?: string | undefined;
    orderId?: number | undefined;
    order?: AmsOrderModel | undefined;
    userId: number;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;
}

export enum OrderScanStatusEnum {
    Success = 0,
    Failure = 1,
}

export class ConfigurationViewModel implements IConfigurationViewModel {
    lookupAndReasonTypes?: LookupAndReasonTypesViewModel[] | undefined;

    constructor(data?: IConfigurationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lookupAndReasonTypes"])) {
                this.lookupAndReasonTypes = [] as any;
                for (let item of _data["lookupAndReasonTypes"])
                    this.lookupAndReasonTypes!.push(LookupAndReasonTypesViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lookupAndReasonTypes)) {
            data["lookupAndReasonTypes"] = [];
            for (let item of this.lookupAndReasonTypes)
                data["lookupAndReasonTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfigurationViewModel {
    lookupAndReasonTypes?: LookupAndReasonTypesViewModel[] | undefined;
}

export class LookupAndReasonTypesViewModel implements ILookupAndReasonTypesViewModel {
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: ILookupAndReasonTypesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LookupAndReasonTypesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LookupAndReasonTypesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ILookupAndReasonTypesViewModel {
    code?: string | undefined;
    name?: string | undefined;
}

export class PagedResultsOfPickerListOutput implements IPagedResultsOfPickerListOutput {
    resultCount!: number;
    results?: PickerListOutput[] | undefined;

    constructor(data?: IPagedResultsOfPickerListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PickerListOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfPickerListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfPickerListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultsOfPickerListOutput {
    resultCount: number;
    results?: PickerListOutput[] | undefined;
}

export class PickerListOutput implements IPickerListOutput {
    pickerId!: number;
    name!: string;
    statusCode!: number;
    lastClockedTime?: ClockedTimeModel | undefined;
    userId!: number;
    ordersCount!: number;
    totalCases!: number;
    totalBottles!: number;
    casePicked!: number;

    constructor(data?: IPickerListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickerId = _data["pickerId"];
            this.name = _data["name"];
            this.statusCode = _data["statusCode"];
            this.lastClockedTime = _data["lastClockedTime"] ? ClockedTimeModel.fromJS(_data["lastClockedTime"]) : <any>undefined;
            this.userId = _data["userId"];
            this.ordersCount = _data["ordersCount"];
            this.totalCases = _data["totalCases"];
            this.totalBottles = _data["totalBottles"];
            this.casePicked = _data["casePicked"];
        }
    }

    static fromJS(data: any): PickerListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PickerListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickerId"] = this.pickerId;
        data["name"] = this.name;
        data["statusCode"] = this.statusCode;
        data["lastClockedTime"] = this.lastClockedTime ? this.lastClockedTime.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["ordersCount"] = this.ordersCount;
        data["totalCases"] = this.totalCases;
        data["totalBottles"] = this.totalBottles;
        data["casePicked"] = this.casePicked;
        return data;
    }
}

export interface IPickerListOutput {
    pickerId: number;
    name: string;
    statusCode: number;
    lastClockedTime?: ClockedTimeModel | undefined;
    userId: number;
    ordersCount: number;
    totalCases: number;
    totalBottles: number;
    casePicked: number;
}

export class PickerOrderViewModel implements IPickerOrderViewModel {
    orderId!: number;
    amsOrderId!: number;
    orderStatusCode!: AmsOrderStatusEnum;
    numberOfCases!: number;
    numberOfBottles!: number;
    lineItemCount!: number;
    customer?: string | undefined;
    shipToCity?: string | undefined;
    shipToState?: string | undefined;
    progressDate?: Date | undefined;
    orderLineItems?: AmsOrderLineItemModel[] | undefined;

    constructor(data?: IPickerOrderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.amsOrderId = _data["amsOrderId"];
            this.orderStatusCode = _data["orderStatusCode"];
            this.numberOfCases = _data["numberOfCases"];
            this.numberOfBottles = _data["numberOfBottles"];
            this.lineItemCount = _data["lineItemCount"];
            this.customer = _data["customer"];
            this.shipToCity = _data["shipToCity"];
            this.shipToState = _data["shipToState"];
            this.progressDate = _data["progressDate"] ? new Date(_data["progressDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["orderLineItems"])) {
                this.orderLineItems = [] as any;
                for (let item of _data["orderLineItems"])
                    this.orderLineItems!.push(AmsOrderLineItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PickerOrderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PickerOrderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["amsOrderId"] = this.amsOrderId;
        data["orderStatusCode"] = this.orderStatusCode;
        data["numberOfCases"] = this.numberOfCases;
        data["numberOfBottles"] = this.numberOfBottles;
        data["lineItemCount"] = this.lineItemCount;
        data["customer"] = this.customer;
        data["shipToCity"] = this.shipToCity;
        data["shipToState"] = this.shipToState;
        data["progressDate"] = this.progressDate ? this.progressDate.toISOString() : <any>undefined;
        if (Array.isArray(this.orderLineItems)) {
            data["orderLineItems"] = [];
            for (let item of this.orderLineItems)
                data["orderLineItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPickerOrderViewModel {
    orderId: number;
    amsOrderId: number;
    orderStatusCode: AmsOrderStatusEnum;
    numberOfCases: number;
    numberOfBottles: number;
    lineItemCount: number;
    customer?: string | undefined;
    shipToCity?: string | undefined;
    shipToState?: string | undefined;
    progressDate?: Date | undefined;
    orderLineItems?: AmsOrderLineItemModel[] | undefined;
}

export class SkuScanReportViewModel implements ISkuScanReportViewModel {
    skuScanReportId!: number;
    scanStatus!: SkuScanStatusEnum;
    partNo!: string;
    orderId?: number | undefined;
    order?: AmsOrderModel | undefined;
    orderLineItemId?: number | undefined;
    orderLineItem?: AmsOrderLineItemModel | undefined;
    userId!: number;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;

    constructor(data?: ISkuScanReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuScanReportId = _data["skuScanReportId"];
            this.scanStatus = _data["scanStatus"];
            this.partNo = _data["partNo"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? AmsOrderModel.fromJS(_data["order"]) : <any>undefined;
            this.orderLineItemId = _data["orderLineItemId"];
            this.orderLineItem = _data["orderLineItem"] ? AmsOrderLineItemModel.fromJS(_data["orderLineItem"]) : <any>undefined;
            this.userId = _data["userId"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SkuScanReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SkuScanReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuScanReportId"] = this.skuScanReportId;
        data["scanStatus"] = this.scanStatus;
        data["partNo"] = this.partNo;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["orderLineItemId"] = this.orderLineItemId;
        data["orderLineItem"] = this.orderLineItem ? this.orderLineItem.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISkuScanReportViewModel {
    skuScanReportId: number;
    scanStatus: SkuScanStatusEnum;
    partNo: string;
    orderId?: number | undefined;
    order?: AmsOrderModel | undefined;
    orderLineItemId?: number | undefined;
    orderLineItem?: AmsOrderLineItemModel | undefined;
    userId: number;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;
}

export enum SkuScanStatusEnum {
    Success = 0,
    UnassignedOrder = 1,
    Failure = 2,
}

export class AmsLaneOnHandViewModel implements IAmsLaneOnHandViewModel {
    warehouse!: string;
    lane!: string;
    partNo!: string;
    loc!: string;
    bottlesOnHand!: number;
    bottlesOnHandP1!: number;
    bottlesOnHandP2!: number;
    bottlesReservedIn?: number | undefined;
    bottlesReservedOut?: number | undefined;
    fifoString!: Date;

    constructor(data?: IAmsLaneOnHandViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"];
            this.lane = _data["lane"];
            this.partNo = _data["partNo"];
            this.loc = _data["loc"];
            this.bottlesOnHand = _data["bottlesOnHand"];
            this.bottlesOnHandP1 = _data["bottlesOnHandP1"];
            this.bottlesOnHandP2 = _data["bottlesOnHandP2"];
            this.bottlesReservedIn = _data["bottlesReservedIn"];
            this.bottlesReservedOut = _data["bottlesReservedOut"];
            this.fifoString = _data["fifoString"] ? new Date(_data["fifoString"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AmsLaneOnHandViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmsLaneOnHandViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse;
        data["lane"] = this.lane;
        data["partNo"] = this.partNo;
        data["loc"] = this.loc;
        data["bottlesOnHand"] = this.bottlesOnHand;
        data["bottlesOnHandP1"] = this.bottlesOnHandP1;
        data["bottlesOnHandP2"] = this.bottlesOnHandP2;
        data["bottlesReservedIn"] = this.bottlesReservedIn;
        data["bottlesReservedOut"] = this.bottlesReservedOut;
        data["fifoString"] = this.fifoString ? formatDate(this.fifoString) : <any>undefined;
        return data;
    }
}

export interface IAmsLaneOnHandViewModel {
    warehouse: string;
    lane: string;
    partNo: string;
    loc: string;
    bottlesOnHand: number;
    bottlesOnHandP1: number;
    bottlesOnHandP2: number;
    bottlesReservedIn?: number | undefined;
    bottlesReservedOut?: number | undefined;
    fifoString: Date;
}

export class PrinterLocationDTO implements IPrinterLocationDTO {
    locationCode?: string | undefined;
    isOnline!: boolean;
    isDefault!: boolean;
    printerStatus?: string | undefined;

    constructor(data?: IPrinterLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationCode = _data["locationCode"];
            this.isOnline = _data["isOnline"];
            this.isDefault = _data["isDefault"];
            this.printerStatus = _data["printerStatus"];
        }
    }

    static fromJS(data: any): PrinterLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PrinterLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationCode"] = this.locationCode;
        data["isOnline"] = this.isOnline;
        data["isDefault"] = this.isDefault;
        data["printerStatus"] = this.printerStatus;
        return data;
    }
}

export interface IPrinterLocationDTO {
    locationCode?: string | undefined;
    isOnline: boolean;
    isDefault: boolean;
    printerStatus?: string | undefined;
}

export class AuthResultViewModel implements IAuthResultViewModel {
    userId!: number;
    name?: string | undefined;
    email?: string | undefined;
    permissions?: SystemPermission[] | undefined;
    token?: string | undefined;
    expiredIn!: number;
    pickerId?: number | undefined;

    constructor(data?: IAuthResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.token = _data["token"];
            this.expiredIn = _data["expiredIn"];
            this.pickerId = _data["pickerId"];
        }
    }

    static fromJS(data: any): AuthResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["token"] = this.token;
        data["expiredIn"] = this.expiredIn;
        data["pickerId"] = this.pickerId;
        return data;
    }
}

export interface IAuthResultViewModel {
    userId: number;
    name?: string | undefined;
    email?: string | undefined;
    permissions?: SystemPermission[] | undefined;
    token?: string | undefined;
    expiredIn: number;
    pickerId?: number | undefined;
}

export class UserLoginInput implements IUserLoginInput {
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: IUserLoginInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserLoginInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IUserLoginInput {
    email?: string | undefined;
    password?: string | undefined;
}

export class AuditEventModel extends BasePagedModel implements IAuditEventModel {
    actorSystemUser?: SystemUserModel | undefined;
    auditEventType?: AuditEventTypeModel | undefined;
    auditEventEntities!: AuditEventEntityModel[];
    userNotifications!: UserNotificationModel[];
    tableName!: string;
    auditEventId!: number;
    auditEventTypeId!: AuditEventType;
    actorSystemUserId?: number | undefined;
    summary!: string;
    metadataJson?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    actorSystemUserFirstName!: string;
    actorSystemUserLastName!: string;
    auditEventTypeName!: string;

    constructor(data?: IAuditEventModel) {
        super(data);
        if (!data) {
            this.auditEventEntities = [];
            this.userNotifications = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.actorSystemUser = _data["actorSystemUser"] ? SystemUserModel.fromJS(_data["actorSystemUser"]) : <any>undefined;
            this.auditEventType = _data["auditEventType"] ? AuditEventTypeModel.fromJS(_data["auditEventType"]) : <any>undefined;
            if (Array.isArray(_data["auditEventEntities"])) {
                this.auditEventEntities = [] as any;
                for (let item of _data["auditEventEntities"])
                    this.auditEventEntities!.push(AuditEventEntityModel.fromJS(item));
            }
            if (Array.isArray(_data["userNotifications"])) {
                this.userNotifications = [] as any;
                for (let item of _data["userNotifications"])
                    this.userNotifications!.push(UserNotificationModel.fromJS(item));
            }
            this.tableName = _data["tableName"];
            this.auditEventId = _data["auditEventId"];
            this.auditEventTypeId = _data["auditEventTypeId"];
            this.actorSystemUserId = _data["actorSystemUserId"];
            this.summary = _data["summary"];
            this.metadataJson = _data["metadataJson"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.actorSystemUserFirstName = _data["actorSystemUserFirstName"];
            this.actorSystemUserLastName = _data["actorSystemUserLastName"];
            this.auditEventTypeName = _data["auditEventTypeName"];
        }
    }

    static override fromJS(data: any): AuditEventModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actorSystemUser"] = this.actorSystemUser ? this.actorSystemUser.toJSON() : <any>undefined;
        data["auditEventType"] = this.auditEventType ? this.auditEventType.toJSON() : <any>undefined;
        if (Array.isArray(this.auditEventEntities)) {
            data["auditEventEntities"] = [];
            for (let item of this.auditEventEntities)
                data["auditEventEntities"].push(item.toJSON());
        }
        if (Array.isArray(this.userNotifications)) {
            data["userNotifications"] = [];
            for (let item of this.userNotifications)
                data["userNotifications"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["auditEventId"] = this.auditEventId;
        data["auditEventTypeId"] = this.auditEventTypeId;
        data["actorSystemUserId"] = this.actorSystemUserId;
        data["summary"] = this.summary;
        data["metadataJson"] = this.metadataJson;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["actorSystemUserFirstName"] = this.actorSystemUserFirstName;
        data["actorSystemUserLastName"] = this.actorSystemUserLastName;
        data["auditEventTypeName"] = this.auditEventTypeName;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditEventModel extends IBasePagedModel {
    actorSystemUser?: SystemUserModel | undefined;
    auditEventType?: AuditEventTypeModel | undefined;
    auditEventEntities: AuditEventEntityModel[];
    userNotifications: UserNotificationModel[];
    tableName: string;
    auditEventId: number;
    auditEventTypeId: AuditEventType;
    actorSystemUserId?: number | undefined;
    summary: string;
    metadataJson?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
    actorSystemUserFirstName: string;
    actorSystemUserLastName: string;
    auditEventTypeName: string;
}

export class AuditEventTypeModel extends BasePagedModel implements IAuditEventTypeModel {
    tableName!: string;
    auditEventTypeId!: AuditEventType;
    name!: string;
    description?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IAuditEventTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.auditEventTypeId = _data["auditEventTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): AuditEventTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["auditEventTypeId"] = this.auditEventTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditEventTypeModel extends IBasePagedModel {
    tableName: string;
    auditEventTypeId: AuditEventType;
    name: string;
    description?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export enum AuditEventType {
    Unknown = 1,
    OrderGrouping = 2,
    LoadAddOrderGroupConflict = 3,
    UserNotificationAcknowledgement = 4,
}

export class AuditEventEntityModel extends BasePagedModel implements IAuditEventEntityModel {
    auditEvent!: AuditEventModel;
    auditEntityType?: AuditEntityTypeModel | undefined;
    auditEntityRole?: AuditEntityRoleModel | undefined;
    tableName!: string;
    auditEventEntityId!: number;
    auditEventId!: number;
    auditEntityTypeId!: AuditEntityType;
    entityId!: number;
    auditEntityRoleId!: AuditEntityRole;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IAuditEventEntityModel) {
        super(data);
        if (!data) {
            this.auditEvent = new AuditEventModel();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.auditEvent = _data["auditEvent"] ? AuditEventModel.fromJS(_data["auditEvent"]) : new AuditEventModel();
            this.auditEntityType = _data["auditEntityType"] ? AuditEntityTypeModel.fromJS(_data["auditEntityType"]) : <any>undefined;
            this.auditEntityRole = _data["auditEntityRole"] ? AuditEntityRoleModel.fromJS(_data["auditEntityRole"]) : <any>undefined;
            this.tableName = _data["tableName"];
            this.auditEventEntityId = _data["auditEventEntityId"];
            this.auditEventId = _data["auditEventId"];
            this.auditEntityTypeId = _data["auditEntityTypeId"];
            this.entityId = _data["entityId"];
            this.auditEntityRoleId = _data["auditEntityRoleId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): AuditEventEntityModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventEntityModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditEvent"] = this.auditEvent ? this.auditEvent.toJSON() : <any>undefined;
        data["auditEntityType"] = this.auditEntityType ? this.auditEntityType.toJSON() : <any>undefined;
        data["auditEntityRole"] = this.auditEntityRole ? this.auditEntityRole.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["auditEventEntityId"] = this.auditEventEntityId;
        data["auditEventId"] = this.auditEventId;
        data["auditEntityTypeId"] = this.auditEntityTypeId;
        data["entityId"] = this.entityId;
        data["auditEntityRoleId"] = this.auditEntityRoleId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditEventEntityModel extends IBasePagedModel {
    auditEvent: AuditEventModel;
    auditEntityType?: AuditEntityTypeModel | undefined;
    auditEntityRole?: AuditEntityRoleModel | undefined;
    tableName: string;
    auditEventEntityId: number;
    auditEventId: number;
    auditEntityTypeId: AuditEntityType;
    entityId: number;
    auditEntityRoleId: AuditEntityRole;
    dateAdded: Date;
    dateModified: Date;
}

export class AuditEntityTypeModel extends BasePagedModel implements IAuditEntityTypeModel {
    tableName!: string;
    auditEntityTypeId!: AuditEntityType;
    name!: string;
    description?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IAuditEntityTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.auditEntityTypeId = _data["auditEntityTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): AuditEntityTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEntityTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["auditEntityTypeId"] = this.auditEntityTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditEntityTypeModel extends IBasePagedModel {
    tableName: string;
    auditEntityTypeId: AuditEntityType;
    name: string;
    description?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export enum AuditEntityType {
    Unknown = 1,
    Order = 2,
    OrderGroup = 3,
    Load = 4,
    Note = 5,
    SystemUser = 6,
    UserNotification = 7,
}

export class AuditEntityRoleModel extends BasePagedModel implements IAuditEntityRoleModel {
    tableName!: string;
    auditEntityRoleId!: AuditEntityRole;
    name!: string;
    description?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IAuditEntityRoleModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.auditEntityRoleId = _data["auditEntityRoleId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): AuditEntityRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEntityRoleModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["auditEntityRoleId"] = this.auditEntityRoleId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAuditEntityRoleModel extends IBasePagedModel {
    tableName: string;
    auditEntityRoleId: AuditEntityRole;
    name: string;
    description?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export enum AuditEntityRole {
    Unknown = 1,
    Subject = 2,
    Affected = 3,
    Created = 4,
    NotificationRecipient = 5,
    Acknowledged = 6,
}

export class UserNotificationModel extends BasePagedModel implements IUserNotificationModel {
    auditEvent!: AuditEventModel;
    createdByUser?: SystemUserModel | undefined;
    recipients!: UserNotificationRecipientModel[];
    tableName!: string;
    userNotificationId!: number;
    userNotificationType?: UserNotificationTypeModel | undefined;
    userNotificationTypeId!: UserNotificationType;
    auditEventId!: number;
    createdByUserId?: number | undefined;
    title!: string;
    message!: string;
    metadataJson?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;
    createdByUserName!: string;

    constructor(data?: IUserNotificationModel) {
        super(data);
        if (!data) {
            this.auditEvent = new AuditEventModel();
            this.recipients = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.auditEvent = _data["auditEvent"] ? AuditEventModel.fromJS(_data["auditEvent"]) : new AuditEventModel();
            this.createdByUser = _data["createdByUser"] ? SystemUserModel.fromJS(_data["createdByUser"]) : <any>undefined;
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(UserNotificationRecipientModel.fromJS(item));
            }
            this.tableName = _data["tableName"];
            this.userNotificationId = _data["userNotificationId"];
            this.userNotificationType = _data["userNotificationType"] ? UserNotificationTypeModel.fromJS(_data["userNotificationType"]) : <any>undefined;
            this.userNotificationTypeId = _data["userNotificationTypeId"];
            this.auditEventId = _data["auditEventId"];
            this.createdByUserId = _data["createdByUserId"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.metadataJson = _data["metadataJson"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.createdByUserName = _data["createdByUserName"];
        }
    }

    static override fromJS(data: any): UserNotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditEvent"] = this.auditEvent ? this.auditEvent.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["userNotificationId"] = this.userNotificationId;
        data["userNotificationType"] = this.userNotificationType ? this.userNotificationType.toJSON() : <any>undefined;
        data["userNotificationTypeId"] = this.userNotificationTypeId;
        data["auditEventId"] = this.auditEventId;
        data["createdByUserId"] = this.createdByUserId;
        data["title"] = this.title;
        data["message"] = this.message;
        data["metadataJson"] = this.metadataJson;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["createdByUserName"] = this.createdByUserName;
        super.toJSON(data);
        return data;
    }
}

export interface IUserNotificationModel extends IBasePagedModel {
    auditEvent: AuditEventModel;
    createdByUser?: SystemUserModel | undefined;
    recipients: UserNotificationRecipientModel[];
    tableName: string;
    userNotificationId: number;
    userNotificationType?: UserNotificationTypeModel | undefined;
    userNotificationTypeId: UserNotificationType;
    auditEventId: number;
    createdByUserId?: number | undefined;
    title: string;
    message: string;
    metadataJson?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
    createdByUserName: string;
}

export class UserNotificationRecipientModel extends BasePagedModel implements IUserNotificationRecipientModel {
    userNotification!: UserNotificationModel;
    systemUser!: SystemUserModel;
    tableName!: string;
    userNotificationRecipientId!: number;
    userNotificationId!: number;
    systemUserId!: number;
    dateRead?: Date | undefined;
    dateAcknowledged?: Date | undefined;
    dateDismissed?: Date | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IUserNotificationRecipientModel) {
        super(data);
        if (!data) {
            this.userNotification = new UserNotificationModel();
            this.systemUser = new SystemUserModel();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userNotification = _data["userNotification"] ? UserNotificationModel.fromJS(_data["userNotification"]) : new UserNotificationModel();
            this.systemUser = _data["systemUser"] ? SystemUserModel.fromJS(_data["systemUser"]) : new SystemUserModel();
            this.tableName = _data["tableName"];
            this.userNotificationRecipientId = _data["userNotificationRecipientId"];
            this.userNotificationId = _data["userNotificationId"];
            this.systemUserId = _data["systemUserId"];
            this.dateRead = _data["dateRead"] ? new Date(_data["dateRead"].toString()) : <any>undefined;
            this.dateAcknowledged = _data["dateAcknowledged"] ? new Date(_data["dateAcknowledged"].toString()) : <any>undefined;
            this.dateDismissed = _data["dateDismissed"] ? new Date(_data["dateDismissed"].toString()) : <any>undefined;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): UserNotificationRecipientModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationRecipientModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNotification"] = this.userNotification ? this.userNotification.toJSON() : <any>undefined;
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["userNotificationRecipientId"] = this.userNotificationRecipientId;
        data["userNotificationId"] = this.userNotificationId;
        data["systemUserId"] = this.systemUserId;
        data["dateRead"] = this.dateRead ? this.dateRead.toISOString() : <any>undefined;
        data["dateAcknowledged"] = this.dateAcknowledged ? this.dateAcknowledged.toISOString() : <any>undefined;
        data["dateDismissed"] = this.dateDismissed ? this.dateDismissed.toISOString() : <any>undefined;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserNotificationRecipientModel extends IBasePagedModel {
    userNotification: UserNotificationModel;
    systemUser: SystemUserModel;
    tableName: string;
    userNotificationRecipientId: number;
    userNotificationId: number;
    systemUserId: number;
    dateRead?: Date | undefined;
    dateAcknowledged?: Date | undefined;
    dateDismissed?: Date | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export class UserNotificationTypeModel extends BasePagedModel implements IUserNotificationTypeModel {
    tableName!: string;
    userNotificationTypeId!: UserNotificationType;
    name!: string;
    description?: string | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IUserNotificationTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.userNotificationTypeId = _data["userNotificationTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): UserNotificationTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["userNotificationTypeId"] = this.userNotificationTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserNotificationTypeModel extends IBasePagedModel {
    tableName: string;
    userNotificationTypeId: UserNotificationType;
    name: string;
    description?: string | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export enum UserNotificationType {
    Unknown = 1,
    LoadBuilderOrderGrouping = 2,
    LoadBuilderAddOrderToLoad = 3,
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export abstract class BaseRequestModel extends BaseModel implements IBaseRequestModel {
    pageNumber!: number;
    pageSize!: number;
    filterText?: string | undefined;
    useDefaultReport?: boolean | undefined;
    pagingDisabled?: boolean | undefined;

    constructor(data?: IBaseRequestModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.filterText = _data["filterText"];
            this.useDefaultReport = _data["useDefaultReport"];
            this.pagingDisabled = _data["pagingDisabled"];
        }
    }

    static override fromJS(data: any): BaseRequestModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseRequestModel' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["filterText"] = this.filterText;
        data["useDefaultReport"] = this.useDefaultReport;
        data["pagingDisabled"] = this.pagingDisabled;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseRequestModel extends IBaseModel {
    pageNumber: number;
    pageSize: number;
    filterText?: string | undefined;
    useDefaultReport?: boolean | undefined;
    pagingDisabled?: boolean | undefined;
}

export class SearchOptionsBase extends BaseRequestModel implements ISearchOptionsBase {
    sortBy?: string | undefined;
    isSortAscending?: boolean | undefined;
    pagerLetter?: string | undefined;
    columnSelection?: string[] | undefined;
    filters?: SearchFilter[][] | undefined;
    report?: ReportModel | undefined;

    constructor(data?: ISearchOptionsBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sortBy = _data["sortBy"];
            this.isSortAscending = _data["isSortAscending"];
            this.pagerLetter = _data["pagerLetter"];
            if (Array.isArray(_data["columnSelection"])) {
                this.columnSelection = [] as any;
                for (let item of _data["columnSelection"])
                    this.columnSelection!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(item);
            }
            this.report = _data["report"] ? ReportModel.fromJS(_data["report"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): SearchOptionsBase {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOptionsBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortBy"] = this.sortBy;
        data["isSortAscending"] = this.isSortAscending;
        data["pagerLetter"] = this.pagerLetter;
        if (Array.isArray(this.columnSelection)) {
            data["columnSelection"] = [];
            for (let item of this.columnSelection)
                data["columnSelection"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item);
        }
        data["report"] = this.report ? this.report.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchOptionsBase extends IBaseRequestModel {
    sortBy?: string | undefined;
    isSortAscending?: boolean | undefined;
    pagerLetter?: string | undefined;
    columnSelection?: string[] | undefined;
    filters?: SearchFilter[][] | undefined;
    report?: ReportModel | undefined;
}

export class SearchOptions extends SearchOptionsBase implements ISearchOptions {
    sortColumns?: SortColumn[] | undefined;
    fields?: SearchFields | undefined;
    includeRelatedEntities?: boolean | undefined;

    constructor(data?: ISearchOptions) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortColumns"])) {
                this.sortColumns = [] as any;
                for (let item of _data["sortColumns"])
                    this.sortColumns!.push(SortColumn.fromJS(item));
            }
            this.fields = _data["fields"] ? SearchFields.fromJS(_data["fields"]) : <any>undefined;
            this.includeRelatedEntities = _data["includeRelatedEntities"];
        }
    }

    static override fromJS(data: any): SearchOptions {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOptions();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortColumns)) {
            data["sortColumns"] = [];
            for (let item of this.sortColumns)
                data["sortColumns"].push(item.toJSON());
        }
        data["fields"] = this.fields ? this.fields.toJSON() : <any>undefined;
        data["includeRelatedEntities"] = this.includeRelatedEntities;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchOptions extends ISearchOptionsBase {
    sortColumns?: SortColumn[] | undefined;
    fields?: SearchFields | undefined;
    includeRelatedEntities?: boolean | undefined;
}

export class SortColumn implements ISortColumn {
    sortBy!: string;
    isSortAscending?: boolean | undefined;

    constructor(data?: ISortColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortBy = _data["sortBy"];
            this.isSortAscending = _data["isSortAscending"];
        }
    }

    static fromJS(data: any): SortColumn {
        data = typeof data === 'object' ? data : {};
        let result = new SortColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortBy"] = this.sortBy;
        data["isSortAscending"] = this.isSortAscending;
        return data;
    }
}

export interface ISortColumn {
    sortBy: string;
    isSortAscending?: boolean | undefined;
}

export class SearchFields implements ISearchFields {
    includeInactive?: boolean | undefined;
    isActive?: boolean | undefined;
    refLanguageID?: number | undefined;
    dateStartInclusive?: Date | undefined;
    dateEndExclusive?: Date | undefined;
    excludeStatusIds?: number[] | undefined;
    locationId?: number | undefined;
    orderCustomerId?: number | undefined;
    chosenDesignationIds?: number[] | undefined;
    orderTypeId?: OrderType | undefined;
    statesList?: CountryStates[] | undefined;
    includeNWDWarehouse?: boolean | undefined;
    includeLoadJourney?: boolean | undefined;
    loadIds?: number[] | undefined;
    onlyNWDWarehouses?: boolean | undefined;
    loadId?: number | undefined;
    loadStopId?: number | undefined;
    currentOrders?: boolean | undefined;
    hasEmailAddress?: boolean | undefined;
    hasUsername?: boolean | undefined;
    hasPickingPermissions?: boolean | undefined;
    systemRoleGroup?: SystemRoleGroups | undefined;
    exceptionIds?: number[] | undefined;

    constructor(data?: ISearchFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeInactive = _data["includeInactive"];
            this.isActive = _data["isActive"];
            this.refLanguageID = _data["refLanguageID"];
            this.dateStartInclusive = _data["dateStartInclusive"] ? new Date(_data["dateStartInclusive"].toString()) : <any>undefined;
            this.dateEndExclusive = _data["dateEndExclusive"] ? new Date(_data["dateEndExclusive"].toString()) : <any>undefined;
            if (Array.isArray(_data["excludeStatusIds"])) {
                this.excludeStatusIds = [] as any;
                for (let item of _data["excludeStatusIds"])
                    this.excludeStatusIds!.push(item);
            }
            this.locationId = _data["locationId"];
            this.orderCustomerId = _data["orderCustomerId"];
            if (Array.isArray(_data["chosenDesignationIds"])) {
                this.chosenDesignationIds = [] as any;
                for (let item of _data["chosenDesignationIds"])
                    this.chosenDesignationIds!.push(item);
            }
            this.orderTypeId = _data["orderTypeId"];
            if (Array.isArray(_data["statesList"])) {
                this.statesList = [] as any;
                for (let item of _data["statesList"])
                    this.statesList!.push(item);
            }
            this.includeNWDWarehouse = _data["includeNWDWarehouse"];
            this.includeLoadJourney = _data["includeLoadJourney"];
            if (Array.isArray(_data["loadIds"])) {
                this.loadIds = [] as any;
                for (let item of _data["loadIds"])
                    this.loadIds!.push(item);
            }
            this.onlyNWDWarehouses = _data["onlyNWDWarehouses"];
            this.loadId = _data["loadId"];
            this.loadStopId = _data["loadStopId"];
            this.currentOrders = _data["currentOrders"];
            this.hasEmailAddress = _data["hasEmailAddress"];
            this.hasUsername = _data["hasUsername"];
            this.hasPickingPermissions = _data["hasPickingPermissions"];
            this.systemRoleGroup = _data["systemRoleGroup"];
            if (Array.isArray(_data["exceptionIds"])) {
                this.exceptionIds = [] as any;
                for (let item of _data["exceptionIds"])
                    this.exceptionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchFields {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeInactive"] = this.includeInactive;
        data["isActive"] = this.isActive;
        data["refLanguageID"] = this.refLanguageID;
        data["dateStartInclusive"] = this.dateStartInclusive ? this.dateStartInclusive.toISOString() : <any>undefined;
        data["dateEndExclusive"] = this.dateEndExclusive ? this.dateEndExclusive.toISOString() : <any>undefined;
        if (Array.isArray(this.excludeStatusIds)) {
            data["excludeStatusIds"] = [];
            for (let item of this.excludeStatusIds)
                data["excludeStatusIds"].push(item);
        }
        data["locationId"] = this.locationId;
        data["orderCustomerId"] = this.orderCustomerId;
        if (Array.isArray(this.chosenDesignationIds)) {
            data["chosenDesignationIds"] = [];
            for (let item of this.chosenDesignationIds)
                data["chosenDesignationIds"].push(item);
        }
        data["orderTypeId"] = this.orderTypeId;
        if (Array.isArray(this.statesList)) {
            data["statesList"] = [];
            for (let item of this.statesList)
                data["statesList"].push(item);
        }
        data["includeNWDWarehouse"] = this.includeNWDWarehouse;
        data["includeLoadJourney"] = this.includeLoadJourney;
        if (Array.isArray(this.loadIds)) {
            data["loadIds"] = [];
            for (let item of this.loadIds)
                data["loadIds"].push(item);
        }
        data["onlyNWDWarehouses"] = this.onlyNWDWarehouses;
        data["loadId"] = this.loadId;
        data["loadStopId"] = this.loadStopId;
        data["currentOrders"] = this.currentOrders;
        data["hasEmailAddress"] = this.hasEmailAddress;
        data["hasUsername"] = this.hasUsername;
        data["hasPickingPermissions"] = this.hasPickingPermissions;
        data["systemRoleGroup"] = this.systemRoleGroup;
        if (Array.isArray(this.exceptionIds)) {
            data["exceptionIds"] = [];
            for (let item of this.exceptionIds)
                data["exceptionIds"].push(item);
        }
        return data;
    }
}

export interface ISearchFields {
    includeInactive?: boolean | undefined;
    isActive?: boolean | undefined;
    refLanguageID?: number | undefined;
    dateStartInclusive?: Date | undefined;
    dateEndExclusive?: Date | undefined;
    excludeStatusIds?: number[] | undefined;
    locationId?: number | undefined;
    orderCustomerId?: number | undefined;
    chosenDesignationIds?: number[] | undefined;
    orderTypeId?: OrderType | undefined;
    statesList?: CountryStates[] | undefined;
    includeNWDWarehouse?: boolean | undefined;
    includeLoadJourney?: boolean | undefined;
    loadIds?: number[] | undefined;
    onlyNWDWarehouses?: boolean | undefined;
    loadId?: number | undefined;
    loadStopId?: number | undefined;
    currentOrders?: boolean | undefined;
    hasEmailAddress?: boolean | undefined;
    hasUsername?: boolean | undefined;
    hasPickingPermissions?: boolean | undefined;
    systemRoleGroup?: SystemRoleGroups | undefined;
    exceptionIds?: number[] | undefined;
}

export class SearchFilter implements ISearchFilter {
    property?: string | undefined;
    relatedEntityIdPropertyName?: string | undefined;
    value?: string | undefined;
    compareType?: SearchFilterCompareTypeEnum | undefined;
    operatorType?: SearchFilterOperatorEnum | undefined;
    isStringCompare!: boolean;
    isNumberCompare!: boolean;
    isDateTimeCompare!: boolean;
    isDateOnlyCompare!: boolean;
    isBooleanCompare!: boolean;
    isTableEnumCompare!: boolean;
    isEnumCompare!: boolean;

    constructor(data?: ISearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.relatedEntityIdPropertyName = _data["relatedEntityIdPropertyName"];
            this.value = _data["value"];
            this.compareType = _data["compareType"];
            this.operatorType = _data["operatorType"];
            this.isStringCompare = _data["isStringCompare"];
            this.isNumberCompare = _data["isNumberCompare"];
            this.isDateTimeCompare = _data["isDateTimeCompare"];
            this.isDateOnlyCompare = _data["isDateOnlyCompare"];
            this.isBooleanCompare = _data["isBooleanCompare"];
            this.isTableEnumCompare = _data["isTableEnumCompare"];
            this.isEnumCompare = _data["isEnumCompare"];
        }
    }

    static fromJS(data: any): SearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["relatedEntityIdPropertyName"] = this.relatedEntityIdPropertyName;
        data["value"] = this.value;
        data["compareType"] = this.compareType;
        data["operatorType"] = this.operatorType;
        data["isStringCompare"] = this.isStringCompare;
        data["isNumberCompare"] = this.isNumberCompare;
        data["isDateTimeCompare"] = this.isDateTimeCompare;
        data["isDateOnlyCompare"] = this.isDateOnlyCompare;
        data["isBooleanCompare"] = this.isBooleanCompare;
        data["isTableEnumCompare"] = this.isTableEnumCompare;
        data["isEnumCompare"] = this.isEnumCompare;
        return data;
    }
}

export interface ISearchFilter {
    property?: string | undefined;
    relatedEntityIdPropertyName?: string | undefined;
    value?: string | undefined;
    compareType?: SearchFilterCompareTypeEnum | undefined;
    operatorType?: SearchFilterOperatorEnum | undefined;
    isStringCompare: boolean;
    isNumberCompare: boolean;
    isDateTimeCompare: boolean;
    isDateOnlyCompare: boolean;
    isBooleanCompare: boolean;
    isTableEnumCompare: boolean;
    isEnumCompare: boolean;
}

export enum SearchFilterCompareTypeEnum {
    String = 1,
    Number = 2,
    DateTime = 3,
    TableEnum = 4,
    Boolean = 5,
    Enum = 8,
    DateOnly = 9,
}

export enum SearchFilterOperatorEnum {
    Is = 1,
    IsNot = 2,
    Contain = 3,
    NotContain = 4,
    GreaterThan = 5,
    LessThan = 6,
    Before = 7,
    OnOrBefore = 8,
    After = 9,
    OnOrAfter = 10,
    PastMonth = 11,
    PastWeek = 12,
    PastYear = 13,
    ThisYear = 14,
    Between = 15,
    StartsWith = 16,
    EndsWith = 17,
    IsSet = 18,
    IsNotSet = 19,
}

export class ReportModel implements IReportModel {
    reportColumns?: ReportColumn[][] | undefined;
    columnSettingsJson?: string | undefined;
    addIcon?: string[] | undefined;
    removeIcon?: string[] | undefined;

    constructor(data?: IReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportColumns"])) {
                this.reportColumns = [] as any;
                for (let item of _data["reportColumns"])
                    this.reportColumns!.push(item);
            }
            this.columnSettingsJson = _data["columnSettingsJson"];
            if (Array.isArray(_data["addIcon"])) {
                this.addIcon = [] as any;
                for (let item of _data["addIcon"])
                    this.addIcon!.push(item);
            }
            if (Array.isArray(_data["removeIcon"])) {
                this.removeIcon = [] as any;
                for (let item of _data["removeIcon"])
                    this.removeIcon!.push(item);
            }
        }
    }

    static fromJS(data: any): ReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportColumns)) {
            data["reportColumns"] = [];
            for (let item of this.reportColumns)
                data["reportColumns"].push(item);
        }
        data["columnSettingsJson"] = this.columnSettingsJson;
        if (Array.isArray(this.addIcon)) {
            data["addIcon"] = [];
            for (let item of this.addIcon)
                data["addIcon"].push(item);
        }
        if (Array.isArray(this.removeIcon)) {
            data["removeIcon"] = [];
            for (let item of this.removeIcon)
                data["removeIcon"].push(item);
        }
        return data;
    }
}

export interface IReportModel {
    reportColumns?: ReportColumn[][] | undefined;
    columnSettingsJson?: string | undefined;
    addIcon?: string[] | undefined;
    removeIcon?: string[] | undefined;
}

export class ReportColumn implements IReportColumn {
    columnName?: string | undefined;
    conditions?: ReportColumnCondition[] | undefined;

    constructor(data?: IReportColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(ReportColumnCondition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportColumn {
        data = typeof data === 'object' ? data : {};
        let result = new ReportColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportColumn {
    columnName?: string | undefined;
    conditions?: ReportColumnCondition[] | undefined;
}

export class ReportColumnCondition implements IReportColumnCondition {
    operator!: SearchFilterOperatorEnum;
    comparator!: SearchFilterCompareTypeEnum;
    value?: string | undefined;
    value2?: string | undefined;
    isStringCompare!: boolean;
    isNumberCompare!: boolean;
    isDateTimeCompare!: boolean;
    isBooleanCompare!: boolean;
    isTableEnumCompare!: boolean;
    isEnumCompare!: boolean;

    constructor(data?: IReportColumnCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operator = _data["operator"];
            this.comparator = _data["comparator"];
            this.value = _data["value"];
            this.value2 = _data["value2"];
            this.isStringCompare = _data["isStringCompare"];
            this.isNumberCompare = _data["isNumberCompare"];
            this.isDateTimeCompare = _data["isDateTimeCompare"];
            this.isBooleanCompare = _data["isBooleanCompare"];
            this.isTableEnumCompare = _data["isTableEnumCompare"];
            this.isEnumCompare = _data["isEnumCompare"];
        }
    }

    static fromJS(data: any): ReportColumnCondition {
        data = typeof data === 'object' ? data : {};
        let result = new ReportColumnCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator;
        data["comparator"] = this.comparator;
        data["value"] = this.value;
        data["value2"] = this.value2;
        data["isStringCompare"] = this.isStringCompare;
        data["isNumberCompare"] = this.isNumberCompare;
        data["isDateTimeCompare"] = this.isDateTimeCompare;
        data["isBooleanCompare"] = this.isBooleanCompare;
        data["isTableEnumCompare"] = this.isTableEnumCompare;
        data["isEnumCompare"] = this.isEnumCompare;
        return data;
    }
}

export interface IReportColumnCondition {
    operator: SearchFilterOperatorEnum;
    comparator: SearchFilterCompareTypeEnum;
    value?: string | undefined;
    value2?: string | undefined;
    isStringCompare: boolean;
    isNumberCompare: boolean;
    isDateTimeCompare: boolean;
    isBooleanCompare: boolean;
    isTableEnumCompare: boolean;
    isEnumCompare: boolean;
}

export class ListResultItem extends BasePagedModel implements IListResultItem {
    label?: string | undefined;
    value?: any | undefined;
    checked?: boolean | undefined;
    isActive?: boolean | undefined;
    group?: string | undefined;
    description?: string | undefined;
    disabled?: boolean | undefined;
    valueInt64?: number | undefined;

    constructor(data?: IListResultItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.checked = _data["checked"];
            this.isActive = _data["isActive"];
            this.group = _data["group"];
            this.description = _data["description"];
            this.disabled = _data["disabled"];
            this.valueInt64 = _data["valueInt64"];
        }
    }

    static override fromJS(data: any): ListResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["checked"] = this.checked;
        data["isActive"] = this.isActive;
        data["group"] = this.group;
        data["description"] = this.description;
        data["disabled"] = this.disabled;
        data["valueInt64"] = this.valueInt64;
        super.toJSON(data);
        return data;
    }
}

export interface IListResultItem extends IBasePagedModel {
    label?: string | undefined;
    value?: any | undefined;
    checked?: boolean | undefined;
    isActive?: boolean | undefined;
    group?: string | undefined;
    description?: string | undefined;
    disabled?: boolean | undefined;
    valueInt64?: number | undefined;
}

export class ExternalSyncBadgeDTO implements IExternalSyncBadgeDTO {
    unreviewedCustomerCount!: number;
    unreviewedLocationCount!: number;
    totalCount!: number;

    constructor(data?: IExternalSyncBadgeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreviewedCustomerCount = _data["unreviewedCustomerCount"];
            this.unreviewedLocationCount = _data["unreviewedLocationCount"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ExternalSyncBadgeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSyncBadgeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreviewedCustomerCount"] = this.unreviewedCustomerCount;
        data["unreviewedLocationCount"] = this.unreviewedLocationCount;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IExternalSyncBadgeDTO {
    unreviewedCustomerCount: number;
    unreviewedLocationCount: number;
    totalCount: number;
}

export class SyncEventModel extends BasePagedModel implements ISyncEventModel {
    load?: LoadModel | undefined;
    order?: OrderModel | undefined;
    orderCustomer?: OrderCustomerModel | undefined;
    loadStopOrder?: LoadStopOrderModel | undefined;
    syncEventId!: number;
    syncEventType!: SyncEventEnum;
    syncSource!: SyncSourceEnum;
    infoText?: string | undefined;
    errorText?: string | undefined;
    loadId?: number | undefined;
    orderId?: number | undefined;
    orderCustomerId?: number | undefined;
    loadStopOrderId?: number | undefined;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: ISyncEventModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.load = _data["load"] ? LoadModel.fromJS(_data["load"]) : <any>undefined;
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : <any>undefined;
            this.orderCustomer = _data["orderCustomer"] ? OrderCustomerModel.fromJS(_data["orderCustomer"]) : <any>undefined;
            this.loadStopOrder = _data["loadStopOrder"] ? LoadStopOrderModel.fromJS(_data["loadStopOrder"]) : <any>undefined;
            this.syncEventId = _data["syncEventId"];
            this.syncEventType = _data["syncEventType"];
            this.syncSource = _data["syncSource"];
            this.infoText = _data["infoText"];
            this.errorText = _data["errorText"];
            this.loadId = _data["loadId"];
            this.orderId = _data["orderId"];
            this.orderCustomerId = _data["orderCustomerId"];
            this.loadStopOrderId = _data["loadStopOrderId"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SyncEventModel {
        data = typeof data === 'object' ? data : {};
        let result = new SyncEventModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["load"] = this.load ? this.load.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["orderCustomer"] = this.orderCustomer ? this.orderCustomer.toJSON() : <any>undefined;
        data["loadStopOrder"] = this.loadStopOrder ? this.loadStopOrder.toJSON() : <any>undefined;
        data["syncEventId"] = this.syncEventId;
        data["syncEventType"] = this.syncEventType;
        data["syncSource"] = this.syncSource;
        data["infoText"] = this.infoText;
        data["errorText"] = this.errorText;
        data["loadId"] = this.loadId;
        data["orderId"] = this.orderId;
        data["orderCustomerId"] = this.orderCustomerId;
        data["loadStopOrderId"] = this.loadStopOrderId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISyncEventModel extends IBasePagedModel {
    load?: LoadModel | undefined;
    order?: OrderModel | undefined;
    orderCustomer?: OrderCustomerModel | undefined;
    loadStopOrder?: LoadStopOrderModel | undefined;
    syncEventId: number;
    syncEventType: SyncEventEnum;
    syncSource: SyncSourceEnum;
    infoText?: string | undefined;
    errorText?: string | undefined;
    loadId?: number | undefined;
    orderId?: number | undefined;
    orderCustomerId?: number | undefined;
    loadStopOrderId?: number | undefined;
    dateAdded: Date;
    dateModified: Date;
}

export enum SyncEventEnum {
    Created = 1,
    Updated = 2,
    Deleted = 3,
    Error = 4,
}

export class TransportationOrder implements ITransportationOrder {
    actions?: string | undefined;
    allocationSourceTypeId?: string | undefined;
    billingMethodId?: string | undefined;
    businessUnitGroupId?: string | undefined;
    businessUnitId?: string | undefined;
    cancelled?: boolean | undefined;
    climateControlId?: string | undefined;
    closed?: boolean | undefined;
    creationType?: string | undefined;
    customerId?: string | undefined;
    deliveryEndDateTime?: string | undefined;
    deliveryStartDateTime?: string | undefined;
    deliveryTimeZone?: string | undefined;
    designatedCarrierId?: string | undefined;
    designatedEquipmentTypeId?: string | undefined;
    designatedModeId?: string | undefined;
    designatedParcelRateShopGroupId?: string | undefined;
    designatedServiceLevelId?: string | undefined;
    designatedShipViaId?: string | undefined;
    designatedShipmentBusinessUnitId?: string | undefined;
    designatedShipmentId?: string | undefined;
    designatedStaticRouteId?: string | undefined;
    designatedStopId?: string | undefined;
    designatedStopSequenceNumber?: number | undefined;
    destinationAddress!: Address;
    destinationDockId?: string | undefined;
    destinationFacilityAliasId?: string | undefined;
    destinationFacilityId!: string;
    destinationLatitude?: number | undefined;
    destinationLongitude?: number | undefined;
    destinationTransportationZoneId?: string | undefined;
    dimensionUomId?: string | undefined;
    extended?: ExtendedProperties | undefined;
    freightAllowance?: number | undefined;
    freightAllowanceCurrencyCode?: string | undefined;
    height?: number | undefined;
    lastDoUpdateTimestamp?: string | undefined;
    length?: number | undefined;
    lpnCount?: number | undefined;
    mustShipTogetherCode?: string | undefined;
    mustShipTogetherRestricted?: boolean | undefined;
    nextLegPickupDateTime?: string | undefined;
    orderId?: string | undefined;
    orgId?: string | undefined;
    originAddress!: Address;
    originDockId?: string | undefined;
    originFacilityAliasId?: string | undefined;
    originFacilityId!: string;
    originLatitude?: number | undefined;
    originLongitude?: number | undefined;
    originTransportationZoneId?: string | undefined;
    palletCount?: number | undefined;
    parentTransportationOrderId?: string | undefined;
    pickupEndDateTime?: string | undefined;
    pickupEndDateTimeInLocalTime?: string | undefined;
    pickupStartDateTime?: string | undefined;
    pickupStartDateTimeInLocalDateTime?: string | undefined;
    pickupTimeZone?: string | undefined;
    plannedPathId?: string | undefined;
    plannedPathSetId?: string | undefined;
    planningDestination?: string | undefined;
    planningOrigin?: string | undefined;
    planningStatusId?: ToPlanningStatusIdProperties | undefined;
    planningTypeId?: string | undefined;
    postOfficeBoxDestination?: boolean | undefined;
    preCarriageZoneId?: string | undefined;
    prePlanTransportation?: boolean | undefined;
    priority?: number | undefined;
    productClassId?: string | undefined;
    residentialDestination?: boolean | undefined;
    revenueCalculationLevel?: string | undefined;
    revenueCurrencyCode?: string | undefined;
    splitTransportationOrder?: boolean | undefined;
    splittable?: boolean | undefined;
    totalRevenue?: number | undefined;
    transportationOrderId!: string;
    transportationResponsibilityId?: string | undefined;
    vendorId?: string | undefined;
    vendorRoutingRequestId?: string | undefined;
    warehouseShipmentReference?: string | undefined;
    width?: number | undefined;
    transportationOrderLine!: TransportationOrderLine[];
    transportationOrderAccessorial!: TransportationOrderAccessorial[];
    transportationOrderContact!: TransportationOrderContact[];
    transportationOrderNote!: TransportationOrderNote[];
    transportationOrderRevenue!: TransportationOrderRevenue[];
    transportationOrderSupplementalQuantity!: TransportationOrderSupplementalQuantity[];
    toAdditionalAttributes?: ToAdditionalAttributes | undefined;

    constructor(data?: ITransportationOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.destinationAddress = new Address();
            this.originAddress = new Address();
            this.transportationOrderLine = [];
            this.transportationOrderAccessorial = [];
            this.transportationOrderContact = [];
            this.transportationOrderNote = [];
            this.transportationOrderRevenue = [];
            this.transportationOrderSupplementalQuantity = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actions = _data["actions"];
            this.allocationSourceTypeId = _data["allocationSourceTypeId"];
            this.billingMethodId = _data["billingMethodId"];
            this.businessUnitGroupId = _data["businessUnitGroupId"];
            this.businessUnitId = _data["businessUnitId"];
            this.cancelled = _data["cancelled"];
            this.climateControlId = _data["climateControlId"];
            this.closed = _data["closed"];
            this.creationType = _data["creationType"];
            this.customerId = _data["customerId"];
            this.deliveryEndDateTime = _data["deliveryEndDateTime"];
            this.deliveryStartDateTime = _data["deliveryStartDateTime"];
            this.deliveryTimeZone = _data["deliveryTimeZone"];
            this.designatedCarrierId = _data["designatedCarrierId"];
            this.designatedEquipmentTypeId = _data["designatedEquipmentTypeId"];
            this.designatedModeId = _data["designatedModeId"];
            this.designatedParcelRateShopGroupId = _data["designatedParcelRateShopGroupId"];
            this.designatedServiceLevelId = _data["designatedServiceLevelId"];
            this.designatedShipViaId = _data["designatedShipViaId"];
            this.designatedShipmentBusinessUnitId = _data["designatedShipmentBusinessUnitId"];
            this.designatedShipmentId = _data["designatedShipmentId"];
            this.designatedStaticRouteId = _data["designatedStaticRouteId"];
            this.designatedStopId = _data["designatedStopId"];
            this.designatedStopSequenceNumber = _data["designatedStopSequenceNumber"];
            this.destinationAddress = _data["destinationAddress"] ? Address.fromJS(_data["destinationAddress"]) : new Address();
            this.destinationDockId = _data["destinationDockId"];
            this.destinationFacilityAliasId = _data["destinationFacilityAliasId"];
            this.destinationFacilityId = _data["destinationFacilityId"];
            this.destinationLatitude = _data["destinationLatitude"];
            this.destinationLongitude = _data["destinationLongitude"];
            this.destinationTransportationZoneId = _data["destinationTransportationZoneId"];
            this.dimensionUomId = _data["dimensionUomId"];
            this.extended = _data["extended"] ? ExtendedProperties.fromJS(_data["extended"]) : <any>undefined;
            this.freightAllowance = _data["freightAllowance"];
            this.freightAllowanceCurrencyCode = _data["freightAllowanceCurrencyCode"];
            this.height = _data["height"];
            this.lastDoUpdateTimestamp = _data["lastDoUpdateTimestamp"];
            this.length = _data["length"];
            this.lpnCount = _data["lpnCount"];
            this.mustShipTogetherCode = _data["mustShipTogetherCode"];
            this.mustShipTogetherRestricted = _data["mustShipTogetherRestricted"];
            this.nextLegPickupDateTime = _data["nextLegPickupDateTime"];
            this.orderId = _data["orderId"];
            this.orgId = _data["orgId"];
            this.originAddress = _data["originAddress"] ? Address.fromJS(_data["originAddress"]) : new Address();
            this.originDockId = _data["originDockId"];
            this.originFacilityAliasId = _data["originFacilityAliasId"];
            this.originFacilityId = _data["originFacilityId"];
            this.originLatitude = _data["originLatitude"];
            this.originLongitude = _data["originLongitude"];
            this.originTransportationZoneId = _data["originTransportationZoneId"];
            this.palletCount = _data["palletCount"];
            this.parentTransportationOrderId = _data["parentTransportationOrderId"];
            this.pickupEndDateTime = _data["pickupEndDateTime"];
            this.pickupEndDateTimeInLocalTime = _data["pickupEndDateTimeInLocalTime"];
            this.pickupStartDateTime = _data["pickupStartDateTime"];
            this.pickupStartDateTimeInLocalDateTime = _data["pickupStartDateTimeInLocalDateTime"];
            this.pickupTimeZone = _data["pickupTimeZone"];
            this.plannedPathId = _data["plannedPathId"];
            this.plannedPathSetId = _data["plannedPathSetId"];
            this.planningDestination = _data["planningDestination"];
            this.planningOrigin = _data["planningOrigin"];
            this.planningStatusId = _data["planningStatusId"] ? ToPlanningStatusIdProperties.fromJS(_data["planningStatusId"]) : <any>undefined;
            this.planningTypeId = _data["planningTypeId"];
            this.postOfficeBoxDestination = _data["postOfficeBoxDestination"];
            this.preCarriageZoneId = _data["preCarriageZoneId"];
            this.prePlanTransportation = _data["prePlanTransportation"];
            this.priority = _data["priority"];
            this.productClassId = _data["productClassId"];
            this.residentialDestination = _data["residentialDestination"];
            this.revenueCalculationLevel = _data["revenueCalculationLevel"];
            this.revenueCurrencyCode = _data["revenueCurrencyCode"];
            this.splitTransportationOrder = _data["splitTransportationOrder"];
            this.splittable = _data["splittable"];
            this.totalRevenue = _data["totalRevenue"];
            this.transportationOrderId = _data["transportationOrderId"];
            this.transportationResponsibilityId = _data["transportationResponsibilityId"];
            this.vendorId = _data["vendorId"];
            this.vendorRoutingRequestId = _data["vendorRoutingRequestId"];
            this.warehouseShipmentReference = _data["warehouseShipmentReference"];
            this.width = _data["width"];
            if (Array.isArray(_data["transportationOrderLine"])) {
                this.transportationOrderLine = [] as any;
                for (let item of _data["transportationOrderLine"])
                    this.transportationOrderLine!.push(TransportationOrderLine.fromJS(item));
            }
            if (Array.isArray(_data["transportationOrderAccessorial"])) {
                this.transportationOrderAccessorial = [] as any;
                for (let item of _data["transportationOrderAccessorial"])
                    this.transportationOrderAccessorial!.push(TransportationOrderAccessorial.fromJS(item));
            }
            if (Array.isArray(_data["transportationOrderContact"])) {
                this.transportationOrderContact = [] as any;
                for (let item of _data["transportationOrderContact"])
                    this.transportationOrderContact!.push(TransportationOrderContact.fromJS(item));
            }
            if (Array.isArray(_data["transportationOrderNote"])) {
                this.transportationOrderNote = [] as any;
                for (let item of _data["transportationOrderNote"])
                    this.transportationOrderNote!.push(TransportationOrderNote.fromJS(item));
            }
            if (Array.isArray(_data["transportationOrderRevenue"])) {
                this.transportationOrderRevenue = [] as any;
                for (let item of _data["transportationOrderRevenue"])
                    this.transportationOrderRevenue!.push(TransportationOrderRevenue.fromJS(item));
            }
            if (Array.isArray(_data["transportationOrderSupplementalQuantity"])) {
                this.transportationOrderSupplementalQuantity = [] as any;
                for (let item of _data["transportationOrderSupplementalQuantity"])
                    this.transportationOrderSupplementalQuantity!.push(TransportationOrderSupplementalQuantity.fromJS(item));
            }
            this.toAdditionalAttributes = _data["toAdditionalAttributes"] ? ToAdditionalAttributes.fromJS(_data["toAdditionalAttributes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TransportationOrder {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actions"] = this.actions;
        data["allocationSourceTypeId"] = this.allocationSourceTypeId;
        data["billingMethodId"] = this.billingMethodId;
        data["businessUnitGroupId"] = this.businessUnitGroupId;
        data["businessUnitId"] = this.businessUnitId;
        data["cancelled"] = this.cancelled;
        data["climateControlId"] = this.climateControlId;
        data["closed"] = this.closed;
        data["creationType"] = this.creationType;
        data["customerId"] = this.customerId;
        data["deliveryEndDateTime"] = this.deliveryEndDateTime;
        data["deliveryStartDateTime"] = this.deliveryStartDateTime;
        data["deliveryTimeZone"] = this.deliveryTimeZone;
        data["designatedCarrierId"] = this.designatedCarrierId;
        data["designatedEquipmentTypeId"] = this.designatedEquipmentTypeId;
        data["designatedModeId"] = this.designatedModeId;
        data["designatedParcelRateShopGroupId"] = this.designatedParcelRateShopGroupId;
        data["designatedServiceLevelId"] = this.designatedServiceLevelId;
        data["designatedShipViaId"] = this.designatedShipViaId;
        data["designatedShipmentBusinessUnitId"] = this.designatedShipmentBusinessUnitId;
        data["designatedShipmentId"] = this.designatedShipmentId;
        data["designatedStaticRouteId"] = this.designatedStaticRouteId;
        data["designatedStopId"] = this.designatedStopId;
        data["designatedStopSequenceNumber"] = this.designatedStopSequenceNumber;
        data["destinationAddress"] = this.destinationAddress ? this.destinationAddress.toJSON() : <any>undefined;
        data["destinationDockId"] = this.destinationDockId;
        data["destinationFacilityAliasId"] = this.destinationFacilityAliasId;
        data["destinationFacilityId"] = this.destinationFacilityId;
        data["destinationLatitude"] = this.destinationLatitude;
        data["destinationLongitude"] = this.destinationLongitude;
        data["destinationTransportationZoneId"] = this.destinationTransportationZoneId;
        data["dimensionUomId"] = this.dimensionUomId;
        data["extended"] = this.extended ? this.extended.toJSON() : <any>undefined;
        data["freightAllowance"] = this.freightAllowance;
        data["freightAllowanceCurrencyCode"] = this.freightAllowanceCurrencyCode;
        data["height"] = this.height;
        data["lastDoUpdateTimestamp"] = this.lastDoUpdateTimestamp;
        data["length"] = this.length;
        data["lpnCount"] = this.lpnCount;
        data["mustShipTogetherCode"] = this.mustShipTogetherCode;
        data["mustShipTogetherRestricted"] = this.mustShipTogetherRestricted;
        data["nextLegPickupDateTime"] = this.nextLegPickupDateTime;
        data["orderId"] = this.orderId;
        data["orgId"] = this.orgId;
        data["originAddress"] = this.originAddress ? this.originAddress.toJSON() : <any>undefined;
        data["originDockId"] = this.originDockId;
        data["originFacilityAliasId"] = this.originFacilityAliasId;
        data["originFacilityId"] = this.originFacilityId;
        data["originLatitude"] = this.originLatitude;
        data["originLongitude"] = this.originLongitude;
        data["originTransportationZoneId"] = this.originTransportationZoneId;
        data["palletCount"] = this.palletCount;
        data["parentTransportationOrderId"] = this.parentTransportationOrderId;
        data["pickupEndDateTime"] = this.pickupEndDateTime;
        data["pickupEndDateTimeInLocalTime"] = this.pickupEndDateTimeInLocalTime;
        data["pickupStartDateTime"] = this.pickupStartDateTime;
        data["pickupStartDateTimeInLocalDateTime"] = this.pickupStartDateTimeInLocalDateTime;
        data["pickupTimeZone"] = this.pickupTimeZone;
        data["plannedPathId"] = this.plannedPathId;
        data["plannedPathSetId"] = this.plannedPathSetId;
        data["planningDestination"] = this.planningDestination;
        data["planningOrigin"] = this.planningOrigin;
        data["planningStatusId"] = this.planningStatusId ? this.planningStatusId.toJSON() : <any>undefined;
        data["planningTypeId"] = this.planningTypeId;
        data["postOfficeBoxDestination"] = this.postOfficeBoxDestination;
        data["preCarriageZoneId"] = this.preCarriageZoneId;
        data["prePlanTransportation"] = this.prePlanTransportation;
        data["priority"] = this.priority;
        data["productClassId"] = this.productClassId;
        data["residentialDestination"] = this.residentialDestination;
        data["revenueCalculationLevel"] = this.revenueCalculationLevel;
        data["revenueCurrencyCode"] = this.revenueCurrencyCode;
        data["splitTransportationOrder"] = this.splitTransportationOrder;
        data["splittable"] = this.splittable;
        data["totalRevenue"] = this.totalRevenue;
        data["transportationOrderId"] = this.transportationOrderId;
        data["transportationResponsibilityId"] = this.transportationResponsibilityId;
        data["vendorId"] = this.vendorId;
        data["vendorRoutingRequestId"] = this.vendorRoutingRequestId;
        data["warehouseShipmentReference"] = this.warehouseShipmentReference;
        data["width"] = this.width;
        if (Array.isArray(this.transportationOrderLine)) {
            data["transportationOrderLine"] = [];
            for (let item of this.transportationOrderLine)
                data["transportationOrderLine"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationOrderAccessorial)) {
            data["transportationOrderAccessorial"] = [];
            for (let item of this.transportationOrderAccessorial)
                data["transportationOrderAccessorial"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationOrderContact)) {
            data["transportationOrderContact"] = [];
            for (let item of this.transportationOrderContact)
                data["transportationOrderContact"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationOrderNote)) {
            data["transportationOrderNote"] = [];
            for (let item of this.transportationOrderNote)
                data["transportationOrderNote"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationOrderRevenue)) {
            data["transportationOrderRevenue"] = [];
            for (let item of this.transportationOrderRevenue)
                data["transportationOrderRevenue"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationOrderSupplementalQuantity)) {
            data["transportationOrderSupplementalQuantity"] = [];
            for (let item of this.transportationOrderSupplementalQuantity)
                data["transportationOrderSupplementalQuantity"].push(item.toJSON());
        }
        data["toAdditionalAttributes"] = this.toAdditionalAttributes ? this.toAdditionalAttributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITransportationOrder {
    actions?: string | undefined;
    allocationSourceTypeId?: string | undefined;
    billingMethodId?: string | undefined;
    businessUnitGroupId?: string | undefined;
    businessUnitId?: string | undefined;
    cancelled?: boolean | undefined;
    climateControlId?: string | undefined;
    closed?: boolean | undefined;
    creationType?: string | undefined;
    customerId?: string | undefined;
    deliveryEndDateTime?: string | undefined;
    deliveryStartDateTime?: string | undefined;
    deliveryTimeZone?: string | undefined;
    designatedCarrierId?: string | undefined;
    designatedEquipmentTypeId?: string | undefined;
    designatedModeId?: string | undefined;
    designatedParcelRateShopGroupId?: string | undefined;
    designatedServiceLevelId?: string | undefined;
    designatedShipViaId?: string | undefined;
    designatedShipmentBusinessUnitId?: string | undefined;
    designatedShipmentId?: string | undefined;
    designatedStaticRouteId?: string | undefined;
    designatedStopId?: string | undefined;
    designatedStopSequenceNumber?: number | undefined;
    destinationAddress: Address;
    destinationDockId?: string | undefined;
    destinationFacilityAliasId?: string | undefined;
    destinationFacilityId: string;
    destinationLatitude?: number | undefined;
    destinationLongitude?: number | undefined;
    destinationTransportationZoneId?: string | undefined;
    dimensionUomId?: string | undefined;
    extended?: ExtendedProperties | undefined;
    freightAllowance?: number | undefined;
    freightAllowanceCurrencyCode?: string | undefined;
    height?: number | undefined;
    lastDoUpdateTimestamp?: string | undefined;
    length?: number | undefined;
    lpnCount?: number | undefined;
    mustShipTogetherCode?: string | undefined;
    mustShipTogetherRestricted?: boolean | undefined;
    nextLegPickupDateTime?: string | undefined;
    orderId?: string | undefined;
    orgId?: string | undefined;
    originAddress: Address;
    originDockId?: string | undefined;
    originFacilityAliasId?: string | undefined;
    originFacilityId: string;
    originLatitude?: number | undefined;
    originLongitude?: number | undefined;
    originTransportationZoneId?: string | undefined;
    palletCount?: number | undefined;
    parentTransportationOrderId?: string | undefined;
    pickupEndDateTime?: string | undefined;
    pickupEndDateTimeInLocalTime?: string | undefined;
    pickupStartDateTime?: string | undefined;
    pickupStartDateTimeInLocalDateTime?: string | undefined;
    pickupTimeZone?: string | undefined;
    plannedPathId?: string | undefined;
    plannedPathSetId?: string | undefined;
    planningDestination?: string | undefined;
    planningOrigin?: string | undefined;
    planningStatusId?: ToPlanningStatusIdProperties | undefined;
    planningTypeId?: string | undefined;
    postOfficeBoxDestination?: boolean | undefined;
    preCarriageZoneId?: string | undefined;
    prePlanTransportation?: boolean | undefined;
    priority?: number | undefined;
    productClassId?: string | undefined;
    residentialDestination?: boolean | undefined;
    revenueCalculationLevel?: string | undefined;
    revenueCurrencyCode?: string | undefined;
    splitTransportationOrder?: boolean | undefined;
    splittable?: boolean | undefined;
    totalRevenue?: number | undefined;
    transportationOrderId: string;
    transportationResponsibilityId?: string | undefined;
    vendorId?: string | undefined;
    vendorRoutingRequestId?: string | undefined;
    warehouseShipmentReference?: string | undefined;
    width?: number | undefined;
    transportationOrderLine: TransportationOrderLine[];
    transportationOrderAccessorial: TransportationOrderAccessorial[];
    transportationOrderContact: TransportationOrderContact[];
    transportationOrderNote: TransportationOrderNote[];
    transportationOrderRevenue: TransportationOrderRevenue[];
    transportationOrderSupplementalQuantity: TransportationOrderSupplementalQuantity[];
    toAdditionalAttributes?: ToAdditionalAttributes | undefined;
}

export class Address implements IAddress {
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    county?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    postalCode?: string | undefined;
    state?: string | undefined;
    size?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.county = _data["county"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.postalCode = _data["postalCode"];
            this.state = _data["state"];
            this.size = _data["size"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["country"] = this.country;
        data["county"] = this.county;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["postalCode"] = this.postalCode;
        data["state"] = this.state;
        data["size"] = this.size;
        data["code"] = this.code;
        data["description"] = this.description;
        data["type"] = this.type;
        return data;
    }
}

export interface IAddress {
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    county?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    postalCode?: string | undefined;
    state?: string | undefined;
    size?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
}

export class ExtendedProperties implements IExtendedProperties {
    specialInstructions?: string | undefined;
    loadType?: string | undefined;
    poNumber?: string | undefined;

    constructor(data?: IExtendedProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialInstructions = _data["specialInstructions"];
            this.loadType = _data["loadType"];
            this.poNumber = _data["poNumber"];
        }
    }

    static fromJS(data: any): ExtendedProperties {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialInstructions"] = this.specialInstructions;
        data["loadType"] = this.loadType;
        data["poNumber"] = this.poNumber;
        return data;
    }
}

export interface IExtendedProperties {
    specialInstructions?: string | undefined;
    loadType?: string | undefined;
    poNumber?: string | undefined;
}

export class ToPlanningStatusIdProperties implements IToPlanningStatusIdProperties {
    toPlanningStatusId?: string | undefined;

    constructor(data?: IToPlanningStatusIdProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toPlanningStatusId = _data["toPlanningStatusId"];
        }
    }

    static fromJS(data: any): ToPlanningStatusIdProperties {
        data = typeof data === 'object' ? data : {};
        let result = new ToPlanningStatusIdProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toPlanningStatusId"] = this.toPlanningStatusId;
        return data;
    }
}

export interface IToPlanningStatusIdProperties {
    toPlanningStatusId?: string | undefined;
}

export class TransportationOrderLine implements ITransportationOrderLine {
    actions?: string | undefined;
    cancelled?: boolean | undefined;
    climateControlId?: string | undefined;
    closed?: boolean | undefined;
    commodityCodeId?: string | undefined;
    deliveryEndDateTime?: string | undefined;
    deliveryStartDateTime?: string | undefined;
    designatedCarrierId?: string | undefined;
    designatedEquipmentTypeId?: string | undefined;
    designatedModeId?: string | undefined;
    designatedServiceLevelId?: string | undefined;
    designatedShipViaId?: string | undefined;
    designatedShipmentBusinessUnitId?: string | undefined;
    designatedShipmentId?: string | undefined;
    designatedStopId?: string | undefined;
    designatedStopSequenceNumber?: string | undefined;
    dimensionUomId?: string | undefined;
    extended?: { [key: string]: string; } | undefined;
    extendedVolume?: number | undefined;
    extendedWeight?: number | undefined;
    freightAllowance?: number | undefined;
    freightAllowanceCurrencyCode?: string | undefined;
    hazardousMaterial?: boolean | undefined;
    hazardousMaterialId?: string | undefined;
    height?: number | undefined;
    itemId?: string | undefined;
    lastDoLineUpdateTimestamp?: string | undefined;
    length?: number | undefined;
    mustShipTogetherCode?: string | undefined;
    mustShipTogetherRestricted?: boolean | undefined;
    nmfcFreightClassId?: string | undefined;
    orderId?: string | undefined;
    orderLineId?: string | undefined;
    orderedQuantity!: number;
    orgId?: string | undefined;
    originalDimensionUomId?: string | undefined;
    originalHeight?: string | undefined;
    originalLength?: string | undefined;
    originalOrderId?: string | undefined;
    originalOrderLineId?: string | undefined;
    originalOrderedQuantity?: string | undefined;
    originalVolume?: number | undefined;
    originalVolumeUomId?: string | undefined;
    originalWeight?: number | undefined;
    originalWeightUomId?: string | undefined;
    originalWidth?: number | undefined;
    pickupEndDateTime?: string | undefined;
    pickupStartDateTime?: string | undefined;
    pickupStartDateTimeInLocalDateTime?: string | undefined;
    productClassId?: string | undefined;
    purchaseRequestId?: string | undefined;
    purchaseRequestLineId?: string | undefined;
    quantityUomId?: string | undefined;
    referenceOrder?: string | undefined;
    referenceOrderLine?: string | undefined;
    splittable?: boolean | undefined;
    tareVolume?: number | undefined;
    tareWeight?: number | undefined;
    transportationOrderLineId!: string;
    unitVolume?: number | undefined;
    unitWeight?: number | undefined;
    vendorRoutingRequestId?: string | undefined;
    vendorRoutingRequestLineId?: string | undefined;
    volumeUomId?: string | undefined;
    weightUomId?: string | undefined;
    width?: number | undefined;
    toLineAdditionalAttributes!: ToLineAdditionalAttributes;
    transportationOrderLineFinancial!: TransportationOrderLineFinancial[];
    transportationOrderLineRevenue!: TransportationOrderLineRevenue[];
    transportationOrderLineSupplementalQuantity!: TransportationOrderLineSupplementalQuantity[];

    constructor(data?: ITransportationOrderLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.toLineAdditionalAttributes = new ToLineAdditionalAttributes();
            this.transportationOrderLineFinancial = [];
            this.transportationOrderLineRevenue = [];
            this.transportationOrderLineSupplementalQuantity = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actions = _data["actions"];
            this.cancelled = _data["cancelled"];
            this.climateControlId = _data["climateControlId"];
            this.closed = _data["closed"];
            this.commodityCodeId = _data["commodityCodeId"];
            this.deliveryEndDateTime = _data["deliveryEndDateTime"];
            this.deliveryStartDateTime = _data["deliveryStartDateTime"];
            this.designatedCarrierId = _data["designatedCarrierId"];
            this.designatedEquipmentTypeId = _data["designatedEquipmentTypeId"];
            this.designatedModeId = _data["designatedModeId"];
            this.designatedServiceLevelId = _data["designatedServiceLevelId"];
            this.designatedShipViaId = _data["designatedShipViaId"];
            this.designatedShipmentBusinessUnitId = _data["designatedShipmentBusinessUnitId"];
            this.designatedShipmentId = _data["designatedShipmentId"];
            this.designatedStopId = _data["designatedStopId"];
            this.designatedStopSequenceNumber = _data["designatedStopSequenceNumber"];
            this.dimensionUomId = _data["dimensionUomId"];
            if (_data["extended"]) {
                this.extended = {} as any;
                for (let key in _data["extended"]) {
                    if (_data["extended"].hasOwnProperty(key))
                        (<any>this.extended)![key] = _data["extended"][key];
                }
            }
            this.extendedVolume = _data["extendedVolume"];
            this.extendedWeight = _data["extendedWeight"];
            this.freightAllowance = _data["freightAllowance"];
            this.freightAllowanceCurrencyCode = _data["freightAllowanceCurrencyCode"];
            this.hazardousMaterial = _data["hazardousMaterial"];
            this.hazardousMaterialId = _data["hazardousMaterialId"];
            this.height = _data["height"];
            this.itemId = _data["itemId"];
            this.lastDoLineUpdateTimestamp = _data["lastDoLineUpdateTimestamp"];
            this.length = _data["length"];
            this.mustShipTogetherCode = _data["mustShipTogetherCode"];
            this.mustShipTogetherRestricted = _data["mustShipTogetherRestricted"];
            this.nmfcFreightClassId = _data["nmfcFreightClassId"];
            this.orderId = _data["orderId"];
            this.orderLineId = _data["orderLineId"];
            this.orderedQuantity = _data["orderedQuantity"];
            this.orgId = _data["orgId"];
            this.originalDimensionUomId = _data["originalDimensionUomId"];
            this.originalHeight = _data["originalHeight"];
            this.originalLength = _data["originalLength"];
            this.originalOrderId = _data["originalOrderId"];
            this.originalOrderLineId = _data["originalOrderLineId"];
            this.originalOrderedQuantity = _data["originalOrderedQuantity"];
            this.originalVolume = _data["originalVolume"];
            this.originalVolumeUomId = _data["originalVolumeUomId"];
            this.originalWeight = _data["originalWeight"];
            this.originalWeightUomId = _data["originalWeightUomId"];
            this.originalWidth = _data["originalWidth"];
            this.pickupEndDateTime = _data["pickupEndDateTime"];
            this.pickupStartDateTime = _data["pickupStartDateTime"];
            this.pickupStartDateTimeInLocalDateTime = _data["pickupStartDateTimeInLocalDateTime"];
            this.productClassId = _data["productClassId"];
            this.purchaseRequestId = _data["purchaseRequestId"];
            this.purchaseRequestLineId = _data["purchaseRequestLineId"];
            this.quantityUomId = _data["quantityUomId"];
            this.referenceOrder = _data["referenceOrder"];
            this.referenceOrderLine = _data["referenceOrderLine"];
            this.splittable = _data["splittable"];
            this.tareVolume = _data["tareVolume"];
            this.tareWeight = _data["tareWeight"];
            this.transportationOrderLineId = _data["transportationOrderLineId"];
            this.unitVolume = _data["unitVolume"];
            this.unitWeight = _data["unitWeight"];
            this.vendorRoutingRequestId = _data["vendorRoutingRequestId"];
            this.vendorRoutingRequestLineId = _data["vendorRoutingRequestLineId"];
            this.volumeUomId = _data["volumeUomId"];
            this.weightUomId = _data["weightUomId"];
            this.width = _data["width"];
            this.toLineAdditionalAttributes = _data["toLineAdditionalAttributes"] ? ToLineAdditionalAttributes.fromJS(_data["toLineAdditionalAttributes"]) : new ToLineAdditionalAttributes();
            if (Array.isArray(_data["transportationOrderLineFinancial"])) {
                this.transportationOrderLineFinancial = [] as any;
                for (let item of _data["transportationOrderLineFinancial"])
                    this.transportationOrderLineFinancial!.push(TransportationOrderLineFinancial.fromJS(item));
            }
            if (Array.isArray(_data["transportationOrderLineRevenue"])) {
                this.transportationOrderLineRevenue = [] as any;
                for (let item of _data["transportationOrderLineRevenue"])
                    this.transportationOrderLineRevenue!.push(TransportationOrderLineRevenue.fromJS(item));
            }
            if (Array.isArray(_data["transportationOrderLineSupplementalQuantity"])) {
                this.transportationOrderLineSupplementalQuantity = [] as any;
                for (let item of _data["transportationOrderLineSupplementalQuantity"])
                    this.transportationOrderLineSupplementalQuantity!.push(TransportationOrderLineSupplementalQuantity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransportationOrderLine {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationOrderLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actions"] = this.actions;
        data["cancelled"] = this.cancelled;
        data["climateControlId"] = this.climateControlId;
        data["closed"] = this.closed;
        data["commodityCodeId"] = this.commodityCodeId;
        data["deliveryEndDateTime"] = this.deliveryEndDateTime;
        data["deliveryStartDateTime"] = this.deliveryStartDateTime;
        data["designatedCarrierId"] = this.designatedCarrierId;
        data["designatedEquipmentTypeId"] = this.designatedEquipmentTypeId;
        data["designatedModeId"] = this.designatedModeId;
        data["designatedServiceLevelId"] = this.designatedServiceLevelId;
        data["designatedShipViaId"] = this.designatedShipViaId;
        data["designatedShipmentBusinessUnitId"] = this.designatedShipmentBusinessUnitId;
        data["designatedShipmentId"] = this.designatedShipmentId;
        data["designatedStopId"] = this.designatedStopId;
        data["designatedStopSequenceNumber"] = this.designatedStopSequenceNumber;
        data["dimensionUomId"] = this.dimensionUomId;
        if (this.extended) {
            data["extended"] = {};
            for (let key in this.extended) {
                if (this.extended.hasOwnProperty(key))
                    (<any>data["extended"])[key] = (<any>this.extended)[key];
            }
        }
        data["extendedVolume"] = this.extendedVolume;
        data["extendedWeight"] = this.extendedWeight;
        data["freightAllowance"] = this.freightAllowance;
        data["freightAllowanceCurrencyCode"] = this.freightAllowanceCurrencyCode;
        data["hazardousMaterial"] = this.hazardousMaterial;
        data["hazardousMaterialId"] = this.hazardousMaterialId;
        data["height"] = this.height;
        data["itemId"] = this.itemId;
        data["lastDoLineUpdateTimestamp"] = this.lastDoLineUpdateTimestamp;
        data["length"] = this.length;
        data["mustShipTogetherCode"] = this.mustShipTogetherCode;
        data["mustShipTogetherRestricted"] = this.mustShipTogetherRestricted;
        data["nmfcFreightClassId"] = this.nmfcFreightClassId;
        data["orderId"] = this.orderId;
        data["orderLineId"] = this.orderLineId;
        data["orderedQuantity"] = this.orderedQuantity;
        data["orgId"] = this.orgId;
        data["originalDimensionUomId"] = this.originalDimensionUomId;
        data["originalHeight"] = this.originalHeight;
        data["originalLength"] = this.originalLength;
        data["originalOrderId"] = this.originalOrderId;
        data["originalOrderLineId"] = this.originalOrderLineId;
        data["originalOrderedQuantity"] = this.originalOrderedQuantity;
        data["originalVolume"] = this.originalVolume;
        data["originalVolumeUomId"] = this.originalVolumeUomId;
        data["originalWeight"] = this.originalWeight;
        data["originalWeightUomId"] = this.originalWeightUomId;
        data["originalWidth"] = this.originalWidth;
        data["pickupEndDateTime"] = this.pickupEndDateTime;
        data["pickupStartDateTime"] = this.pickupStartDateTime;
        data["pickupStartDateTimeInLocalDateTime"] = this.pickupStartDateTimeInLocalDateTime;
        data["productClassId"] = this.productClassId;
        data["purchaseRequestId"] = this.purchaseRequestId;
        data["purchaseRequestLineId"] = this.purchaseRequestLineId;
        data["quantityUomId"] = this.quantityUomId;
        data["referenceOrder"] = this.referenceOrder;
        data["referenceOrderLine"] = this.referenceOrderLine;
        data["splittable"] = this.splittable;
        data["tareVolume"] = this.tareVolume;
        data["tareWeight"] = this.tareWeight;
        data["transportationOrderLineId"] = this.transportationOrderLineId;
        data["unitVolume"] = this.unitVolume;
        data["unitWeight"] = this.unitWeight;
        data["vendorRoutingRequestId"] = this.vendorRoutingRequestId;
        data["vendorRoutingRequestLineId"] = this.vendorRoutingRequestLineId;
        data["volumeUomId"] = this.volumeUomId;
        data["weightUomId"] = this.weightUomId;
        data["width"] = this.width;
        data["toLineAdditionalAttributes"] = this.toLineAdditionalAttributes ? this.toLineAdditionalAttributes.toJSON() : <any>undefined;
        if (Array.isArray(this.transportationOrderLineFinancial)) {
            data["transportationOrderLineFinancial"] = [];
            for (let item of this.transportationOrderLineFinancial)
                data["transportationOrderLineFinancial"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationOrderLineRevenue)) {
            data["transportationOrderLineRevenue"] = [];
            for (let item of this.transportationOrderLineRevenue)
                data["transportationOrderLineRevenue"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationOrderLineSupplementalQuantity)) {
            data["transportationOrderLineSupplementalQuantity"] = [];
            for (let item of this.transportationOrderLineSupplementalQuantity)
                data["transportationOrderLineSupplementalQuantity"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITransportationOrderLine {
    actions?: string | undefined;
    cancelled?: boolean | undefined;
    climateControlId?: string | undefined;
    closed?: boolean | undefined;
    commodityCodeId?: string | undefined;
    deliveryEndDateTime?: string | undefined;
    deliveryStartDateTime?: string | undefined;
    designatedCarrierId?: string | undefined;
    designatedEquipmentTypeId?: string | undefined;
    designatedModeId?: string | undefined;
    designatedServiceLevelId?: string | undefined;
    designatedShipViaId?: string | undefined;
    designatedShipmentBusinessUnitId?: string | undefined;
    designatedShipmentId?: string | undefined;
    designatedStopId?: string | undefined;
    designatedStopSequenceNumber?: string | undefined;
    dimensionUomId?: string | undefined;
    extended?: { [key: string]: string; } | undefined;
    extendedVolume?: number | undefined;
    extendedWeight?: number | undefined;
    freightAllowance?: number | undefined;
    freightAllowanceCurrencyCode?: string | undefined;
    hazardousMaterial?: boolean | undefined;
    hazardousMaterialId?: string | undefined;
    height?: number | undefined;
    itemId?: string | undefined;
    lastDoLineUpdateTimestamp?: string | undefined;
    length?: number | undefined;
    mustShipTogetherCode?: string | undefined;
    mustShipTogetherRestricted?: boolean | undefined;
    nmfcFreightClassId?: string | undefined;
    orderId?: string | undefined;
    orderLineId?: string | undefined;
    orderedQuantity: number;
    orgId?: string | undefined;
    originalDimensionUomId?: string | undefined;
    originalHeight?: string | undefined;
    originalLength?: string | undefined;
    originalOrderId?: string | undefined;
    originalOrderLineId?: string | undefined;
    originalOrderedQuantity?: string | undefined;
    originalVolume?: number | undefined;
    originalVolumeUomId?: string | undefined;
    originalWeight?: number | undefined;
    originalWeightUomId?: string | undefined;
    originalWidth?: number | undefined;
    pickupEndDateTime?: string | undefined;
    pickupStartDateTime?: string | undefined;
    pickupStartDateTimeInLocalDateTime?: string | undefined;
    productClassId?: string | undefined;
    purchaseRequestId?: string | undefined;
    purchaseRequestLineId?: string | undefined;
    quantityUomId?: string | undefined;
    referenceOrder?: string | undefined;
    referenceOrderLine?: string | undefined;
    splittable?: boolean | undefined;
    tareVolume?: number | undefined;
    tareWeight?: number | undefined;
    transportationOrderLineId: string;
    unitVolume?: number | undefined;
    unitWeight?: number | undefined;
    vendorRoutingRequestId?: string | undefined;
    vendorRoutingRequestLineId?: string | undefined;
    volumeUomId?: string | undefined;
    weightUomId?: string | undefined;
    width?: number | undefined;
    toLineAdditionalAttributes: ToLineAdditionalAttributes;
    transportationOrderLineFinancial: TransportationOrderLineFinancial[];
    transportationOrderLineRevenue: TransportationOrderLineRevenue[];
    transportationOrderLineSupplementalQuantity: TransportationOrderLineSupplementalQuantity[];
}

export class ToLineAdditionalAttributes implements IToLineAdditionalAttributes {
    actions?: string | undefined;
    distributedCost?: number | undefined;
    distributedCurrencyCode?: string | undefined;
    extended?: string | undefined;
    shippedQuantity?: number | undefined;
    shippedVolume?: number | undefined;
    shippedWeight?: number | undefined;
    receivedQuantity?: number | undefined;
    receivedVolume?: number | undefined;
    receivedWeight?: number | undefined;

    constructor(data?: IToLineAdditionalAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actions = _data["actions"];
            this.distributedCost = _data["distributedCost"];
            this.distributedCurrencyCode = _data["distributedCurrencyCode"];
            this.extended = _data["extended"];
            this.shippedQuantity = _data["shippedQuantity"];
            this.shippedVolume = _data["shippedVolume"];
            this.shippedWeight = _data["shippedWeight"];
            this.receivedQuantity = _data["receivedQuantity"];
            this.receivedVolume = _data["receivedVolume"];
            this.receivedWeight = _data["receivedWeight"];
        }
    }

    static fromJS(data: any): ToLineAdditionalAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new ToLineAdditionalAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actions"] = this.actions;
        data["distributedCost"] = this.distributedCost;
        data["distributedCurrencyCode"] = this.distributedCurrencyCode;
        data["extended"] = this.extended;
        data["shippedQuantity"] = this.shippedQuantity;
        data["shippedVolume"] = this.shippedVolume;
        data["shippedWeight"] = this.shippedWeight;
        data["receivedQuantity"] = this.receivedQuantity;
        data["receivedVolume"] = this.receivedVolume;
        data["receivedWeight"] = this.receivedWeight;
        return data;
    }
}

export interface IToLineAdditionalAttributes {
    actions?: string | undefined;
    distributedCost?: number | undefined;
    distributedCurrencyCode?: string | undefined;
    extended?: string | undefined;
    shippedQuantity?: number | undefined;
    shippedVolume?: number | undefined;
    shippedWeight?: number | undefined;
    receivedQuantity?: number | undefined;
    receivedVolume?: number | undefined;
    receivedWeight?: number | undefined;
}

export class TransportationOrderLineFinancial implements ITransportationOrderLineFinancial {
    actions?: string | undefined;
    currencyCode?: string | undefined;
    extended?: string | undefined;
    value?: number | undefined;
    orderFinancialTypeId!: string;

    constructor(data?: ITransportationOrderLineFinancial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actions = _data["actions"];
            this.currencyCode = _data["currencyCode"];
            this.extended = _data["extended"];
            this.value = _data["value"];
            this.orderFinancialTypeId = _data["orderFinancialTypeId"];
        }
    }

    static fromJS(data: any): TransportationOrderLineFinancial {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationOrderLineFinancial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actions"] = this.actions;
        data["currencyCode"] = this.currencyCode;
        data["extended"] = this.extended;
        data["value"] = this.value;
        data["orderFinancialTypeId"] = this.orderFinancialTypeId;
        return data;
    }
}

export interface ITransportationOrderLineFinancial {
    actions?: string | undefined;
    currencyCode?: string | undefined;
    extended?: string | undefined;
    value?: number | undefined;
    orderFinancialTypeId: string;
}

export class TransportationOrderLineRevenue implements ITransportationOrderLineRevenue {
    actions?: string | undefined;
    applyAction?: string | undefined;
    chargeDefinitionId!: string;
    chargeSummary?: string | undefined;
    chargeTypeId?: string | undefined;
    contractedAmount?: number | undefined;
    contractedApproval?: boolean | undefined;
    cost!: number;
    costExpressionId?: string | undefined;
    currencyCode!: string;
    extended?: string | undefined;
    flexRateId?: string | undefined;
    orgId?: string | undefined;
    overriddenAmount?: number | undefined;
    purgeDate?: string | undefined;
    ratingLaneId?: string | undefined;
    ratingLaneOptionId?: string | undefined;
    serviceProviderId?: string | undefined;
    userDescription?: string | undefined;

    constructor(data?: ITransportationOrderLineRevenue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actions = _data["actions"];
            this.applyAction = _data["applyAction"];
            this.chargeDefinitionId = _data["chargeDefinitionId"];
            this.chargeSummary = _data["chargeSummary"];
            this.chargeTypeId = _data["chargeTypeId"];
            this.contractedAmount = _data["contractedAmount"];
            this.contractedApproval = _data["contractedApproval"];
            this.cost = _data["cost"];
            this.costExpressionId = _data["costExpressionId"];
            this.currencyCode = _data["currencyCode"];
            this.extended = _data["extended"];
            this.flexRateId = _data["flexRateId"];
            this.orgId = _data["orgId"];
            this.overriddenAmount = _data["overriddenAmount"];
            this.purgeDate = _data["purgeDate"];
            this.ratingLaneId = _data["ratingLaneId"];
            this.ratingLaneOptionId = _data["ratingLaneOptionId"];
            this.serviceProviderId = _data["serviceProviderId"];
            this.userDescription = _data["userDescription"];
        }
    }

    static fromJS(data: any): TransportationOrderLineRevenue {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationOrderLineRevenue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actions"] = this.actions;
        data["applyAction"] = this.applyAction;
        data["chargeDefinitionId"] = this.chargeDefinitionId;
        data["chargeSummary"] = this.chargeSummary;
        data["chargeTypeId"] = this.chargeTypeId;
        data["contractedAmount"] = this.contractedAmount;
        data["contractedApproval"] = this.contractedApproval;
        data["cost"] = this.cost;
        data["costExpressionId"] = this.costExpressionId;
        data["currencyCode"] = this.currencyCode;
        data["extended"] = this.extended;
        data["flexRateId"] = this.flexRateId;
        data["orgId"] = this.orgId;
        data["overriddenAmount"] = this.overriddenAmount;
        data["purgeDate"] = this.purgeDate;
        data["ratingLaneId"] = this.ratingLaneId;
        data["ratingLaneOptionId"] = this.ratingLaneOptionId;
        data["serviceProviderId"] = this.serviceProviderId;
        data["userDescription"] = this.userDescription;
        return data;
    }
}

export interface ITransportationOrderLineRevenue {
    actions?: string | undefined;
    applyAction?: string | undefined;
    chargeDefinitionId: string;
    chargeSummary?: string | undefined;
    chargeTypeId?: string | undefined;
    contractedAmount?: number | undefined;
    contractedApproval?: boolean | undefined;
    cost: number;
    costExpressionId?: string | undefined;
    currencyCode: string;
    extended?: string | undefined;
    flexRateId?: string | undefined;
    orgId?: string | undefined;
    overriddenAmount?: number | undefined;
    purgeDate?: string | undefined;
    ratingLaneId?: string | undefined;
    ratingLaneOptionId?: string | undefined;
    serviceProviderId?: string | undefined;
    userDescription?: string | undefined;
}

export class TransportationOrderLineSupplementalQuantity implements ITransportationOrderLineSupplementalQuantity {
    actions?: string | undefined;
    extended?: string | undefined;
    plannedQuantity?: number | undefined;
    receivedQuantity?: number | undefined;
    shippedQuantity?: number | undefined;
    uomId!: string;

    constructor(data?: ITransportationOrderLineSupplementalQuantity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actions = _data["actions"];
            this.extended = _data["extended"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.receivedQuantity = _data["receivedQuantity"];
            this.shippedQuantity = _data["shippedQuantity"];
            this.uomId = _data["uomId"];
        }
    }

    static fromJS(data: any): TransportationOrderLineSupplementalQuantity {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationOrderLineSupplementalQuantity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actions"] = this.actions;
        data["extended"] = this.extended;
        data["plannedQuantity"] = this.plannedQuantity;
        data["receivedQuantity"] = this.receivedQuantity;
        data["shippedQuantity"] = this.shippedQuantity;
        data["uomId"] = this.uomId;
        return data;
    }
}

export interface ITransportationOrderLineSupplementalQuantity {
    actions?: string | undefined;
    extended?: string | undefined;
    plannedQuantity?: number | undefined;
    receivedQuantity?: number | undefined;
    shippedQuantity?: number | undefined;
    uomId: string;
}

export class TransportationOrderAccessorial implements ITransportationOrderAccessorial {
    accessorialId!: string;
    actions?: string | undefined;
    applyAction?: string | undefined;
    extended?: string | undefined;
    orgId?: string | undefined;

    constructor(data?: ITransportationOrderAccessorial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessorialId = _data["accessorialId"];
            this.actions = _data["actions"];
            this.applyAction = _data["applyAction"];
            this.extended = _data["extended"];
            this.orgId = _data["orgId"];
        }
    }

    static fromJS(data: any): TransportationOrderAccessorial {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationOrderAccessorial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessorialId"] = this.accessorialId;
        data["actions"] = this.actions;
        data["applyAction"] = this.applyAction;
        data["extended"] = this.extended;
        data["orgId"] = this.orgId;
        return data;
    }
}

export interface ITransportationOrderAccessorial {
    accessorialId: string;
    actions?: string | undefined;
    applyAction?: string | undefined;
    extended?: string | undefined;
    orgId?: string | undefined;
}

export class TransportationOrderContact implements ITransportationOrderContact {
    actions?: string | undefined;
    applyAction?: string | undefined;
    contactDetails?: Contact | undefined;
    contactTypeId!: string;
    extended?: string | undefined;
    orgId?: string | undefined;
    transportationOrderPk!: string;

    constructor(data?: ITransportationOrderContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actions = _data["actions"];
            this.applyAction = _data["applyAction"];
            this.contactDetails = _data["contactDetails"] ? Contact.fromJS(_data["contactDetails"]) : <any>undefined;
            this.contactTypeId = _data["contactTypeId"];
            this.extended = _data["extended"];
            this.orgId = _data["orgId"];
            this.transportationOrderPk = _data["transportationOrderPk"];
        }
    }

    static fromJS(data: any): TransportationOrderContact {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationOrderContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actions"] = this.actions;
        data["applyAction"] = this.applyAction;
        data["contactDetails"] = this.contactDetails ? this.contactDetails.toJSON() : <any>undefined;
        data["contactTypeId"] = this.contactTypeId;
        data["extended"] = this.extended;
        data["orgId"] = this.orgId;
        data["transportationOrderPk"] = this.transportationOrderPk;
        return data;
    }
}

export interface ITransportationOrderContact {
    actions?: string | undefined;
    applyAction?: string | undefined;
    contactDetails?: Contact | undefined;
    contactTypeId: string;
    extended?: string | undefined;
    orgId?: string | undefined;
    transportationOrderPk: string;
}

export class Contact implements IContact {
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    alternateEmail?: string | undefined;
    alternateFirstName?: string | undefined;
    alternateLastName?: string | undefined;
    city?: string | undefined;
    company?: string | undefined;
    country?: string | undefined;
    county?: string | undefined;
    department?: string | undefined;
    email?: string | undefined;
    fax?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobilePhone?: string | undefined;
    notes?: string | undefined;
    phone?: string | undefined;
    postalCode?: string | undefined;
    prefix?: string | undefined;
    state?: string | undefined;
    title?: string | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.alternateEmail = _data["alternateEmail"];
            this.alternateFirstName = _data["alternateFirstName"];
            this.alternateLastName = _data["alternateLastName"];
            this.city = _data["city"];
            this.company = _data["company"];
            this.country = _data["country"];
            this.county = _data["county"];
            this.department = _data["department"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobilePhone = _data["mobilePhone"];
            this.notes = _data["notes"];
            this.phone = _data["phone"];
            this.postalCode = _data["postalCode"];
            this.prefix = _data["prefix"];
            this.state = _data["state"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["alternateEmail"] = this.alternateEmail;
        data["alternateFirstName"] = this.alternateFirstName;
        data["alternateLastName"] = this.alternateLastName;
        data["city"] = this.city;
        data["company"] = this.company;
        data["country"] = this.country;
        data["county"] = this.county;
        data["department"] = this.department;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobilePhone"] = this.mobilePhone;
        data["notes"] = this.notes;
        data["phone"] = this.phone;
        data["postalCode"] = this.postalCode;
        data["prefix"] = this.prefix;
        data["state"] = this.state;
        data["title"] = this.title;
        return data;
    }
}

export interface IContact {
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    alternateEmail?: string | undefined;
    alternateFirstName?: string | undefined;
    alternateLastName?: string | undefined;
    city?: string | undefined;
    company?: string | undefined;
    country?: string | undefined;
    county?: string | undefined;
    department?: string | undefined;
    email?: string | undefined;
    fax?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobilePhone?: string | undefined;
    notes?: string | undefined;
    phone?: string | undefined;
    postalCode?: string | undefined;
    prefix?: string | undefined;
    state?: string | undefined;
    title?: string | undefined;
}

export class TransportationOrderNote implements ITransportationOrderNote {
    actions?: string | undefined;
    extended?: string | undefined;
    noteSequence!: number;
    noteValue?: string | undefined;
    noteVisibility?: string | undefined;
    orgId?: string | undefined;
    sourceId?: string | undefined;
    sourceTypeId?: string | undefined;

    constructor(data?: ITransportationOrderNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actions = _data["actions"];
            this.extended = _data["extended"];
            this.noteSequence = _data["noteSequence"];
            this.noteValue = _data["noteValue"];
            this.noteVisibility = _data["noteVisibility"];
            this.orgId = _data["orgId"];
            this.sourceId = _data["sourceId"];
            this.sourceTypeId = _data["sourceTypeId"];
        }
    }

    static fromJS(data: any): TransportationOrderNote {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationOrderNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actions"] = this.actions;
        data["extended"] = this.extended;
        data["noteSequence"] = this.noteSequence;
        data["noteValue"] = this.noteValue;
        data["noteVisibility"] = this.noteVisibility;
        data["orgId"] = this.orgId;
        data["sourceId"] = this.sourceId;
        data["sourceTypeId"] = this.sourceTypeId;
        return data;
    }
}

export interface ITransportationOrderNote {
    actions?: string | undefined;
    extended?: string | undefined;
    noteSequence: number;
    noteValue?: string | undefined;
    noteVisibility?: string | undefined;
    orgId?: string | undefined;
    sourceId?: string | undefined;
    sourceTypeId?: string | undefined;
}

export class TransportationOrderRevenue implements ITransportationOrderRevenue {
    actions?: string | undefined;
    applyAction?: string | undefined;
    chargeDefinitionId!: string;
    chargeSummary?: string | undefined;
    chargeTypeId?: string | undefined;
    contractedAmount?: number | undefined;
    contractedApproval?: boolean | undefined;
    cost!: number;
    costExpressionId?: string | undefined;
    currencyCode!: string;
    editTransportationOrderRevenueFromUI?: boolean | undefined;
    extended?: string | undefined;
    flexRateId?: string | undefined;
    orgId?: string | undefined;
    overriddenAmount?: number | undefined;
    ratingLaneId?: string | undefined;
    ratingLaneOptionId?: string | undefined;
    serviceProviderId?: string | undefined;
    userDescription?: string | undefined;

    constructor(data?: ITransportationOrderRevenue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actions = _data["actions"];
            this.applyAction = _data["applyAction"];
            this.chargeDefinitionId = _data["chargeDefinitionId"];
            this.chargeSummary = _data["chargeSummary"];
            this.chargeTypeId = _data["chargeTypeId"];
            this.contractedAmount = _data["contractedAmount"];
            this.contractedApproval = _data["contractedApproval"];
            this.cost = _data["cost"];
            this.costExpressionId = _data["costExpressionId"];
            this.currencyCode = _data["currencyCode"];
            this.editTransportationOrderRevenueFromUI = _data["editTransportationOrderRevenueFromUI"];
            this.extended = _data["extended"];
            this.flexRateId = _data["flexRateId"];
            this.orgId = _data["orgId"];
            this.overriddenAmount = _data["overriddenAmount"];
            this.ratingLaneId = _data["ratingLaneId"];
            this.ratingLaneOptionId = _data["ratingLaneOptionId"];
            this.serviceProviderId = _data["serviceProviderId"];
            this.userDescription = _data["userDescription"];
        }
    }

    static fromJS(data: any): TransportationOrderRevenue {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationOrderRevenue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actions"] = this.actions;
        data["applyAction"] = this.applyAction;
        data["chargeDefinitionId"] = this.chargeDefinitionId;
        data["chargeSummary"] = this.chargeSummary;
        data["chargeTypeId"] = this.chargeTypeId;
        data["contractedAmount"] = this.contractedAmount;
        data["contractedApproval"] = this.contractedApproval;
        data["cost"] = this.cost;
        data["costExpressionId"] = this.costExpressionId;
        data["currencyCode"] = this.currencyCode;
        data["editTransportationOrderRevenueFromUI"] = this.editTransportationOrderRevenueFromUI;
        data["extended"] = this.extended;
        data["flexRateId"] = this.flexRateId;
        data["orgId"] = this.orgId;
        data["overriddenAmount"] = this.overriddenAmount;
        data["ratingLaneId"] = this.ratingLaneId;
        data["ratingLaneOptionId"] = this.ratingLaneOptionId;
        data["serviceProviderId"] = this.serviceProviderId;
        data["userDescription"] = this.userDescription;
        return data;
    }
}

export interface ITransportationOrderRevenue {
    actions?: string | undefined;
    applyAction?: string | undefined;
    chargeDefinitionId: string;
    chargeSummary?: string | undefined;
    chargeTypeId?: string | undefined;
    contractedAmount?: number | undefined;
    contractedApproval?: boolean | undefined;
    cost: number;
    costExpressionId?: string | undefined;
    currencyCode: string;
    editTransportationOrderRevenueFromUI?: boolean | undefined;
    extended?: string | undefined;
    flexRateId?: string | undefined;
    orgId?: string | undefined;
    overriddenAmount?: number | undefined;
    ratingLaneId?: string | undefined;
    ratingLaneOptionId?: string | undefined;
    serviceProviderId?: string | undefined;
    userDescription?: string | undefined;
}

export class TransportationOrderSupplementalQuantity implements ITransportationOrderSupplementalQuantity {
    actions?: string | undefined;
    extended?: string | undefined;
    totalSize!: number;
    uomId!: string;

    constructor(data?: ITransportationOrderSupplementalQuantity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actions = _data["actions"];
            this.extended = _data["extended"];
            this.totalSize = _data["totalSize"];
            this.uomId = _data["uomId"];
        }
    }

    static fromJS(data: any): TransportationOrderSupplementalQuantity {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationOrderSupplementalQuantity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actions"] = this.actions;
        data["extended"] = this.extended;
        data["totalSize"] = this.totalSize;
        data["uomId"] = this.uomId;
        return data;
    }
}

export interface ITransportationOrderSupplementalQuantity {
    actions?: string | undefined;
    extended?: string | undefined;
    totalSize: number;
    uomId: string;
}

export class ToAdditionalAttributes implements IToAdditionalAttributes {
    actions?: string | undefined;
    extended?: string | undefined;
    actualDeliveryDateTime?: string | undefined;
    distributedCost?: number | undefined;
    distributedCurrencyCode?: string | undefined;
    incotermId?: string | undefined;
    trackingNumber?: string | undefined;
    vendorCompanyName?: string | undefined;
    collectOnDeliveryFundsId?: string | undefined;
    deliveryEstimatedTimeOfArrival?: string | undefined;
    deliveryOnTimeStatusId?: string | undefined;
    totalMonetaryValue?: number | undefined;
    totalMonetaryValueCurrencyCode?: string | undefined;
    receivedStatusId?: ToReceivedStatusIdProps | undefined;

    constructor(data?: IToAdditionalAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actions = _data["actions"];
            this.extended = _data["extended"];
            this.actualDeliveryDateTime = _data["actualDeliveryDateTime"];
            this.distributedCost = _data["distributedCost"];
            this.distributedCurrencyCode = _data["distributedCurrencyCode"];
            this.incotermId = _data["incotermId"];
            this.trackingNumber = _data["trackingNumber"];
            this.vendorCompanyName = _data["vendorCompanyName"];
            this.collectOnDeliveryFundsId = _data["collectOnDeliveryFundsId"];
            this.deliveryEstimatedTimeOfArrival = _data["deliveryEstimatedTimeOfArrival"];
            this.deliveryOnTimeStatusId = _data["deliveryOnTimeStatusId"];
            this.totalMonetaryValue = _data["totalMonetaryValue"];
            this.totalMonetaryValueCurrencyCode = _data["totalMonetaryValueCurrencyCode"];
            this.receivedStatusId = _data["receivedStatusId"] ? ToReceivedStatusIdProps.fromJS(_data["receivedStatusId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ToAdditionalAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new ToAdditionalAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actions"] = this.actions;
        data["extended"] = this.extended;
        data["actualDeliveryDateTime"] = this.actualDeliveryDateTime;
        data["distributedCost"] = this.distributedCost;
        data["distributedCurrencyCode"] = this.distributedCurrencyCode;
        data["incotermId"] = this.incotermId;
        data["trackingNumber"] = this.trackingNumber;
        data["vendorCompanyName"] = this.vendorCompanyName;
        data["collectOnDeliveryFundsId"] = this.collectOnDeliveryFundsId;
        data["deliveryEstimatedTimeOfArrival"] = this.deliveryEstimatedTimeOfArrival;
        data["deliveryOnTimeStatusId"] = this.deliveryOnTimeStatusId;
        data["totalMonetaryValue"] = this.totalMonetaryValue;
        data["totalMonetaryValueCurrencyCode"] = this.totalMonetaryValueCurrencyCode;
        data["receivedStatusId"] = this.receivedStatusId ? this.receivedStatusId.toJSON() : <any>undefined;
        return data;
    }
}

export interface IToAdditionalAttributes {
    actions?: string | undefined;
    extended?: string | undefined;
    actualDeliveryDateTime?: string | undefined;
    distributedCost?: number | undefined;
    distributedCurrencyCode?: string | undefined;
    incotermId?: string | undefined;
    trackingNumber?: string | undefined;
    vendorCompanyName?: string | undefined;
    collectOnDeliveryFundsId?: string | undefined;
    deliveryEstimatedTimeOfArrival?: string | undefined;
    deliveryOnTimeStatusId?: string | undefined;
    totalMonetaryValue?: number | undefined;
    totalMonetaryValueCurrencyCode?: string | undefined;
    receivedStatusId?: ToReceivedStatusIdProps | undefined;
}

export class ToReceivedStatusIdProps implements IToReceivedStatusIdProps {
    toReceivedStatusId?: string | undefined;

    constructor(data?: IToReceivedStatusIdProps) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toReceivedStatusId = _data["toReceivedStatusId"];
        }
    }

    static fromJS(data: any): ToReceivedStatusIdProps {
        data = typeof data === 'object' ? data : {};
        let result = new ToReceivedStatusIdProps();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toReceivedStatusId"] = this.toReceivedStatusId;
        return data;
    }
}

export interface IToReceivedStatusIdProps {
    toReceivedStatusId?: string | undefined;
}

export class LoadCarrierNoteUpdates implements ILoadCarrierNoteUpdates {
    stopNoteUpdates!: LoadCarrierNoteUpdate[];

    constructor(data?: ILoadCarrierNoteUpdates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.stopNoteUpdates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stopNoteUpdates"])) {
                this.stopNoteUpdates = [] as any;
                for (let item of _data["stopNoteUpdates"])
                    this.stopNoteUpdates!.push(LoadCarrierNoteUpdate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoadCarrierNoteUpdates {
        data = typeof data === 'object' ? data : {};
        let result = new LoadCarrierNoteUpdates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stopNoteUpdates)) {
            data["stopNoteUpdates"] = [];
            for (let item of this.stopNoteUpdates)
                data["stopNoteUpdates"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILoadCarrierNoteUpdates {
    stopNoteUpdates: LoadCarrierNoteUpdate[];
}

export class LoadCarrierNoteUpdate implements ILoadCarrierNoteUpdate {
    objectId!: number;
    updatedNote!: string;

    constructor(data?: ILoadCarrierNoteUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.updatedNote = _data["updatedNote"];
        }
    }

    static fromJS(data: any): LoadCarrierNoteUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new LoadCarrierNoteUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["updatedNote"] = this.updatedNote;
        return data;
    }
}

export interface ILoadCarrierNoteUpdate {
    objectId: number;
    updatedNote: string;
}

export class LoadRemoveOrdersUpdate implements ILoadRemoveOrdersUpdate {
    loadId!: number;
    orderIdsToRemove!: number[];

    constructor(data?: ILoadRemoveOrdersUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderIdsToRemove = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loadId = _data["loadId"];
            if (Array.isArray(_data["orderIdsToRemove"])) {
                this.orderIdsToRemove = [] as any;
                for (let item of _data["orderIdsToRemove"])
                    this.orderIdsToRemove!.push(item);
            }
        }
    }

    static fromJS(data: any): LoadRemoveOrdersUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new LoadRemoveOrdersUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loadId"] = this.loadId;
        if (Array.isArray(this.orderIdsToRemove)) {
            data["orderIdsToRemove"] = [];
            for (let item of this.orderIdsToRemove)
                data["orderIdsToRemove"].push(item);
        }
        return data;
    }
}

export interface ILoadRemoveOrdersUpdate {
    loadId: number;
    orderIdsToRemove: number[];
}

export class AddOrderToLoadPreflightResponse implements IAddOrderToLoadPreflightResponse {
    isBlocked!: boolean;
    blockingMessage?: string | undefined;
    classification!: AddOrderToLoadWorkflowClassification;
    request!: AddOrderToLoadPreflightRequest;
    orderGroupId?: number | undefined;
    affectedOrderIds!: number[];
    affectedLoadIds!: number[];
    allowedActions!: AddOrderToLoadGroupConflictResolutionType[];
    requirements!: PreflightRequirementDTO[];

    constructor(data?: IAddOrderToLoadPreflightResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.request = new AddOrderToLoadPreflightRequest();
            this.affectedOrderIds = [];
            this.affectedLoadIds = [];
            this.allowedActions = [];
            this.requirements = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isBlocked = _data["isBlocked"];
            this.blockingMessage = _data["blockingMessage"];
            this.classification = _data["classification"];
            this.request = _data["request"] ? AddOrderToLoadPreflightRequest.fromJS(_data["request"]) : new AddOrderToLoadPreflightRequest();
            this.orderGroupId = _data["orderGroupId"];
            if (Array.isArray(_data["affectedOrderIds"])) {
                this.affectedOrderIds = [] as any;
                for (let item of _data["affectedOrderIds"])
                    this.affectedOrderIds!.push(item);
            }
            if (Array.isArray(_data["affectedLoadIds"])) {
                this.affectedLoadIds = [] as any;
                for (let item of _data["affectedLoadIds"])
                    this.affectedLoadIds!.push(item);
            }
            if (Array.isArray(_data["allowedActions"])) {
                this.allowedActions = [] as any;
                for (let item of _data["allowedActions"])
                    this.allowedActions!.push(item);
            }
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements!.push(PreflightRequirementDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddOrderToLoadPreflightResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderToLoadPreflightResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBlocked"] = this.isBlocked;
        data["blockingMessage"] = this.blockingMessage;
        data["classification"] = this.classification;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["orderGroupId"] = this.orderGroupId;
        if (Array.isArray(this.affectedOrderIds)) {
            data["affectedOrderIds"] = [];
            for (let item of this.affectedOrderIds)
                data["affectedOrderIds"].push(item);
        }
        if (Array.isArray(this.affectedLoadIds)) {
            data["affectedLoadIds"] = [];
            for (let item of this.affectedLoadIds)
                data["affectedLoadIds"].push(item);
        }
        if (Array.isArray(this.allowedActions)) {
            data["allowedActions"] = [];
            for (let item of this.allowedActions)
                data["allowedActions"].push(item);
        }
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddOrderToLoadPreflightResponse {
    isBlocked: boolean;
    blockingMessage?: string | undefined;
    classification: AddOrderToLoadWorkflowClassification;
    request: AddOrderToLoadPreflightRequest;
    orderGroupId?: number | undefined;
    affectedOrderIds: number[];
    affectedLoadIds: number[];
    allowedActions: AddOrderToLoadGroupConflictResolutionType[];
    requirements: PreflightRequirementDTO[];
}

export enum AddOrderToLoadWorkflowClassification {
    None = 0,
    Blocked = 1,
    UngroupedOrNoIssue = 2,
    GroupScopeChoiceRequired = 3,
    GroupConflictPlannedBooked = 4,
    GroupConflictInTransitDelivered = 5,
}

export class AddOrderToLoadPreflightRequest implements IAddOrderToLoadPreflightRequest {
    loadId!: number;
    orderId!: number;
    locationId!: number;
    shouldAddGroup!: boolean;
    deliveryIsConsolidation!: boolean;

    constructor(data?: IAddOrderToLoadPreflightRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loadId = _data["loadId"];
            this.orderId = _data["orderId"];
            this.locationId = _data["locationId"];
            this.shouldAddGroup = _data["shouldAddGroup"];
            this.deliveryIsConsolidation = _data["deliveryIsConsolidation"];
        }
    }

    static fromJS(data: any): AddOrderToLoadPreflightRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderToLoadPreflightRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loadId"] = this.loadId;
        data["orderId"] = this.orderId;
        data["locationId"] = this.locationId;
        data["shouldAddGroup"] = this.shouldAddGroup;
        data["deliveryIsConsolidation"] = this.deliveryIsConsolidation;
        return data;
    }
}

export interface IAddOrderToLoadPreflightRequest {
    loadId: number;
    orderId: number;
    locationId: number;
    shouldAddGroup: boolean;
    deliveryIsConsolidation: boolean;
}

export enum AddOrderToLoadGroupConflictResolutionType {
    Unknown = 0,
    Cancel = 1,
    AddToLoadPreserveGroup = 2,
    AddToLoadRemoveFromGroup = 3,
}

export class PreflightRequirementDTO implements IPreflightRequirementDTO {
    requirementType!: PreflightRequirementType;
    message!: string;
    orderIds!: number[];
    loadIds!: number[];
    systemUserIds!: number[];

    constructor(data?: IPreflightRequirementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderIds = [];
            this.loadIds = [];
            this.systemUserIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirementType = _data["requirementType"];
            this.message = _data["message"];
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            if (Array.isArray(_data["loadIds"])) {
                this.loadIds = [] as any;
                for (let item of _data["loadIds"])
                    this.loadIds!.push(item);
            }
            if (Array.isArray(_data["systemUserIds"])) {
                this.systemUserIds = [] as any;
                for (let item of _data["systemUserIds"])
                    this.systemUserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PreflightRequirementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreflightRequirementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirementType"] = this.requirementType;
        data["message"] = this.message;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        if (Array.isArray(this.loadIds)) {
            data["loadIds"] = [];
            for (let item of this.loadIds)
                data["loadIds"].push(item);
        }
        if (Array.isArray(this.systemUserIds)) {
            data["systemUserIds"] = [];
            for (let item of this.systemUserIds)
                data["systemUserIds"].push(item);
        }
        return data;
    }
}

export interface IPreflightRequirementDTO {
    requirementType: PreflightRequirementType;
    message: string;
    orderIds: number[];
    loadIds: number[];
    systemUserIds: number[];
}

export enum PreflightRequirementType {
    None = 0,
    Acknowledgement = 1,
    OrderNote = 2,
    LoadBuilderNotification = 3,
}

export class AddOrderToLoadConfirmResponse implements IAddOrderToLoadConfirmResponse {
    isConfirmed!: boolean;
    rejectionMessage?: string | undefined;
    preflight!: AddOrderToLoadPreflightResponse;
    load?: LoadModel | undefined;
    validatedNoteIds!: number[];
    auditEventId?: number | undefined;

    constructor(data?: IAddOrderToLoadConfirmResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.preflight = new AddOrderToLoadPreflightResponse();
            this.validatedNoteIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isConfirmed = _data["isConfirmed"];
            this.rejectionMessage = _data["rejectionMessage"];
            this.preflight = _data["preflight"] ? AddOrderToLoadPreflightResponse.fromJS(_data["preflight"]) : new AddOrderToLoadPreflightResponse();
            this.load = _data["load"] ? LoadModel.fromJS(_data["load"]) : <any>undefined;
            if (Array.isArray(_data["validatedNoteIds"])) {
                this.validatedNoteIds = [] as any;
                for (let item of _data["validatedNoteIds"])
                    this.validatedNoteIds!.push(item);
            }
            this.auditEventId = _data["auditEventId"];
        }
    }

    static fromJS(data: any): AddOrderToLoadConfirmResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderToLoadConfirmResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isConfirmed"] = this.isConfirmed;
        data["rejectionMessage"] = this.rejectionMessage;
        data["preflight"] = this.preflight ? this.preflight.toJSON() : <any>undefined;
        data["load"] = this.load ? this.load.toJSON() : <any>undefined;
        if (Array.isArray(this.validatedNoteIds)) {
            data["validatedNoteIds"] = [];
            for (let item of this.validatedNoteIds)
                data["validatedNoteIds"].push(item);
        }
        data["auditEventId"] = this.auditEventId;
        return data;
    }
}

export interface IAddOrderToLoadConfirmResponse {
    isConfirmed: boolean;
    rejectionMessage?: string | undefined;
    preflight: AddOrderToLoadPreflightResponse;
    load?: LoadModel | undefined;
    validatedNoteIds: number[];
    auditEventId?: number | undefined;
}

export class AddOrderToLoadConfirmRequest implements IAddOrderToLoadConfirmRequest {
    loadId!: number;
    orderId!: number;
    locationId!: number;
    deliveryIsConsolidation!: boolean;
    responseType!: AddOrderToLoadUserResponseType;
    expectedClassification!: AddOrderToLoadWorkflowClassification;
    expectedOrderGroupId?: number | undefined;
    expectedAffectedOrderIds!: number[];
    expectedAffectedLoadIds!: number[];
    requiredOrderNoteIds!: number[];

    constructor(data?: IAddOrderToLoadConfirmRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.expectedAffectedOrderIds = [];
            this.expectedAffectedLoadIds = [];
            this.requiredOrderNoteIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loadId = _data["loadId"];
            this.orderId = _data["orderId"];
            this.locationId = _data["locationId"];
            this.deliveryIsConsolidation = _data["deliveryIsConsolidation"];
            this.responseType = _data["responseType"];
            this.expectedClassification = _data["expectedClassification"];
            this.expectedOrderGroupId = _data["expectedOrderGroupId"];
            if (Array.isArray(_data["expectedAffectedOrderIds"])) {
                this.expectedAffectedOrderIds = [] as any;
                for (let item of _data["expectedAffectedOrderIds"])
                    this.expectedAffectedOrderIds!.push(item);
            }
            if (Array.isArray(_data["expectedAffectedLoadIds"])) {
                this.expectedAffectedLoadIds = [] as any;
                for (let item of _data["expectedAffectedLoadIds"])
                    this.expectedAffectedLoadIds!.push(item);
            }
            if (Array.isArray(_data["requiredOrderNoteIds"])) {
                this.requiredOrderNoteIds = [] as any;
                for (let item of _data["requiredOrderNoteIds"])
                    this.requiredOrderNoteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddOrderToLoadConfirmRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderToLoadConfirmRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loadId"] = this.loadId;
        data["orderId"] = this.orderId;
        data["locationId"] = this.locationId;
        data["deliveryIsConsolidation"] = this.deliveryIsConsolidation;
        data["responseType"] = this.responseType;
        data["expectedClassification"] = this.expectedClassification;
        data["expectedOrderGroupId"] = this.expectedOrderGroupId;
        if (Array.isArray(this.expectedAffectedOrderIds)) {
            data["expectedAffectedOrderIds"] = [];
            for (let item of this.expectedAffectedOrderIds)
                data["expectedAffectedOrderIds"].push(item);
        }
        if (Array.isArray(this.expectedAffectedLoadIds)) {
            data["expectedAffectedLoadIds"] = [];
            for (let item of this.expectedAffectedLoadIds)
                data["expectedAffectedLoadIds"].push(item);
        }
        if (Array.isArray(this.requiredOrderNoteIds)) {
            data["requiredOrderNoteIds"] = [];
            for (let item of this.requiredOrderNoteIds)
                data["requiredOrderNoteIds"].push(item);
        }
        return data;
    }
}

export interface IAddOrderToLoadConfirmRequest {
    loadId: number;
    orderId: number;
    locationId: number;
    deliveryIsConsolidation: boolean;
    responseType: AddOrderToLoadUserResponseType;
    expectedClassification: AddOrderToLoadWorkflowClassification;
    expectedOrderGroupId?: number | undefined;
    expectedAffectedOrderIds: number[];
    expectedAffectedLoadIds: number[];
    requiredOrderNoteIds: number[];
}

export enum AddOrderToLoadUserResponseType {
    Unknown = 0,
    Cancel = 1,
    AddSelectedOrderPreserveGroup = 2,
    AddAllOrdersInGroupPreserveGroup = 3,
    AddSelectedOrderRemoveFromGroup = 4,
}

export class LocationMergeInfoDTO implements ILocationMergeInfoDTO {
    locationsToMerge!: LocationModel[];
    locationIdToConnectedOrderIds!: { [key: string]: number[]; };
    locationIdToConnectedLoadIds!: { [key: string]: number[]; };
    locationIdToConnectedNoteIds!: { [key: string]: number[]; };
    locationIdToConnectedContactIds!: { [key: string]: number[]; };

    constructor(data?: ILocationMergeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.locationsToMerge = [];
            this.locationIdToConnectedOrderIds = {};
            this.locationIdToConnectedLoadIds = {};
            this.locationIdToConnectedNoteIds = {};
            this.locationIdToConnectedContactIds = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locationsToMerge"])) {
                this.locationsToMerge = [] as any;
                for (let item of _data["locationsToMerge"])
                    this.locationsToMerge!.push(LocationModel.fromJS(item));
            }
            if (_data["locationIdToConnectedOrderIds"]) {
                this.locationIdToConnectedOrderIds = {} as any;
                for (let key in _data["locationIdToConnectedOrderIds"]) {
                    if (_data["locationIdToConnectedOrderIds"].hasOwnProperty(key))
                        (<any>this.locationIdToConnectedOrderIds)![key] = _data["locationIdToConnectedOrderIds"][key] !== undefined ? _data["locationIdToConnectedOrderIds"][key] : [];
                }
            }
            if (_data["locationIdToConnectedLoadIds"]) {
                this.locationIdToConnectedLoadIds = {} as any;
                for (let key in _data["locationIdToConnectedLoadIds"]) {
                    if (_data["locationIdToConnectedLoadIds"].hasOwnProperty(key))
                        (<any>this.locationIdToConnectedLoadIds)![key] = _data["locationIdToConnectedLoadIds"][key] !== undefined ? _data["locationIdToConnectedLoadIds"][key] : [];
                }
            }
            if (_data["locationIdToConnectedNoteIds"]) {
                this.locationIdToConnectedNoteIds = {} as any;
                for (let key in _data["locationIdToConnectedNoteIds"]) {
                    if (_data["locationIdToConnectedNoteIds"].hasOwnProperty(key))
                        (<any>this.locationIdToConnectedNoteIds)![key] = _data["locationIdToConnectedNoteIds"][key] !== undefined ? _data["locationIdToConnectedNoteIds"][key] : [];
                }
            }
            if (_data["locationIdToConnectedContactIds"]) {
                this.locationIdToConnectedContactIds = {} as any;
                for (let key in _data["locationIdToConnectedContactIds"]) {
                    if (_data["locationIdToConnectedContactIds"].hasOwnProperty(key))
                        (<any>this.locationIdToConnectedContactIds)![key] = _data["locationIdToConnectedContactIds"][key] !== undefined ? _data["locationIdToConnectedContactIds"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): LocationMergeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationMergeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locationsToMerge)) {
            data["locationsToMerge"] = [];
            for (let item of this.locationsToMerge)
                data["locationsToMerge"].push(item.toJSON());
        }
        if (this.locationIdToConnectedOrderIds) {
            data["locationIdToConnectedOrderIds"] = {};
            for (let key in this.locationIdToConnectedOrderIds) {
                if (this.locationIdToConnectedOrderIds.hasOwnProperty(key))
                    (<any>data["locationIdToConnectedOrderIds"])[key] = (<any>this.locationIdToConnectedOrderIds)[key];
            }
        }
        if (this.locationIdToConnectedLoadIds) {
            data["locationIdToConnectedLoadIds"] = {};
            for (let key in this.locationIdToConnectedLoadIds) {
                if (this.locationIdToConnectedLoadIds.hasOwnProperty(key))
                    (<any>data["locationIdToConnectedLoadIds"])[key] = (<any>this.locationIdToConnectedLoadIds)[key];
            }
        }
        if (this.locationIdToConnectedNoteIds) {
            data["locationIdToConnectedNoteIds"] = {};
            for (let key in this.locationIdToConnectedNoteIds) {
                if (this.locationIdToConnectedNoteIds.hasOwnProperty(key))
                    (<any>data["locationIdToConnectedNoteIds"])[key] = (<any>this.locationIdToConnectedNoteIds)[key];
            }
        }
        if (this.locationIdToConnectedContactIds) {
            data["locationIdToConnectedContactIds"] = {};
            for (let key in this.locationIdToConnectedContactIds) {
                if (this.locationIdToConnectedContactIds.hasOwnProperty(key))
                    (<any>data["locationIdToConnectedContactIds"])[key] = (<any>this.locationIdToConnectedContactIds)[key];
            }
        }
        return data;
    }
}

export interface ILocationMergeInfoDTO {
    locationsToMerge: LocationModel[];
    locationIdToConnectedOrderIds: { [key: string]: number[]; };
    locationIdToConnectedLoadIds: { [key: string]: number[]; };
    locationIdToConnectedNoteIds: { [key: string]: number[]; };
    locationIdToConnectedContactIds: { [key: string]: number[]; };
}

export class OrderCustomerMergeInfoDTO implements IOrderCustomerMergeInfoDTO {
    orderCustomersToMerge!: OrderCustomerModel[];
    orderCustomerIdToConnectedOrderIds!: { [key: string]: number[]; };
    orderCustomerIdToConnectedLocationIds!: { [key: string]: number[]; };
    orderCustomerIdToConnectedContactIds!: { [key: string]: number[]; };
    orderCustomerIdToConnectedNoteIds!: { [key: string]: number[]; };
    orderCustomerIdToConnectedFileIds!: { [key: string]: number[]; };
    orderCustomerIdToConnectedSystemCustomerIds!: { [key: string]: number[]; };

    constructor(data?: IOrderCustomerMergeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderCustomersToMerge = [];
            this.orderCustomerIdToConnectedOrderIds = {};
            this.orderCustomerIdToConnectedLocationIds = {};
            this.orderCustomerIdToConnectedContactIds = {};
            this.orderCustomerIdToConnectedNoteIds = {};
            this.orderCustomerIdToConnectedFileIds = {};
            this.orderCustomerIdToConnectedSystemCustomerIds = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderCustomersToMerge"])) {
                this.orderCustomersToMerge = [] as any;
                for (let item of _data["orderCustomersToMerge"])
                    this.orderCustomersToMerge!.push(OrderCustomerModel.fromJS(item));
            }
            if (_data["orderCustomerIdToConnectedOrderIds"]) {
                this.orderCustomerIdToConnectedOrderIds = {} as any;
                for (let key in _data["orderCustomerIdToConnectedOrderIds"]) {
                    if (_data["orderCustomerIdToConnectedOrderIds"].hasOwnProperty(key))
                        (<any>this.orderCustomerIdToConnectedOrderIds)![key] = _data["orderCustomerIdToConnectedOrderIds"][key] !== undefined ? _data["orderCustomerIdToConnectedOrderIds"][key] : [];
                }
            }
            if (_data["orderCustomerIdToConnectedLocationIds"]) {
                this.orderCustomerIdToConnectedLocationIds = {} as any;
                for (let key in _data["orderCustomerIdToConnectedLocationIds"]) {
                    if (_data["orderCustomerIdToConnectedLocationIds"].hasOwnProperty(key))
                        (<any>this.orderCustomerIdToConnectedLocationIds)![key] = _data["orderCustomerIdToConnectedLocationIds"][key] !== undefined ? _data["orderCustomerIdToConnectedLocationIds"][key] : [];
                }
            }
            if (_data["orderCustomerIdToConnectedContactIds"]) {
                this.orderCustomerIdToConnectedContactIds = {} as any;
                for (let key in _data["orderCustomerIdToConnectedContactIds"]) {
                    if (_data["orderCustomerIdToConnectedContactIds"].hasOwnProperty(key))
                        (<any>this.orderCustomerIdToConnectedContactIds)![key] = _data["orderCustomerIdToConnectedContactIds"][key] !== undefined ? _data["orderCustomerIdToConnectedContactIds"][key] : [];
                }
            }
            if (_data["orderCustomerIdToConnectedNoteIds"]) {
                this.orderCustomerIdToConnectedNoteIds = {} as any;
                for (let key in _data["orderCustomerIdToConnectedNoteIds"]) {
                    if (_data["orderCustomerIdToConnectedNoteIds"].hasOwnProperty(key))
                        (<any>this.orderCustomerIdToConnectedNoteIds)![key] = _data["orderCustomerIdToConnectedNoteIds"][key] !== undefined ? _data["orderCustomerIdToConnectedNoteIds"][key] : [];
                }
            }
            if (_data["orderCustomerIdToConnectedFileIds"]) {
                this.orderCustomerIdToConnectedFileIds = {} as any;
                for (let key in _data["orderCustomerIdToConnectedFileIds"]) {
                    if (_data["orderCustomerIdToConnectedFileIds"].hasOwnProperty(key))
                        (<any>this.orderCustomerIdToConnectedFileIds)![key] = _data["orderCustomerIdToConnectedFileIds"][key] !== undefined ? _data["orderCustomerIdToConnectedFileIds"][key] : [];
                }
            }
            if (_data["orderCustomerIdToConnectedSystemCustomerIds"]) {
                this.orderCustomerIdToConnectedSystemCustomerIds = {} as any;
                for (let key in _data["orderCustomerIdToConnectedSystemCustomerIds"]) {
                    if (_data["orderCustomerIdToConnectedSystemCustomerIds"].hasOwnProperty(key))
                        (<any>this.orderCustomerIdToConnectedSystemCustomerIds)![key] = _data["orderCustomerIdToConnectedSystemCustomerIds"][key] !== undefined ? _data["orderCustomerIdToConnectedSystemCustomerIds"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): OrderCustomerMergeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomerMergeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderCustomersToMerge)) {
            data["orderCustomersToMerge"] = [];
            for (let item of this.orderCustomersToMerge)
                data["orderCustomersToMerge"].push(item.toJSON());
        }
        if (this.orderCustomerIdToConnectedOrderIds) {
            data["orderCustomerIdToConnectedOrderIds"] = {};
            for (let key in this.orderCustomerIdToConnectedOrderIds) {
                if (this.orderCustomerIdToConnectedOrderIds.hasOwnProperty(key))
                    (<any>data["orderCustomerIdToConnectedOrderIds"])[key] = (<any>this.orderCustomerIdToConnectedOrderIds)[key];
            }
        }
        if (this.orderCustomerIdToConnectedLocationIds) {
            data["orderCustomerIdToConnectedLocationIds"] = {};
            for (let key in this.orderCustomerIdToConnectedLocationIds) {
                if (this.orderCustomerIdToConnectedLocationIds.hasOwnProperty(key))
                    (<any>data["orderCustomerIdToConnectedLocationIds"])[key] = (<any>this.orderCustomerIdToConnectedLocationIds)[key];
            }
        }
        if (this.orderCustomerIdToConnectedContactIds) {
            data["orderCustomerIdToConnectedContactIds"] = {};
            for (let key in this.orderCustomerIdToConnectedContactIds) {
                if (this.orderCustomerIdToConnectedContactIds.hasOwnProperty(key))
                    (<any>data["orderCustomerIdToConnectedContactIds"])[key] = (<any>this.orderCustomerIdToConnectedContactIds)[key];
            }
        }
        if (this.orderCustomerIdToConnectedNoteIds) {
            data["orderCustomerIdToConnectedNoteIds"] = {};
            for (let key in this.orderCustomerIdToConnectedNoteIds) {
                if (this.orderCustomerIdToConnectedNoteIds.hasOwnProperty(key))
                    (<any>data["orderCustomerIdToConnectedNoteIds"])[key] = (<any>this.orderCustomerIdToConnectedNoteIds)[key];
            }
        }
        if (this.orderCustomerIdToConnectedFileIds) {
            data["orderCustomerIdToConnectedFileIds"] = {};
            for (let key in this.orderCustomerIdToConnectedFileIds) {
                if (this.orderCustomerIdToConnectedFileIds.hasOwnProperty(key))
                    (<any>data["orderCustomerIdToConnectedFileIds"])[key] = (<any>this.orderCustomerIdToConnectedFileIds)[key];
            }
        }
        if (this.orderCustomerIdToConnectedSystemCustomerIds) {
            data["orderCustomerIdToConnectedSystemCustomerIds"] = {};
            for (let key in this.orderCustomerIdToConnectedSystemCustomerIds) {
                if (this.orderCustomerIdToConnectedSystemCustomerIds.hasOwnProperty(key))
                    (<any>data["orderCustomerIdToConnectedSystemCustomerIds"])[key] = (<any>this.orderCustomerIdToConnectedSystemCustomerIds)[key];
            }
        }
        return data;
    }
}

export interface IOrderCustomerMergeInfoDTO {
    orderCustomersToMerge: OrderCustomerModel[];
    orderCustomerIdToConnectedOrderIds: { [key: string]: number[]; };
    orderCustomerIdToConnectedLocationIds: { [key: string]: number[]; };
    orderCustomerIdToConnectedContactIds: { [key: string]: number[]; };
    orderCustomerIdToConnectedNoteIds: { [key: string]: number[]; };
    orderCustomerIdToConnectedFileIds: { [key: string]: number[]; };
    orderCustomerIdToConnectedSystemCustomerIds: { [key: string]: number[]; };
}

export class OrderGroupingPreflightResponse implements IOrderGroupingPreflightResponse {
    isBlocked!: boolean;
    blockingMessage?: string | undefined;
    operationType!: OrderGroupingOperationType;
    targetOrderGroupId?: number | undefined;
    messages!: string[];
    orderIds!: number[];
    existingOrderGroupIds!: number[];
    requirements!: PreflightRequirementDTO[];

    constructor(data?: IOrderGroupingPreflightResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = [];
            this.orderIds = [];
            this.existingOrderGroupIds = [];
            this.requirements = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isBlocked = _data["isBlocked"];
            this.blockingMessage = _data["blockingMessage"];
            this.operationType = _data["operationType"];
            this.targetOrderGroupId = _data["targetOrderGroupId"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            if (Array.isArray(_data["existingOrderGroupIds"])) {
                this.existingOrderGroupIds = [] as any;
                for (let item of _data["existingOrderGroupIds"])
                    this.existingOrderGroupIds!.push(item);
            }
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements!.push(PreflightRequirementDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderGroupingPreflightResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGroupingPreflightResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBlocked"] = this.isBlocked;
        data["blockingMessage"] = this.blockingMessage;
        data["operationType"] = this.operationType;
        data["targetOrderGroupId"] = this.targetOrderGroupId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        if (Array.isArray(this.existingOrderGroupIds)) {
            data["existingOrderGroupIds"] = [];
            for (let item of this.existingOrderGroupIds)
                data["existingOrderGroupIds"].push(item);
        }
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderGroupingPreflightResponse {
    isBlocked: boolean;
    blockingMessage?: string | undefined;
    operationType: OrderGroupingOperationType;
    targetOrderGroupId?: number | undefined;
    messages: string[];
    orderIds: number[];
    existingOrderGroupIds: number[];
    requirements: PreflightRequirementDTO[];
}

export enum OrderGroupingOperationType {
    Unknown = 0,
    Auto = 1,
    CreateGroup = 2,
    AddToExistingGroup = 3,
    MultipleGroupMergeUnsupported = 4,
}

export class OrderGroupingPreflightRequest implements IOrderGroupingPreflightRequest {
    orderIds!: number[];
    targetOrderGroupId?: number | undefined;
    operationType!: OrderGroupingOperationType;

    constructor(data?: IOrderGroupingPreflightRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            this.targetOrderGroupId = _data["targetOrderGroupId"];
            this.operationType = _data["operationType"];
        }
    }

    static fromJS(data: any): OrderGroupingPreflightRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGroupingPreflightRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["targetOrderGroupId"] = this.targetOrderGroupId;
        data["operationType"] = this.operationType;
        return data;
    }
}

export interface IOrderGroupingPreflightRequest {
    orderIds: number[];
    targetOrderGroupId?: number | undefined;
    operationType: OrderGroupingOperationType;
}

export class OrderGroupingConfirmResponse implements IOrderGroupingConfirmResponse {
    preflight!: OrderGroupingPreflightResponse;
    isConfirmed!: boolean;
    rejectionMessage?: string | undefined;
    orderGroupId?: number | undefined;
    orderIds!: number[];
    validatedNoteIds!: number[];
    auditEventId?: number | undefined;
    userNotificationIds!: number[];

    constructor(data?: IOrderGroupingConfirmResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.preflight = new OrderGroupingPreflightResponse();
            this.orderIds = [];
            this.validatedNoteIds = [];
            this.userNotificationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preflight = _data["preflight"] ? OrderGroupingPreflightResponse.fromJS(_data["preflight"]) : new OrderGroupingPreflightResponse();
            this.isConfirmed = _data["isConfirmed"];
            this.rejectionMessage = _data["rejectionMessage"];
            this.orderGroupId = _data["orderGroupId"];
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            if (Array.isArray(_data["validatedNoteIds"])) {
                this.validatedNoteIds = [] as any;
                for (let item of _data["validatedNoteIds"])
                    this.validatedNoteIds!.push(item);
            }
            this.auditEventId = _data["auditEventId"];
            if (Array.isArray(_data["userNotificationIds"])) {
                this.userNotificationIds = [] as any;
                for (let item of _data["userNotificationIds"])
                    this.userNotificationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): OrderGroupingConfirmResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGroupingConfirmResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preflight"] = this.preflight ? this.preflight.toJSON() : <any>undefined;
        data["isConfirmed"] = this.isConfirmed;
        data["rejectionMessage"] = this.rejectionMessage;
        data["orderGroupId"] = this.orderGroupId;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        if (Array.isArray(this.validatedNoteIds)) {
            data["validatedNoteIds"] = [];
            for (let item of this.validatedNoteIds)
                data["validatedNoteIds"].push(item);
        }
        data["auditEventId"] = this.auditEventId;
        if (Array.isArray(this.userNotificationIds)) {
            data["userNotificationIds"] = [];
            for (let item of this.userNotificationIds)
                data["userNotificationIds"].push(item);
        }
        return data;
    }
}

export interface IOrderGroupingConfirmResponse {
    preflight: OrderGroupingPreflightResponse;
    isConfirmed: boolean;
    rejectionMessage?: string | undefined;
    orderGroupId?: number | undefined;
    orderIds: number[];
    validatedNoteIds: number[];
    auditEventId?: number | undefined;
    userNotificationIds: number[];
}

export class OrderGroupingConfirmRequest implements IOrderGroupingConfirmRequest {
    groupingRequest!: OrderGroupingPreflightRequest;
    selectedAction!: OrderGroupingOperationType;
    acknowledged!: boolean;
    requiredOrderNoteIds!: number[];

    constructor(data?: IOrderGroupingConfirmRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groupingRequest = new OrderGroupingPreflightRequest();
            this.requiredOrderNoteIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupingRequest = _data["groupingRequest"] ? OrderGroupingPreflightRequest.fromJS(_data["groupingRequest"]) : new OrderGroupingPreflightRequest();
            this.selectedAction = _data["selectedAction"];
            this.acknowledged = _data["acknowledged"];
            if (Array.isArray(_data["requiredOrderNoteIds"])) {
                this.requiredOrderNoteIds = [] as any;
                for (let item of _data["requiredOrderNoteIds"])
                    this.requiredOrderNoteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): OrderGroupingConfirmRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGroupingConfirmRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupingRequest"] = this.groupingRequest ? this.groupingRequest.toJSON() : <any>undefined;
        data["selectedAction"] = this.selectedAction;
        data["acknowledged"] = this.acknowledged;
        if (Array.isArray(this.requiredOrderNoteIds)) {
            data["requiredOrderNoteIds"] = [];
            for (let item of this.requiredOrderNoteIds)
                data["requiredOrderNoteIds"].push(item);
        }
        return data;
    }
}

export interface IOrderGroupingConfirmRequest {
    groupingRequest: OrderGroupingPreflightRequest;
    selectedAction: OrderGroupingOperationType;
    acknowledged: boolean;
    requiredOrderNoteIds: number[];
}

export abstract class CriticalFinalizerObject implements ICriticalFinalizerObject {

    constructor(data?: ICriticalFinalizerObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CriticalFinalizerObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CriticalFinalizerObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICriticalFinalizerObject {
}

export abstract class SafeHandle extends CriticalFinalizerObject implements ISafeHandle {
    isClosed!: boolean;
    isInvalid!: boolean;

    constructor(data?: ISafeHandle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isClosed = _data["isClosed"];
            this.isInvalid = _data["isInvalid"];
        }
    }

    static override fromJS(data: any): SafeHandle {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SafeHandle' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isClosed"] = this.isClosed;
        data["isInvalid"] = this.isInvalid;
        super.toJSON(data);
        return data;
    }
}

export interface ISafeHandle extends ICriticalFinalizerObject {
    isClosed: boolean;
    isInvalid: boolean;
}

export abstract class SafeHandleZeroOrMinusOneIsInvalid extends SafeHandle implements ISafeHandleZeroOrMinusOneIsInvalid {
    isInvalid!: boolean;

    constructor(data?: ISafeHandleZeroOrMinusOneIsInvalid) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isInvalid = _data["isInvalid"];
        }
    }

    static override fromJS(data: any): SafeHandleZeroOrMinusOneIsInvalid {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SafeHandleZeroOrMinusOneIsInvalid' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInvalid"] = this.isInvalid;
        super.toJSON(data);
        return data;
    }
}

export interface ISafeHandleZeroOrMinusOneIsInvalid extends ISafeHandle {
    isInvalid: boolean;
}

export class SafeFileHandle extends SafeHandleZeroOrMinusOneIsInvalid implements ISafeFileHandle {
    path?: string | undefined;
    disableFileLocking!: boolean;
    isAsync!: boolean;
    canSeek!: boolean;
    supportsRandomAccess!: boolean;
    threadPoolBinding?: ThreadPoolBoundHandle | undefined;
    isInvalid!: boolean;

    constructor(data?: ISafeFileHandle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.path = _data["path"];
            this.disableFileLocking = _data["disableFileLocking"];
            this.isAsync = _data["isAsync"];
            this.canSeek = _data["canSeek"];
            this.supportsRandomAccess = _data["supportsRandomAccess"];
            this.threadPoolBinding = _data["threadPoolBinding"] ? ThreadPoolBoundHandle.fromJS(_data["threadPoolBinding"]) : <any>undefined;
            this.isInvalid = _data["isInvalid"];
        }
    }

    static override fromJS(data: any): SafeFileHandle {
        data = typeof data === 'object' ? data : {};
        let result = new SafeFileHandle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["disableFileLocking"] = this.disableFileLocking;
        data["isAsync"] = this.isAsync;
        data["canSeek"] = this.canSeek;
        data["supportsRandomAccess"] = this.supportsRandomAccess;
        data["threadPoolBinding"] = this.threadPoolBinding ? this.threadPoolBinding.toJSON() : <any>undefined;
        data["isInvalid"] = this.isInvalid;
        super.toJSON(data);
        return data;
    }
}

export interface ISafeFileHandle extends ISafeHandleZeroOrMinusOneIsInvalid {
    path?: string | undefined;
    disableFileLocking: boolean;
    isAsync: boolean;
    canSeek: boolean;
    supportsRandomAccess: boolean;
    threadPoolBinding?: ThreadPoolBoundHandle | undefined;
    isInvalid: boolean;
}

export class ThreadPoolBoundHandle implements IThreadPoolBoundHandle {
    handle!: SafeHandle;

    constructor(data?: IThreadPoolBoundHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handle = _data["handle"] ? SafeHandle.fromJS(_data["handle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThreadPoolBoundHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ThreadPoolBoundHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handle"] = this.handle ? this.handle.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThreadPoolBoundHandle {
    handle: SafeHandle;
}

export abstract class MarshalByRefObject implements IMarshalByRefObject {

    constructor(data?: IMarshalByRefObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MarshalByRefObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MarshalByRefObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMarshalByRefObject {
}

export abstract class Stream extends MarshalByRefObject implements IStream {
    canRead!: boolean;
    canWrite!: boolean;
    canSeek!: boolean;
    canTimeout!: boolean;
    length!: number;
    position!: number;
    readTimeout!: number;
    writeTimeout!: number;

    constructor(data?: IStream) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canRead = _data["canRead"];
            this.canWrite = _data["canWrite"];
            this.canSeek = _data["canSeek"];
            this.canTimeout = _data["canTimeout"];
            this.length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static override fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Stream' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        super.toJSON(data);
        return data;
    }
}

export interface IStream extends IMarshalByRefObject {
    canRead: boolean;
    canWrite: boolean;
    canSeek: boolean;
    canTimeout: boolean;
    length: number;
    position: number;
    readTimeout: number;
    writeTimeout: number;
}

export class OrderAvailabilityReportInputDTO implements IOrderAvailabilityReportInputDTO {
    locationId!: number;
    scheduleAppointment?: boolean | undefined;
    appointmentDate?: Date | undefined;
    appointmentTime?: string | undefined;
    contactName?: string | undefined;
    fax?: string | undefined;

    constructor(data?: IOrderAvailabilityReportInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.scheduleAppointment = _data["scheduleAppointment"];
            this.appointmentDate = _data["appointmentDate"] ? new Date(_data["appointmentDate"].toString()) : <any>undefined;
            this.appointmentTime = _data["appointmentTime"];
            this.contactName = _data["contactName"];
            this.fax = _data["fax"];
        }
    }

    static fromJS(data: any): OrderAvailabilityReportInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderAvailabilityReportInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["scheduleAppointment"] = this.scheduleAppointment;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["appointmentTime"] = this.appointmentTime;
        data["contactName"] = this.contactName;
        data["fax"] = this.fax;
        return data;
    }
}

export interface IOrderAvailabilityReportInputDTO {
    locationId: number;
    scheduleAppointment?: boolean | undefined;
    appointmentDate?: Date | undefined;
    appointmentTime?: string | undefined;
    contactName?: string | undefined;
    fax?: string | undefined;
}

export class OrderStatusReportInputDTO implements IOrderStatusReportInputDTO {
    orderCustomerId?: number | undefined;
    startDate!: Date;
    endDate?: Date | undefined;
    orderType?: OrderStatusReportTypeEnum | undefined;

    constructor(data?: IOrderStatusReportInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCustomerId = _data["orderCustomerId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.orderType = _data["orderType"];
        }
    }

    static fromJS(data: any): OrderStatusReportInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusReportInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCustomerId"] = this.orderCustomerId;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["orderType"] = this.orderType;
        return data;
    }
}

export interface IOrderStatusReportInputDTO {
    orderCustomerId?: number | undefined;
    startDate: Date;
    endDate?: Date | undefined;
    orderType?: OrderStatusReportTypeEnum | undefined;
}

export enum OrderStatusReportTypeEnum {
    Current = 1,
    Delivered = 2,
    Cancelled = 3,
    All = 4,
}

export class CdtfaReportInputDTO implements ICdtfaReportInputDTO {
    month?: number | undefined;
    year?: number | undefined;

    constructor(data?: ICdtfaReportInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): CdtfaReportInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CdtfaReportInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface ICdtfaReportInputDTO {
    month?: number | undefined;
    year?: number | undefined;
}

export class ReportSubscriptionModel extends BasePagedModel implements IReportSubscriptionModel {
    tableName!: string;
    systemCustomer?: SystemCustomerModel | undefined;
    reportSubscriptionId!: number;
    systemCustomerId?: number | undefined;
    customEmail?: string | undefined;
    orderCustomerId?: number | undefined;
    isOnSunday!: boolean;
    isOnMonday!: boolean;
    isOnTuesday!: boolean;
    isOnWednesday!: boolean;
    isOnThursday!: boolean;
    isOnFriday!: boolean;
    isOnSaturday!: boolean;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: IReportSubscriptionModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.systemCustomer = _data["systemCustomer"] ? SystemCustomerModel.fromJS(_data["systemCustomer"]) : <any>undefined;
            this.reportSubscriptionId = _data["reportSubscriptionId"];
            this.systemCustomerId = _data["systemCustomerId"];
            this.customEmail = _data["customEmail"];
            this.orderCustomerId = _data["orderCustomerId"];
            this.isOnSunday = _data["isOnSunday"];
            this.isOnMonday = _data["isOnMonday"];
            this.isOnTuesday = _data["isOnTuesday"];
            this.isOnWednesday = _data["isOnWednesday"];
            this.isOnThursday = _data["isOnThursday"];
            this.isOnFriday = _data["isOnFriday"];
            this.isOnSaturday = _data["isOnSaturday"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ReportSubscriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSubscriptionModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["systemCustomer"] = this.systemCustomer ? this.systemCustomer.toJSON() : <any>undefined;
        data["reportSubscriptionId"] = this.reportSubscriptionId;
        data["systemCustomerId"] = this.systemCustomerId;
        data["customEmail"] = this.customEmail;
        data["orderCustomerId"] = this.orderCustomerId;
        data["isOnSunday"] = this.isOnSunday;
        data["isOnMonday"] = this.isOnMonday;
        data["isOnTuesday"] = this.isOnTuesday;
        data["isOnWednesday"] = this.isOnWednesday;
        data["isOnThursday"] = this.isOnThursday;
        data["isOnFriday"] = this.isOnFriday;
        data["isOnSaturday"] = this.isOnSaturday;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IReportSubscriptionModel extends IBasePagedModel {
    tableName: string;
    systemCustomer?: SystemCustomerModel | undefined;
    reportSubscriptionId: number;
    systemCustomerId?: number | undefined;
    customEmail?: string | undefined;
    orderCustomerId?: number | undefined;
    isOnSunday: boolean;
    isOnMonday: boolean;
    isOnTuesday: boolean;
    isOnWednesday: boolean;
    isOnThursday: boolean;
    isOnFriday: boolean;
    isOnSaturday: boolean;
    dateAdded: Date;
    dateModified: Date;
}

export class UserNotificationViewDTO implements IUserNotificationViewDTO {
    userNotificationId!: number;
    userNotificationRecipientId!: number;
    userNotificationType!: UserNotificationType;
    title!: string;
    message!: string;
    auditEventId!: number;
    createdByUserName!: string;
    dateAdded!: Date;
    loadIds!: number[];
    orderIds!: number[];
    orderGroupId?: number | undefined;
    dateAcknowledged?: Date | undefined;

    constructor(data?: IUserNotificationViewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.loadIds = [];
            this.orderIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNotificationId = _data["userNotificationId"];
            this.userNotificationRecipientId = _data["userNotificationRecipientId"];
            this.userNotificationType = _data["userNotificationType"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.auditEventId = _data["auditEventId"];
            this.createdByUserName = _data["createdByUserName"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            if (Array.isArray(_data["loadIds"])) {
                this.loadIds = [] as any;
                for (let item of _data["loadIds"])
                    this.loadIds!.push(item);
            }
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            this.orderGroupId = _data["orderGroupId"];
            this.dateAcknowledged = _data["dateAcknowledged"] ? new Date(_data["dateAcknowledged"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserNotificationViewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationViewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNotificationId"] = this.userNotificationId;
        data["userNotificationRecipientId"] = this.userNotificationRecipientId;
        data["userNotificationType"] = this.userNotificationType;
        data["title"] = this.title;
        data["message"] = this.message;
        data["auditEventId"] = this.auditEventId;
        data["createdByUserName"] = this.createdByUserName;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        if (Array.isArray(this.loadIds)) {
            data["loadIds"] = [];
            for (let item of this.loadIds)
                data["loadIds"].push(item);
        }
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["orderGroupId"] = this.orderGroupId;
        data["dateAcknowledged"] = this.dateAcknowledged ? this.dateAcknowledged.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserNotificationViewDTO {
    userNotificationId: number;
    userNotificationRecipientId: number;
    userNotificationType: UserNotificationType;
    title: string;
    message: string;
    auditEventId: number;
    createdByUserName: string;
    dateAdded: Date;
    loadIds: number[];
    orderIds: number[];
    orderGroupId?: number | undefined;
    dateAcknowledged?: Date | undefined;
}

export class LoginDTO implements ILoginDTO {
    admin?: SystemAdminModel | undefined;
    customerLogin?: SystemCustomerModel | undefined;
    employee?: SystemEmployeeModel | undefined;
    scanToPick?: SystemScanToPickModel | undefined;

    constructor(data?: ILoginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.admin = _data["admin"] ? SystemAdminModel.fromJS(_data["admin"]) : <any>undefined;
            this.customerLogin = _data["customerLogin"] ? SystemCustomerModel.fromJS(_data["customerLogin"]) : <any>undefined;
            this.employee = _data["employee"] ? SystemEmployeeModel.fromJS(_data["employee"]) : <any>undefined;
            this.scanToPick = _data["scanToPick"] ? SystemScanToPickModel.fromJS(_data["scanToPick"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LoginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["admin"] = this.admin ? this.admin.toJSON() : <any>undefined;
        data["customerLogin"] = this.customerLogin ? this.customerLogin.toJSON() : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["scanToPick"] = this.scanToPick ? this.scanToPick.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginDTO {
    admin?: SystemAdminModel | undefined;
    customerLogin?: SystemCustomerModel | undefined;
    employee?: SystemEmployeeModel | undefined;
    scanToPick?: SystemScanToPickModel | undefined;
}

export class SystemUserRequestModel extends BasePagedModel implements ISystemUserRequestModel {
    tableName!: string;
    systemUserRequestId!: number;
    emailAddress!: string;
    firstName?: string | undefined;
    lastname?: string | undefined;
    companyName!: string;
    phone!: string;
    city!: string;
    state!: string;
    additionalInfo!: string;
    dateAdded!: Date;
    dateModified!: Date;

    constructor(data?: ISystemUserRequestModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"];
            this.systemUserRequestId = _data["systemUserRequestId"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastname = _data["lastname"];
            this.companyName = _data["companyName"];
            this.phone = _data["phone"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.additionalInfo = _data["additionalInfo"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SystemUserRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserRequestModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["systemUserRequestId"] = this.systemUserRequestId;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastname"] = this.lastname;
        data["companyName"] = this.companyName;
        data["phone"] = this.phone;
        data["city"] = this.city;
        data["state"] = this.state;
        data["additionalInfo"] = this.additionalInfo;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemUserRequestModel extends IBasePagedModel {
    tableName: string;
    systemUserRequestId: number;
    emailAddress: string;
    firstName?: string | undefined;
    lastname?: string | undefined;
    companyName: string;
    phone: string;
    city: string;
    state: string;
    additionalInfo: string;
    dateAdded: Date;
    dateModified: Date;
}

export class AuthResult implements IAuthResult {
    token?: string | undefined;
    expiresIn!: number;
    errorMessage?: string | undefined;
    userId!: number;
    primaryUserId!: number;
    userLogin?: string | undefined;
    userName?: string | undefined;
    userRoles?: SystemPermission[] | undefined;
    fullName?: string | undefined;
    userIdentityCurrent?: AuthUserIdentity | undefined;
    userIdentities?: AuthUserIdentity[] | undefined;

    constructor(data?: IAuthResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expiresIn = _data["expiresIn"];
            this.errorMessage = _data["errorMessage"];
            this.userId = _data["userId"];
            this.primaryUserId = _data["primaryUserId"];
            this.userLogin = _data["userLogin"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(item);
            }
            this.fullName = _data["fullName"];
            this.userIdentityCurrent = _data["userIdentityCurrent"] ? AuthUserIdentity.fromJS(_data["userIdentityCurrent"]) : <any>undefined;
            if (Array.isArray(_data["userIdentities"])) {
                this.userIdentities = [] as any;
                for (let item of _data["userIdentities"])
                    this.userIdentities!.push(AuthUserIdentity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expiresIn"] = this.expiresIn;
        data["errorMessage"] = this.errorMessage;
        data["userId"] = this.userId;
        data["primaryUserId"] = this.primaryUserId;
        data["userLogin"] = this.userLogin;
        data["userName"] = this.userName;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item);
        }
        data["fullName"] = this.fullName;
        data["userIdentityCurrent"] = this.userIdentityCurrent ? this.userIdentityCurrent.toJSON() : <any>undefined;
        if (Array.isArray(this.userIdentities)) {
            data["userIdentities"] = [];
            for (let item of this.userIdentities)
                data["userIdentities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuthResult {
    token?: string | undefined;
    expiresIn: number;
    errorMessage?: string | undefined;
    userId: number;
    primaryUserId: number;
    userLogin?: string | undefined;
    userName?: string | undefined;
    userRoles?: SystemPermission[] | undefined;
    fullName?: string | undefined;
    userIdentityCurrent?: AuthUserIdentity | undefined;
    userIdentities?: AuthUserIdentity[] | undefined;
}

export class AuthUserIdentity implements IAuthUserIdentity {
    identityName?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    hash?: string | undefined;
    deviceToken?: string | undefined;
    applyRolePermissions?: boolean | undefined;
    identityType?: string | undefined;
    systemUserId?: number | undefined;
    systemAdminId?: number | undefined;
    systemCustomerId?: number | undefined;
    systemCarrierId?: number | undefined;
    systemEmployeeId?: number | undefined;
    systemScanToPickId?: number | undefined;
    customerId?: number | undefined;
    customerName!: string;
    roleName!: string;
    carrierId?: number | undefined;
    carrierName!: string;

    constructor(data?: IAuthUserIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityName = _data["identityName"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.hash = _data["hash"];
            this.deviceToken = _data["deviceToken"];
            this.applyRolePermissions = _data["applyRolePermissions"];
            this.identityType = _data["identityType"];
            this.systemUserId = _data["systemUserId"];
            this.systemAdminId = _data["systemAdminId"];
            this.systemCustomerId = _data["systemCustomerId"];
            this.systemCarrierId = _data["systemCarrierId"];
            this.systemEmployeeId = _data["systemEmployeeId"];
            this.systemScanToPickId = _data["systemScanToPickId"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.roleName = _data["roleName"];
            this.carrierId = _data["carrierId"];
            this.carrierName = _data["carrierName"];
        }
    }

    static fromJS(data: any): AuthUserIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new AuthUserIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityName"] = this.identityName;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["hash"] = this.hash;
        data["deviceToken"] = this.deviceToken;
        data["applyRolePermissions"] = this.applyRolePermissions;
        data["identityType"] = this.identityType;
        data["systemUserId"] = this.systemUserId;
        data["systemAdminId"] = this.systemAdminId;
        data["systemCustomerId"] = this.systemCustomerId;
        data["systemCarrierId"] = this.systemCarrierId;
        data["systemEmployeeId"] = this.systemEmployeeId;
        data["systemScanToPickId"] = this.systemScanToPickId;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["roleName"] = this.roleName;
        data["carrierId"] = this.carrierId;
        data["carrierName"] = this.carrierName;
        return data;
    }
}

export interface IAuthUserIdentity {
    identityName?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    hash?: string | undefined;
    deviceToken?: string | undefined;
    applyRolePermissions?: boolean | undefined;
    identityType?: string | undefined;
    systemUserId?: number | undefined;
    systemAdminId?: number | undefined;
    systemCustomerId?: number | undefined;
    systemCarrierId?: number | undefined;
    systemEmployeeId?: number | undefined;
    systemScanToPickId?: number | undefined;
    customerId?: number | undefined;
    customerName: string;
    roleName: string;
    carrierId?: number | undefined;
    carrierName: string;
}

export class AuthUser implements IAuthUser {
    login?: string | undefined;
    password?: string | undefined;
    localTime?: string | undefined;
    timezoneOffsetMinutes?: number | undefined;
    source?: string | undefined;
    passwordOld?: string | undefined;
    hash?: string | undefined;
    resetMode?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    pin?: number | undefined;
    deviceToken?: string | undefined;

    constructor(data?: IAuthUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.password = _data["password"];
            this.localTime = _data["localTime"];
            this.timezoneOffsetMinutes = _data["timezoneOffsetMinutes"];
            this.source = _data["source"];
            this.passwordOld = _data["passwordOld"];
            this.hash = _data["hash"];
            this.resetMode = _data["resetMode"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.pin = _data["pin"];
            this.deviceToken = _data["deviceToken"];
        }
    }

    static fromJS(data: any): AuthUser {
        data = typeof data === 'object' ? data : {};
        let result = new AuthUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["password"] = this.password;
        data["localTime"] = this.localTime;
        data["timezoneOffsetMinutes"] = this.timezoneOffsetMinutes;
        data["source"] = this.source;
        data["passwordOld"] = this.passwordOld;
        data["hash"] = this.hash;
        data["resetMode"] = this.resetMode;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["pin"] = this.pin;
        data["deviceToken"] = this.deviceToken;
        return data;
    }
}

export interface IAuthUser {
    login?: string | undefined;
    password?: string | undefined;
    localTime?: string | undefined;
    timezoneOffsetMinutes?: number | undefined;
    source?: string | undefined;
    passwordOld?: string | undefined;
    hash?: string | undefined;
    resetMode?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    pin?: number | undefined;
    deviceToken?: string | undefined;
}

export class Headers implements IHeaders {

    [key: string]: any;

    constructor(data?: IHeaders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Headers {
        data = typeof data === 'object' ? data : {};
        let result = new Headers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IHeaders {

    [key: string]: any;
}

export class Headers2 implements IHeaders2 {

    [key: string]: any;

    constructor(data?: IHeaders2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Headers2 {
        data = typeof data === 'object' ? data : {};
        let result = new Headers2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IHeaders2 {

    [key: string]: any;
}

export class Headers3 implements IHeaders3 {

    [key: string]: any;

    constructor(data?: IHeaders3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Headers3 {
        data = typeof data === 'object' ? data : {};
        let result = new Headers3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IHeaders3 {

    [key: string]: any;
}

export class Headers4 implements IHeaders4 {

    [key: string]: any;

    constructor(data?: IHeaders4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Headers4 {
        data = typeof data === 'object' ? data : {};
        let result = new Headers4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IHeaders4 {

    [key: string]: any;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}